

"use strict";
var _0_Constants;
(function (_0_Constants) {
    _0_Constants.AI_ASSISTANT_OPERATOR_ID = -1;
    _0_Constants.AI_ASSISTANT_NAME = 'ИИ-ассистент';
    function isAiAssistant(operatorId) {
        return Number(operatorId) === _0_Constants.AI_ASSISTANT_OPERATOR_ID;
    }
    _0_Constants.isAiAssistant = isAiAssistant;
    _0_Constants.MESSAGE_DELETED_SYSTEM_MESSAGE = 'message_deleted';
    function isRevokeNotice(systemMessage) {
        return systemMessage === _0_Constants.MESSAGE_DELETED_SYSTEM_MESSAGE;
    }
    _0_Constants.isRevokeNotice = isRevokeNotice;
    _0_Constants.MESSAGE_DELETED_BY_OWNER_SYSTEM_MESSAGE = 'message_deleted_by_owner';
    function isOwnerRevokeNotice(systemMessage) {
        return systemMessage === _0_Constants.MESSAGE_DELETED_BY_OWNER_SYSTEM_MESSAGE;
    }
    _0_Constants.isOwnerRevokeNotice = isOwnerRevokeNotice;
    function aiTransferRefusalOf(value) {
        return value === 'ai_disabled' || value === 'ai_no_api_key' || value === 'ai_check_failed'
            ? value
            : null;
    }
    _0_Constants.aiTransferRefusalOf = aiTransferRefusalOf;
    _0_Constants.AI_TRANSFER_OPTION_LABEL = {
        ai_disabled: 'ИИ-ассистент (выключен в настройках)',
        ai_no_api_key: 'ИИ-ассистент (не задан API-ключ провайдера ИИ)',
        ai_check_failed: 'ИИ-ассистент (недоступен)',
    };
    _0_Constants.AI_TRANSFER_REFUSAL_TEXT = {
        ai_disabled: 'ИИ-ассистент выключен в настройках. Включите его в настройках ИИ-ассистента или передайте чат оператору.',
        ai_no_api_key: 'Не задан API-ключ провайдера ИИ, поэтому ИИ-ассистент не может вести чат. Подключите ключ на странице «Провайдер ИИ и API-ключи» или передайте чат оператору.',
        ai_check_failed: 'Не удалось проверить, может ли ИИ-ассистент принять чат. Повторите действие.',
    };
    function isLoadedOperatorData(data) {
        return data.id !== undefined && data.central_user_id !== undefined;
    }
    _0_Constants.isLoadedOperatorData = isLoadedOperatorData;
})(_0_Constants || (_0_Constants = {}));


"use strict";
var _1_Tasks;
(function (_1_Tasks) {
    var sessionValue = Math.floor(Math.random() * 1000).toString();
    window.session = sessionValue;
    localStorage.setItem('session', sessionValue);
    var onStorage = function (event) {
        var _a;
        if (typeof Android === 'object' ||
            window.ReactNativeWebView) {
            return;
        }
        var storedSession = (_a = window.session) !== null && _a !== void 0 ? _a : '';
        var isSessionChanged = event.key === 'session' && event.newValue !== null && event.newValue !== storedSession;
        if (isSessionChanged) {
            try {
                _10_Chat_WebSocket.Chat_WebSocket.auth_verification_error = true;
                if (_10_Chat_WebSocket.Chat_WebSocket.socket) {
                    _10_Chat_WebSocket.Chat_WebSocket.socket.close();
                }
            }
            catch (e) {
                console.log(e);
            }
            var duplicateSessionTemplate = "\n        <style>\n          .chat-duplicate-session {\n            background: #f5f7fb;\n            min-height: 100vh;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            padding: 24px;\n            font-family: 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n            color: #1f2a37;\n          }\n          .chat-duplicate-session__card {\n            background: #ffffff;\n            border-radius: 16px;\n            box-shadow: 0 24px 60px rgba(15, 23, 42, 0.12);\n            padding: 32px;\n            width: 100%;\n            max-width: 420px;\n            text-align: center;\n          }\n          .chat-duplicate-session__icon {\n            font-size: 42px;\n            margin-bottom: 16px;\n            color: #f97316;\n          }\n          .chat-duplicate-session__title {\n            font-size: 24px;\n            font-weight: 600;\n            margin-bottom: 12px;\n          }\n          .chat-duplicate-session__text {\n            font-size: 16px;\n            line-height: 1.6;\n            color: #4b5563;\n            margin-bottom: 24px;\n          }\n          .chat-duplicate-session__button {\n            display: inline-flex;\n            align-items: center;\n            justify-content: center;\n            padding: 10px 20px;\n            border: none;\n            border-radius: 999px;\n            font-size: 15px;\n            font-weight: 600;\n            color: #ffffff;\n            background: linear-gradient(135deg, #2563eb, #3b82f6);\n            cursor: pointer;\n            transition: box-shadow 0.2s ease, transform 0.2s ease;\n          }\n          .chat-duplicate-session__button:hover {\n            box-shadow: 0 8px 20px rgba(37, 99, 235, 0.35);\n            transform: translateY(-1px);\n          }\n        </style>\n        <div class=\"chat-duplicate-session\">\n          <div class=\"chat-duplicate-session__card\">\n            <div class=\"chat-duplicate-session__icon\">&#9888;</div>\n            <div class=\"chat-duplicate-session__title\">\u0427\u0430\u0442 \u0443\u0436\u0435 \u043E\u0442\u043A\u0440\u044B\u0442 \u0432 \u0434\u0440\u0443\u0433\u043E\u0439 \u0432\u043A\u043B\u0430\u0434\u043A\u0435</div>\n            <p class=\"chat-duplicate-session__text\">\n              \u041C\u044B \u043E\u0431\u043D\u0430\u0440\u0443\u0436\u0438\u043B\u0438 \u0430\u043A\u0442\u0438\u0432\u043D\u0443\u044E \u0441\u0435\u0441\u0441\u0438\u044E. \u0417\u0430\u043A\u0440\u043E\u0439\u0442\u0435 \u043B\u0438\u0448\u043D\u044E\u044E \u0432\u043A\u043B\u0430\u0434\u043A\u0443 \u0438\u043B\u0438 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u044D\u0442\u0443 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443,\n              \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u0440\u0430\u0431\u043E\u0442\u0443.\n            </p>\n            <button type=\"button\" class=\"chat-duplicate-session__button\" onclick=\"window.location.reload()\">\n              \u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443\n            </button>\n          </div>\n        </div>";
            $('body').html(duplicateSessionTemplate);
        }
    };
    window.addEventListener('storage', onStorage);
    _1_Tasks.htmlToText = function (str) {
        var textAreaDiv = document.createElement('textarea');
        textAreaDiv.textContent = str;
        return textAreaDiv.innerHTML;
    };
    _1_Tasks.escapeHtml = function (str) {
        return str
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    };
    _1_Tasks.findContactItemByPhone = function (phoneValue) {
        var itemElements = document.querySelectorAll('.contact_item');
        for (var index = 0; index < itemElements.length; index++) {
            var itemElement = itemElements[index];
            if (itemElement === undefined)
                continue;
            if (itemElement.getAttribute('data-phone') === phoneValue) {
                return $(itemElement);
            }
        }
        return $('[data-phone="__sendapi_not_found__"]');
    };
    $('#chat_subscribers').html('');
    $('.menu_tabs').css('margin-left', '10px').css('width', '208px').css('border-bottom', '0');
    $('.menu_tabs a')
        .css('width', 'inherit')
        .css('min-width', '32px')
        .css('text-align', 'center')
        .css('margin', '0');
    $('#chat_work').show();
    _1_Tasks.Tasks = {};
})(_1_Tasks || (_1_Tasks = {}));


"use strict";
var _2_Draft;
(function (_2_Draft) {
    _2_Draft.Draft = {
        clear: function () {
            var operatorId = _7_Chat.Chat.operator_data.id;
            if (operatorId === undefined) {
                console.error('Draft.clear|данные оператора ещё не загружены');
                return;
            }
            var id = operatorId.toString();
            if (localStorage.getItem('botcorpDraft') === null) {
                localStorage.setItem('botcorpDraft', id);
                return;
            }
            if (Number(localStorage.getItem('botcorpDraft')) === Number(id)) {
                return;
            }
            localStorage.setItem('botcorpDraft', id);
            for (var key in localStorage) {
                if (key.search('botcorpDraft_') === 0)
                    localStorage.removeItem(key);
            }
        },
        put_t: function (phone, text) {
            if (text === '') {
                localStorage.removeItem("botcorpDraft_t_".concat(phone));
                return;
            }
            localStorage.setItem("botcorpDraft_t_".concat(phone), text);
        },
        put_d: function (phone, text) {
            if (text === '') {
                localStorage.removeItem("botcorpDraft_d_".concat(phone));
                return;
            }
            localStorage.setItem("botcorpDraft_d_".concat(phone), text);
        },
        get_t: function (phone) {
            var text = localStorage.getItem("botcorpDraft_t_".concat(phone));
            return text !== null ? text : '';
        },
        get_d: function (phone) {
            var text = localStorage.getItem("botcorpDraft_d_".concat(phone));
            return text !== null ? text : '';
        },
        del: function (phone) {
            localStorage.removeItem("botcorpDraft_t_".concat(phone));
            localStorage.removeItem("botcorpDraft_d_".concat(phone));
        },
    };
})(_2_Draft || (_2_Draft = {}));


"use strict";
var _3_SorterWork;
(function (_3_SorterWork) {
    var SorterWorkCls = (function () {
        function SorterWorkCls() {
            var _this = this;
            this.config = {
                categ: 'take_to_work',
                contactHeight: 35,
                contactCount: 90,
                pageContactCount: 30,
                pageHeight: 1050,
                pageCurrent: 1,
                pageBlok1: 1,
                pageBlok2: 2,
                pageBlok3: 3,
            };
            this._lastWorkHtml = '';
            this.handler = function (data) {
                _this.config.pageCurrent = Math.ceil(data.position / _this.config.pageHeight);
                if (_this.config.pageCurrent > 1) {
                    if (_this.config.pageCurrent !== _this.config.pageBlok2) {
                        _this.config.pageBlok1 = _this.config.pageCurrent - 1;
                        _this.config.pageBlok2 = _this.config.pageCurrent;
                        _this.config.pageBlok3 = _this.config.pageCurrent + 1;
                        _this.load();
                    }
                }
                else if (_this.config.pageCurrent <= 1) {
                    _this.config.pageCurrent = 1;
                    if (_this.config.pageCurrent !== _this.config.pageBlok1) {
                        _this.config.pageBlok1 = 1;
                        _this.config.pageBlok2 = 2;
                        _this.config.pageBlok3 = 3;
                        _this.load();
                    }
                }
            };
            this.load = function (callback) {
                var _a, _b, _c;
                var Chat = _7_Chat.Chat;
                var Contacts = _5_Contacts.Contacts;
                var callbackFn = callback !== undefined ? callback : function () { };
                var page = _this.config.pageCurrent;
                var limit = _this.config.contactCount;
                var p = page - 1;
                var start = 0;
                if (p === 0) {
                    start = 0;
                }
                else {
                    start = p * _this.config.pageContactCount - _this.config.pageContactCount;
                }
                if (Chat.offlineCacheReady() && Chat.Chat_Store) {
                    Chat.Chat_Store.getContactsPagePr({
                        categ: '0',
                        start: start,
                        limit: limit,
                        phones: Object.keys(Contacts.work_my),
                    })
                        .then(function (pageData) {
                        var sorts = [];
                        for (var _i = 0, _a = pageData.rows; _i < _a.length; _i++) {
                            var row = _a[_i];
                            Chat.seedContactFromSnapshotRow(row);
                            sorts.push({ phone: row.phone, noread: row.noread });
                        }
                        var offlineData = {
                            result: 0,
                            page: page,
                            sorts: sorts,
                            allCount: pageData.total,
                        };
                        _this.view(offlineData, start, function () {
                            callbackFn();
                        });
                        $('#chat_category_work .category-item-count').html("(".concat(pageData.total, ")"));
                    })
                        .catch(function (error) {
                        console.error('SorterWork.load|offline|error=', error);
                        callbackFn();
                    });
                }
                else {
                    _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                        data: {
                            query: 'contact_sort_load_v2',
                            categ: _this.config.categ,
                            page: page,
                            start: start,
                            limit: limit,
                        },
                        before: function () { },
                        success: function (data) {
                            if (data.result === 0) {
                                if (data.page === _this.config.pageCurrent) {
                                    _this.view(data, start, function () {
                                        callbackFn();
                                    });
                                    $('#chat_category_work .category-item-count').html("(".concat(data.allCount ? data.allCount : 0, ")"));
                                    return;
                                }
                                callbackFn();
                            }
                        },
                        error: function () {
                            _this.load();
                        },
                    });
                }
                for (var _i = 0, _d = Contacts.category_noread_items(); _i < _d.length; _i++) {
                    var category = _d[_i];
                    var noreadCount = (_a = category.noread_count) !== null && _a !== void 0 ? _a : 0;
                    var userCountMs = (_b = category.user_count_ms) !== null && _b !== void 0 ? _b : 0;
                    var categoryName = (_c = category.name) !== null && _c !== void 0 ? _c : '';
                    if (noreadCount > 0) {
                        var noread_count = noreadCount > 999 ? '999+' : String(noreadCount);
                        $('.category-item-noread-' + category.id).html(noread_count);
                    }
                    else {
                        $('.category-item-noread-' + category.id).html('');
                    }
                    var visibleCount = Contacts.categoryVisibleCount(category.id, userCountMs);
                    $('.category-item[data-id="' + category.id + '"]').attr('title', categoryName + ' (' + visibleCount + ')');
                    $('.category-item-count.item-' + category.id).html('(' + visibleCount + ')');
                }
            };
            this.view = function (data, start, callback) {
                var _a, _b, _c, _d, _e, _f;
                var sorts = data.sorts;
                var Contacts = _5_Contacts.Contacts;
                var Chat = _7_Chat.Chat;
                var escapeHtml = _1_Tasks.escapeHtml;
                var findContactItemByPhone = _1_Tasks.findContactItemByPhone;
                var callbackFn = callback !== undefined ? callback : function () { };
                var html = '';
                var k = 0;
                var chatOpenSubscriber = Chat.chat_open_subscriber !== false && Chat.chat_open_subscriber !== null
                    ? String(Chat.chat_open_subscriber)
                    : '';
                var _loop_1 = function (key) {
                    var item = sorts[key];
                    if (!item)
                        return "continue";
                    var phone = item.phone;
                    var phoneEscaped = escapeHtml(phone);
                    Contacts.noread_by_phone[phone] = typeof item.noread === 'number' ? item.noread : 0;
                    var translateY = (start + k) * _this.config.contactHeight;
                    k++;
                    var open_1 = chatOpenSubscriber === phone ? ' show_subscriber' : '';
                    var work_my = '';
                    if (Contacts.work_my.hasOwnProperty(phone))
                        work_my = ' work_my';
                    if (Contacts.data.hasOwnProperty(phone)) {
                        if (chatOpenSubscriber === phone) {
                            if (Contacts.no_read[chatOpenSubscriber] &&
                                (Contacts.work_my[chatOpenSubscriber] ||
                                    ((_a = Contacts.data[phone]) === null || _a === void 0 ? void 0 : _a.transport) === 'whatsapp_group')) {
                                $('.mark_as_read').removeClass('hidden');
                            }
                            else {
                                $('.mark_as_read').addClass('hidden');
                            }
                        }
                        var _g = Chat.getContactPresentationData({
                            phone: phone,
                            transport: (_b = Contacts.data[phone]) === null || _b === void 0 ? void 0 : _b.transport,
                            name: (_c = Contacts.data[phone]) === null || _c === void 0 ? void 0 : _c.name,
                            name_custom: (_d = Contacts.data[phone]) === null || _d === void 0 ? void 0 : _d.name_custom,
                            insta_login: (_e = Contacts.data[phone]) === null || _e === void 0 ? void 0 : _e.insta_login,
                            telegram_login: (_f = Contacts.data[phone]) === null || _f === void 0 ? void 0 : _f.telegram_login,
                        }), contactIcon = _g.contactIcon, contactName = _g.contactName, contactPhone = _g.contactPhone;
                        html +=
                            "<li data-phone=\"".concat(phoneEscaped, "\" data-i18n-user-content class=\"contact_item ").concat(open_1).concat(work_my, "\" style=\"transform: translateY(").concat(translateY, "px);") +
                                " transition: none 0s ease 0s;\" onclick=\"_7_Chat.Chat.click_open_subscriber({phone:this.getAttribute('data-phone'),call_from:'SorterWork|work_list'})\">" +
                                "<i class=\"".concat(contactIcon, "\"></i> <b>") +
                                (contactName !== null ? contactName : '') +
                                "</b> ".concat(contactPhone) +
                                " <span class=\"no_read_kol\">" +
                                (item.noread !== undefined && item.noread > 0 ? item.noread : '') +
                                "</span></li>";
                    }
                    else {
                        Contacts.data_get({ phone: phone, dop_data: item }, function (user, dop_item) {
                            var _a, _b, _c, _d, _e;
                            var _f = Chat.getContactPresentationData({
                                phone: user.phone,
                                transport: (_a = Contacts.data[user.phone]) === null || _a === void 0 ? void 0 : _a.transport,
                                name: (_b = Contacts.data[user.phone]) === null || _b === void 0 ? void 0 : _b.name,
                                name_custom: (_c = Contacts.data[user.phone]) === null || _c === void 0 ? void 0 : _c.name_custom,
                                insta_login: (_d = Contacts.data[user.phone]) === null || _d === void 0 ? void 0 : _d.insta_login,
                                telegram_login: (_e = Contacts.data[user.phone]) === null || _e === void 0 ? void 0 : _e.telegram_login,
                            }), contactIcon = _f.contactIcon, contactName = _f.contactName, contactPhone = _f.contactPhone;
                            findContactItemByPhone(user.phone).html("<i class=\"".concat(contactIcon, "\"></i> <b>") +
                                (contactName !== null ? contactName : '') +
                                "</b> ".concat(contactPhone, " <span class=\"no_read_kol\">") +
                                (dop_item !== undefined && dop_item.noread !== undefined && dop_item.noread > 0
                                    ? dop_item.noread
                                    : '') +
                                "</span>");
                        }, function (_data) {
                            findContactItemByPhone(phone).html('');
                            _this._lastWorkHtml = null;
                            setTimeout(function () {
                                _this.load();
                            }, 1000);
                        });
                        html += "<li data-phone=\"".concat(phoneEscaped, "\" data-i18n-user-content class=\"contact_item ").concat(open_1).concat(work_my, "\" style=\"transform: translateY(").concat(translateY, "px); transition: none 0s ease 0s;\" onclick=\"_7_Chat.Chat.click_open_subscriber({phone:this.getAttribute('data-phone'),call_from:'SorterWork|work_list_spinner'})\">");
                        html += "<i class=\"fa fa-spinner fa-spin\"></i>";
                        html += "</li>";
                    }
                };
                for (var key in sorts) {
                    _loop_1(key);
                }
                var applyChromeAndCallback = function () {
                    if (html === '')
                        $('#chat_category_work').hide();
                    else
                        $('#chat_category_work').show();
                    $('#chat_work').height(data.allCount * _this.config.contactHeight);
                    callbackFn();
                };
                if (_this._lastWorkHtml === html) {
                    applyChromeAndCallback();
                    return;
                }
                _this._lastWorkHtml = html;
                var promiseLike = $.when($('#chat_work').html(html));
                {
                    if (typeof promiseLike.then === 'function') {
                        promiseLike.then(function () {
                            applyChromeAndCallback();
                        });
                        return;
                    }
                }
                applyChromeAndCallback();
            };
        }
        return SorterWorkCls;
    }());
    _3_SorterWork.SorterWork = new SorterWorkCls();
})(_3_SorterWork || (_3_SorterWork = {}));


"use strict";
var _4_Sorter;
(function (_4_Sorter) {
    var MIN_PAGE_CONTACT_COUNT = 20;
    var LOADER_HEIGHT = 32;
    var MIN_EMPTY_BAND = 70;
    _4_Sorter.Sorter = {
        config: {
            categ: '0',
            contactHeight: 35,
            contactCount: 60,
            pageContactCount: 20,
            pageHeight: 700,
            pageCurrent: 1,
            pageBlok1: 1,
            pageBlok2: 2,
            pageBlok3: 3,
        },
        _lastSubscribersHtml: '',
        viewportHeight: function () {
            var innerHeight = typeof window !== 'undefined' ? window.innerHeight : 0;
            var windowHeight = typeof innerHeight === 'number' && innerHeight > 0 ? innerHeight : 0;
            var sidebarHeight = _4_Sorter.Sorter.sidebarElement().height();
            if (typeof sidebarHeight === 'number' && sidebarHeight > 0) {
                return windowHeight > 0 ? Math.min(sidebarHeight, windowHeight) : sidebarHeight;
            }
            return windowHeight;
        },
        sidebarElement: function () {
            var list = $('#chat_subscribers');
            if (list.length === 0)
                return $('.sidebar');
            var own = list.closest('.sidebar');
            if (own.length > 0)
                return own;
            var anySidebar = $('.sidebar');
            if (anySidebar.length > 0)
                return anySidebar;
            return list.parent();
        },
        listOffsetTop: function () {
            var listOffset = $('#chat_subscribers').offset();
            var viewportOffset = _4_Sorter.Sorter.sidebarElement().offset();
            if (listOffset === undefined || viewportOffset === undefined)
                return 0;
            return listOffset.top - viewportOffset.top;
        },
        _loading: false,
        _renderedTop: 0,
        _renderedBottom: 0,
        emptyBand: function () {
            var visibleHeight = _4_Sorter.Sorter.viewportHeight();
            if (!(visibleHeight > 0))
                return { top: 0, height: 0 };
            var offset = _4_Sorter.Sorter.listOffsetTop();
            var clamp = function (value) { return Math.min(Math.max(value, 0), visibleHeight); };
            var listTop = clamp(offset);
            var renderedTop = clamp(offset + _4_Sorter.Sorter._renderedTop);
            var renderedBottom = clamp(offset + _4_Sorter.Sorter._renderedBottom);
            var above = { top: listTop, height: Math.max(0, renderedTop - listTop) };
            var below = { top: renderedBottom, height: visibleHeight - renderedBottom };
            return above.height > below.height ? above : below;
        },
        loaderElement: function () {
            var existing = $('#chat_subscribers_loader');
            if (existing.length > 0)
                return existing;
            var container = _4_Sorter.Sorter.sidebarElement();
            if (container.length === 0)
                return null;
            container.append('<div id="chat_subscribers_loader" style="position:absolute;left:0;right:0;z-index:5;' +
                "display:none;height:".concat(LOADER_HEIGHT, "px;line-height:").concat(LOADER_HEIGHT, "px;text-align:center;") +
                'color:#9aa0a6;font-size:24px;pointer-events:none;">' +
                '<i class="fa fa-spinner fa-spin"></i>' +
                '</div>');
            return $('#chat_subscribers_loader');
        },
        loadingStart: function () {
            if (_4_Sorter.Sorter._loading)
                return;
            _4_Sorter.Sorter._loading = true;
            _4_Sorter.Sorter.loadingSync();
        },
        loadingStop: function () {
            _4_Sorter.Sorter._loading = false;
            _4_Sorter.Sorter.loadingSync();
        },
        loadingSync: function () {
            var loader = _4_Sorter.Sorter.loaderElement();
            if (loader === null)
                return;
            var waiting = _4_Sorter.Sorter._loading;
            var band = waiting ? _4_Sorter.Sorter.emptyBand() : { top: 0, height: 0 };
            if (band.height < MIN_EMPTY_BAND) {
                loader.css('display', 'none');
                return;
            }
            var listTopLimit = Math.max(0, _4_Sorter.Sorter.listOffsetTop());
            var centered = Math.round(band.top + band.height / 2 - LOADER_HEIGHT / 2);
            var top = Math.max(listTopLimit, centered);
            loader.css({
                top: "".concat(top, "px"),
                display: 'block',
            });
        },
        syncViewportConfig: function () {
            var visibleHeight = _4_Sorter.Sorter.viewportHeight();
            if (!(visibleHeight > 0))
                return false;
            var pageContactCount = Math.max(MIN_PAGE_CONTACT_COUNT, Math.ceil(visibleHeight / _4_Sorter.Sorter.config.contactHeight) + 1);
            if (pageContactCount === _4_Sorter.Sorter.config.pageContactCount)
                return false;
            _4_Sorter.Sorter.config.pageContactCount = pageContactCount;
            _4_Sorter.Sorter.config.pageHeight = pageContactCount * _4_Sorter.Sorter.config.contactHeight;
            _4_Sorter.Sorter.config.contactCount = pageContactCount * 3;
            return true;
        },
        handler: function (data) {
            if (_4_Sorter.Sorter.syncViewportConfig()) {
                _4_Sorter.Sorter.config.pageBlok1 = 0;
                _4_Sorter.Sorter.config.pageBlok2 = 0;
                _4_Sorter.Sorter.config.pageBlok3 = 0;
            }
            var workHeight = $('#chat_work').height();
            data.position = data.position - ((workHeight || 0) + 42);
            if (data.position < 0)
                data.position = 0;
            _4_Sorter.Sorter.config.pageCurrent = Math.ceil(data.position / _4_Sorter.Sorter.config.pageHeight);
            if (_4_Sorter.Sorter.config.pageCurrent > 1) {
                if (_4_Sorter.Sorter.config.pageCurrent !== _4_Sorter.Sorter.config.pageBlok2) {
                    _4_Sorter.Sorter.config.pageBlok1 = _4_Sorter.Sorter.config.pageCurrent - 1;
                    _4_Sorter.Sorter.config.pageBlok2 = _4_Sorter.Sorter.config.pageCurrent;
                    _4_Sorter.Sorter.config.pageBlok3 = _4_Sorter.Sorter.config.pageCurrent + 1;
                    _4_Sorter.Sorter.load();
                }
            }
            else if (_4_Sorter.Sorter.config.pageCurrent <= 1) {
                _4_Sorter.Sorter.config.pageCurrent = 1;
                if (_4_Sorter.Sorter.config.pageCurrent !== _4_Sorter.Sorter.config.pageBlok1) {
                    _4_Sorter.Sorter.config.pageBlok1 = 1;
                    _4_Sorter.Sorter.config.pageBlok2 = 2;
                    _4_Sorter.Sorter.config.pageBlok3 = 3;
                    _4_Sorter.Sorter.load();
                }
            }
            _4_Sorter.Sorter.loadingSync();
        },
        load: function (callback) {
            var _a, _b, _c;
            var Chat = _7_Chat.Chat;
            var Contacts = _5_Contacts.Contacts;
            _3_SorterWork.SorterWork.load();
            var callbackFn = callback !== undefined ? callback : function () { };
            if (_4_Sorter.Sorter.config.pageCurrent <= 1)
                _4_Sorter.Sorter.syncViewportConfig();
            var page = _4_Sorter.Sorter.config.pageCurrent;
            var limit = _4_Sorter.Sorter.config.contactCount;
            var p = page - 1;
            var start = 0;
            if (p === 0) {
                start = 0;
            }
            else {
                start = p * _4_Sorter.Sorter.config.pageContactCount - _4_Sorter.Sorter.config.pageContactCount;
            }
            _4_Sorter.Sorter.loadingStart();
            if (Chat.offlineCacheReady() && Chat.Chat_Store) {
                var isWorkList_1 = _4_Sorter.Sorter.config.categ === 'take_to_work' || _4_Sorter.Sorter.config.categ === 'my_chats';
                var phonesFilter = isWorkList_1 ? Object.keys(Contacts.work_my) : null;
                Chat.Chat_Store.getContactsPagePr({
                    categ: String(_4_Sorter.Sorter.config.categ),
                    start: start,
                    limit: limit,
                    phones: phonesFilter,
                })
                    .then(function (pageData) {
                    var sorts = {};
                    var index = 0;
                    for (var _i = 0, _a = pageData.rows; _i < _a.length; _i++) {
                        var row = _a[_i];
                        if (!isWorkList_1 && Contacts.work_my.hasOwnProperty(row.phone))
                            continue;
                        Chat.seedContactFromSnapshotRow(row);
                        sorts[String(index)] = { phone: row.phone, noread: row.noread };
                        index++;
                    }
                    _4_Sorter.Sorter.loadingStop();
                    _4_Sorter.Sorter.view(sorts, start, function () {
                        callbackFn();
                    });
                })
                    .catch(function (error) {
                    console.error('Sorter.load|offline|error=', error);
                    _4_Sorter.Sorter.loadingStop();
                    callbackFn();
                });
            }
            else {
                _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'contact_sort_load_v2',
                        categ: _4_Sorter.Sorter.config.categ,
                        page: page,
                        start: start,
                        limit: limit,
                    },
                    before: function () { },
                    success: function (data) {
                        _4_Sorter.Sorter.loadingStop();
                        if (data.result === 0) {
                            if (data.page === _4_Sorter.Sorter.config.pageCurrent) {
                                _4_Sorter.Sorter.view(data.sorts, start, function () {
                                    callbackFn();
                                });
                                return;
                            }
                            callbackFn();
                        }
                    },
                    error: function () {
                        _4_Sorter.Sorter.loadingStop();
                        _4_Sorter.Sorter.load();
                    },
                });
            }
            for (var _i = 0, _d = Contacts.category_noread_items(); _i < _d.length; _i++) {
                var category = _d[_i];
                var noreadCount = (_a = category.noread_count) !== null && _a !== void 0 ? _a : 0;
                var userCountMs = (_b = category.user_count_ms) !== null && _b !== void 0 ? _b : 0;
                var categoryName = (_c = category.name) !== null && _c !== void 0 ? _c : '';
                if (noreadCount > 0) {
                    var noread_count = noreadCount;
                    if (noreadCount > 999)
                        noread_count = '999+';
                    $(".category-item-noread-".concat(category.id)).html(noread_count.toString());
                }
                else {
                    $(".category-item-noread-".concat(category.id)).html('');
                }
                var visibleCount = Contacts.categoryVisibleCount(category.id, userCountMs);
                $(".category-item[data-id=\"".concat(category.id, "\"]")).attr('title', categoryName + ' (' + visibleCount + ')');
                $(".category-item-count.item-".concat(category.id)).html('(' + visibleCount + ')');
            }
        },
        view: function (sorts, start, callback) {
            var _a, _b, _c, _d, _e, _f;
            var Chat = _7_Chat.Chat;
            var Contacts = _5_Contacts.Contacts;
            var escapeHtml = _1_Tasks.escapeHtml;
            var findContactItemByPhone = _1_Tasks.findContactItemByPhone;
            var callbackFn = callback !== undefined ? callback : function () { };
            Chat.contactsSnapshotSchedule(sorts, String(_4_Sorter.Sorter.config.categ), start);
            var html = '';
            var k = 0;
            var chatOpenSubscriber = Chat.chat_open_subscriber !== false && Chat.chat_open_subscriber !== null
                ? String(Chat.chat_open_subscriber)
                : '';
            var _loop_1 = function (key) {
                var item = sorts[key];
                if (!item)
                    return "continue";
                var phone = item.phone;
                var phoneEscaped = escapeHtml(phone);
                Contacts.noread_by_phone[phone] = typeof item.noread === 'number' ? item.noread : 0;
                if (typeof Bitrix24Handler !== 'undefined' && Bitrix24Handler.isCrmContext()) {
                    if (!Bitrix24Handler.matchesContactPhone(phone)) {
                        return "continue";
                    }
                }
                var translateY = (start + k) * _4_Sorter.Sorter.config.contactHeight;
                k++;
                var open_1 = chatOpenSubscriber === phone ? ' show_subscriber' : '';
                var work_alien = '';
                if (Contacts.work_alien.hasOwnProperty(phone))
                    work_alien = ' work_alien';
                var work_my = '';
                if (Contacts.work_my.hasOwnProperty(phone))
                    work_my = ' work_my';
                var awaitOperator = Contacts.work_await.hasOwnProperty(phone) && work_alien === '' && work_my === '';
                var ai_handoff = awaitOperator ? ' ai_handoff' : '';
                var aiHandoffLabel = awaitOperator
                    ? "<span class=\"label label-warning ai_handoff_label\" title=\"".concat(escapeHtml(Chat.l('ИИ поговорил с клиентом и передал чат в общую очередь — возьмите его в работу')), "\"><i class=\"fa fa-robot\"></i> ").concat(escapeHtml(Chat.l('ИИ: нужен оператор')), "</span>")
                    : '';
                if (Contacts.data.hasOwnProperty(phone)) {
                    if (chatOpenSubscriber === phone) {
                        var hasNoRead = Contacts.no_read[chatOpenSubscriber];
                        var isNoReadDefined = typeof hasNoRead !== 'undefined';
                        var hasWorkMy = typeof Contacts.work_my[chatOpenSubscriber] !== 'undefined';
                        var isWhatsappGroup = ((_a = Contacts.data[phone]) === null || _a === void 0 ? void 0 : _a.transport) === 'whatsapp_group';
                        if (isNoReadDefined && (hasWorkMy || isWhatsappGroup)) {
                            $('.mark_as_read').removeClass('hidden');
                        }
                        else {
                            $('.mark_as_read').addClass('hidden');
                        }
                    }
                    var _g = Chat.getContactPresentationData({
                        phone: phone,
                        transport: (_b = Contacts.data[phone]) === null || _b === void 0 ? void 0 : _b.transport,
                        name: (_c = Contacts.data[phone]) === null || _c === void 0 ? void 0 : _c.name,
                        name_custom: (_d = Contacts.data[phone]) === null || _d === void 0 ? void 0 : _d.name_custom,
                        insta_login: (_e = Contacts.data[phone]) === null || _e === void 0 ? void 0 : _e.insta_login,
                        telegram_login: (_f = Contacts.data[phone]) === null || _f === void 0 ? void 0 : _f.telegram_login,
                    }), contactIcon = _g.contactIcon, contactName = _g.contactName, contactPhone = _g.contactPhone;
                    html +=
                        "<li data-phone=\"".concat(phoneEscaped, "\" data-i18n-user-content class=\"contact_item ").concat(open_1).concat(work_alien).concat(work_my).concat(ai_handoff, "\" ") +
                            " style=\"transform: translateY(".concat(translateY, "px); transition: none 0s ease 0s;\" ") +
                            " onclick=\"_7_Chat.Chat.click_open_subscriber({phone:this.getAttribute('data-phone'),call_from:'Sorter|subscribers_list'})\">" +
                            "<i class=\"".concat(contactIcon, "\"></i> <b>") +
                            (contactName !== null ? contactName : '') +
                            '</b> ' +
                            contactPhone +
                            aiHandoffLabel +
                            ' <span class="no_read_kol">' +
                            (item.noread !== undefined && item.noread > 0 ? item.noread : '') +
                            '</span></li>';
                }
                else {
                    Contacts.data_get({ phone: phone, dop_data: item }, function (user, dop_item) {
                        var _a, _b, _c, _d, _e;
                        var _f = _7_Chat.Chat.getContactPresentationData({
                            phone: user.phone,
                            transport: (_a = Contacts.data[user.phone]) === null || _a === void 0 ? void 0 : _a.transport,
                            name: (_b = Contacts.data[user.phone]) === null || _b === void 0 ? void 0 : _b.name,
                            name_custom: (_c = Contacts.data[user.phone]) === null || _c === void 0 ? void 0 : _c.name_custom,
                            insta_login: (_d = Contacts.data[user.phone]) === null || _d === void 0 ? void 0 : _d.insta_login,
                            telegram_login: (_e = Contacts.data[user.phone]) === null || _e === void 0 ? void 0 : _e.telegram_login,
                        }), contactIcon = _f.contactIcon, contactName = _f.contactName, contactPhone = _f.contactPhone;
                        findContactItemByPhone(user.phone).html("<i class=\"".concat(contactIcon, "\"></i> <b>") +
                            (contactName !== null ? contactName : '') +
                            "</b> " +
                            contactPhone +
                            aiHandoffLabel +
                            " <span class=\"no_read_kol\">" +
                            (dop_item !== undefined && dop_item.noread !== undefined && dop_item.noread > 0
                                ? dop_item.noread
                                : '') +
                            '</span>');
                    }, function (_data) {
                        findContactItemByPhone(phone).html('');
                        _4_Sorter.Sorter._lastSubscribersHtml = null;
                        setTimeout(function () {
                            Contacts.category_noread_load(function () {
                                _4_Sorter.Sorter.load();
                            });
                        }, 1000);
                    });
                    html += "<li data-phone=\"".concat(phoneEscaped, "\" data-i18n-user-content class=\"contact_item ").concat(open_1).concat(work_alien).concat(work_my).concat(ai_handoff, "\" style=\"transform: translateY(").concat(translateY, "px); transition: none 0s ease 0s;\" onclick=\"_7_Chat.Chat.click_open_subscriber({phone:this.getAttribute('data-phone'),call_from:'Sorter|subscribers_list_spinner'})\">");
                    html += "<i class=\"fa fa-spinner fa-spin\"></i>";
                    html += "</li>";
                }
            };
            for (var key in sorts) {
                _loop_1(key);
            }
            _4_Sorter.Sorter._renderedTop = start * _4_Sorter.Sorter.config.contactHeight;
            _4_Sorter.Sorter._renderedBottom = (start + k) * _4_Sorter.Sorter.config.contactHeight;
            _4_Sorter.Sorter.loadingSync();
            if (_4_Sorter.Sorter._lastSubscribersHtml === html) {
                callbackFn();
                return;
            }
            _4_Sorter.Sorter._lastSubscribersHtml = html;
            var promiseLike = $.when($('#chat_subscribers').html(html));
            {
                if (typeof promiseLike.then === 'function') {
                    promiseLike.then(function () {
                        callbackFn();
                    });
                    return;
                }
            }
            callbackFn();
        },
    };
    if (typeof Bitrix24Handler !== 'undefined') {
        Bitrix24Handler.onReady(function (ctx) {
            console.log('[Sorter] Bitrix24 Context Ready, reloading list...', ctx);
            _4_Sorter.Sorter.load();
        });
    }
})(_4_Sorter || (_4_Sorter = {}));


"use strict";
var _5_Contacts;
(function (_5_Contacts) {
    var ContactsCls = (function () {
        function ContactsCls() {
            this.data = {};
            this.sorts = [];
            this.sorts_temp = [];
            this.category = {};
            this.category_count = {};
            this.category_sort = [];
            this.category_noread = {};
            this.category_noread_items = function () {
                var list = _5_Contacts.Contacts.category_noread;
                if (Array.isArray(list))
                    return list;
                return Object.keys(list)
                    .map(function (id) { return list[id]; })
                    .filter(function (item) { return !!item; });
            };
            this.no_read = {};
            this.noread_by_phone = {};
            this.work_my = {};
            this.work_alien = {};
            this.work_alien_phone = null;
            this.work_ai = {};
            this.work_await = {};
            this.init = function () {
                var Chat = _7_Chat.Chat;
                if (typeof Bitrix24Handler !== 'undefined') {
                    Bitrix24Handler.onReady(function (ctx) {
                        var contactPhone = ctx.contactPhone;
                        if (ctx.isCrmPlacement && contactPhone) {
                            console.log('[Contacts] Bitrix24 Opening chat for', contactPhone);
                            setTimeout(function () {
                                Chat.click_open_subscriber({
                                    phone: contactPhone,
                                    call_from: 'Bitrix24|auto_open',
                                });
                            }, 500);
                        }
                    });
                }
                _5_Contacts.Contacts.category_noread_load(function () {
                    text_loader_update(Chat.l('Загрузка категорий...'));
                    var Sorter = _4_Sorter.Sorter;
                    _5_Contacts.Contacts.category_load(function () {
                        var _a;
                        var categ = _5_Contacts.Contacts.category_sort[0];
                        if (categ && ((_a = _5_Contacts.Contacts.category[categ]) === null || _a === void 0 ? void 0 : _a.h) === 0) {
                            Sorter.config.categ = categ;
                        }
                        text_loader_update(Chat.l('Загрузка чатов взятых в работу...'));
                        _5_Contacts.Contacts.work_load(1, function () {
                            var _a, _b;
                            var chat_update = localStorage.getItem('chat_update');
                            if (chat_update !== null && chat_update !== '') {
                                localStorage.setItem('chat_update', '');
                                setTimeout(function (phone) {
                                    Chat.click_open_subscriber({
                                        phone: phone,
                                        call_from: 'Contacts|init|localStorage_chat_update',
                                    });
                                }, 500, chat_update);
                            }
                            var url_params = Chat.url_hash();
                            if (url_params['phone']) {
                                setTimeout(function (phone) {
                                    Chat.click_open_subscriber({
                                        phone: phone,
                                        call_from: 'Contacts|init|url_hash_phone',
                                    });
                                }, 200, (_a = url_params['phone']) !== null && _a !== void 0 ? _a : '');
                            }
                            if (!url_params['phone']) {
                                var query = new URLSearchParams(window.location.search);
                                var queryPhone = (_b = query.get('phone')) === null || _b === void 0 ? void 0 : _b.replace(/^\+/, '');
                                if (queryPhone) {
                                    setTimeout(function (phone) {
                                        Chat.click_open_subscriber({
                                            phone: phone,
                                            call_from: 'Contacts|init|query_param_phone',
                                        });
                                    }, 200, queryPhone);
                                }
                            }
                            _5_Contacts.Contacts.category_open(Sorter.config.categ);
                            Chat.is_chat_loader({ contacts_init: true });
                        });
                    });
                });
            };
            this.data_get = function (_a, callback, error) {
                var phone = _a.phone, dop_data = _a.dop_data, cache = _a.cache;
                if (!phone || phone === 'false')
                    return;
                if (typeof cache === 'undefined')
                    cache = true;
                if (typeof callback !== 'function')
                    callback = function () { };
                if (typeof error !== 'function')
                    error = function () { };
                _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'contact_data_get',
                        phone: phone,
                        cache: cache,
                    },
                    before: function () { },
                    success: function (data) {
                        if (data.result === 0) {
                            _5_Contacts.Contacts.data[data.users.phone] = data.users;
                            _7_Chat.Chat.contactUpsertFromData(data.users.phone);
                            if (callback)
                                callback(data.users, dop_data);
                        }
                        else {
                            if (error)
                                error(data);
                        }
                    },
                    error: function (e) {
                        console.error('e', e);
                    },
                });
            };
            this.sort_up = function (phone, callback) {
                if (typeof phone === 'undefined')
                    return;
                if (typeof callback !== 'function')
                    callback = function () { };
                var temp = null;
                for (var key in _5_Contacts.Contacts.sorts) {
                    if (!_5_Contacts.Contacts.sorts[key]) {
                        continue;
                    }
                    var tmp = _5_Contacts.Contacts.sorts[key];
                    if (phone === tmp.phone) {
                        temp = tmp;
                        break;
                    }
                }
                if (temp == null)
                    return;
                var temp_sorts = [];
                temp_sorts.push(temp);
                for (var key2 in _5_Contacts.Contacts.sorts) {
                    var tmp = _5_Contacts.Contacts.sorts[key2];
                    if (!tmp) {
                        continue;
                    }
                    if (temp.phone !== tmp.phone) {
                        temp_sorts.push(tmp);
                    }
                }
                _5_Contacts.Contacts.sorts = temp_sorts;
                callback();
            };
            this.categoryVisibleCount = function (categoryId, userCountMs) {
                var _a;
                var total = Number(userCountMs);
                if (!Number.isFinite(total)) {
                    console.error('categoryVisibleCount|user_count_ms не число=', userCountMs);
                    return 0;
                }
                var categIdStr = String(categoryId);
                if (categIdStr === 'blocked')
                    return total;
                var inWork = 0;
                for (var phone in _5_Contacts.Contacts.work_my) {
                    if (!Object.prototype.hasOwnProperty.call(_5_Contacts.Contacts.work_my, phone))
                        continue;
                    if (categIdStr === '0') {
                        inWork++;
                        continue;
                    }
                    var categories = (_a = _5_Contacts.Contacts.data[phone]) === null || _a === void 0 ? void 0 : _a.category;
                    if (!Array.isArray(categories))
                        continue;
                    if (categories.some(function (c) { return String(c) === categIdStr; }))
                        inWork++;
                }
                var visible = total - inWork;
                return visible > 0 ? visible : 0;
            };
            this.category_noread_load = function (callback) {
                if (typeof callback !== 'function') {
                    callback = function () { };
                }
                var onLoaded = callback;
                _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'contact_category_noread_load',
                    },
                    before: function () { },
                    success: function (data) {
                        if (data.result === 0) {
                            _5_Contacts.Contacts.category_noread = data.category_noread;
                            var chatStoreForNoread = _7_Chat.Chat.Chat_Store;
                            if (chatStoreForNoread && chatStoreForNoread.isActive()) {
                                chatStoreForNoread
                                    .saveCategoryNoreadMetaPr({ noread: data.category_noread, saved_at: Date.now() })
                                    .catch(function (error) {
                                    console.error('category_noread_load|saveCategoryNoreadMetaPr|error=', error);
                                });
                            }
                            onLoaded();
                        }
                    },
                    error: function () { },
                });
            };
            this.category_load = function (callback) {
                if (typeof callback !== 'function') {
                    callback = function () { };
                }
                var onLoaded = callback;
                _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'contact_category_load',
                    },
                    before: function () { },
                    success: function (data) {
                        if (data.result !== 0) {
                            console.error('category_load|error|data=', data);
                            return;
                        }
                        _5_Contacts.Contacts.category = data.c;
                        _5_Contacts.Contacts.category_sort = data.s;
                        var chatStoreForCategories = _7_Chat.Chat.Chat_Store;
                        if (chatStoreForCategories && chatStoreForCategories.isActive()) {
                            chatStoreForCategories
                                .saveCategoriesMetaPr({ list: data.c, sort: data.s, saved_at: Date.now() })
                                .catch(function (error) {
                                console.error('category_load|saveCategoriesMetaPr|error=', error);
                            });
                        }
                        _5_Contacts.Contacts.category_render();
                        onLoaded();
                    },
                    error: function (error) {
                        console.error('contact_category_load|error=', error);
                    },
                });
            };
            this.category_render = function () {
                var _a;
                var Chat = _7_Chat.Chat;
                var Sorter = _4_Sorter.Sorter;
                var categ_item = "<li><a class=\"category-item\" href=\"#\" data-id=\"0\" title=\"".concat(Chat.l('Все'), "\" style=\"display:block; padding:3px 20px;\">") +
                    Chat.l('Все') +
                    " <small class=\"category-item-count item-0\"></small> " +
                    "<span class=\"no_read_kol category-item-noread-0\"></span>" +
                    "<span class=\"hidden btn btn-default btn-xs\"><i class=\"fas fa-envelope\"></i></span></a></li>";
                for (var key in _5_Contacts.Contacts.category_sort) {
                    var categId = _5_Contacts.Contacts.category_sort[key];
                    if (!categId)
                        continue;
                    if (((_a = _5_Contacts.Contacts.category[categId]) === null || _a === void 0 ? void 0 : _a.h) === 0) {
                        var categName = _1_Tasks.escapeHtml(_5_Contacts.Contacts.category[categId].n);
                        categ_item +=
                            "<li><a class=\"category-item\" href=\"#\" data-id=\"".concat(categId, "\" data-i18n-user-content title=\"").concat(categName, "\" style=\"display:block; padding:3px 20px;\">") +
                                categName +
                                " <small class=\"category-item-count item-".concat(categId, "\"></small> ") +
                                "<span class=\"no_read_kol category-item-noread-".concat(categId, "\"></span>") +
                                "<span class=\"hidden btn btn-default btn-xs\"><i class=\"fas fa-envelope\"></i></span></a></li>";
                    }
                }
                categ_item +=
                    "<li class=\"divider\" style=\"margin: 5px 0; border-bottom: 1px solid #e5e5e5;\"></li>" +
                        "<li><a class=\"category-item\" href=\"#\" data-id=\"blocked\" title=\"".concat(Chat.l('Заблокированные'), "\" style=\"display:block; padding:3px 20px;\">") +
                        "<i class=\"fa fa-ban\" style=\"margin-right:5px;color:#d9534f;\"></i>" +
                        Chat.l('Заблокированные') +
                        " <small class=\"category-item-count item-blocked\"></small> " +
                        "<span class=\"no_read_kol category-item-noread-blocked\"></span>" +
                        "<span class=\"hidden btn btn-default btn-xs\"><i class=\"fas fa-envelope\"></i></span></a></li>";
                var selectedCategory = _5_Contacts.Contacts.category[Sorter.config.categ];
                $('#chat_category_dropdown').html('<div class="dropdown">\n' +
                    "  <button class=\"btn btn-secondary dropdown-toggle\" type=\"button\" id=\"dropdownCateg\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" title=\"".concat(Chat.l('Все'), "\">\n") +
                    '    <i class="fa fa-align-justify" aria-hidden="true"></i> <span id="dropdownCategName" data-i18n-user-content>' +
                    (Sorter.config.categ === '0'
                        ? Chat.l('Все')
                        : Sorter.config.categ === 'blocked'
                            ? Chat.l('Заблокированные')
                            : selectedCategory
                                ? _1_Tasks.escapeHtml(selectedCategory.n)
                                : Chat.l('Все')) +
                    " <small class=\"category-item-count item-".concat(Sorter.config.categ, "\"></small></span>") +
                    " <span class=\"no_read_kol category-item-noread-".concat(Sorter.config.categ, "\"></span> ") +
                    '    <span class="caret"></span>' +
                    '  </button>\n' +
                    '  <ul class="dropdown-menu" aria-labelledby="dropdownCateg">' +
                    categ_item +
                    '</ul>\n' +
                    '</div>');
                var currentCateg = String(Sorter.config.categ);
                var nav_item = '';
                nav_item +=
                    "<li class=\"chat-categ-section\" data-section=\"funnel\">" +
                        "<i class=\"fa fa-caret-down section-arrow\"></i> " +
                        Chat.l('Воронка') +
                        "</li>";
                var funnelItems = [
                    { id: 'funnel_new', icon: 'fa fa-plus-circle', label: Chat.l('Новые') },
                    {
                        id: 'funnel_confirmed',
                        icon: 'fa fa-check-circle',
                        label: Chat.l('Сделано подтверждение'),
                    },
                    { id: 'funnel_in_progress', icon: 'fa fa-spinner', label: Chat.l('В работе') },
                    { id: 'funnel_success', icon: 'fa fa-trophy', label: Chat.l('Успех') },
                    { id: 'funnel_rejected', icon: 'fa fa-times-circle', label: Chat.l('Отказ') },
                ];
                nav_item += "<div class=\"chat-categ-section-items\" data-section=\"funnel\">";
                for (var _i = 0, funnelItems_1 = funnelItems; _i < funnelItems_1.length; _i++) {
                    var fi = funnelItems_1[_i];
                    nav_item +=
                        "<li class=\"chat-categ-nav-item subitem".concat(currentCateg === fi.id ? ' active' : '', "\" data-id=\"").concat(fi.id, "\">") +
                            "<i class=\"".concat(fi.icon, "\"></i> ") +
                            fi.label +
                            " <small class=\"category-item-count item-".concat(fi.id, "\"></small>") +
                            "<span class=\"no_read_kol category-item-noread-".concat(fi.id, "\"></span>") +
                            "</li>";
                }
                nav_item += "</div>";
                nav_item +=
                    "<li class=\"chat-categ-section\" data-section=\"smart\">" +
                        "<i class=\"fa fa-caret-down section-arrow\"></i> " +
                        Chat.l('Смарт-фильтры') +
                        "</li>";
                nav_item += "<div class=\"chat-categ-section-items\" data-section=\"smart\">";
                nav_item +=
                    "<li class=\"chat-categ-nav-item subitem".concat(currentCateg === 'smart_open' ? ' active' : '', "\" data-id=\"smart_open\">") +
                        "<i class=\"fa fa-folder-open\"></i> " +
                        Chat.l('Открытые') +
                        " <small class=\"category-item-count item-smart_open\"></small>" +
                        "<span class=\"no_read_kol category-item-noread-smart_open\"></span>" +
                        "</li>";
                nav_item += "</div>";
                $('#chat_category').html('<ul class="chat-categ-nav">' + nav_item + '</ul>');
                _5_Contacts.Contacts.print_tab_noread();
            };
            this.category_save = function (e) {
                var savedCategory = e ? _5_Contacts.Contacts.category[e.id] : undefined;
                if (e && savedCategory) {
                    savedCategory.r = e.visible ? 1 : 0;
                }
                _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'contact_category_save',
                        category: _5_Contacts.Contacts.category,
                        sort: _5_Contacts.Contacts.category_sort,
                    },
                    before: function () { },
                    success: function (data) {
                        if (data.result === 0) {
                            _5_Contacts.Contacts.category_load(function () {
                                _4_Sorter.Sorter.load();
                            });
                            $('#modal_setting').modal('hide');
                        }
                    },
                    error: function () { },
                });
            };
            this.category_open = function (categ) {
                if (categ === undefined)
                    categ = 0;
                var Sorter = _4_Sorter.Sorter;
                Sorter.config.categ = categ;
                if (categ === 'take_to_work') {
                    $('#chat_subscribers').height(Object.keys(_5_Contacts.Contacts.work_my).length * Sorter.config.contactHeight);
                    Sorter.load(function () {
                        setTimeout(function () {
                            $('.sidebar').nanoScroller();
                        }, 500);
                    });
                    return;
                }
                if (categ === 'my_chats') {
                    var myCount_1 = Object.keys(_5_Contacts.Contacts.work_my).length;
                    $('#chat_subscribers').height(myCount_1 * Sorter.config.contactHeight);
                    Sorter.load(function () {
                        $(".category-item-count.item-my_chats").html("(".concat(myCount_1, ")"));
                        $('.chat-categ-nav-item').removeClass('active');
                        $('#dropdownCateg').html('<i class="fa fa-align-justify" aria-hidden="true"></i> ' +
                            $('.category-item[data-id="my_chats"]').html() +
                            ' <span class="caret" style="float: right; margin-top: 8px;"></span>');
                        setTimeout(function () {
                            $('.sidebar').nanoScroller();
                        }, 500);
                    });
                    return;
                }
                var applyCategoryCount = function (kol) {
                    var visibleKol = _5_Contacts.Contacts.categoryVisibleCount(categ, kol);
                    $('#chat_subscribers').height(visibleKol * Sorter.config.contactHeight);
                    var categIdStr = String(categ);
                    $(".category-item-count.item-".concat(categIdStr)).html("(".concat(visibleKol, ")"));
                    Sorter.load(function () {
                        $('.chat-categ-nav-item').removeClass('active');
                        $(".chat-categ-nav-item[data-id=\"".concat(categ, "\"]")).addClass('active');
                        var dropdownContent = $('.category-item[data-id="' + categ + '"]').html();
                        if (dropdownContent) {
                            $('#dropdownCateg').html('<i class="fa fa-align-justify" aria-hidden="true"></i> ' +
                                dropdownContent +
                                ' <span class="caret" style="float: right; margin-top: 8px;"></span>');
                        }
                        setTimeout(function () {
                            $('.sidebar').nanoScroller();
                        }, 500);
                    });
                };
                var Chat = _7_Chat.Chat;
                if (Chat.offlineCacheReady() && Chat.Chat_Store) {
                    Chat.Chat_Store.getContactsPagePr({ categ: String(categ), start: 0, limit: 0 })
                        .then(function (pageData) {
                        applyCategoryCount(pageData.total);
                    })
                        .catch(function (error) {
                        console.error('category_open|offline|error=', error);
                    });
                    return;
                }
                _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'number_contacts_in_category',
                        categ: categ,
                    },
                    before: function () { },
                    success: function (data) {
                        if (data.result === 0) {
                            applyCategoryCount(data.kol);
                        }
                    },
                    error: function () { },
                });
            };
            this.no_read_set = function (data) {
                var _a;
                if (!_5_Contacts.Contacts.data.hasOwnProperty(data.ph_numb)) {
                    _5_Contacts.Contacts.data_get({ phone: data.ph_numb }, function () {
                        if (data.k === undefined)
                            data.k = 0;
                        data.k++;
                        if (data.k > 20)
                            return;
                        setTimeout(function () {
                            _5_Contacts.Contacts.category_noread_load(function () {
                                _5_Contacts.Contacts.no_read_set(data);
                            });
                        }, 200);
                    }, function (error) {
                        console.error(error);
                    });
                    return;
                }
                var Chat = _7_Chat.Chat;
                if (((_a = _5_Contacts.Contacts.data[data.ph_numb]) === null || _a === void 0 ? void 0 : _a.transport) === 'whatsapp_biz') {
                    _5_Contacts.Contacts.waba_status_check(data.ph_numb, function (color) {
                        console.log(color);
                        console.log(!color || !!color.b);
                        if (!color || !!color.b)
                            return;
                        _5_Contacts.Contacts.data_get({ phone: data.ph_numb, cache: false }, function () {
                            console.log('но кеш');
                            if (Chat.chat_view_subscriber === data.ph_numb) {
                                _5_Contacts.Contacts.render_waba_status(data.ph_numb);
                            }
                        }, function (error) {
                            console.error(error);
                        });
                    });
                }
                _5_Contacts.Contacts.category_noread = data.category;
                _1_Tasks.Tasks['sorter_load'] = true;
                _5_Contacts.Contacts.print_tab_noread();
                if (typeof Chat.toastr_mass[data.ph_numb] === 'undefined') {
                    if (Object.keys(Chat.toastr_mass).length > 8)
                        return;
                    if (Chat.operator_data.chat_notyfi_new_message_off !== 1) {
                        Chat.toastr_mass[data.ph_numb] = 1;
                        toastr.options.onclick = function () {
                            Chat.click_open_subscriber({
                                phone: {
                                    data: function (e) {
                                        if (e === 'phone')
                                            return data.ph_numb;
                                        return undefined;
                                    },
                                },
                                call_from: 'Contacts|noread|toastr_new_inbox',
                            });
                        };
                        toastr.options.closeButton = true;
                        toastr.success('Новое входящее сообщение.');
                        toastr.options.onHidden = function () {
                            delete Chat.toastr_mass[data.ph_numb];
                        };
                    }
                    var ipcRendererInstance = window
                        .ipcRenderer;
                    if (ipcRendererInstance && typeof ipcRendererInstance.on === 'function') {
                        ipcRendererInstance.on('asynchronous-reply', function (_event, arg) {
                            if (typeof arg !== 'object' || arg === null || Array.isArray(arg))
                                return;
                            var phone = arg['phone'];
                            if (typeof phone !== 'string' || phone === '')
                                return;
                            Chat.click_open_subscriber({
                                phone: phone,
                                call_from: 'Contacts|ipc|asynchronous-reply',
                            });
                        });
                        ipcRendererInstance.send('asynchronous-message', {
                            notyfi: 'MessageBeep',
                            phone: data.ph_numb,
                        });
                    }
                    else if (Chat.win_programm_version()) {
                        console.log('MessageBeep');
                        console.log('{"notyfi":"MessageBeep","phone":"' + data.ph_numb + '"}');
                        if (Chat.operator_data.chat_audio_notyfi_new_message_off !== 1) {
                            Chat.audio_play();
                        }
                        if (typeof Android !== 'undefined' && typeof (Android === null || Android === void 0 ? void 0 : Android.getNotify) === 'function') {
                            Android.getNotify();
                        }
                    }
                    else {
                        if (Chat.operator_data.chat_audio_notyfi_new_message_off !== 1) {
                            Chat.audio_play();
                        }
                        console.log('MessageBeep');
                        notifyMe(data.ph_numb);
                        if (typeof Android !== 'undefined' && typeof (Android === null || Android === void 0 ? void 0 : Android.getNotify) === 'function') {
                            Android.getNotify();
                        }
                    }
                    setTimeout(function () {
                        delete Chat.toastr_mass[data.ph_numb];
                    }, 1000);
                }
                if (Chat.chat_view_subscriber && String(data.ph_numb) === String(Chat.chat_view_subscriber)) {
                    Chat.messages_get({
                        phone: String(Chat.chat_view_subscriber),
                        direction: 'DOWN',
                    });
                }
            };
            this.no_read_del = function (phone) {
                delete _5_Contacts.Contacts.no_read[phone];
                _5_Contacts.Contacts.category_noread_load(function () {
                    _1_Tasks.Tasks['sorter_load'] = true;
                });
                if (_7_Chat.Chat.chat_open_subscriber === phone) {
                    $('.message_inbox').removeClass('no-read');
                    $('.mark_as_read').addClass('hidden');
                }
            };
            this.no_read_check = function (phone) {
                _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'contact_no_read_check',
                        phone: phone,
                    },
                    before: function () { },
                    success: function (data) {
                        if (data && data.result === 0 && data.phone) {
                            if (_7_Chat.Chat.chat_open_subscriber === data.phone ||
                                String(_7_Chat.Chat.chat_open_subscriber) === data.phone) {
                                $('.message_inbox').removeClass('no-read');
                                $('.mark_as_read').addClass('hidden');
                                delete _5_Contacts.Contacts.no_read[data.phone];
                            }
                        }
                    },
                    error: function () { },
                });
            };
            this.work_load = function (page, callback) {
                if (typeof page === 'undefined') {
                    page = 1;
                }
                if (typeof callback !== 'function')
                    callback = function () { };
                var onLoaded = callback;
                if (page === 1) {
                    _5_Contacts.Contacts.work_my = {};
                    _5_Contacts.Contacts.work_alien = {};
                    _5_Contacts.Contacts.work_ai = {};
                    _5_Contacts.Contacts.work_await = {};
                }
                _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'contact_work_load',
                        page: page,
                    },
                    before: function () { },
                    success: function (data) {
                        if (data.result === 0) {
                            if (data.w_await) {
                                _5_Contacts.Contacts.work_await = data.w_await;
                            }
                            if (data.page !== 'end') {
                                _5_Contacts.Contacts.work_my = $.extend(_5_Contacts.Contacts.work_my, data.w_my);
                                _5_Contacts.Contacts.work_alien = $.extend(_5_Contacts.Contacts.work_alien, data.w_alien);
                                if (data.w_ai) {
                                    _5_Contacts.Contacts.work_ai = $.extend(_5_Contacts.Contacts.work_ai, data.w_ai);
                                }
                                for (var phone in data.w_alien) {
                                    var w = data.w_alien[phone];
                                    if (w && w.op_n === _0_Constants.AI_ASSISTANT_NAME) {
                                        _5_Contacts.Contacts.work_ai[phone] = true;
                                    }
                                }
                                _5_Contacts.Contacts.work_load(data.page, onLoaded);
                            }
                            else {
                                var chatStoreForWorks = _7_Chat.Chat.Chat_Store;
                                if (chatStoreForWorks && chatStoreForWorks.isActive()) {
                                    chatStoreForWorks
                                        .saveWorksMetaPr({
                                        work_my: _5_Contacts.Contacts.work_my,
                                        work_alien: _5_Contacts.Contacts.work_alien,
                                        work_ai: _5_Contacts.Contacts.work_ai,
                                        work_await: _5_Contacts.Contacts.work_await,
                                        saved_at: Date.now(),
                                    })
                                        .catch(function (error) {
                                        console.error('work_load|saveWorksMetaPr|error=', error);
                                    });
                                }
                                onLoaded();
                            }
                        }
                    },
                    error: function (e) {
                        console.error('Contacts.work_load|error=', e);
                    },
                });
            };
            this.print_tab_noread = function () { };
            this.forward_phones = function (page, search_text, callback) {
                if (page === undefined)
                    page = 1;
                if (search_text === undefined)
                    search_text = '';
                _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'forward_phones',
                        page: page,
                        search_text: search_text,
                    },
                    before: function () { },
                    success: function (data) {
                        data.page = page;
                        callback(data);
                    },
                    error: function () {
                        callback({ result: 1 });
                    },
                });
            };
            this.waba_status_time = null;
            this.waba_status = function (time) {
                var tc = Math.floor(Date.now() / 1000);
                var t1 = 86400;
                var t2 = 86100;
                if (time === null)
                    return { b: false, c: '#dd4b39' };
                if (time === undefined)
                    return { b: true, c: '#00a65a' };
                if (tc - time > t1)
                    return { b: false, c: '#dd4b39' };
                if (tc - time > t2)
                    return { b: true, c: '#ff9800' };
                return { b: true, c: '#00a65a' };
            };
            this.waba_status_check = function (phone, cb) {
                if (_5_Contacts.Contacts.waba_status_time !== null)
                    clearTimeout(_5_Contacts.Contacts.waba_status_time);
                if (_5_Contacts.Contacts.data[phone] && _7_Chat.Chat.chat_view_subscriber === phone) {
                    var _a = _5_Contacts.Contacts.data[phone], transport = _a.transport, inbox_time = _a.inbox_time;
                    if (transport !== 'whatsapp_biz') {
                        return cb(false);
                    }
                    cb(_5_Contacts.Contacts.waba_status(inbox_time));
                    _5_Contacts.Contacts.waba_status_time = setTimeout(function () {
                        _5_Contacts.Contacts.waba_status_check(phone, cb);
                    }, 100000);
                }
            };
            this.render_waba_status = function (phone) {
                $('#chat_transport i').html('');
                _5_Contacts.Contacts.waba_status_check(phone, function (color) {
                    if (!color)
                        return;
                    $('#chat_transport i').html("<span style=\"color:".concat(color.c, "; font-size: 60px;position: absolute; top:-48px;left: -10px;\">.</span>"));
                });
            };
            this.instagram2_check = function (phone) {
                var Chat = _7_Chat.Chat;
                var contact = _5_Contacts.Contacts.data[phone];
                if (!contact || !contact.transport || contact.transport !== 'instagram')
                    return false;
                if (!Chat.operator_data.channel || !Chat.operator_data.channel.instagram2)
                    return false;
                if (!contact.sp_numb || !Chat.operator_data.channel.instagram2[contact.sp_numb])
                    return false;
                return true;
            };
        }
        return ContactsCls;
    }());
    _5_Contacts.Contacts = new ContactsCls();
})(_5_Contacts || (_5_Contacts = {}));


"use strict";
var _6_FileUpload;
(function (_6_FileUpload) {
    _6_FileUpload.FileUpload = {
        chatInitCheck: false,
        chatInit: function () {
            'use strict';
            var centralUserId = _7_Chat.Chat.operator_data.central_user_id;
            if (centralUserId === undefined) {
                console.error('FileUpload.chatInit|данные оператора ещё не загружены');
                return;
            }
            var fileupload3 = $('#fileupload3');
            if (_6_FileUpload.FileUpload.chatInitCheck) {
                fileupload3.fileupload('destroy');
            }
            _6_FileUpload.FileUpload.chatInitCheck = true;
            fileupload3
                .fileupload({
                url: "/files-uploader/upload",
                dataType: 'json',
                formData: (function () {
                    var subscriberRaw = _7_Chat.Chat.chat_view_subscriber;
                    if (typeof subscriberRaw === 'string') {
                        return {
                            central_user_id: centralUserId,
                            ph_numb: subscriberRaw,
                        };
                    }
                    if (subscriberRaw) {
                        console.warn('FileUpload.chatInit: chat_view_subscriber имеет неожиданный тип', subscriberRaw);
                        return {
                            central_user_id: centralUserId,
                            ph_numb: String(subscriberRaw),
                        };
                    }
                    return {
                        central_user_id: centralUserId,
                        ph_numb: '',
                    };
                })(),
                autoUpload: false,
                disableImageResize: false,
                previewCrop: true,
                imageMaxHeight: 4000,
                imageMaxWidth: 4000,
                maxNumberOfFiles: 1,
                process: [],
                add: function (_e, data) {
                    var self = $(this);
                    if (_7_Chat.Chat.chat_open_subscriber) {
                        _7_Chat.Chat.list_images_show();
                        data
                            .process(function () {
                            return self.fileupload('process', data);
                        })
                            .done(function () {
                            data.submit();
                        });
                    }
                },
                start: function () {
                    $('#progress2 .progress-bar2').css('width', '0%');
                },
                done: function (_e, data) {
                    if (data.result.result === 0) {
                        var chat_view_subscriber = _7_Chat.Chat.chat_view_subscriber;
                        var fileExt_1 = data.result.fileExt.toLowerCase();
                        if (fileExt_1 !== 'jpeg' &&
                            fileExt_1 !== 'jpg' &&
                            fileExt_1 !== 'png' &&
                            fileExt_1 !== 'gif' &&
                            fileExt_1 !== 'webp') {
                            var normalizedSubscriber = '';
                            if (typeof chat_view_subscriber === 'string') {
                                normalizedSubscriber = chat_view_subscriber;
                            }
                            else if (chat_view_subscriber) {
                                console.warn('FileUpload.chatInit: chat_view_subscriber для проверки демо-режима имеет неожиданный тип', chat_view_subscriber);
                                normalizedSubscriber = String(chat_view_subscriber);
                            }
                            if (_7_Chat.Chat.operator_data.account_test &&
                                normalizedSubscriber === '77470942848') {
                                _7_Chat.Chat.click_img_delete2(data.result.fileUrl);
                                swal({
                                    icon: 'error',
                                    title: 'Ошибка!',
                                    text: 'В демо режиме разрешена отправка только изображений в Тех. поддержку.',
                                });
                                return;
                            }
                        }
                        _6_FileUpload.FileUpload.fileNormalize({ url: data.result.fileUrl, ext: fileExt_1 }, function (e) {
                            if (fileExt_1 === 'oga')
                                data.result.fileUrl = e.url;
                            var prependResult = $('#list_images_body').prepend('<div class="p_load image_item" data-file_url="' +
                                data.result.fileUrl +
                                '">\n' +
                                ' <button class="btn btn-default btn-xs pull-right image_item_delete" data-file_url="' +
                                data.result.fileUrl +
                                '">' +
                                '  <i class="fas fa-trash-alt"></i></button> ' +
                                e.html +
                                '</div>');
                            var whenResult = $.when(prependResult);
                            if (typeof whenResult.then === 'function') {
                                whenResult.then(function () {
                                    $('.message_send_button').removeClass('hidden');
                                    $('#audio_message_record').addClass('hidden');
                                    if (data.result.message_sound) {
                                        $('#chat_message_send').click();
                                    }
                                });
                            }
                        });
                        $('#progress2 .progress-bar2').css('width', '0%');
                    }
                    else {
                        toastr.options.closeButton = true;
                        if (data.result.result_description) {
                            toastr.error(data.result.result_description);
                        }
                        else {
                            console.error('FileUpload.chatInit|done|нет result_description=', data.result);
                        }
                        $('#progress2 .progress-bar2').css('width', '0%');
                    }
                },
                fail: function (_e, data) {
                    console.log('fail|e=', _e);
                    console.log('fail|data=', data);
                    console.log('fail|data.errorThrown=', data.errorThrown);
                    toastr.options.closeButton = true;
                    if ((data === null || data === void 0 ? void 0 : data.errorThrown) == 'Bad Gateway') {
                        toastr.error('Не удалось загрузить файл: сервер не доступен. Попробуйте еще раз');
                    }
                    else {
                        toastr.error('Не удалось загрузить файл. Попробуйте еще раз');
                    }
                    $('#progress2 .progress-bar2').css('width', '0%');
                },
                progressall: function (_e, data) {
                    var progress = parseInt(String((data.loaded / data.total) * 100), 10);
                    $('#progress2 .progress-bar2').css('width', progress + '%');
                },
            })
                .prop('disabled', !$.support.fileInput)
                .parent()
                .addClass($.support.fileInput ? '' : 'disabled');
        },
        quickMessagesInitCheck: false,
        quickMessagesInit: function () {
            'use strict';
            var centralUserId = _7_Chat.Chat.operator_data.central_user_id;
            if (centralUserId === undefined) {
                console.error('FileUpload.quickMessagesInit|данные оператора ещё не загружены');
                return;
            }
            var fileupload4 = $('#fileupload_quick_messages');
            if (_6_FileUpload.FileUpload.quickMessagesInitCheck) {
                fileupload4.fileupload('destroy');
            }
            _6_FileUpload.FileUpload.quickMessagesInitCheck = true;
            fileupload4
                .fileupload({
                url: _7_Chat.Chat.chatoperator + '/fileupload',
                dataType: 'json',
                formData: {
                    central_user_id: centralUserId,
                    ph_numb: 'quickMessages',
                },
                autoUpload: false,
                disableImageResize: false,
                previewCrop: true,
                imageMaxHeight: 4000,
                imageMaxWidth: 4000,
                process: [],
                add: function (_e, data) {
                    var self = $(this);
                    data
                        .process(function () {
                        return self.fileupload('process', data);
                    })
                        .done(function () {
                        data.submit();
                    });
                },
                start: function () {
                    $('#progress4 .progress-bar4').css('width', '0%').parent().show();
                },
                done: function (_e, data) {
                    if (data.result.result === 0) {
                        var fileExt = data.result.fileExt.toLowerCase();
                        _6_FileUpload.FileUpload.fileNormalize({ url: data.result.fileUrl, ext: fileExt }, function (e) {
                            $('#quick_message_files').append("<div class=\"p_load image_item\" data-file_url=\"".concat(data.result.fileUrl, "\">") +
                                "<button class=\"btn btn-default btn-xs pull-right image_item_delete\" data-file_url=\"".concat(data.result.fileUrl, "\">") +
                                "<i class=\"fas fa-trash-alt\"></i></button>".concat(e.html, "</div>"));
                        });
                        $('#progress4 .progress-bar4').css('width', '0%').parent().hide();
                    }
                    else {
                        toastr.options.closeButton = true;
                        if (data.result.result_description) {
                            toastr.error(data.result.result_description);
                        }
                        else {
                            console.error('FileUpload.quickMessagesInit|done|нет result_description=', data.result);
                        }
                        $('#progress4 .progress-bar4').css('width', '0%').parent().hide();
                    }
                },
                fail: function (_e, data) {
                    $('#progress4 .progress-bar4').css('width', '0%').parent().hide();
                    toastr.options.closeButton = true;
                    if ((data === null || data === void 0 ? void 0 : data.errorThrown) == 'Bad Gateway') {
                        toastr.error('Не удалось загрузить файл: сервер не доступен. Попробуйте еще раз');
                    }
                    else {
                        toastr.error('Не удалось загрузить файл. Попробуйте еще раз');
                    }
                },
                progressall: function (_e, data) {
                    var progress = parseInt(String((data.loaded / data.total) * 100), 10);
                    $('#progress4 .progress-bar4')
                        .css('width', progress + '%')
                        .css('height', '20px')
                        .parent()
                        .show();
                },
            })
                .prop('disabled', !$.support.fileInput)
                .parent()
                .addClass($.support.fileInput ? '' : 'disabled');
        },
        fileNormalize: function (_a, cb) {
            var url = _a.url, ext = _a.ext, t = _a.t;
            var files = '';
            if (t === undefined) {
                var _fnExt = ext ? ext.toLowerCase() : ext;
                switch (_fnExt ? _fnExt : 'none') {
                    case 'jpeg':
                    case 'jpg':
                    case 'png':
                    case 'gif':
                    case 'webp':
                        files =
                            '<img class="open_img imgload" onload="_7_Chat.Chat.imgload(this)" src="' +
                                _1_Tasks.escapeHtml(url) +
                                '">';
                        break;
                    case 'ppt':
                    case 'pptx':
                        files = '<i class="fa fa-file-powerpoint"></i>';
                        break;
                    case 'xls':
                    case 'xlsx':
                        files = '<i class="fa fa-file-excel"></i>';
                        break;
                    case 'doc':
                    case 'docx':
                        files = '<i class="fa fa-file-word"></i>';
                        break;
                    case 'pdf':
                        files = '<i class="fa fa-file-pdf"></i>';
                        break;
                    case 'mpeg':
                        files = '<i class="fa fa-file-video"></i>';
                        break;
                    case 'txt':
                        files = '<i class="fa fa-file-alt"></i>';
                        break;
                    case 'oga':
                        url = url.replace(new RegExp('.oga$'), '.mp3');
                        break;
                    default:
                        files = '<i class="fa fa-file"></i>';
                        break;
                }
                cb({ html: files, url: url });
                return;
            }
            console.warn('FileUpload.fileNormalize: параметр t не поддерживается', t);
        },
        cb_quickMessages: function () {
            $('#template_file_url').val('');
        },
    };
})(_6_FileUpload || (_6_FileUpload = {}));


"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _6_1_Chat_Store;
(function (_6_1_Chat_Store) {
    _6_1_Chat_Store.SERVER_PAGE_LIMIT = 20;
    _6_1_Chat_Store.HYDRATE_LIMIT = 30;
    _6_1_Chat_Store.CACHE_PAGE_LIMIT = 20;
    _6_1_Chat_Store.KEEP_MAX_PER_CONTACT = 300;
    _6_1_Chat_Store.MAX_RANGES = 2;
    _6_1_Chat_Store.PRUNE_CONTACT_AGE_MS = 60 * 24 * 60 * 60 * 1000;
    function toMessageStatus(status) {
        var text = String(status);
        if (text === '0' ||
            text === '1' ||
            text === '2' ||
            text === '3' ||
            text === '4' ||
            text === '5') {
            return text;
        }
        return Number(status);
    }
    _6_1_Chat_Store.toMessageStatus = toMessageStatus;
    _6_1_Chat_Store.OUTBOX_CLAIM_STALE_MS = 60 * 1000;
    function cloneState(prev, phone, nowMs) {
        if (!prev) {
            return { ph_numb: phone, ranges: [], history_complete: 0, updated_at: nowMs };
        }
        return {
            ph_numb: phone,
            ranges: prev.ranges.map(function (r) {
                return { min: r.min, max: r.max };
            }),
            history_complete: prev.history_complete,
            updated_at: nowMs,
        };
    }
    function normalizeRanges(state, purge) {
        state.ranges.sort(function (a, b) {
            return b.max - a.max;
        });
        var merged = [];
        for (var _i = 0, _a = state.ranges; _i < _a.length; _i++) {
            var r = _a[_i];
            var last = merged[merged.length - 1];
            if (last && r.max >= last.min - 1) {
                last.min = Math.min(last.min, r.min);
            }
            else {
                merged.push({ min: r.min, max: r.max });
            }
        }
        while (merged.length > _6_1_Chat_Store.MAX_RANGES) {
            var dropped = merged.pop();
            if (dropped) {
                purge.push(dropped);
                state.history_complete = 0;
            }
        }
        state.ranges = merged;
    }
    function applyServerBatch(prev, phone, meta, batchMin, batchMax, batchLen, nowMs) {
        var purge = [];
        var state = cloneState(prev, phone, nowMs);
        var head = state.ranges[0];
        if (batchMin === null || batchMax === null || batchLen === 0) {
            if (meta.direction === 'UP' &&
                head &&
                meta.requestedMinId !== null &&
                meta.requestedMinId >= head.min &&
                meta.requestedMinId <= head.max) {
                state.history_complete = 1;
            }
            return { state: state, purge: purge };
        }
        var full = meta.pageFull;
        if (meta.direction === 'DOWN') {
            if (!head) {
                state.ranges = [{ min: batchMin, max: batchMax }];
                if (meta.requestedMaxId === null && !full) {
                    state.history_complete = 1;
                }
            }
            else if (meta.requestedMaxId === null) {
                if (batchMin <= head.max + 1) {
                    head.min = Math.min(head.min, batchMin);
                    head.max = Math.max(head.max, batchMax);
                }
                else if (!full) {
                    for (var _i = 0, _a = state.ranges; _i < _a.length; _i++) {
                        var r = _a[_i];
                        purge.push(r);
                    }
                    state.ranges = [{ min: batchMin, max: batchMax }];
                    state.history_complete = 1;
                }
                else {
                    state.ranges.unshift({ min: batchMin, max: batchMax });
                }
            }
            else {
                var anchored = meta.requestedMaxId <= head.max;
                if (batchMin <= head.max + 1 || (anchored && !full)) {
                    head.min = Math.min(head.min, batchMin);
                    head.max = Math.max(head.max, batchMax);
                }
                else {
                    state.ranges.unshift({ min: batchMin, max: batchMax });
                }
            }
        }
        else {
            var anchorId = meta.requestedMinId;
            if (anchorId !== null) {
                var target = null;
                for (var _b = 0, _c = state.ranges; _b < _c.length; _b++) {
                    var r = _c[_b];
                    if (anchorId >= r.min && anchorId <= r.max) {
                        target = r;
                        break;
                    }
                }
                if (target) {
                    target.min = Math.min(target.min, batchMin);
                    if (!full) {
                        var keep = [];
                        for (var _d = 0, _e = state.ranges; _d < _e.length; _d++) {
                            var r = _e[_d];
                            if (r === target || r.max > target.max) {
                                keep.push(r);
                            }
                            else {
                                var purgeMax = Math.min(r.max, batchMin - 1);
                                if (purgeMax >= r.min)
                                    purge.push({ min: r.min, max: purgeMax });
                            }
                        }
                        state.ranges = keep;
                        state.history_complete = 1;
                    }
                }
            }
        }
        normalizeRanges(state, purge);
        return { state: state, purge: purge };
    }
    _6_1_Chat_Store.applyServerBatch = applyServerBatch;
    function applySentMessages(prev, phone, minId, maxId, nowMs) {
        var state = cloneState(prev, phone, nowMs);
        var head = state.ranges[0];
        if (!head) {
            state.ranges = [{ min: minId, max: maxId }];
        }
        else {
            head.max = Math.max(head.max, maxId);
            head.min = Math.min(head.min, minId);
        }
        return state;
    }
    _6_1_Chat_Store.applySentMessages = applySentMessages;
    function toCachedMessages(phone, messages) {
        var _a;
        var result = [];
        for (var _i = 0, messages_1 = messages; _i < messages_1.length; _i++) {
            var msg = messages_1[_i];
            var id = typeof msg.id === 'number' ? msg.id : Number((_a = msg.id) !== null && _a !== void 0 ? _a : msg._id);
            if (!Number.isFinite(id) || id <= 0)
                continue;
            var cached = __assign(__assign({}, msg), { id: id, cache_key: phone });
            for (var _b = 0, _c = Object.keys(cached); _b < _c.length; _b++) {
                var key = _c[_b];
                if (Reflect.get(cached, key) === undefined)
                    Reflect.set(cached, key, null);
            }
            result.push(cached);
        }
        return result;
    }
    _6_1_Chat_Store.toCachedMessages = toCachedMessages;
    var Chat_Store = (function () {
        function Chat_Store(operator_id) {
            var _this = this;
            this.db = null;
            this.messages = null;
            this.syncState = null;
            this.contactsSnapshot = null;
            this._contactsPageCache = null;
            this.meta = null;
            this.outbox = null;
            this.isActive = function () {
                return _this.db !== null && _this.messages !== null && _this.syncState !== null;
            };
            this.hydratePr = function (phone) { return __awaiter(_this, void 0, void 0, function () {
                var state, head, freshState, freshHead, slice, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.messages || !this.syncState)
                                return [2, null];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 7, , 8]);
                            return [4, this.syncState.get(phone)];
                        case 2:
                            state = _a.sent();
                            head = state === null || state === void 0 ? void 0 : state.ranges[0];
                            if (!state || !head)
                                return [2, null];
                            return [4, this.pruneContactPr(phone, state)];
                        case 3:
                            _a.sent();
                            return [4, this.syncState.get(phone)];
                        case 4:
                            freshState = _a.sent();
                            freshHead = freshState === null || freshState === void 0 ? void 0 : freshState.ranges[0];
                            if (!freshState || !freshHead)
                                return [2, null];
                            return [4, this.readSlicePr(phone, freshHead, freshHead.max, _6_1_Chat_Store.HYDRATE_LIMIT, true)];
                        case 5:
                            slice = _a.sent();
                            if (!slice.messages.length)
                                return [2, null];
                            freshState.updated_at = Date.now();
                            return [4, this.syncState.put(freshState)];
                        case 6:
                            _a.sent();
                            return [2, {
                                    messages: slice.messages,
                                    hasMoreCached: slice.hasMoreCached,
                                    historyComplete: freshState.history_complete === 1,
                                }];
                        case 7:
                            error_1 = _a.sent();
                            console.error('Chat_Store|hydratePr|error=', error_1);
                            return [2, null];
                        case 8: return [2];
                    }
                });
            }); };
            this.getOlderPagePr = function (phone, beforeId) { return __awaiter(_this, void 0, void 0, function () {
                var state, head, slice, error_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.messages || !this.syncState)
                                return [2, null];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 4, , 5]);
                            return [4, this.syncState.get(phone)];
                        case 2:
                            state = _a.sent();
                            head = state === null || state === void 0 ? void 0 : state.ranges[0];
                            if (!state || !head)
                                return [2, null];
                            if (beforeId <= head.min || beforeId > head.max + 1)
                                return [2, null];
                            return [4, this.readSlicePr(phone, head, beforeId - 1, _6_1_Chat_Store.CACHE_PAGE_LIMIT, true)];
                        case 3:
                            slice = _a.sent();
                            if (!slice.messages.length)
                                return [2, null];
                            return [2, {
                                    messages: slice.messages,
                                    hasMoreCached: slice.hasMoreCached,
                                    historyComplete: state.history_complete === 1,
                                }];
                        case 4:
                            error_2 = _a.sent();
                            console.error('Chat_Store|getOlderPagePr|error=', error_2);
                            return [2, null];
                        case 5: return [2];
                    }
                });
            }); };
            this.putServerBatchPr = function (phone, messagesBatch, meta) { return __awaiter(_this, void 0, void 0, function () {
                var messagesTable, syncTable, db, cached_2, batchMin_1, batchMax_1, _i, cached_1, msg, error_3;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            messagesTable = this.messages;
                            syncTable = this.syncState;
                            db = this.db;
                            if (!messagesTable || !syncTable || !db)
                                return [2];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            cached_2 = toCachedMessages(phone, messagesBatch);
                            batchMin_1 = null;
                            batchMax_1 = null;
                            for (_i = 0, cached_1 = cached_2; _i < cached_1.length; _i++) {
                                msg = cached_1[_i];
                                if (batchMin_1 === null || msg.id < batchMin_1)
                                    batchMin_1 = msg.id;
                                if (batchMax_1 === null || msg.id > batchMax_1)
                                    batchMax_1 = msg.id;
                            }
                            return [4, db.transaction('rw', [messagesTable, syncTable], function () { return __awaiter(_this, void 0, void 0, function () {
                                    var prev, res, _i, _a, range;
                                    var _b;
                                    return __generator(this, function (_c) {
                                        switch (_c.label) {
                                            case 0:
                                                if (!cached_2.length) return [3, 2];
                                                return [4, messagesTable.bulkPut(cached_2)];
                                            case 1:
                                                _c.sent();
                                                _c.label = 2;
                                            case 2: return [4, syncTable.get(phone)];
                                            case 3:
                                                prev = (_b = (_c.sent())) !== null && _b !== void 0 ? _b : null;
                                                res = applyServerBatch(prev, phone, meta, batchMin_1, batchMax_1, cached_2.length, Date.now());
                                                _i = 0, _a = res.purge;
                                                _c.label = 4;
                                            case 4:
                                                if (!(_i < _a.length)) return [3, 7];
                                                range = _a[_i];
                                                return [4, this.deleteRangePr(phone, range.min, range.max)];
                                            case 5:
                                                _c.sent();
                                                _c.label = 6;
                                            case 6:
                                                _i++;
                                                return [3, 4];
                                            case 7: return [4, syncTable.put(res.state)];
                                            case 8:
                                                _c.sent();
                                                return [2];
                                        }
                                    });
                                }); })];
                        case 2:
                            _a.sent();
                            return [3, 4];
                        case 3:
                            error_3 = _a.sent();
                            console.error('Chat_Store|putServerBatchPr|error=', error_3);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            }); };
            this.putSentMessagesPr = function (phone, messagesBatch) { return __awaiter(_this, void 0, void 0, function () {
                var messagesTable, syncTable, db, cached_4, firstCached, minId_1, maxId_1, _i, cached_3, msg, error_4;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            messagesTable = this.messages;
                            syncTable = this.syncState;
                            db = this.db;
                            if (!messagesTable || !syncTable || !db)
                                return [2];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            cached_4 = toCachedMessages(phone, messagesBatch);
                            firstCached = cached_4[0];
                            if (!firstCached)
                                return [2];
                            minId_1 = firstCached.id;
                            maxId_1 = firstCached.id;
                            for (_i = 0, cached_3 = cached_4; _i < cached_3.length; _i++) {
                                msg = cached_3[_i];
                                if (msg.id < minId_1)
                                    minId_1 = msg.id;
                                if (msg.id > maxId_1)
                                    maxId_1 = msg.id;
                            }
                            return [4, db.transaction('rw', [messagesTable, syncTable], function () {
                                    return __awaiter(this, void 0, void 0, function () {
                                        var prev;
                                        var _a;
                                        return __generator(this, function (_b) {
                                            switch (_b.label) {
                                                case 0: return [4, messagesTable.bulkPut(cached_4)];
                                                case 1:
                                                    _b.sent();
                                                    return [4, syncTable.get(phone)];
                                                case 2:
                                                    prev = (_a = (_b.sent())) !== null && _a !== void 0 ? _a : null;
                                                    return [4, syncTable.put(applySentMessages(prev, phone, minId_1, maxId_1, Date.now()))];
                                                case 3:
                                                    _b.sent();
                                                    return [2];
                                            }
                                        });
                                    });
                                })];
                        case 2:
                            _a.sent();
                            return [3, 4];
                        case 3:
                            error_4 = _a.sent();
                            console.error('Chat_Store|putSentMessagesPr|error=', error_4);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            }); };
            this.markHistoryCompletePr = function (phone, requestedMinId) { return __awaiter(_this, void 0, void 0, function () {
                var syncTable, prev, res, error_5;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            syncTable = this.syncState;
                            if (!syncTable)
                                return [2];
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 5, , 6]);
                            return [4, syncTable.get(phone)];
                        case 2:
                            prev = (_a = (_b.sent())) !== null && _a !== void 0 ? _a : null;
                            res = applyServerBatch(prev, phone, { direction: 'UP', requestedMinId: requestedMinId, requestedMaxId: null, pageFull: false }, null, null, 0, Date.now());
                            if (!res.state.ranges.length) return [3, 4];
                            return [4, syncTable.put(res.state)];
                        case 3:
                            _b.sent();
                            _b.label = 4;
                        case 4: return [3, 6];
                        case 5:
                            error_5 = _b.sent();
                            console.error('Chat_Store|markHistoryCompletePr|error=', error_5);
                            return [3, 6];
                        case 6: return [2];
                    }
                });
            }); };
            this.updateStatusesPr = function (phone, ids, status, statusMsg) { return __awaiter(_this, void 0, void 0, function () {
                var messagesTable, keys, _i, ids_1, id, error_6;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            messagesTable = this.messages;
                            if (!messagesTable || !ids.length)
                                return [2];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            keys = [];
                            for (_i = 0, ids_1 = ids; _i < ids_1.length; _i++) {
                                id = ids_1[_i];
                                keys.push([phone, id]);
                            }
                            return [4, messagesTable
                                    .where('[cache_key+id]')
                                    .anyOf(keys)
                                    .modify(function (msg) {
                                    msg.message_status = toMessageStatus(status);
                                    if (statusMsg)
                                        msg.message_status_msg = statusMsg;
                                })];
                        case 2:
                            _a.sent();
                            return [3, 4];
                        case 3:
                            error_6 = _a.sent();
                            console.error('Chat_Store|updateStatusesPr|error=', error_6);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            }); };
            this.updateMessageFieldsPr = function (phone, id, fields) { return __awaiter(_this, void 0, void 0, function () {
                var messagesTable, _ignoredId, updatable, error_7;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            messagesTable = this.messages;
                            if (!messagesTable || !Number.isFinite(id) || id <= 0)
                                return [2];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            _ignoredId = fields.id, updatable = __rest(fields, ["id"]);
                            return [4, messagesTable.update([phone, id], updatable)];
                        case 2:
                            _a.sent();
                            return [3, 4];
                        case 3:
                            error_7 = _a.sent();
                            console.error('Chat_Store|updateMessageFieldsPr|error=', error_7);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            }); };
            this.upsertContactsPr = function (rows, options) { return __awaiter(_this, void 0, void 0, function () {
                var table, db, now_1, ordRange_1, error_8;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            table = this.contactsSnapshot;
                            db = this.db;
                            if (!table || !db || !rows.length)
                                return [2];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            now_1 = Date.now();
                            ordRange_1 = options !== undefined ? options.ordRange : undefined;
                            return [4, db.transaction('rw', [table], function () {
                                    return __awaiter(this, void 0, void 0, function () {
                                        var fresh, _i, rows_1, row, stale, _a, stale_1, row, _b, rows_2, row, existing, merged;
                                        var _c, _d, _e, _f, _g, _h, _j, _k, _l;
                                        return __generator(this, function (_m) {
                                            switch (_m.label) {
                                                case 0:
                                                    if (!(ordRange_1 !== undefined && ordRange_1.end > ordRange_1.start)) return [3, 5];
                                                    fresh = {};
                                                    for (_i = 0, rows_1 = rows; _i < rows_1.length; _i++) {
                                                        row = rows_1[_i];
                                                        if (row.phone)
                                                            fresh[row.phone] = true;
                                                    }
                                                    return [4, table
                                                            .where('ord')
                                                            .between(ordRange_1.start, ordRange_1.end, true, false)
                                                            .toArray()];
                                                case 1:
                                                    stale = _m.sent();
                                                    _a = 0, stale_1 = stale;
                                                    _m.label = 2;
                                                case 2:
                                                    if (!(_a < stale_1.length)) return [3, 5];
                                                    row = stale_1[_a];
                                                    if (fresh[row.phone] === true)
                                                        return [3, 4];
                                                    return [4, table.put(__assign(__assign({}, row), { ord: null, updated_at: now_1 }))];
                                                case 3:
                                                    _m.sent();
                                                    _m.label = 4;
                                                case 4:
                                                    _a++;
                                                    return [3, 2];
                                                case 5:
                                                    _b = 0, rows_2 = rows;
                                                    _m.label = 6;
                                                case 6:
                                                    if (!(_b < rows_2.length)) return [3, 10];
                                                    row = rows_2[_b];
                                                    if (!row.phone)
                                                        return [3, 9];
                                                    return [4, table.get(row.phone)];
                                                case 7:
                                                    existing = _m.sent();
                                                    merged = {
                                                        phone: row.phone,
                                                        ord: row.ord !== undefined ? row.ord : ((_c = existing === null || existing === void 0 ? void 0 : existing.ord) !== null && _c !== void 0 ? _c : null),
                                                        noread: row.noread !== undefined ? row.noread : ((_d = existing === null || existing === void 0 ? void 0 : existing.noread) !== null && _d !== void 0 ? _d : 0),
                                                        name: row.name !== undefined ? row.name : ((_e = existing === null || existing === void 0 ? void 0 : existing.name) !== null && _e !== void 0 ? _e : ''),
                                                        name_custom: row.name_custom !== undefined ? row.name_custom : ((_f = existing === null || existing === void 0 ? void 0 : existing.name_custom) !== null && _f !== void 0 ? _f : null),
                                                        transport: row.transport !== undefined
                                                            ? row.transport
                                                            : ((_g = existing === null || existing === void 0 ? void 0 : existing.transport) !== null && _g !== void 0 ? _g : 'undefined'),
                                                        insta_login: row.insta_login !== undefined ? row.insta_login : ((_h = existing === null || existing === void 0 ? void 0 : existing.insta_login) !== null && _h !== void 0 ? _h : null),
                                                        telegram_login: row.telegram_login !== undefined
                                                            ? row.telegram_login
                                                            : ((_j = existing === null || existing === void 0 ? void 0 : existing.telegram_login) !== null && _j !== void 0 ? _j : null),
                                                        sp_numb: row.sp_numb !== undefined ? row.sp_numb : ((_k = existing === null || existing === void 0 ? void 0 : existing.sp_numb) !== null && _k !== void 0 ? _k : null),
                                                        category: row.category !== undefined ? row.category : ((_l = existing === null || existing === void 0 ? void 0 : existing.category) !== null && _l !== void 0 ? _l : null),
                                                        updated_at: now_1,
                                                    };
                                                    return [4, table.put(merged)];
                                                case 8:
                                                    _m.sent();
                                                    _m.label = 9;
                                                case 9:
                                                    _b++;
                                                    return [3, 6];
                                                case 10: return [2];
                                            }
                                        });
                                    });
                                })];
                        case 2:
                            _a.sent();
                            this._contactsPageCache = null;
                            return [3, 4];
                        case 3:
                            error_8 = _a.sent();
                            console.error('Chat_Store|upsertContactsPr|error=', error_8);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            }); };
            this.getContactsPagePr = function (params) { return __awaiter(_this, void 0, void 0, function () {
                var table, _a, rows, total, all, phonesSet_1, categ_1, filtered, error_9;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            table = this.contactsSnapshot;
                            if (!table)
                                return [2, { rows: [], total: 0 }];
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 6, , 7]);
                            if (!(!params.phones && params.categ === '0')) return [3, 3];
                            return [4, Promise.all([
                                    table.orderBy('ord').offset(params.start).limit(params.limit).toArray(),
                                    table.orderBy('ord').count(),
                                ])];
                        case 2:
                            _a = _b.sent(), rows = _a[0], total = _a[1];
                            return [2, { rows: rows, total: total }];
                        case 3:
                            all = this._contactsPageCache;
                            if (!!all) return [3, 5];
                            return [4, table.orderBy('ord').toArray()];
                        case 4:
                            all = _b.sent();
                            this._contactsPageCache = all;
                            _b.label = 5;
                        case 5:
                            phonesSet_1 = null;
                            if (params.phones) {
                                phonesSet_1 = new Set(params.phones);
                            }
                            categ_1 = params.categ;
                            filtered = all.filter(function (row) {
                                if (phonesSet_1)
                                    return phonesSet_1.has(row.phone);
                                return Array.isArray(row.category) && row.category.indexOf(categ_1) !== -1;
                            });
                            return [2, {
                                    rows: filtered.slice(params.start, params.start + params.limit),
                                    total: filtered.length,
                                }];
                        case 6:
                            error_9 = _b.sent();
                            console.error('Chat_Store|getContactsPagePr|error=', error_9);
                            return [2, { rows: [], total: 0 }];
                        case 7: return [2];
                    }
                });
            }); };
            this.saveCategoriesMetaPr = function (value) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.putMetaPr({ key: 'categories', value: value })];
                        case 1:
                            _a.sent();
                            return [2];
                    }
                });
            }); };
            this.getCategoriesMetaPr = function () { return __awaiter(_this, void 0, void 0, function () {
                var row;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.getMetaPr('categories')];
                        case 1:
                            row = _a.sent();
                            return [2, row !== null && row.key === 'categories' ? row.value : null];
                    }
                });
            }); };
            this.saveCategoryNoreadMetaPr = function (value) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.putMetaPr({ key: 'category_noread', value: value })];
                        case 1:
                            _a.sent();
                            return [2];
                    }
                });
            }); };
            this.getCategoryNoreadMetaPr = function () { return __awaiter(_this, void 0, void 0, function () {
                var row;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.getMetaPr('category_noread')];
                        case 1:
                            row = _a.sent();
                            return [2, row !== null && row.key === 'category_noread' ? row.value : null];
                    }
                });
            }); };
            this.saveWorksMetaPr = function (value) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.putMetaPr({ key: 'works', value: value })];
                        case 1:
                            _a.sent();
                            return [2];
                    }
                });
            }); };
            this.getWorksMetaPr = function () { return __awaiter(_this, void 0, void 0, function () {
                var row;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.getMetaPr('works')];
                        case 1:
                            row = _a.sent();
                            return [2, row !== null && row.key === 'works' ? row.value : null];
                    }
                });
            }); };
            this.outboxAddPr = function (item) { return __awaiter(_this, void 0, void 0, function () {
                var table, row, error_10;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            table = this.outbox;
                            if (!table)
                                return [2];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            row = __assign(__assign({}, item), { claimed_at: null });
                            return [4, table.add(row)];
                        case 2:
                            _a.sent();
                            return [3, 4];
                        case 3:
                            error_10 = _a.sent();
                            console.error('Chat_Store|outboxAddPr|error=', error_10);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            }); };
            this.outboxAllPr = function () { return __awaiter(_this, void 0, void 0, function () {
                var table, error_11;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            table = this.outbox;
                            if (!table)
                                return [2, []];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, table.orderBy('oid').toArray()];
                        case 2: return [2, _a.sent()];
                        case 3:
                            error_11 = _a.sent();
                            console.error('Chat_Store|outboxAllPr|error=', error_11);
                            return [2, []];
                        case 4: return [2];
                    }
                });
            }); };
            this.outboxByPhonePr = function (phone) { return __awaiter(_this, void 0, void 0, function () {
                var table, rows, error_12;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            table = this.outbox;
                            if (!table)
                                return [2, []];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, table.where('phone').equals(phone).toArray()];
                        case 2:
                            rows = _a.sent();
                            rows.sort(function (a, b) {
                                var _a, _b;
                                return ((_a = a.oid) !== null && _a !== void 0 ? _a : 0) - ((_b = b.oid) !== null && _b !== void 0 ? _b : 0);
                            });
                            return [2, rows];
                        case 3:
                            error_12 = _a.sent();
                            console.error('Chat_Store|outboxByPhonePr|error=', error_12);
                            return [2, []];
                        case 4: return [2];
                    }
                });
            }); };
            this.outboxClaimPr = function (oid) { return __awaiter(_this, void 0, void 0, function () {
                var table, db, error_13;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            table = this.outbox;
                            db = this.db;
                            if (!table || !db)
                                return [2, false];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, db.transaction('rw', [table], function () {
                                    return __awaiter(this, void 0, void 0, function () {
                                        var row, now;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4, table.get(oid)];
                                                case 1:
                                                    row = _a.sent();
                                                    if (!row)
                                                        return [2, false];
                                                    now = Date.now();
                                                    if (row.claimed_at !== null && now - row.claimed_at < _6_1_Chat_Store.OUTBOX_CLAIM_STALE_MS) {
                                                        return [2, false];
                                                    }
                                                    row.claimed_at = now;
                                                    return [4, table.put(row)];
                                                case 2:
                                                    _a.sent();
                                                    return [2, true];
                                            }
                                        });
                                    });
                                })];
                        case 2: return [2, _a.sent()];
                        case 3:
                            error_13 = _a.sent();
                            console.error('Chat_Store|outboxClaimPr|error=', error_13);
                            return [2, false];
                        case 4: return [2];
                    }
                });
            }); };
            this.outboxDeletePr = function (oid) { return __awaiter(_this, void 0, void 0, function () {
                var table, error_14;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            table = this.outbox;
                            if (!table)
                                return [2];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, table.delete(oid)];
                        case 2:
                            _a.sent();
                            return [3, 4];
                        case 3:
                            error_14 = _a.sent();
                            console.error('Chat_Store|outboxDeletePr|error=', error_14);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            }); };
            this.outboxReleasePr = function (oid) { return __awaiter(_this, void 0, void 0, function () {
                var table, row, error_15;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            table = this.outbox;
                            if (!table)
                                return [2];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 5, , 6]);
                            return [4, table.get(oid)];
                        case 2:
                            row = _a.sent();
                            if (!(row && row.claimed_at !== null)) return [3, 4];
                            row.claimed_at = null;
                            return [4, table.put(row)];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4: return [3, 6];
                        case 5:
                            error_15 = _a.sent();
                            console.error('Chat_Store|outboxReleasePr|error=', error_15);
                            return [3, 6];
                        case 6: return [2];
                    }
                });
            }); };
            this.putMetaPr = function (row) { return __awaiter(_this, void 0, void 0, function () {
                var table, error_16;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            table = this.meta;
                            if (!table)
                                return [2];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, table.put(row)];
                        case 2:
                            _a.sent();
                            return [3, 4];
                        case 3:
                            error_16 = _a.sent();
                            console.error('Chat_Store|putMetaPr|error=', error_16, row.key);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            }); };
            this.getMetaPr = function (key) { return __awaiter(_this, void 0, void 0, function () {
                var table, row, error_17;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            table = this.meta;
                            if (!table)
                                return [2, null];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, table.get(key)];
                        case 2:
                            row = _a.sent();
                            return [2, row !== null && row !== void 0 ? row : null];
                        case 3:
                            error_17 = _a.sent();
                            console.error('Chat_Store|getMetaPr|error=', error_17, key);
                            return [2, null];
                        case 4: return [2];
                    }
                });
            }); };
            this.deleteDatabasePr = function () { return __awaiter(_this, void 0, void 0, function () {
                var db, error_18;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            db = this.db;
                            this.db = null;
                            this.messages = null;
                            this.syncState = null;
                            this.contactsSnapshot = null;
                            this.meta = null;
                            this.outbox = null;
                            if (!db)
                                return [2];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, db.delete()];
                        case 2:
                            _a.sent();
                            return [3, 4];
                        case 3:
                            error_18 = _a.sent();
                            console.error('Chat_Store|deleteDatabasePr|error=', error_18);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            }); };
            this.readSlicePr = function (phone, head, upToId, limit, includeUpper) { return __awaiter(_this, void 0, void 0, function () {
                var messagesTable, rows, hasMoreCached, slice;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            messagesTable = this.messages;
                            if (!messagesTable)
                                return [2, { messages: [], hasMoreCached: false }];
                            return [4, messagesTable
                                    .where('[cache_key+id]')
                                    .between([phone, head.min], [phone, upToId], true, includeUpper)
                                    .reverse()
                                    .limit(limit + 1)
                                    .toArray()];
                        case 1:
                            rows = _a.sent();
                            hasMoreCached = rows.length > limit;
                            slice = hasMoreCached ? rows.slice(0, limit) : rows;
                            slice.sort(function (a, b) {
                                return a.id - b.id;
                            });
                            return [2, { messages: slice, hasMoreCached: hasMoreCached }];
                    }
                });
            }); };
            this.deleteRangePr = function (phone, minId, maxId) { return __awaiter(_this, void 0, void 0, function () {
                var messagesTable;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            messagesTable = this.messages;
                            if (!messagesTable)
                                return [2];
                            return [4, messagesTable
                                    .where('[cache_key+id]')
                                    .between([phone, minId], [phone, maxId], true, true)
                                    .delete()];
                        case 1:
                            _a.sent();
                            return [2];
                    }
                });
            }); };
            this.pruneContactPr = function (phone, state) { return __awaiter(_this, void 0, void 0, function () {
                var messagesTable, syncTable, head, count, boundary;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            messagesTable = this.messages;
                            syncTable = this.syncState;
                            head = state.ranges[0];
                            if (!messagesTable || !syncTable || !head)
                                return [2];
                            return [4, messagesTable
                                    .where('[cache_key+id]')
                                    .between([phone, head.min], [phone, head.max], true, true)
                                    .count()];
                        case 1:
                            count = _a.sent();
                            if (count <= _6_1_Chat_Store.KEEP_MAX_PER_CONTACT)
                                return [2];
                            return [4, messagesTable
                                    .where('[cache_key+id]')
                                    .between([phone, head.min], [phone, head.max], true, true)
                                    .reverse()
                                    .offset(_6_1_Chat_Store.KEEP_MAX_PER_CONTACT - 1)
                                    .first()];
                        case 2:
                            boundary = _a.sent();
                            if (!boundary)
                                return [2];
                            return [4, messagesTable
                                    .where('[cache_key+id]')
                                    .between([phone, 0], [phone, boundary.id], true, false)
                                    .delete()];
                        case 3:
                            _a.sent();
                            state.ranges = [{ min: boundary.id, max: head.max }];
                            state.history_complete = 0;
                            state.updated_at = Date.now();
                            return [4, syncTable.put(state)];
                        case 4:
                            _a.sent();
                            return [2];
                    }
                });
            }); };
            this.pruneOldContactsPr = function () { return __awaiter(_this, void 0, void 0, function () {
                var messagesTable, syncTable, cutoff, stale, _i, stale_2, state;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            messagesTable = this.messages;
                            syncTable = this.syncState;
                            if (!messagesTable || !syncTable)
                                return [2];
                            cutoff = Date.now() - _6_1_Chat_Store.PRUNE_CONTACT_AGE_MS;
                            return [4, syncTable.where('updated_at').below(cutoff).toArray()];
                        case 1:
                            stale = _a.sent();
                            _i = 0, stale_2 = stale;
                            _a.label = 2;
                        case 2:
                            if (!(_i < stale_2.length)) return [3, 6];
                            state = stale_2[_i];
                            return [4, messagesTable
                                    .where('[cache_key+id]')
                                    .between([state.ph_numb, 0], [state.ph_numb, Infinity], true, true)
                                    .delete()];
                        case 3:
                            _a.sent();
                            return [4, syncTable.delete(state.ph_numb)];
                        case 4:
                            _a.sent();
                            _a.label = 5;
                        case 5:
                            _i++;
                            return [3, 2];
                        case 6:
                            if (stale.length) {
                                console.log('Chat_Store|pruneOldContactsPr|removed_contacts=', stale.length);
                            }
                            return [2];
                    }
                });
            }); };
            if (typeof Chat_useDexie === 'undefined' || !Chat_useDexie)
                return;
            if (typeof Dexie === 'undefined') {
                console.error('Chat_Store|Dexie не загружен — локальный кэш чата выключен');
                return;
            }
            try {
                var db = new Dexie("ChatDB".concat(operator_id));
                db.version(5).stores({ messages: null });
                db.version(6).stores({
                    messages: '[cache_key+id]',
                    sync_state: 'ph_numb, updated_at',
                });
                db.version(7).stores({
                    contacts_snapshot: 'phone, ord',
                });
                db.version(8).stores({
                    contacts_snapshot: 'phone, ord, updated_at',
                    meta: 'key',
                    outbox: '++oid, phone, created_at',
                });
                db.version(9)
                    .stores({})
                    .upgrade(function (tx) {
                    return Promise.all([
                        tx.table('messages').clear(),
                        tx.table('sync_state').clear(),
                    ]).then(function () {
                        console.log('Chat_Store|upgrade v9|кэш переписки сброшен (переход на message_get_v2)');
                    });
                });
                this.db = db;
                this.messages = db.table('messages');
                this.syncState = db.table('sync_state');
                this.contactsSnapshot = db.table('contacts_snapshot');
                this.meta = db.table('meta');
                this.outbox = db.table('outbox');
                console.log('Chat_Store|init|ChatDB' + operator_id);
                setTimeout(function () {
                    _this.pruneOldContactsPr().catch(function (error) {
                        console.error('Chat_Store|pruneOldContactsPr|error=', error);
                    });
                }, 15000);
            }
            catch (error) {
                console.error('Chat_Store|init|error=', error);
                this.db = null;
                this.messages = null;
                this.syncState = null;
                this.contactsSnapshot = null;
                this.meta = null;
                this.outbox = null;
            }
        }
        return Chat_Store;
    }());
    _6_1_Chat_Store.Chat_Store = Chat_Store;
})(_6_1_Chat_Store || (_6_1_Chat_Store = {}));


"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var MAX_TRANSPORT_STYLE_ID = 'sendapi-chat-max-transport-styles';
var MAX_TRANSPORT_ICON_SVG = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1000 1000\"><path fill-rule=\"evenodd\" d=\"M508.211 878.328c-75.007 0-109.864-10.95-170.453-54.75-38.325 49.275-159.686 87.783-164.979 21.9 0-49.456-10.95-91.248-23.36-136.873-14.782-56.21-31.572-118.807-31.572-209.508 0-216.626 177.754-379.597 388.357-379.597 210.785 0 375.947 171.001 375.947 381.604.707 207.346-166.595 376.118-373.94 377.224m3.103-571.585c-102.564-5.292-182.499 65.7-200.201 177.024-14.6 92.162 11.315 204.398 33.397 210.238 10.585 2.555 37.23-18.98 53.837-35.587a189.8 189.8 0 0 0 92.71 33.032c106.273 5.112 197.08-75.794 204.215-181.95 4.154-106.382-77.67-196.486-183.958-202.574Z\" clip-rule=\"evenodd\"/></svg>";
var _7_Chat;
(function (_7_Chat) {
    var OFFLINE_OPERATOR_SNAPSHOT_KEY = 'chat_offline_operator_v1';
    var HYDRATE_TIMEOUT_MS = 2000;
    var FRESH_WAIT_MS = 400;
    var GAP_FILL_MAX_PAGES = 5;
    var INIT_LOADER_WATCHDOG_MS = 20000;
    var CONTACTS_SNAPSHOT_DEBOUNCE_MS = 4000;
    var CONTACTS_SNAPSHOT_MAX_WAIT_MS = 15000;
    function isOfflineOperatorSnapshot(value) {
        if (typeof value !== 'object' || value === null || Array.isArray(value))
            return false;
        var nullableString = function (item) { return item === null || typeof item === 'string'; };
        var nullableNumber = function (item) { return item === null || typeof item === 'number'; };
        var roles = Reflect.get(value, 'roles');
        var rolesValid = roles === null ||
            (Array.isArray(roles) &&
                roles.every(function (role) {
                    return typeof role === 'string';
                }));
        return (typeof Reflect.get(value, 'id') === 'number' &&
            typeof Reflect.get(value, 'central_user_id') === 'number' &&
            nullableString(Reflect.get(value, 'user_name')) &&
            nullableString(Reflect.get(value, 'user_email')) &&
            rolesValid &&
            nullableNumber(Reflect.get(value, 'auto_read')) &&
            nullableNumber(Reflect.get(value, 'contact_view')) &&
            typeof Reflect.get(value, 'saved_at') === 'number');
    }
    function isChatIntegrationList(value) {
        if (!Array.isArray(value))
            return false;
        for (var index = 0; index < value.length; index++) {
            var entry = value[index];
            if (typeof entry !== 'object' || entry === null || Array.isArray(entry))
                return false;
            var provider = Reflect.get(entry, 'provider');
            if (provider !== 'amocrm' &&
                provider !== 'uon' &&
                provider !== 'sendapi_deals' &&
                provider !== 'bitrix24_deals' &&
                provider !== 'glo') {
                return false;
            }
            var name_1 = Reflect.get(entry, 'name');
            if (name_1 !== undefined && typeof name_1 !== 'string')
                return false;
            var amocrmMode = Reflect.get(entry, 'amocrm_mode');
            if (amocrmMode !== undefined && typeof amocrmMode !== 'number')
                return false;
        }
        return true;
    }
    function isGetTagsResponse(value) {
        if (typeof value !== 'object' || value === null)
            return false;
        if (typeof Reflect.get(value, 'success') !== 'boolean')
            return false;
        var list = Reflect.get(value, 'data');
        if (!Array.isArray(list))
            return false;
        return list.every(function (tag) {
            return (typeof tag === 'object' &&
                tag !== null &&
                typeof Reflect.get(tag, '_id') === 'string' &&
                typeof Reflect.get(tag, 'tag_name') === 'string');
        });
    }
    function isGetOutcomesResponse(value) {
        if (typeof value !== 'object' || value === null)
            return false;
        if (typeof Reflect.get(value, 'success') !== 'boolean')
            return false;
        var list = Reflect.get(value, 'data');
        if (!Array.isArray(list))
            return false;
        return list.every(function (outcome) {
            return (typeof outcome === 'object' &&
                outcome !== null &&
                typeof Reflect.get(outcome, '_id') === 'string' &&
                typeof Reflect.get(outcome, 'outcome_name') === 'string');
        });
    }
    function cabinetPageUrl(path) {
        return '/' + _7_Chat.Chat.serviceSite.replace(/^\/+/, '') + path;
    }
    function formFieldText(id) {
        var field = document.getElementById(id);
        if (field instanceof HTMLInputElement ||
            field instanceof HTMLTextAreaElement ||
            field instanceof HTMLSelectElement) {
            return field.value;
        }
        console.error("formFieldText|#".concat(id, "|\u043D\u0435\u0442 \u043F\u043E\u043B\u044F \u0432\u0432\u043E\u0434\u0430 \u0432 \u0440\u0430\u0437\u043C\u0435\u0442\u043A\u0435"));
        return null;
    }
    var WABA_ADDRESS_PREFIX = 'whatsapp_biz_';
    var WABA_BSUID_PATTERN = /^([A-Z]{2})\.(?:ENT\.)?[A-Za-z0-9]{1,128}$/;
    _7_Chat.Chat = {
        obj: {
            d: $(document),
            textarea_message_text: $('#textarea_message_text'),
            textarea_message_text2: $('.textarea_message_text'),
            id_warning_info: $('#warning_info'),
        },
        waba_template: {},
        waba_template_list: [],
        waba_template_channels: [],
        waba_template_app_id: null,
        search_time: null,
        chatTimeUtc: null,
        localOffsetInMinutes: null,
        offsetInMinutes: '',
        navbarPageId: '',
        ensureTransportIconStyles: function () {
            if (typeof document === 'undefined') {
                return;
            }
            if (document.getElementById(MAX_TRANSPORT_STYLE_ID)) {
                return;
            }
            var styleElement = document.createElement('style');
            styleElement.id = MAX_TRANSPORT_STYLE_ID;
            var encodedMaxIcon = encodeURIComponent(MAX_TRANSPORT_ICON_SVG);
            styleElement.textContent = "\n        .sa-transport-icon {\n          display: inline-block;\n          position: relative;\n          width: 1.18em;\n          height: 1.18em;\n          vertical-align: -0.24em;\n        }\n\n        .sa-transport-icon::before {\n          content: '';\n          position: absolute;\n          inset: 0;\n          background-color: currentColor;\n          -webkit-mask: url(\"data:image/svg+xml,".concat(encodedMaxIcon, "\") center / contain no-repeat;\n          mask: url(\"data:image/svg+xml,").concat(encodedMaxIcon, "\") center / contain no-repeat;\n        }\n\n        .sa-transport-icon--max-group::after,\n        .sa-transport-icon--max-channel::after {\n          position: absolute;\n          right: -0.25em;\n          bottom: -0.15em;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          min-width: 1.1em;\n          height: 1.1em;\n          padding: 0 0.18em;\n          border-radius: 999px;\n          background: #fff;\n          box-shadow: 0 0 0 1px rgba(83, 62, 238, 0.18);\n          color: #533eee;\n          font-family: \"Font Awesome 5 Free\";\n          font-size: 0.48em;\n          font-style: normal;\n          font-variant: normal;\n          font-weight: 900;\n          line-height: 1;\n          text-rendering: auto;\n          -webkit-font-smoothing: antialiased;\n          -moz-osx-font-smoothing: grayscale;\n          content: '';\n        }\n\n        .sa-transport-icon--max-group::after {\n          content: \"\\f0c0\";\n        }\n\n        .sa-transport-icon--max-channel::after {\n          content: \"\\f0a1\";\n        }\n      ");
            document.head.appendChild(styleElement);
        },
        isTgTransport: function (transport) {
            return transport === 'tg' || transport === 'tg_group';
        },
        isMaxTransport: function (transport) {
            return transport === 'max' || transport === 'max_group' || transport === 'max_channel';
        },
        stripTransportPrefix: function (phone) {
            return phone.replace(/^(whatsapp_biz_|telegram_|tg_group_|tg_)/, '');
        },
        wabaBsuidPattern: WABA_BSUID_PATTERN,
        isWabaBsuidAddress: function (phone) {
            return (phone.startsWith(WABA_ADDRESS_PREFIX) &&
                WABA_BSUID_PATTERN.test(phone.slice(WABA_ADDRESS_PREFIX.length)));
        },
        wabaBsuidContactName: function (_a) {
            var phone = _a.phone, name = _a.name, name_custom = _a.name_custom;
            var preferredName = _7_Chat.Chat.getPreferredContactName({ name: name, name_custom: name_custom });
            var bsuid = phone.slice(WABA_ADDRESS_PREFIX.length);
            return preferredName === phone || preferredName === bsuid ? '' : preferredName;
        },
        getPreferredContactName: function (_a) {
            var name = _a.name, name_custom = _a.name_custom;
            if (typeof name_custom === 'string' && name_custom !== '') {
                return name_custom;
            }
            if (typeof name === 'string') {
                return name;
            }
            return '';
        },
        getContactPresentationData: function (_a) {
            var phone = _a.phone, transport = _a.transport, name = _a.name, name_custom = _a.name_custom, insta_login = _a.insta_login, telegram_login = _a.telegram_login;
            var escapeHtml = _1_Tasks.escapeHtml;
            var preferredName = _7_Chat.Chat.getPreferredContactName({ name: name, name_custom: name_custom });
            var shouldAlwaysShowName = _7_Chat.Chat.isMaxTransport(transport);
            var contactName = _7_Chat.Chat.operator_data.contact_view === 1 || shouldAlwaysShowName
                ? escapeHtml(preferredName)
                : '';
            var contactPhone = escapeHtml(_7_Chat.Chat.stripTransportPrefix(phone));
            var contactIcon = _7_Chat.Chat.transportIcon(transport);
            if (_7_Chat.Chat.isWabaBsuidAddress(phone)) {
                return {
                    contactIcon: contactIcon,
                    contactName: escapeHtml(_7_Chat.Chat.wabaBsuidContactName({ phone: phone, name: name, name_custom: name_custom })),
                    contactPhone: escapeHtml(_7_Chat.Chat.l('Номер скрыт')),
                };
            }
            if (transport === 'whatsapp_group') {
                contactPhone = '';
            }
            else if (transport === 'instagram') {
                contactPhone = insta_login ? '@' + escapeHtml(insta_login) : '';
            }
            else if (_7_Chat.Chat.isTgTransport(transport)) {
                var tgLogin = typeof telegram_login === 'string' ? telegram_login : '';
                if (contactName) {
                    contactPhone = tgLogin
                        ? "<span style=\"font-weight:normal;color:#888;\">".concat(escapeHtml(tgLogin), "</span>")
                        : '';
                }
                else if (tgLogin) {
                    contactName = escapeHtml(tgLogin);
                    contactPhone = '';
                }
                else {
                    contactName = escapeHtml(_7_Chat.Chat.stripTransportPrefix(phone));
                    contactPhone = '';
                }
            }
            else if (_7_Chat.Chat.isMaxTransport(transport)) {
                contactPhone = '';
            }
            return {
                contactIcon: contactIcon,
                contactName: contactName,
                contactPhone: contactPhone,
            };
        },
        getSubscriberNameHtml: function (_a) {
            var phone = _a.phone, transport = _a.transport, name = _a.name, name_custom = _a.name_custom, insta_login = _a.insta_login, telegram_login = _a.telegram_login;
            var escapeHtml = _1_Tasks.escapeHtml;
            var preferredName = _7_Chat.Chat.getPreferredContactName({ name: name, name_custom: name_custom });
            if (transport === 'whatsapp_group') {
                return "<b class=\"phone_text\">".concat(escapeHtml(name || ''), "</b>");
            }
            if (_7_Chat.Chat.isTgTransport(transport)) {
                var tgLogin = typeof telegram_login === 'string' ? telegram_login : '';
                if (preferredName) {
                    var loginHtml = tgLogin && !preferredName.includes(tgLogin)
                        ? " <span style=\"font-weight:normal;color:#888;\">".concat(escapeHtml(tgLogin), "</span>")
                        : '';
                    return "<b class=\"phone_text\">".concat(escapeHtml(preferredName), "</b>").concat(loginHtml);
                }
                if (tgLogin) {
                    return escapeHtml(tgLogin);
                }
                return escapeHtml(_7_Chat.Chat.stripTransportPrefix(phone));
            }
            if (_7_Chat.Chat.isMaxTransport(transport)) {
                return preferredName
                    ? "<b class=\"phone_text\">".concat(escapeHtml(preferredName), "</b>")
                    : '<span class="phone_text"></span>';
            }
            if (transport === 'instagram' && insta_login) {
                var contactName_1 = typeof name === 'string' && name !== ''
                    ? "<strong class=\"phone_text\">(".concat(escapeHtml(name), ")</strong> ")
                    : ' <span class="phone_text"></span>';
                return "".concat(contactName_1, "@").concat(escapeHtml(insta_login));
            }
            if (transport === 'instagram_post' && insta_login) {
                var contactName_2 = typeof name === 'string' && name !== ''
                    ? "<strong class=\"phone_text\">(".concat(escapeHtml(name), ")</strong> ")
                    : ' <span class="phone_text"></span>';
                return "<a href=\"/".concat(escapeHtml(insta_login), "\" target=\"_blank\">").concat(contactName_2).concat(escapeHtml(phone), "</a>");
            }
            if (_7_Chat.Chat.isWabaBsuidAddress(phone)) {
                var bsuidContactName = _7_Chat.Chat.wabaBsuidContactName({ phone: phone, name: name, name_custom: name_custom });
                var bsuidNameHtml = bsuidContactName !== ''
                    ? "<strong class=\"phone_text\">(".concat(escapeHtml(bsuidContactName), ")</strong> ")
                    : ' <span class="phone_text"></span>';
                return "".concat(bsuidNameHtml).concat(escapeHtml(_7_Chat.Chat.l('Номер скрыт')));
            }
            var contactName = typeof name === 'string' && name !== ''
                ? "<strong class=\"phone_text\">(".concat(escapeHtml(name), ")</strong> ")
                : ' <span class="phone_text"></span>';
            return "".concat(contactName).concat(escapeHtml(_7_Chat.Chat.stripTransportPrefix(phone)));
        },
        advancedSearchPhoneHtml: function (_a) {
            var phone = _a.phone, transport = _a.transport, insta_login = _a.insta_login;
            var escapeHtml = _1_Tasks.escapeHtml;
            if (transport === 'whatsapp_group')
                return '';
            if (transport === 'instagram' && typeof insta_login === 'string') {
                return '@' + escapeHtml(insta_login);
            }
            if (_7_Chat.Chat.isWabaBsuidAddress(phone))
                return escapeHtml(_7_Chat.Chat.l('Номер скрыт'));
            return escapeHtml(phone);
        },
        transportIcon: function (transport) {
            if (!transport)
                return 'fa fa-phone';
            switch (transport) {
                case 'whatsapp':
                case 'whatsapp_biz':
                    return 'fab fa-whatsapp';
                case 'whatsapp_group':
                    return 'fa fa-users';
                case 'instagram':
                case 'instagram_post':
                    return 'fab fa-instagram';
                case 'tg':
                case 'tg_group':
                    return 'fab fa-telegram';
                case 'sendapi':
                    return 'fa fa-comments';
                case 'max':
                    _7_Chat.Chat.ensureTransportIconStyles();
                    return 'sa-transport-icon sa-transport-icon--max';
                case 'max_group':
                    _7_Chat.Chat.ensureTransportIconStyles();
                    return 'sa-transport-icon sa-transport-icon--max-group';
                case 'max_channel':
                    _7_Chat.Chat.ensureTransportIconStyles();
                    return 'sa-transport-icon sa-transport-icon--max-channel';
                default:
                    return "fa fa-".concat(transport);
            }
        },
        formatAddContactChannelOption: function (optionData) {
            var optionText = typeof optionData.text === 'string' ? optionData.text : '';
            if (!optionText)
                return optionText;
            var transportRaw = optionData.element ? $(optionData.element).data('transport') : undefined;
            var transport = typeof transportRaw === 'string' ? transportRaw : undefined;
            if (!transport)
                return optionText;
            var iconTransport = transport === 'telegram' ? 'tg' : transport;
            var escapedText = $('<div>').text(optionText).html();
            return ("<span style=\"display:inline-flex;align-items:center;gap:8px;\">" +
                "<i class=\"".concat(_7_Chat.Chat.transportIcon(iconTransport), "\" style=\"width:18px;text-align:center;\"></i>") +
                "<span>".concat(escapedText, "</span>") +
                "</span>");
        },
        syncAddContactChannelSelect: function () {
            var $channelSelect = $('#text_add_channel');
            var selectedValue = String($channelSelect.val() || '');
            var selectedOptionElement = document.querySelector('#text_add_channel option:checked');
            var $label = $('#text_add_channel_label');
            var $menu = $('#text_add_channel_menu');
            $menu.find('li').removeClass('active');
            if (!selectedOptionElement || !selectedValue) {
                $label.text('Выберите канал').css('color', '#777');
                return;
            }
            $label
                .html(_7_Chat.Chat.formatAddContactChannelOption({
                text: selectedOptionElement.text,
                element: selectedOptionElement,
            }))
                .css('color', '');
            $menu
                .find(".add-contact-channel-option[data-value=\"".concat(selectedValue, "\"]"))
                .parent()
                .addClass('active');
        },
        initAddContactChannelSelect: function () {
            var $channelSelect = $('#text_add_channel');
            var $channelMenu = $('#text_add_channel_menu');
            if (!$channelMenu.length) {
                return;
            }
            var menuHtml = '';
            $channelSelect.find('option').each(function (_index, optionElement) {
                if (!(optionElement instanceof HTMLOptionElement))
                    return;
                var $option = $(optionElement);
                var optionValue = String($option.attr('value') || '');
                var optionText = $option.text();
                if (!optionValue || !optionText) {
                    return;
                }
                var escapedValue = $('<div>').text(optionValue).html();
                menuHtml +=
                    "<li><a href=\"#\" class=\"add-contact-channel-option\" data-value=\"".concat(escapedValue, "\">") +
                        "".concat(_7_Chat.Chat.formatAddContactChannelOption({
                            text: optionText,
                            element: optionElement,
                        })) +
                        "</a></li>";
            });
            $channelMenu.html(menuHtml);
            _7_Chat.Chat.syncAddContactChannelSelect();
        },
        selectAddContactChannel: function (channelValue) {
            $('#text_add_channel').val(channelValue).trigger('change');
            $('#add_contact_channel_dropdown').removeClass('open');
        },
        time_zone: function (date, from_db_with_utc) {
            var re = new RegExp('.000Z$', 'g');
            if (typeof date === 'string' && re.test(date)) {
                from_db_with_utc = true;
            }
            var chatTimeUtc = _7_Chat.Chat.chatTimeUtc !== null
                ? _7_Chat.Chat.chatTimeUtc * 60
                : _7_Chat.Chat.localOffsetInMinutes !== null
                    ? Math.abs(_7_Chat.Chat.localOffsetInMinutes)
                    : 0;
            if (!from_db_with_utc) {
                var offset = Math.abs((!isNaN(parseInt(_7_Chat.Chat.offsetInMinutes)) ? parseInt(_7_Chat.Chat.offsetInMinutes) : -360) +
                    chatTimeUtc);
                if (_7_Chat.Chat.chatTimeUtc !== null) {
                    var utcDate_1 = moment(date).subtract(offset, 'minutes').format('YYYY-MM-DD HH:mm:ss');
                    return utcDate_1;
                }
                var utcDate = moment(date).subtract(offset, 'minutes').format('YYYY-MM-DD HH:mm:ss');
                return utcDate;
            }
            else {
                var utcDate = moment(date);
                var adjustedDate = utcDate.utcOffset(chatTimeUtc);
                return adjustedDate.format('YYYY-MM-DD HH:mm:ss');
            }
        },
        is_focus: false,
        map_google: null,
        map_bing: null,
        toastr_mass: {},
        quoted_jump_in_progress: {},
        data: {},
        chat_loader: {},
        operator_data: {},
        chatoperator: '',
        serviceSite: '',
        routePath: '',
        isPageId: '',
        chatSendOnlyFile: false,
        width: 0,
        audio: (function () {
            var beepElement = document.getElementById('beep-one');
            return beepElement instanceof HTMLAudioElement ? beepElement : null;
        })(),
        audio_load: true,
        tags: [],
        outcomes: null,
        upgrade_connect_path_sio: null,
        Chat_Store: null,
        offline_boot_state: 'idle',
        auth_invalid: false,
        contacts_snapshot_last: null,
        contacts_snapshot_timeout: null,
        contacts_snapshot_max_timeout: null,
        contacts_data_upsert_pending: {},
        contacts_data_upsert_timeout: null,
        outbox_flush_running: 0,
        outbox_reflush_timer: 0,
        audio_init: function () {
            var audio = _7_Chat.Chat.audio;
            if (!audio) {
                console.warn('audio_init: audio element not found');
                return;
            }
            try {
                audio.addEventListener('loadeddata', function () {
                    _7_Chat.Chat.audio_load = true;
                    try {
                        audio.muted = false;
                    }
                    catch (e) {
                        console.warn('audio_init|muted error:', e);
                    }
                }, false);
                audio.addEventListener('error', function (e) {
                    console.warn('Audio element error:', e);
                    _7_Chat.Chat.audio_load = false;
                }, false);
            }
            catch (e) {
                console.warn('audio_init|addEventListener error:', e);
                _7_Chat.Chat.audio_load = false;
            }
        },
        audio_play: function () {
            var audio = _7_Chat.Chat.audio;
            if (!_7_Chat.Chat.audio_load || !audio) {
                console.warn('audio_play: audio not ready or not found');
                return;
            }
            try {
                if (!document.body.contains(audio)) {
                    console.warn('audio_play: audio element not in DOM');
                    _7_Chat.Chat.audio_load = false;
                    return;
                }
                try {
                    audio.currentTime = 0;
                }
                catch (e) {
                    console.warn('audio_play|currentTime error:', e);
                }
                setTimeout(function () {
                    try {
                        var playPromise = audio.play();
                        if (playPromise !== undefined) {
                            playPromise
                                .then(function () {
                            })
                                .catch(function (_error) {
                                console.warn('audio_play|play promise rejected:', _error);
                            });
                        }
                    }
                    catch (e) {
                        console.warn('audio_play|play error:', e);
                    }
                }, 500);
            }
            catch (e) {
                console.warn('audio_play|general error:', e);
                _7_Chat.Chat.audio_load = false;
            }
        },
        chat_open_subscriber_click: false,
        chat_open_subscriber: false,
        chat_view_subscriber: false,
        setChatOpenSubscriberFalse: function (reason) {
            _7_Chat.Chat.chat_open_subscriber = false;
            console.log('setChatOpenSubscriberFalse|reason=', reason);
        },
        setChatOpenSubscriber: function (phone, reason) {
            _7_Chat.Chat.chat_open_subscriber = phone;
            console.log('setChatOpenSubscriber|reason=', phone, reason);
        },
        subscriber_last_activity: {},
        wa_operator_typing_paused_timers: {},
        wa_operator_typing_last_composing_at: {},
        tg_operator_typing_paused_timers: {},
        tg_operator_typing_last_composing_at: {},
        notifyWaOperatorTypingFromComposer: function (hasText) {
            var phone = _7_Chat.Chat.chat_view_subscriber;
            if (!phone || phone === 'false') {
                return;
            }
            var phoneStr = String(phone);
            var c = _5_Contacts.Contacts.data[phoneStr];
            if (!c) {
                return;
            }
            if (c.transport !== 'whatsapp' && c.transport !== 'whatsapp_group') {
                return;
            }
            var spNumb = c.sp_numb;
            if (spNumb === undefined || spNumb === null) {
                return;
            }
            var mapKey = "".concat(phoneStr, ":").concat(String(spNumb));
            var COMPOSE_MIN_MS = 2800;
            var PAUSE_AFTER_MS = 2200;
            if (hasText) {
                var now = Date.now();
                var last = _7_Chat.Chat.wa_operator_typing_last_composing_at[mapKey] || 0;
                if (now - last >= COMPOSE_MIN_MS) {
                    _7_Chat.Chat.wa_operator_typing_last_composing_at[mapKey] = now;
                    _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                        data: {
                            query: 'wa_operator_typing',
                            phone: phoneStr,
                            sp_numb: spNumb,
                            transport: c.transport,
                            typing_phase: 'composing',
                        },
                        before: function () { },
                        success: function () { },
                        error: function () { },
                    });
                }
                var prevT = _7_Chat.Chat.wa_operator_typing_paused_timers[mapKey];
                if (prevT) {
                    clearTimeout(prevT);
                    delete _7_Chat.Chat.wa_operator_typing_paused_timers[mapKey];
                }
                _7_Chat.Chat.wa_operator_typing_paused_timers[mapKey] = setTimeout(function () {
                    delete _7_Chat.Chat.wa_operator_typing_paused_timers[mapKey];
                    _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                        data: {
                            query: 'wa_operator_typing',
                            phone: phoneStr,
                            sp_numb: spNumb,
                            transport: c.transport,
                            typing_phase: 'paused',
                        },
                        before: function () { },
                        success: function () { },
                        error: function () { },
                    });
                }, PAUSE_AFTER_MS);
            }
            else {
                var prevT = _7_Chat.Chat.wa_operator_typing_paused_timers[mapKey];
                if (prevT) {
                    clearTimeout(prevT);
                    delete _7_Chat.Chat.wa_operator_typing_paused_timers[mapKey];
                }
                _7_Chat.Chat.wa_operator_typing_last_composing_at[mapKey] = 0;
                _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'wa_operator_typing',
                        phone: phoneStr,
                        sp_numb: spNumb,
                        transport: c.transport,
                        typing_phase: 'paused',
                    },
                    before: function () { },
                    success: function () { },
                    error: function () { },
                });
            }
        },
        notifyTgOperatorTypingFromComposer: function (hasText) {
            var phone = _7_Chat.Chat.chat_view_subscriber;
            if (!phone || phone === 'false') {
                return;
            }
            var phoneStr = String(phone);
            var c = _5_Contacts.Contacts.data[phoneStr];
            if (!c) {
                return;
            }
            if (c.transport !== 'telegram' && c.transport !== 'tg_group') {
                return;
            }
            var spNumb = c.sp_numb;
            if (spNumb === undefined || spNumb === null) {
                return;
            }
            var mapKey = "tg:".concat(phoneStr, ":").concat(String(spNumb));
            var COMPOSE_MIN_MS = 2800;
            var PAUSE_AFTER_MS = 2200;
            if (hasText) {
                var now = Date.now();
                var last = _7_Chat.Chat.tg_operator_typing_last_composing_at[mapKey] || 0;
                if (now - last >= COMPOSE_MIN_MS) {
                    _7_Chat.Chat.tg_operator_typing_last_composing_at[mapKey] = now;
                    _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                        data: {
                            query: 'tg_operator_typing',
                            phone: phoneStr,
                            sp_numb: spNumb,
                            transport: c.transport,
                            typing_phase: 'composing',
                        },
                        before: function () { },
                        success: function () { },
                        error: function () { },
                    });
                }
                var prevT = _7_Chat.Chat.tg_operator_typing_paused_timers[mapKey];
                if (prevT) {
                    clearTimeout(prevT);
                    delete _7_Chat.Chat.tg_operator_typing_paused_timers[mapKey];
                }
                _7_Chat.Chat.tg_operator_typing_paused_timers[mapKey] = setTimeout(function () {
                    delete _7_Chat.Chat.tg_operator_typing_paused_timers[mapKey];
                    _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                        data: {
                            query: 'tg_operator_typing',
                            phone: phoneStr,
                            sp_numb: spNumb,
                            transport: c.transport,
                            typing_phase: 'paused',
                        },
                        before: function () { },
                        success: function () { },
                        error: function () { },
                    });
                }, PAUSE_AFTER_MS);
            }
            else {
                var prevT = _7_Chat.Chat.tg_operator_typing_paused_timers[mapKey];
                if (prevT) {
                    clearTimeout(prevT);
                    delete _7_Chat.Chat.tg_operator_typing_paused_timers[mapKey];
                }
                _7_Chat.Chat.tg_operator_typing_last_composing_at[mapKey] = 0;
                _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'tg_operator_typing',
                        phone: phoneStr,
                        sp_numb: spNumb,
                        transport: c.transport,
                        typing_phase: 'paused',
                    },
                    before: function () { },
                    success: function () { },
                    error: function () { },
                });
            }
        },
        subscriber_full: [],
        chat_open_operator: false,
        chat_increment_id: 1,
        chat_increment_get: function () {
            _7_Chat.Chat.chat_increment_id++;
            return "".concat(Date.now(), "-").concat(_7_Chat.Chat.chat_increment_id);
        },
        chat_memory: { ajax: {} },
        oneSignalUserID: false,
        oneSignalUserIDType: null,
        chat_messages: {},
        chat_messages_query: {},
        chat_messages_query_timeout: {},
        messages_open_state: null,
        messages_gap_fill: {},
        messages_gap_fill_rerun: {},
        deferred_messages: [],
        deferred_messages_id: 1,
        deferred_messages_id_get: function () {
            return _7_Chat.Chat.deferred_messages_id++;
        },
        chat_noread_operator_messages: {},
        chat_noread_operator_messages_load: function () {
            _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                data: {
                    query: 'noread_operator_messages',
                },
                before: function () { },
                success: function (data) {
                    _7_Chat.Chat.noread_operator_messages_update(data, function () {
                        _8_Chat_template.Chat_template.display_noread_operator_messages();
                        if (_7_Chat.Chat.chat_open_operator) {
                            _7_Chat.Chat.operator_messages_query(_7_Chat.Chat.chat_open_operator);
                        }
                    });
                },
            });
        },
        show_page: function (page) {
            $('.content').addClass('hidden');
            $('#' + page).removeClass('hidden');
        },
        isMobile: {
            Android: function () {
                return navigator.userAgent.match(/Android/i);
            },
            BlackBerry: function () {
                return navigator.userAgent.match(/BlackBerry/i);
            },
            iOS: function () {
                return navigator.userAgent.match(/iPhone|iPad|iPod/i);
            },
            Opera: function () {
                return navigator.userAgent.match(/Opera Mini/i);
            },
            Windows: function () {
                return navigator.userAgent.match(/IEMobile/i);
            },
            any: function () {
                return (_7_Chat.Chat.isMobile.Android() ||
                    _7_Chat.Chat.isMobile.BlackBerry() ||
                    _7_Chat.Chat.isMobile.iOS() ||
                    _7_Chat.Chat.isMobile.Opera() ||
                    _7_Chat.Chat.isMobile.Windows());
            },
        },
        lang_set: function (lang) {
            if (lang !== 'russian' && lang !== 'english' && lang !== 'kazakh') {
                throw new TypeError("Unsupported interface language: ".concat(String(lang)));
            }
            var secure = location.protocol === 'https:' ? '; Secure' : '';
            document.cookie = "lang=".concat(encodeURIComponent(lang), "; Path=/; Max-Age=31536000; SameSite=Lax").concat(secure);
            location.reload();
        },
        l: function (str) {
            try {
                if (language_mass === undefined)
                    return str;
                if (language_mass[str] === undefined)
                    return str;
            }
            catch (e) {
                return str;
            }
            return language_mass[str];
        },
        l_composite: function (source) {
            var _a;
            var exact = _7_Chat.Chat.l(source);
            if (exact !== source)
                return exact;
            var fragments = Object.keys(language_mass)
                .filter(function (key) { return key.length >= 3 && /[А-Яа-яЁё]/.test(key); })
                .sort(function (left, right) { return right.length - left.length; });
            var translated = source;
            var remainder = source;
            for (var _i = 0, fragments_1 = fragments; _i < fragments_1.length; _i++) {
                var fragment = fragments_1[_i];
                if (!remainder.includes(fragment))
                    continue;
                remainder = remainder.split(fragment).join('\u0000');
                translated = translated.split(fragment).join((_a = language_mass[fragment]) !== null && _a !== void 0 ? _a : fragment);
            }
            return /[А-Яа-яЁё]/.test(remainder) ? source : translated;
        },
        interface_i18n_observer: null,
        interface_i18n_dialogs_bound: false,
        interface_i18n_skip_selector: [
            'script',
            'style',
            'template',
            'pre',
            'code',
            '[contenteditable="true"]',
            '[data-i18n-ignore]',
            '[data-i18n-user-content]',
            '#message_height',
            '#chat_operator_messages',
            '#chat_subscribers',
            '#answer_block',
            '#waba_table',
            '.image_item',
            '.chat_user_name',
            '.chat_user_email',
            '#chat_operator_name',
            '#chat_subscrib_name',
            '#chat_subscrib_group',
        ].join(','),
        interface_translate_exact: function (source) {
            var _a, _b, _c;
            var match = source.match(/^(\s*)([\s\S]*?)(\s*)$/);
            if (!match)
                return source;
            var key = (_a = match[2]) !== null && _a !== void 0 ? _a : '';
            if (key === '')
                return source;
            return "".concat((_b = match[1]) !== null && _b !== void 0 ? _b : '').concat(_7_Chat.Chat.l(key)).concat((_c = match[3]) !== null && _c !== void 0 ? _c : '');
        },
        interface_i18n_should_skip: function (element) {
            return element !== null && element.closest(_7_Chat.Chat.interface_i18n_skip_selector) !== null;
        },
        interface_translate_element: function (element) {
            if (_7_Chat.Chat.interface_i18n_should_skip(element))
                return;
            var explicitKey = element.getAttribute('data-i18n');
            if (explicitKey)
                element.textContent = _7_Chat.Chat.l(explicitKey);
            for (var _i = 0, _a = [
                'title',
                'placeholder',
                'aria-label',
                'alt',
                'data-original-title',
            ]; _i < _a.length; _i++) {
                var attribute = _a[_i];
                var value = element.getAttribute(attribute);
                if (value === null)
                    continue;
                var translated = _7_Chat.Chat.interface_translate_exact(value);
                if (translated !== value)
                    element.setAttribute(attribute, translated);
            }
            if (element.tagName === 'INPUT' &&
                ['button', 'submit', 'reset'].includes((element.getAttribute('type') || 'text').toLowerCase())) {
                var value = element.getAttribute('value');
                if (value !== null) {
                    var translated = _7_Chat.Chat.interface_translate_exact(value);
                    if (translated !== value)
                        element.setAttribute('value', translated);
                }
            }
        },
        interface_translate_root: function (root) {
            if (root.nodeType === 3) {
                if (!_7_Chat.Chat.interface_i18n_should_skip(root.parentElement)) {
                    var source = root.nodeValue || '';
                    var translated = _7_Chat.Chat.interface_translate_exact(source);
                    if (translated !== source)
                        root.nodeValue = translated;
                }
                return;
            }
            if (root instanceof Element)
                _7_Chat.Chat.interface_translate_element(root);
            if (root instanceof Element || root instanceof Document) {
                root.querySelectorAll('*').forEach(_7_Chat.Chat.interface_translate_element);
            }
            var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
            var current = walker.nextNode();
            while (current) {
                if (!_7_Chat.Chat.interface_i18n_should_skip(current.parentElement)) {
                    var source = current.nodeValue || '';
                    var translated = _7_Chat.Chat.interface_translate_exact(source);
                    if (translated !== source)
                        current.nodeValue = translated;
                }
                current = walker.nextNode();
            }
        },
        init_interface_native_dialogs: function () {
            if (_7_Chat.Chat.interface_i18n_dialogs_bound)
                return;
            var nativeAlert = window.alert.bind(window);
            var nativeConfirm = window.confirm.bind(window);
            var nativePrompt = window.prompt.bind(window);
            window.alert = function (message) {
                nativeAlert(_7_Chat.Chat.l(String(message !== null && message !== void 0 ? message : '')));
            };
            window.confirm = function (message) {
                return nativeConfirm(_7_Chat.Chat.l(String(message !== null && message !== void 0 ? message : '')));
            };
            window.prompt = function (message, defaultValue) {
                return nativePrompt(_7_Chat.Chat.l(String(message !== null && message !== void 0 ? message : '')), defaultValue);
            };
            _7_Chat.Chat.interface_i18n_dialogs_bound = true;
        },
        init_interface_i18n: function () {
            _7_Chat.Chat.init_interface_native_dialogs();
            if (_7_Chat.Chat.interface_i18n_observer !== null)
                return;
            _7_Chat.Chat.interface_translate_root(document.documentElement);
            _7_Chat.Chat.interface_i18n_observer = new MutationObserver(function (records) {
                for (var _i = 0, records_1 = records; _i < records_1.length; _i++) {
                    var record = records_1[_i];
                    if (record.type === 'characterData') {
                        var textNode = record.target;
                        if (_7_Chat.Chat.interface_i18n_should_skip(textNode.parentElement))
                            continue;
                        var source = textNode.nodeValue || '';
                        var translated = _7_Chat.Chat.interface_translate_exact(source);
                        if (translated !== source)
                            textNode.nodeValue = translated;
                        continue;
                    }
                    if (record.type === 'attributes' && record.target instanceof Element) {
                        _7_Chat.Chat.interface_translate_element(record.target);
                        continue;
                    }
                    record.addedNodes.forEach(_7_Chat.Chat.interface_translate_root);
                }
            });
            _7_Chat.Chat.interface_i18n_observer.observe(document.documentElement, {
                subtree: true,
                childList: true,
                characterData: true,
                attributes: true,
                attributeFilter: [
                    'title',
                    'placeholder',
                    'aria-label',
                    'alt',
                    'data-original-title',
                    'value',
                    'data-i18n',
                ],
            });
        },
        url_params: function () {
            return window.location.search
                .replace('?', '')
                .split('&')
                .reduce(function (p, e) {
                var a = e.split('=');
                if (a[0] && a[1]) {
                    p[decodeURIComponent(a[0])] = decodeURIComponent(a[1]);
                }
                return p;
            }, {});
        },
        url_hash: function () {
            return window.location.hash
                .replace('#', '')
                .split('&')
                .reduce(function (p, e) {
                var a = e.split('=');
                if (a[0] && a[1]) {
                    p[decodeURIComponent(a[0])] = decodeURIComponent(a[1]);
                }
                return p;
            }, {});
        },
        chat_scroll_down: true,
        chat_scroll_position: 'top',
        chat_message_send_button: false,
        maps_k1: 0,
        maps_k2: 0,
        resize: function () {
            _7_Chat.Chat.width = $(window).width() || 0;
            var window_height = $(window).height() || 0;
            var chat_subscribe_messages = $('#chat_subscribe_messages');
            $('.wrapper').height(window_height);
            $('.content-wrapper').height(window_height - 50);
            $('.main-sidebar').height(window_height - 50);
            $('.chat_subscriber, .chat_operator').height(window_height - 165);
            chat_subscribe_messages.height(window_height - 184);
            $('.sidebar_scroll_content').addClass('nano-content');
            $('.sidebar')
                .addClass('nano')
                .height(window_height - 120)
                .nanoScroller({
                sliderMinHeight: 40,
                sliderMaxHeight: 40,
            });
            chat_subscribe_messages.nanoScroller();
            if (_7_Chat.Chat.width >= 768) {
                $('div.emoji-wysiwyg-editor.textarea_message_text').width(_7_Chat.Chat.width - 480);
            }
            else {
                $('div.emoji-wysiwyg-editor.textarea_message_text').width(_7_Chat.Chat.width - 188);
            }
        },
        onPostMessage: function (message) {
            if (!(message instanceof MessageEvent)) {
                return;
            }
            var eventRaw;
            var messageData = message.data;
            if (typeof messageData === 'object') {
                eventRaw = messageData;
            }
            else {
                try {
                    if (messageData === undefined ||
                        messageData === '' ||
                        messageData === 'webgl-fingerprint-defender-alert' ||
                        messageData === 'font-fingerprint-defender-alert' ||
                        messageData === 'canvas-fingerprint-defender-alert') {
                        return;
                    }
                    eventRaw = JSON.parse(String(messageData));
                }
                catch (error) {
                    console.error('onMessage|JSON.parse|error=', error);
                    console.error('onMessage|JSON.parse|message=', message);
                    return;
                }
            }
            var eventData = _7_Chat.Chat.readNativeBridgeEvent(eventRaw);
            if (eventData === null) {
                console.error('onMessage|сообщение оболочки не той формы|=', eventRaw);
                return;
            }
            switch (eventData.mode) {
                case 'noHasNotificationPermission':
                    alert('Вы не предоставили разрешений для получения уведомлений о входящих сообщениях');
                    return;
                case 'noIsSubscribed':
                    alert('Вы не включили получение уведомлений о входящих сообщениях');
                    return;
                case 'getPushToken':
                    if (eventData.pushUserId === undefined) {
                        console.error('onMessage|getPushToken без pushUserId|=', eventData);
                        return;
                    }
                    _7_Chat.Chat.oneSignalUserID = eventData.pushUserId;
                    _7_Chat.Chat.oneSignalUserIDType = 'ios';
                    if (eventData.os) {
                        _7_Chat.Chat.oneSignalUserIDType = eventData.os;
                    }
                    _10_Chat_WebSocket.Chat_WebSocket.send({
                        nodejs: 1,
                        command: 'set_app_push_data',
                        push_user_id: _7_Chat.Chat.oneSignalUserID,
                        push_token: eventData.pushToken,
                        type_push: _7_Chat.Chat.oneSignalUserIDType,
                        operator_id: _7_Chat.Chat.operator_data.id,
                        central_user_id: _7_Chat.Chat.operator_data.central_user_id,
                    });
                    return;
            }
        },
        AdminLTE_options: {
            sidebarExpandOnHover: false,
            screenSizes: {
                xs: 480,
                sm: 768,
                md: 992,
                lg: 1200,
            },
        },
        AdminLTE_pushMenu: {
            activate: function (toggleBtn) {
                var screenSizes = _7_Chat.Chat.AdminLTE_options.screenSizes;
                $(document).on('click', toggleBtn, function (e) {
                    var _a;
                    e.preventDefault();
                    if (((_a = $(window).width()) !== null && _a !== void 0 ? _a : 0) > screenSizes.sm - 1) {
                        if (_8_Chat_template.Chat_template.body.hasClass('sidebar-collapse')) {
                            _8_Chat_template.Chat_template.body
                                .removeClass('sidebar-collapse')
                                .trigger('expanded.pushMenu');
                        }
                        else {
                            _8_Chat_template.Chat_template.body
                                .addClass('sidebar-collapse')
                                .trigger('collapsed.pushMenu');
                        }
                    }
                    else {
                        if (_8_Chat_template.Chat_template.body.hasClass('sidebar-open')) {
                            _8_Chat_template.Chat_template.body
                                .removeClass('sidebar-open')
                                .removeClass('sidebar-collapse')
                                .trigger('collapsed.pushMenu');
                        }
                        else {
                            _8_Chat_template.Chat_template.body
                                .addClass('sidebar-open')
                                .trigger('expanded.pushMenu');
                        }
                    }
                });
                $('.content-wrapper').click(function () {
                    var _a;
                    if (((_a = $(window).width()) !== null && _a !== void 0 ? _a : 0) <= screenSizes.sm - 1 &&
                        _8_Chat_template.Chat_template.body.hasClass('sidebar-open')) {
                        _8_Chat_template.Chat_template.body.removeClass('sidebar-open');
                    }
                });
                if (_7_Chat.Chat.AdminLTE_options.sidebarExpandOnHover ||
                    (_8_Chat_template.Chat_template.body.hasClass('fixed') &&
                        _8_Chat_template.Chat_template.body.hasClass('sidebar-mini'))) {
                    this.expandOnHover();
                }
            },
            expandOnHover: function () {
                var screenWidth = _7_Chat.Chat.AdminLTE_options.screenSizes.sm - 1;
                $('.main-sidebar').hover(function () {
                    var _a;
                    if (_8_Chat_template.Chat_template.body.hasClass('sidebar-mini') &&
                        _8_Chat_template.Chat_template.body.hasClass('sidebar-collapse') &&
                        ((_a = $(window).width()) !== null && _a !== void 0 ? _a : 0) > screenWidth) {
                        _7_Chat.Chat.AdminLTE_pushMenu.expand();
                    }
                }, function () {
                    var _a;
                    if (_8_Chat_template.Chat_template.body.hasClass('sidebar-mini') &&
                        _8_Chat_template.Chat_template.body.hasClass('sidebar-expanded-on-hover') &&
                        ((_a = $(window).width()) !== null && _a !== void 0 ? _a : 0) > screenWidth) {
                        _7_Chat.Chat.AdminLTE_pushMenu.collapse();
                    }
                });
            },
            expand: function () {
                _8_Chat_template.Chat_template.body
                    .removeClass('sidebar-collapse')
                    .addClass('sidebar-expanded-on-hover');
            },
            collapse: function () {
                if (_8_Chat_template.Chat_template.body.hasClass('sidebar-expanded-on-hover')) {
                    _8_Chat_template.Chat_template.body
                        .removeClass('sidebar-expanded-on-hover')
                        .addClass('sidebar-collapse');
                }
            },
        },
        answer_btn: function (obj) {
            var answer_id = $(obj).data('chat_message_id');
            if (typeof answer_id === 'string' || typeof answer_id === 'number') {
                _7_Chat.Chat.answer_panel_open(String(answer_id));
            }
        },
        answer_panel_open: function (answer_id) {
            var $bubble = $('#mess_id_' + answer_id);
            if (!$bubble.length)
                return;
            var $copy = $('<div class="answer_mes" style="margin-bottom: 10px;padding-bottom: 10px"></div>');
            $copy.html($bubble.html());
            $copy
                .find('.answer_btn, .forward, .message_quoted, .message_menu, audio, video, iframe')
                .remove();
            $copy.append("<button type=\"button\" class=\"btn btn-xs btn-danger\" onclick=\"_7_Chat.Chat.answer_panel_close()\">".concat(_7_Chat.Chat.l('Отменить'), "</button>"));
            $('#answer_id').val(answer_id);
            $('#answer_block').removeClass('hidden').html('').append($copy);
        },
        answer_panel_close: function () {
            $('#answer_id').val('');
            $('#answer_block').addClass('hidden').html('');
        },
        imgload: function (obj) {
            var _a, _b;
            var img = $(obj);
            var height = img.height();
            var width = img.width();
            if (!height || !width)
                return;
            if (height === width) {
                img.css('width', '100%');
                img.css('height', '100%');
                img.css('margin-top', '0');
            }
            else if (height > width) {
                img.css('width', '100%');
                img.css('top', '50%');
                img.css('margin-top', '-' + ((_a = img.height()) !== null && _a !== void 0 ? _a : 0) / 2 + 'px');
            }
            else {
                img.css('height', '100%');
                img.css('left', '50%');
                img.css('margin-left', '-' + ((_b = img.width()) !== null && _b !== void 0 ? _b : 0) / 2 + 'px');
            }
            img.css('display', 'block');
        },
        imgload2: function () {
            var _a, _b, _c, _d, _f;
            var modal_images = $('#modal_images');
            modal_images.removeClass('hidden');
            var modal_images_img = $('#modal_images_img img');
            modal_images_img.height('initial');
            modal_images_img.width('initial');
            modal_images_img.css('margin-top', '0');
            modal_images_img.css('display', 'inline-block');
            modal_images_img.width('100%');
            if (((_a = modal_images_img.height()) !== null && _a !== void 0 ? _a : 0) > ((_b = modal_images.height()) !== null && _b !== void 0 ? _b : 0)) {
                modal_images_img.width('initial');
                modal_images_img.height((_c = modal_images.height()) !== null && _c !== void 0 ? _c : 0);
            }
            else {
                var top_1 = (((_d = modal_images.height()) !== null && _d !== void 0 ? _d : 0) - ((_f = modal_images_img.height()) !== null && _f !== void 0 ? _f : 0)) / 2;
                modal_images_img.css('margin-top', top_1);
            }
        },
        list_images_close: function () {
            $('#list_images').hide();
            $('#list_images_body .image_item').each(function (_indx, element) {
                var file_url = $(element).data('file_url');
                if ($(element).data('type') === 'clear') {
                    $(element).parent().remove();
                }
                else {
                    $('.image_item[data-file_url="' + file_url + '"]').remove();
                }
            });
        },
        list_images_show: function () {
            $('#list_images').show();
        },
        waba_template_escape: function (value) {
            return String(value)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#039;');
        },
        waba_template_key: function (template) {
            return "".concat(template.app_id, ":").concat(template.cmd);
        },
        waba_template_load: function (options) {
            var keepChannel = (options === null || options === void 0 ? void 0 : options.keepChannel) === true;
            var previousAppId = _7_Chat.Chat.waba_template_app_id;
            _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                data: {
                    query: 'waba_template_get',
                    phone: _7_Chat.Chat.chat_view_subscriber,
                },
                before: function () {
                    if (!keepChannel)
                        $('#waba_table').html('');
                },
                success: function (data) {
                    var _a;
                    if (data.result === 0) {
                        _7_Chat.Chat.waba_template = {};
                        $('#modal_waba_template_id').removeData('template_key');
                        _7_Chat.Chat.waba_template_list = data.template;
                        _7_Chat.Chat.waba_template_channels = data.channels;
                        if (_7_Chat.Chat.waba_template_list.length === 0) {
                            $('#waba_table').html(_7_Chat.Chat.l('Нет шаблонов'));
                            return;
                        }
                        if (_7_Chat.Chat.waba_template_channels.length === 0) {
                            console.error('waba_template_load|channels are missing for non-empty catalog');
                            $('#waba_table').html(_7_Chat.Chat.l('Ошибка контракта WABA-каталога'));
                            return;
                        }
                        var currentAppId = data.current_app_id === null ? null : Number(data.current_app_id);
                        var channelExists = function (appId) {
                            return appId !== null &&
                                _7_Chat.Chat.waba_template_channels.some(function (channel) { return Number(channel.app_id) === appId; });
                        };
                        var firstChannel = (_a = _7_Chat.Chat.waba_template_channels.find(function (channel) { return channel.available; })) !== null && _a !== void 0 ? _a : _7_Chat.Chat.waba_template_channels[0];
                        if (keepChannel && channelExists(previousAppId)) {
                            _7_Chat.Chat.waba_template_app_id = previousAppId;
                        }
                        else if (channelExists(currentAppId)) {
                            _7_Chat.Chat.waba_template_app_id = currentAppId;
                        }
                        else if (firstChannel !== undefined) {
                            _7_Chat.Chat.waba_template_app_id = Number(firstChannel.app_id);
                        }
                        else {
                            _7_Chat.Chat.waba_template_app_id = null;
                        }
                        _7_Chat.Chat.waba_template_render();
                        return;
                    }
                    swal({
                        title: 'ОШИБКА!',
                        html: data.msg,
                        type: 'error',
                        cancelButtonText: 'Закрыть',
                    });
                },
                error: function () {
                    if (!keepChannel) {
                        $('#waba_table').html(_7_Chat.Chat.l('Ошибка загрузки. Повторите действие.'));
                    }
                },
            });
        },
        waba_template_render: function () {
            var _a, _b, _c;
            var channels = _7_Chat.Chat.waba_template_channels;
            var activeAppId = _7_Chat.Chat.waba_template_app_id;
            var html = '';
            if (channels.length > 1) {
                html += '<div class="waba_template_channels" style="margin-bottom: 10px;">';
                for (var _i = 0, channels_1 = channels; _i < channels_1.length; _i++) {
                    var channel = channels_1[_i];
                    var isActive = Number(channel.app_id) === Number(activeAppId);
                    var channelLabel = _7_Chat.Chat.waba_template_escape((_a = channel.phone_number) !== null && _a !== void 0 ? _a : channel.app_id);
                    html +=
                        '<button type="button" class="btn btn-xs waba_template_channel ' +
                            (isActive ? 'btn-primary' : 'btn-default') +
                            (channel.available ? '' : ' waba_template_channel_off') +
                            '" style="margin: 0 5px 5px 0;' +
                            (channel.available ? '' : ' opacity: 0.65;') +
                            '" title="' +
                            _7_Chat.Chat.waba_template_escape((_b = channel.unavailable_reason) !== null && _b !== void 0 ? _b : '') +
                            '" data-app_id="' +
                            Number(channel.app_id) +
                            '">' +
                            channelLabel +
                            '</button>';
                }
                html += '</div>';
            }
            var activeChannel = channels.find(function (channel) { return Number(channel.app_id) === Number(activeAppId); });
            if (activeChannel !== undefined && !activeChannel.available) {
                html +=
                    '<div class="alert alert-warning waba_template_unavailable" style="margin-bottom: 10px;">' +
                        "<b>".concat(_7_Chat.Chat.l('Отправка недоступна.'), "</b> ") +
                        _7_Chat.Chat.waba_template_escape(_7_Chat.Chat.l((_c = activeChannel.unavailable_reason) !== null && _c !== void 0 ? _c : 'Номер недоступен')) +
                        '</div>';
            }
            var rows = _7_Chat.Chat.waba_template_list.filter(function (item) { return Number(item.app_id) === Number(activeAppId); });
            if (rows.length === 0) {
                $('#waba_table').html(html + _7_Chat.Chat.l('Нет шаблонов'));
                return;
            }
            var tbl = '<table class="table display table-striped waba_template_table">';
            for (var index = 0; index < rows.length; index++) {
                var item = rows[index];
                if (item === undefined)
                    continue;
                var templateKey = _7_Chat.Chat.waba_template_key(item);
                _7_Chat.Chat.waba_template[templateKey] = item;
                var sendClass = item.params_count > 0 ? 'waba_template_dop' : 'waba_template_send';
                var titleText = item.title !== undefined && item.title !== '' ? item.title : item.cmd;
                var actionCell = item.available
                    ? "<button type=\"button\" class=\"btn btn-default btn-xs ".concat(sendClass, "\" data-template_key=\"").concat(_7_Chat.Chat.waba_template_escape(templateKey), "\">").concat(_7_Chat.Chat.l('Отправить'), "</button>")
                    : "<span class=\"text-muted waba_template_send_off\">".concat(_7_Chat.Chat.l('Отправка недоступна'), "</span>");
                tbl +=
                    '<tr data-cmd="' +
                        _7_Chat.Chat.waba_template_escape(item.cmd) +
                        '">' +
                        '<td class="waba_template_title" style="white-space: nowrap; vertical-align: middle;"><b>' +
                        _7_Chat.Chat.waba_template_escape(titleText) +
                        '</b></td>' +
                        '<td class="waba_template_message">' +
                        _7_Chat.Chat.waba_template_escape(item.message) +
                        '</td>' +
                        '<td style="white-space: nowrap; vertical-align: middle;">' +
                        actionCell +
                        '</td></tr>';
            }
            tbl += '</table>';
            $('#waba_table').html(html + tbl);
        },
        init_check: false,
        setupDatepickerLocale: function () {
            $.datepicker.regional['ru'] = {
                closeText: 'Закрыть',
                prevText: '&#x3C;Пред',
                nextText: 'След&#x3E;',
                currentText: 'Сегодня',
                monthNames: [
                    'Январь',
                    'Февраль',
                    'Март',
                    'Апрель',
                    'Май',
                    'Июнь',
                    'Июль',
                    'Август',
                    'Сентябрь',
                    'Октябрь',
                    'Ноябрь',
                    'Декабрь',
                ],
                monthNamesShort: [
                    'Янв',
                    'Фев',
                    'Мар',
                    'Апр',
                    'Май',
                    'Июн',
                    'Июл',
                    'Авг',
                    'Сен',
                    'Окт',
                    'Ноя',
                    'Дек',
                ],
                dayNames: [
                    'воскресенье',
                    'понедельник',
                    'вторник',
                    'среда',
                    'четверг',
                    'пятница',
                    'суббота',
                ],
                dayNamesShort: ['вск', 'пнд', 'втр', 'срд', 'чтв', 'птн', 'сбт'],
                dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
                weekHeader: 'Нед',
                dateFormat: 'dd.mm.yy',
                firstDay: 1,
                isRTL: false,
                showMonthAfterYear: false,
                yearSuffix: '',
            };
            $.datepicker.regional['kk'] = {
                closeText: 'Жабу',
                prevText: '&#x3C;Алдыңғы',
                nextText: 'Келесі&#x3E;',
                currentText: 'Бүгін',
                monthNames: [
                    'Қаңтар',
                    'Ақпан',
                    'Наурыз',
                    'Сәуір',
                    'Мамыр',
                    'Маусым',
                    'Шілде',
                    'Тамыз',
                    'Қыркүйек',
                    'Қазан',
                    'Қараша',
                    'Желтоқсан',
                ],
                monthNamesShort: [
                    'Қаң',
                    'Ақп',
                    'Нау',
                    'Сәу',
                    'Мам',
                    'Мау',
                    'Шіл',
                    'Там',
                    'Қыр',
                    'Қаз',
                    'Қар',
                    'Жел',
                ],
                dayNames: ['жексенбі', 'дүйсенбі', 'сейсенбі', 'сәрсенбі', 'бейсенбі', 'жұма', 'сенбі'],
                dayNamesShort: ['жс', 'дс', 'сс', 'ср', 'бс', 'жм', 'сн'],
                dayNamesMin: ['Жс', 'Дс', 'Сс', 'Ср', 'Бс', 'Жм', 'Сн'],
                weekHeader: 'Апта',
                dateFormat: 'dd.mm.yy',
                firstDay: 1,
                isRTL: false,
                showMonthAfterYear: false,
                yearSuffix: '',
            };
            var datepickerLanguages = {
                en: '',
                'ru-RU': 'ru',
                'kk-KZ': 'kk',
            };
            var defaultDatepickerLanguage = 'ru';
            var documentLanguage = document.documentElement.lang;
            var datepickerLanguage = datepickerLanguages[documentLanguage];
            if (datepickerLanguage === undefined) {
                console.error('setupDatepickerLocale|unsupported document language=', documentLanguage, '|оболочка страницы и бандл разошлись по версиям, календарь — на русской локали');
                datepickerLanguage = defaultDatepickerLanguage;
            }
            var datepickerRegional = $.datepicker.regional[datepickerLanguage];
            if (!datepickerRegional) {
                console.error('setupDatepickerLocale|missing datepicker locale=', datepickerLanguage);
                return;
            }
            $.datepicker.setDefaults(datepickerRegional);
            $('.datepicker').datepicker({
                locale: datepickerLanguage || 'en',
            });
        },
        init: function (config) {
            var _a;
            console.log('ww|init|1');
            _7_Chat.Chat.init_check = true;
            _7_Chat.Chat.init_interface_i18n();
            _7_Chat.Chat.audio_init();
            console.log('ww|init|2');
            this.data = $.extend({
                chat_version: '',
                chat_version_new: '',
                myajax: '',
                oneSignalUserID: '',
                oneSignalUserIDType: '',
                navbarPageId: '/?page_id=192',
                chatoperator: '/ws/si/chatoperator',
                serviceSite: '/site',
                routePath: '/chat',
                chat_time_utc: localStorage.getItem('chat_time_utc'),
                local_offset_in_minutes: new Date().getTimezoneOffset(),
            }, config);
            console.log('ww|Chat|this.data=', this.data);
            _7_Chat.Chat.navbarPageId = this.data.navbarPageId || '';
            _7_Chat.Chat.isPageId = this.data.isPageId || '';
            _7_Chat.Chat.offsetInMinutes = this.data.offsetInMinutes || '';
            _7_Chat.Chat.localOffsetInMinutes = (_a = this.data.local_offset_in_minutes) !== null && _a !== void 0 ? _a : null;
            _7_Chat.Chat.chatSendOnlyFile = Boolean(this.data.chatSendOnlyFile);
            _7_Chat.Chat.chatoperator = this.data.chatoperator || '';
            _7_Chat.Chat.serviceSite = this.data.serviceSite || '';
            _7_Chat.Chat.chatTimeUtc = isNaN(parseInt(this.data.chat_time_utc || ''))
                ? null
                : parseInt(this.data.chat_time_utc || '');
            if (this.data.debugSite)
                _7_Chat.Chat.serviceSite = this.data.debugSite;
            else if (this.data.debugSite2)
                _7_Chat.Chat.serviceSite = this.data.debugSite2;
            _7_Chat.Chat.routePath = this.data.routePath || '';
            console.log('ww|init|3');
            _7_Chat.Chat.is_focus = true;
            window.onblur = function () {
                _7_Chat.Chat.is_focus = false;
            };
            window.onfocus = function () {
                if (_7_Chat.Chat.is_focus === false) {
                    _7_Chat.Chat.is_focus = true;
                    auto_read();
                }
                _7_Chat.Chat.is_focus = true;
            };
            console.log('ww|init|4');
            if (_7_Chat.Chat.data.oneSignalUserID !== '') {
                _7_Chat.Chat.oneSignalUserID = _7_Chat.Chat.data.oneSignalUserID || '';
            }
            if (_7_Chat.Chat.data.oneSignalUserIDType !== '') {
                _7_Chat.Chat.oneSignalUserIDType = _7_Chat.Chat.data.oneSignalUserIDType || null;
            }
            if (_7_Chat.Chat.win_programm_version()) {
                $('.clear_win_programm').remove();
            }
            _7_Chat.Chat.is_chat_loader({ websocket: false });
            _7_Chat.Chat.is_chat_loader({ get_operator: false });
            _7_Chat.Chat.is_chat_loader({ contacts_init: false });
            _7_Chat.Chat.cacheBootTry();
            _7_Chat.Chat.initLoaderWatchdog();
            var dexieOn = typeof Chat_useDexie !== 'undefined' && Chat_useDexie;
            if (dexieOn && !_7_Chat.Chat.outbox_reflush_timer) {
                _7_Chat.Chat.outbox_reflush_timer = window.setInterval(function () {
                    if (_7_Chat.Chat.chat_loader['websocket'])
                        _7_Chat.Chat.outboxFlush();
                }, 30000);
            }
            console.log('ww|init|5');
            _7_Chat.Chat.hang_handlers();
        },
        init_tooltips: function () {
            try {
                $('.menu_tabs a[title], .menu_tabs button[title]').tooltip({
                    container: 'body',
                    placement: 'bottom',
                    trigger: 'hover',
                });
            }
            catch (error) {
                console.error('init_tooltips|error=', error);
            }
        },
        hang_handlers_check: false,
        openSubscriberPhone: function () {
            var phone = _7_Chat.Chat.chat_open_subscriber;
            if (!phone || phone === 'false')
                return null;
            return String(phone);
        },
        viewSubscriberPhone: function () {
            var phone = _7_Chat.Chat.chat_view_subscriber;
            if (!phone || phone === 'false')
                return null;
            return String(phone);
        },
        avatar_full_html: function (params) {
            var transport = params.transport, avatar = params.avatar, phone = params.phone, avatar_full = params.avatar_full;
            var stamp = Math.floor(Date.now() / 1000);
            if (avatar_full && avatar_full !== 'null') {
                return "<img width=\"100%\" src=\"".concat(avatar_full, "?").concat(stamp, "\" alt=\"avatar_full\">");
            }
            if (transport === 'whatsapp' || transport === 'instagram') {
                if (Number(avatar) === 1) {
                    return "<img width=\"100%\" src=\"/wp-content/uploads/2010/10/".concat(String(phone), ".jpg?").concat(stamp, "\" alt=\"avatar_full\">");
                }
                return '<div style="padding: 40px;color: #a2a2a2;border: 1px solid #ddd;"><i class="fa fa-spinner fa-spin"></i></div>';
            }
            return "<div style=\"padding: 40px;color: #a2a2a2;border: 1px solid #ddd;\">".concat(_7_Chat.Chat.l('Нет фото'), "</div>");
        },
        readAuthorizationCheck: function (data) {
            if (typeof data !== 'object' || data === null || Array.isArray(data))
                return null;
            var res = data['res'];
            var user = data['user'];
            if (typeof res !== 'number')
                return null;
            if (typeof user !== 'object' || user === null || Array.isArray(user))
                return null;
            var id = user['id'];
            if (typeof id !== 'string' && typeof id !== 'number')
                return null;
            return { res: res, user: { id: id } };
        },
        readNativeBridgeEvent: function (value) {
            if (typeof value !== 'object' || value === null || Array.isArray(value))
                return null;
            var optionalString = function (item) {
                return item === undefined || typeof item === 'string';
            };
            var mode = Reflect.get(value, 'mode');
            var pushUserId = Reflect.get(value, 'pushUserId');
            var os = Reflect.get(value, 'os');
            var pushToken = Reflect.get(value, 'pushToken');
            if (typeof mode !== 'string')
                return null;
            if (!optionalString(pushUserId) || !optionalString(os) || !optionalString(pushToken)) {
                return null;
            }
            return { mode: mode, pushUserId: pushUserId, os: os, pushToken: pushToken };
        },
        readChatOperatorData: function (value) {
            if (typeof value !== 'object' || value === null || Array.isArray(value))
                return null;
            var id = value['id'];
            var centralUserId = value['central_user_id'];
            var isLegacyId = function (item) {
                return typeof item === 'string' || typeof item === 'number';
            };
            if (!isLegacyId(id) || !isLegacyId(centralUserId))
                return null;
            return __assign(__assign({}, value), { id: id, central_user_id: centralUserId });
        },
        readGetOperatorData: function (data) {
            if (typeof data !== 'object' || data === null || Array.isArray(data))
                return null;
            var result = data['result'];
            if (typeof result !== 'number' && typeof result !== 'string')
                return null;
            var operator = data['data'];
            if (operator !== undefined && (typeof operator !== 'object' || operator === null))
                return null;
            var authForm = data['auth_form'];
            if (authForm !== undefined && typeof authForm !== 'string')
                return null;
            var answer = { result: result };
            if (operator !== undefined) {
                var operatorData = _7_Chat.Chat.readChatOperatorData(operator);
                if (operatorData === null)
                    return null;
                answer.data = operatorData;
            }
            if (typeof authForm === 'string')
                answer.auth_form = authForm;
            var integration = data['integration'];
            if (integration !== undefined) {
                if (!isChatIntegrationList(integration))
                    return null;
                answer.integration = integration;
            }
            return answer;
        },
        hang_handlers: function () {
            if (_7_Chat.Chat.hang_handlers_check)
                return;
            _7_Chat.Chat.hang_handlers_check = true;
            var Contacts = _5_Contacts.Contacts;
            var Tasks = _1_Tasks.Tasks;
            var FileUpload = _6_FileUpload.FileUpload;
            var Chat_WebSocket = _10_Chat_WebSocket.Chat_WebSocket;
            var Chat_template = _8_Chat_template.Chat_template;
            console.log('ww|hang_handlers');
            _7_Chat.Chat.get_operator_data();
            _7_Chat.Chat.init_tooltips();
            setInterval(function () {
                if (Object.keys(Tasks).length === 0)
                    return;
                Object.keys(Tasks).forEach(function (item) {
                    if (item === 'sorter_load')
                        _4_Sorter.Sorter.load();
                    delete Tasks[item];
                });
            }, 2000);
            _7_Chat.Chat.show_page('chat_home');
            setTimeout(function () {
                $('.sidebar')
                    .nanoScroller()
                    .on('update', $.throttle(300, function (_event, values) {
                    if (typeof values === 'object' && values !== null) {
                        var position = Reflect.get(values, 'position');
                        var maximum = Reflect.get(values, 'maximum');
                        if (typeof position === 'number' && typeof maximum === 'number') {
                            _4_Sorter.Sorter.handler({ position: position, maximum: maximum });
                        }
                    }
                }));
            }, 500);
            $(document).ready(function () {
                'use strict';
                var _a, _b;
                $('#fileupload_avatar')
                    .fileupload({
                    url: _7_Chat.Chat.routePath + '/chat_avatar_upload',
                    dataType: 'json',
                    formData: {
                        action: 'myajax-submit',
                        form_action: 'fileupload_avatar',
                    },
                    dropZone: $('#dropzone'),
                    autoUpload: false,
                    disableImageResize: /Android(?!.*Chrome)|Opera/.test(window.navigator.userAgent),
                    acceptFileTypes: /(\.|\/)(gif|jpe?g|png)$/i,
                    maxFileSize: 2048,
                    add: function (_e, data) {
                        data.submit();
                    },
                    start: function () {
                        $('#progress3').removeClass('hidden');
                        $('#progress3 .progress-bar').css('width', '0%');
                    },
                    done: function (_e, data) {
                        if (data.result.result === 0) {
                            if (data.result.avatar && typeof data.result.avatar === 'string') {
                                $('.avatar_img').html(data.result.avatar);
                            }
                            $('#progress3').addClass('hidden');
                        }
                        else {
                            toastr.options.closeButton = true;
                            if (data.result.result_description &&
                                typeof data.result.result_description === 'string') {
                                toastr.error(data.result.result_description);
                            }
                            $('#progress3').addClass('hidden');
                        }
                    },
                    fail: function (_e, data) {
                        console.error('fail');
                        console.error({ e: _e, data: data });
                        $('#progress3').addClass('hidden');
                    },
                    progressall: function (_e, data) {
                        var progress = parseInt(String((data.loaded / data.total) * 100), 10);
                        $('#progress3 .progress-bar').css('width', progress + '%');
                    },
                })
                    .prop('disabled', !((_a = $.support) === null || _a === void 0 ? void 0 : _a.fileInput))
                    .parent()
                    .addClass(((_b = $.support) === null || _b === void 0 ? void 0 : _b.fileInput) ? '' : 'disabled');
            });
            Chat_WebSocket.ping_time = Date.now();
            setInterval(function () {
                Chat_WebSocket.heartbeatTick(Date.now());
            }, 30000);
            setInterval(function () {
                var _a;
                if (count_obj(_7_Chat.Chat.subscriber_last_activity)) {
                    var t = Math.floor(Date.now() / 1000);
                    for (var key in _7_Chat.Chat.subscriber_last_activity) {
                        var pp = t - ((_a = _7_Chat.Chat.subscriber_last_activity[key]) !== null && _a !== void 0 ? _a : 0);
                        if (pp > 60 && String(_7_Chat.Chat.chat_view_subscriber) !== String(key)) {
                            delete _7_Chat.Chat.subscriber_last_activity[key];
                            delete _7_Chat.Chat.chat_messages[key];
                        }
                    }
                }
            }, 10000);
            _7_Chat.Chat.AdminLTE_pushMenu.activate('[data-toggle="offcanvas"]');
            _7_Chat.Chat.setupDatepickerLocale();
            Chat_template.body.on('click', '.waba_template_open', function () {
                $('#modal_waba_template_show').modal('show');
                _7_Chat.Chat.waba_template_load();
            });
            Chat_template.body.on('click', '.waba_template_channel', function () {
                var appId = $(this).data('app_id');
                if (appId === undefined || appId === null) {
                    console.error('waba_template_channel|app_id is missing');
                    return;
                }
                _7_Chat.Chat.waba_template_app_id = Number(appId);
                _7_Chat.Chat.waba_template_render();
            });
            Chat_template.body.on('click', '.waba_template_dop', function () {
                var templateKey = $(this).data('template_key');
                if (typeof templateKey !== 'string') {
                    console.error('waba_template_dop|template_key is missing');
                    return;
                }
                var template = _7_Chat.Chat.waba_template[templateKey];
                if (!template) {
                    console.error('waba_template_dop|template is missing|template_key=', templateKey);
                    return;
                }
                $('#template_text').val(template.message);
                $('#modal_waba_template_id').data('template_key', templateKey);
                if (template.params_count > 0) {
                    var labels = _7_Chat.Chat.templatePlaceholderLabels(template.message);
                    var template_dop = '';
                    for (var i = 1; i <= template.params_count; i++) {
                        var label = labels[i - 1];
                        template_dop +=
                            '<div class="form-group">\n' +
                                ' <label class="col-sm-3 control-label">{{' +
                                (label === undefined ? String(i) : label) +
                                '}}</label>\n' +
                                ' <div class="col-sm-9">\n' +
                                '  <input type="text" class="form-control template_dop_item">\n' +
                                ' </div>\n' +
                                '</div>';
                    }
                    $('#template_dop').html(template_dop);
                }
                $('#modal_waba_template_dop_show').modal('show');
            });
            Chat_template.body.on('click', '.waba_template_send', function () {
                if (!_7_Chat.Chat.chat_open_subscriber) {
                    swal({
                        title: 'ОШИБКА!',
                        html: 'Клиента обслуживает другой оператор',
                        type: 'error',
                        cancelButtonText: 'Закрыть',
                    });
                    return;
                }
                var templateKey = $(this).data('template_key');
                if (typeof templateKey !== 'string') {
                    console.error('waba_template_send|template_key is missing');
                    return;
                }
                var template = _7_Chat.Chat.waba_template[templateKey];
                if (!template) {
                    console.error('waba_template_send|template is missing|template_key=', templateKey);
                    return;
                }
                var template_params = [];
                if (template.params_count > 0) {
                    $('.template_dop_item').each(function (_indx, element) {
                        var value = $(element).val();
                        if (typeof value === 'string' && value !== '')
                            template_params.push(value);
                    });
                    if (template_params.length !== template.params_count) {
                        swal({
                            title: 'ОШИБКА!',
                            html: 'Заполнены не все дополнительные поля.',
                            type: 'error',
                            cancelButtonText: 'Закрыть',
                        });
                        return;
                    }
                }
                swal({
                    title: 'Отправить шаблон?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Отправить',
                    cancelButtonText: 'Отмена',
                }).then(function (result) {
                    if (!result.value)
                        return;
                    Chat_WebSocket.ajax_nodejs({
                        data: {
                            query: 'waba_template_send',
                            phone: _7_Chat.Chat.chat_open_subscriber,
                            cmd: template.cmd,
                            template_app_id: template.app_id,
                            sp_numb: template.sp_numb,
                            template_params: template_params,
                        },
                        before: function () { },
                        success: function (data) {
                            if (+data.result === 0 && data.phone) {
                                $('#modal_waba_template_show').modal('hide');
                                $('#modal_waba_template_dop_show').modal('hide');
                                _7_Chat.Chat.click_mark_as_read(data.phone);
                                swal({
                                    title: 'УСПЕХ!',
                                    html: 'Шаблон отправлен',
                                    type: 'success',
                                    cancelButtonText: 'Закрыть',
                                });
                                _7_Chat.Chat.messages_get({
                                    phone: data.phone,
                                    scroll: 'bottom',
                                    direction: 'DOWN',
                                });
                                return;
                            }
                            swal({
                                title: 'ОШИБКА!',
                                html: data.msg,
                                type: 'error',
                                cancelButtonText: 'Закрыть',
                            });
                        },
                        error: function () {
                            swal({
                                title: 'ОШИБКА!',
                                html: 'Ошибка отправки шаблона. Повторите действие.',
                                type: 'error',
                                cancelButtonText: 'Закрыть',
                            });
                        },
                    });
                });
            });
            Chat_template.body.on('click', '#chat_category_dropdown .category-item', function () {
                var categId = $(this).attr('data-id');
                $('.chat-categ-nav-item').removeClass('active');
                Contacts.category_open(categId);
            });
            Chat_template.body.on('click', '#chat_category .chat-categ-nav-item', function () {
                $('.chat-categ-nav-item').removeClass('active');
                $(this).addClass('active');
                Contacts.category_open($(this).attr('data-id'));
            });
            Chat_template.body.on('click', '#chat_category .chat-categ-section', function () {
                var section = $(this).attr('data-section');
                $(this).toggleClass('collapsed');
                $(".chat-categ-section-items[data-section=\"".concat(section, "\"]")).toggleClass('collapsed');
            });
            Chat_template.body.on('click', '.modal_maps_open', function () {
                var maps1 = $(this).data('maps_1');
                var maps2 = $(this).data('maps_2');
                var mapsUrl = $(this).data('maps_url');
                if (typeof maps1 === 'number') {
                    _7_Chat.Chat.maps_k1 = maps1;
                }
                if (typeof maps2 === 'number') {
                    _7_Chat.Chat.maps_k2 = maps2;
                }
                if (mapsUrl !== undefined && mapsUrl !== null && typeof mapsUrl !== 'object') {
                    $('#maps_url').attr('href', String(mapsUrl));
                }
                $('#modal_maps').modal('show');
            });
            $('#modal_maps')
                .on('shown.bs.modal', function () {
                if (_7_Chat.Chat.map_google === null) {
                    _7_Chat.Chat.map_google = 1;
                    $('body').append('<script src="https://api-maps.yandex.ru/2.1?apikey=20738d5a-6646-4f7a-9039-051eb8930d44&onload=initMapGoogle&lang=ru_RU"><\/script>');
                }
                else {
                    initMapGoogle();
                }
            })
                .on('hidden.bs.modal', function (_e) {
                $('#maps_google').html('<i class="fa fa-circle-notch fa-spin"></i>');
            });
            Chat_template.body.on('click', '.modal_maps_open_bing', function () {
                var maps1 = $(this).data('maps_1');
                var mapsUrl = $(this).data('maps_url');
                if (typeof maps1 === 'number') {
                    _7_Chat.Chat.maps_k1 = maps1;
                }
                if (typeof mapsUrl === 'string') {
                    $('#maps_url_bing').attr('href', decodeURIComponent(mapsUrl));
                }
                $('#modal_maps_bing').modal('show');
            });
            $('#modal_maps_bing')
                .on('shown.bs.modal', function () {
                if (_7_Chat.Chat.map_google === null) {
                    $('body').append('<script async defer src="https://maps.googleapis.com/maps/api/js?key=AIzaSyDXKmIdq0E0cI7pC0lfFjXyjhS7LM-3d3M&callback=initMapGoogle_bing"><\/script>');
                }
                else {
                    initMapGoogle_bing();
                }
            })
                .on('hidden.bs.modal', function () {
                $('#maps_bing').html('<i class="fa fa-circle-notch fa-spin"></i>');
            });
            var modal_recorder_audio = $('#modal_recorder_audio');
            Chat_template.body
                .on('click', '#recorder_audio', function () {
                modal_recorder_audio.modal('show');
            })
                .on('click', '#button_recorder_upload', function () {
                if (sound_blob !== null) {
                    var $fileupload3 = $('#fileupload3');
                    if ($fileupload3.data('blueimp-fileupload')) {
                        $fileupload3.fileupload('add', { files: sound_blob });
                        modal_recorder_audio.modal('hide');
                    }
                    else {
                        console.error('File upload plugin is not initialized.');
                        toastr.error('Не удалось добавить голосовую запись. Попробуйте еще раз');
                    }
                }
            });
            modal_recorder_audio
                .on('shown.bs.modal', function () { })
                .on('hidden.bs.modal', function (_e) { });
            $('#beep-one').load();
            var textarea_message_text2_timeout = function () {
                setTimeout(function () {
                    if ($('div').is('.textarea_message_text')) {
                        _7_Chat.Chat.obj.textarea_message_text2 = $('.textarea_message_text');
                    }
                    else {
                        textarea_message_text2_timeout();
                    }
                }, 200);
            };
            textarea_message_text2_timeout();
            if (_7_Chat.Chat.audio) {
                _7_Chat.Chat.audio.addEventListener('ended', function () {
                    _7_Chat.Chat.audio_load = true;
                }, false);
            }
            autosize($('.textarea_message_text, #textarea_operator_text'));
            _7_Chat.Chat.resize();
            $(window).resize(function () {
                _7_Chat.Chat.resize();
            });
            var $chat_subscribe_messages = $('#chat_subscribe_messages');
            var $chat_scroll = (function () {
                var $nanoContent = $chat_subscribe_messages.find('.nano-content');
                return $nanoContent.length ? $nanoContent : $chat_subscribe_messages;
            })();
            $chat_subscribe_messages
                .bind('scrollend', function (_e) { })
                .bind('scrolltop', function (_e) {
                var _a;
                $chat_scroll.scrollTop(100);
                var phone = _7_Chat.Chat.chat_view_subscriber;
                if (phone && ((_a = _7_Chat.Chat.chat_messages[phone]) === null || _a === void 0 ? void 0 : _a.load_history_chek) === 1) {
                    var message_id_min = _7_Chat.Chat.chat_messages[phone].message_id_min;
                    _7_Chat.Chat.message_preloader('show');
                    if (_7_Chat.Chat.isMobile.any()) {
                        _7_Chat.Chat.messages_get({
                            phone: phone,
                            direction: 'UP',
                            message_id: message_id_min !== null && message_id_min !== void 0 ? message_id_min : undefined,
                        });
                    }
                    else {
                        _7_Chat.Chat.messages_get({
                            phone: phone,
                            direction: 'UP',
                            message_id: message_id_min !== null && message_id_min !== void 0 ? message_id_min : undefined,
                        });
                    }
                }
            })
                .scroll(function (_e) {
                var _a, _b;
                var scrollEl = $chat_scroll[0];
                var visibleHeight = (_a = $chat_scroll.height()) !== null && _a !== void 0 ? _a : 0;
                var scrollHeight = scrollEl ? scrollEl.scrollHeight : 0;
                var maxScrollTop = scrollHeight - visibleHeight + 10;
                var currentScrollTop = (_b = $chat_scroll.scrollTop()) !== null && _b !== void 0 ? _b : 0;
                _7_Chat.Chat.chat_scroll_down = currentScrollTop === 0 || maxScrollTop <= currentScrollTop;
                if (currentScrollTop === 100) {
                    _7_Chat.Chat.chat_scroll_position = 'top';
                }
                else if (currentScrollTop >= 100 && maxScrollTop > currentScrollTop) {
                    _7_Chat.Chat.chat_scroll_position = 'center';
                }
                else if (maxScrollTop <= currentScrollTop) {
                    _7_Chat.Chat.chat_scroll_position = 'bottom';
                }
                else if (currentScrollTop < 100) {
                    $chat_scroll.scrollTop(100);
                }
            });
            Chat_template.body.on('click', '.my_work', function () {
                _7_Chat.Chat.click_my_work($(this));
            });
            Chat_template.body.on('click', '#end_dialog_window_button', function () {
                _7_Chat.Chat.end_dialog_save_data();
            });
            $('#chat_message_send').on('click', _7_Chat.Chat.click_message_send);
            Chat_template.body.on('keyup paste', '#textarea_message_text', function (e) {
                var composer = e.currentTarget;
                if (!(composer instanceof HTMLTextAreaElement)) {
                    console.error('textarea_message_text|keyup|элемент не textarea');
                    return;
                }
                var viewPhone = _7_Chat.Chat.viewSubscriberPhone();
                if (viewPhone === null)
                    return;
                _2_Draft.Draft.put_t(viewPhone, composer.value);
                if (!!_7_Chat.Chat.isMobile.iOS()) {
                    if ($(this).val() !== '') {
                        $('.message_send_button').removeClass('hidden');
                        $('#audio_message_record').addClass('hidden');
                    }
                    else {
                        if (!Contacts.instagram2_check(viewPhone)) {
                            $('.message_send_button').addClass('hidden');
                            $('#audio_message_record').removeClass('hidden');
                        }
                        else {
                            $('.message_send_button').removeClass('hidden');
                            $('#audio_message_record').addClass('hidden');
                        }
                    }
                    $(this).focus();
                    var InputThis = $(this);
                    if (e.which === 32) {
                        var quick_messages_data = _7_Chat.Chat.quick_messages_get();
                        if (quick_messages_data !== null) {
                            var quick_messages = quick_messages_data.quick_messages;
                            if (Array.isArray(quick_messages) && quick_messages.length > 0) {
                                var _loop_1 = function (key) {
                                    if (!quick_messages[key]) {
                                        return "continue";
                                    }
                                    var _a = quick_messages[key], command = _a.command, message = _a.message, file_json = _a.file_json;
                                    var text = composer.value;
                                    var Reg = void 0;
                                    try {
                                        Reg = new RegExp('-' + command + ' ', 'i');
                                    }
                                    catch (error) {
                                        console.error('RegExp|error=', error);
                                        return "continue";
                                    }
                                    var pos = text.search(Reg);
                                    if (pos >= 0) {
                                        text = text.replace('-' + command + ' ', message + ' ');
                                        $(this_1).val(text);
                                        if (file_json) {
                                            if (Array.isArray(file_json)) {
                                                file_json.forEach(function (file_item) {
                                                    FileUpload.fileNormalize({ url: file_item.fileUrl, ext: file_item.fileExt }, function (e) {
                                                        var fileUrlAttr = _1_Tasks.escapeHtml(file_item.fileUrl);
                                                        $('#list_images_body').prepend("<div class=\"p_load image_item\" data-file_url=\"".concat(fileUrlAttr, "\">\n") +
                                                            " <button class=\"btn btn-default btn-xs pull-right image_item_delete\" data-file_url=\"".concat(fileUrlAttr, "\" data-type=\"clear\">") +
                                                            '  <i class="fas fa-trash-alt"></i></button> ' +
                                                            e.html +
                                                            '</div>');
                                                    });
                                                });
                                            }
                                            else {
                                                if (file_json.fileUrl) {
                                                    FileUpload.fileNormalize({ url: file_json.fileUrl, ext: file_json.fileExt }, function (e) {
                                                        var fileUrlAttr = _1_Tasks.escapeHtml(file_json.fileUrl);
                                                        $('#list_images_body').prepend("<div class=\"p_load image_item\" data-file_url=\"".concat(fileUrlAttr, "\">\n") +
                                                            " <button class=\"btn btn-default btn-xs pull-right image_item_delete\" data-file_url=\"".concat(fileUrlAttr, "\" data-type=\"clear\">") +
                                                            '  <i class="fas fa-trash-alt"></i></button> ' +
                                                            e.html +
                                                            '</div>');
                                                    });
                                                }
                                            }
                                            _7_Chat.Chat.list_images_show();
                                        }
                                        try {
                                            var editorElement = document.getElementsByClassName('emoji-wysiwyg-editor')[0];
                                            if (editorElement) {
                                                var range = document.createRange();
                                                range.selectNodeContents(editorElement);
                                                range.collapse(false);
                                                var sel = window.getSelection();
                                                if (sel) {
                                                    sel.removeAllRanges();
                                                    sel.addRange(range);
                                                }
                                            }
                                        }
                                        catch (e) { }
                                        InputThis.focus();
                                    }
                                };
                                var this_1 = this;
                                for (var key in quick_messages) {
                                    _loop_1(key);
                                }
                            }
                        }
                    }
                    $(this).removeClass('warning');
                    _7_Chat.Chat.obj.id_warning_info.addClass('hidden');
                    var count_simvol = composer.value.length;
                    if (count_simvol > 1800 && count_simvol < 2000) {
                        _7_Chat.Chat.obj.id_warning_info
                            .removeClass('hidden')
                            .css('background', '#999999')
                            .html(_7_Chat.Chat.l('Осталось символов:') + ' ' + (2000 - count_simvol));
                    }
                    else if (count_simvol === 2000) {
                        $(this).addClass('warning');
                        _7_Chat.Chat.obj.id_warning_info
                            .removeClass('hidden')
                            .css('background', '#f39c12')
                            .html(_7_Chat.Chat.l('Осталось символов:') + ' ' + (2000 - count_simvol));
                    }
                }
                var plainIos = composer.value.trim();
                _7_Chat.Chat.notifyWaOperatorTypingFromComposer(plainIos.length > 0);
                _7_Chat.Chat.notifyTgOperatorTypingFromComposer(plainIos.length > 0);
            });
            Chat_template.body
                .on('keydown', '.emoji-wysiwyg-editor.textarea_message_text', function (e) {
                var viewPhone = _7_Chat.Chat.viewSubscriberPhone();
                if (viewPhone === null)
                    return;
                _2_Draft.Draft.put_d(viewPhone, $(this).html());
                $(this).focus();
                if (e.which === 13 && !e.ctrlKey && !e.shiftKey) {
                    $(this).blur();
                    e.preventDefault();
                    _7_Chat.Chat.click_message_send();
                }
            })
                .on('keyup paste', '.emoji-wysiwyg-editor.textarea_message_text', function (e) {
                var viewPhone = _7_Chat.Chat.viewSubscriberPhone();
                if (viewPhone === null)
                    return;
                _2_Draft.Draft.put_d(viewPhone, $(this).html());
                if ($(this).html() !== '') {
                    $('.message_send_button').removeClass('hidden');
                    $('#audio_message_record').addClass('hidden');
                }
                else {
                    if (!Contacts.instagram2_check(viewPhone)) {
                        $('.message_send_button').addClass('hidden');
                        $('#audio_message_record').removeClass('hidden');
                    }
                    else {
                        $('.message_send_button').removeClass('hidden');
                        $('#audio_message_record').addClass('hidden');
                    }
                }
                $(this).focus();
                var InputThis = $(this);
                if ((!_7_Chat.Chat.isMobile.Android() && e.which === 32) ||
                    (!!_7_Chat.Chat.isMobile.Android() && $(this).text().substr(-1) == ' ')) {
                    var quick_messages_data = _7_Chat.Chat.quick_messages_get();
                    if (quick_messages_data !== null) {
                        var quick_messages = quick_messages_data.quick_messages;
                        if (Array.isArray(quick_messages) && quick_messages.length > 0) {
                            var _loop_2 = function (key) {
                                if (!quick_messages[key]) {
                                    return "continue";
                                }
                                var _a = quick_messages[key], command = _a.command, message = _a.message, file_json = _a.file_json;
                                var text = $(this_2).html();
                                var Reg = void 0;
                                try {
                                    Reg = new RegExp('-' + command + '&nbsp;', 'i');
                                }
                                catch (error) {
                                    console.error('RegExp|error=', error);
                                    return "continue";
                                }
                                var pos = text.search(Reg);
                                if (pos >= 0) {
                                    text = text.replace('-' + command + '&nbsp;', Chat_template.nl2br(_1_Tasks.escapeHtml(message)) + '&nbsp;');
                                    $(this_2).html(text);
                                    if (file_json) {
                                        if (Array.isArray(file_json)) {
                                            var _loop_3 = function (fileUrl, fileExt) {
                                                FileUpload.fileNormalize({ url: fileUrl, ext: fileExt }, function (e) {
                                                    var fileUrlAttr = _1_Tasks.escapeHtml(fileUrl);
                                                    $('#list_images_body').prepend("<div class=\"p_load image_item\" data-file_url=\"".concat(fileUrlAttr, "\">\n") +
                                                        " <button class=\"btn btn-default btn-xs pull-right image_item_delete\" data-file_url=\"".concat(fileUrlAttr, "\" data-type=\"clear\">") +
                                                        '  <i class="fas fa-trash-alt"></i></button> ' +
                                                        e.html +
                                                        '</div>');
                                                });
                                            };
                                            for (var _i = 0, file_json_1 = file_json; _i < file_json_1.length; _i++) {
                                                var _b = file_json_1[_i], fileUrl = _b.fileUrl, fileExt = _b.fileExt;
                                                _loop_3(fileUrl, fileExt);
                                            }
                                        }
                                        else {
                                            if (file_json.fileUrl) {
                                                FileUpload.fileNormalize({ url: file_json.fileUrl, ext: file_json.fileExt }, function (e) {
                                                    var fileUrlAttr = _1_Tasks.escapeHtml(file_json.fileUrl);
                                                    $('#list_images_body').prepend("<div class=\"p_load image_item\" data-file_url=\"".concat(fileUrlAttr, "\">\n") +
                                                        " <button class=\"btn btn-default btn-xs pull-right image_item_delete\" data-file_url=\"".concat(fileUrlAttr, "\" data-type=\"clear\">") +
                                                        '  <i class="fas fa-trash-alt"></i></button> ' +
                                                        e.html +
                                                        '</div>');
                                                });
                                            }
                                        }
                                        _7_Chat.Chat.list_images_show();
                                    }
                                    var editorElement = document.getElementsByClassName('emoji-wysiwyg-editor')[0];
                                    if (editorElement) {
                                        var range = document.createRange();
                                        range.selectNodeContents(editorElement);
                                        range.collapse(false);
                                        var sel = window.getSelection();
                                        if (sel) {
                                            sel.removeAllRanges();
                                            sel.addRange(range);
                                        }
                                    }
                                    InputThis.focus();
                                }
                            };
                            var this_2 = this;
                            for (var key in quick_messages) {
                                _loop_2(key);
                            }
                        }
                    }
                }
                $(this).removeClass('warning');
                _7_Chat.Chat.obj.id_warning_info.addClass('hidden');
                var count_simvol = $(this).html().length;
                if (count_simvol > 1800 && count_simvol < 2000) {
                    _7_Chat.Chat.obj.id_warning_info
                        .removeClass('hidden')
                        .css('background', '#999999')
                        .html('Осталось символов: ' + (2000 - count_simvol));
                }
                else if (count_simvol === 2000) {
                    $(this).addClass('warning');
                    _7_Chat.Chat.obj.id_warning_info
                        .removeClass('hidden')
                        .css('background', '#f39c12')
                        .html('Осталось символов: ' + (2000 - count_simvol));
                }
                var editorPlain = $(this)
                    .text()
                    .replace(/\u00a0/g, ' ')
                    .trim();
                _7_Chat.Chat.notifyWaOperatorTypingFromComposer(editorPlain.length > 0);
                _7_Chat.Chat.notifyTgOperatorTypingFromComposer(editorPlain.length > 0);
            });
            var search_check = false;
            var search_text_l = '';
            var search_text_q = '';
            $('#search-btn').on('click', function () {
                if ($(this).children('i').hasClass('fa-times')) {
                    $('#search_phone_text').val('');
                    search_text_l = '';
                    $('#search_content').addClass('hidden');
                    $('#search-btn i').addClass('fa-search').removeClass('fa-times');
                }
                else {
                    $('#modal_advanced_search').modal('show');
                }
            });
            function search_handler(search_text) {
                var search_text_str = String(search_text).trim();
                if (search_text_str !== '' && search_text_str.length > 2) {
                    if (search_text_l === search_text_str)
                        return;
                    if (search_check) {
                        if (search_text_q !== search_text_l)
                            search_text_q = search_text_str;
                        return;
                    }
                    search_text_l = search_text_str;
                    search_check = true;
                    Chat_WebSocket.ajax_nodejs({
                        data: {
                            query: 'search_subscribers',
                            search_text: search_text_str,
                        },
                        before: function () {
                            $('#search-btn i').removeClass('fa-search fa-times').addClass('fa-spin fa-spinner');
                        },
                        success: function (data) {
                            search_check = false;
                            if (Number(data.result) === 0) {
                                search_handler_view(data);
                                if (search_text_q !== '') {
                                    if (search_text_q === $('#search_phone_text').val()) {
                                        search_handler(search_text_q);
                                        search_text_q = '';
                                    }
                                    else {
                                        search_text_q = '';
                                    }
                                }
                            }
                        },
                        error: function () {
                            search_check = false;
                        },
                    });
                }
                else {
                    $('#search_content').addClass('hidden');
                    $('#search-btn i').addClass('fa-search ').removeClass('fa-times fa-spin fa-spinner');
                }
            }
            function search_handler_view(data) {
                var escapeHtml = _1_Tasks.escapeHtml;
                if (count_obj(data.phones)) {
                    var search_content_phone = "<li class=\"header\">".concat(_7_Chat.Chat.l('КОНТАКТЫ'), "</li>");
                    var search_content_phone_k = 0;
                    var search_content_text = "<li class=\"header\">".concat(_7_Chat.Chat.l('СООБЩЕНИЯ'), "</li>");
                    var search_content_text_k = 0;
                    for (var key in data.phones) {
                        if (!data.phones.hasOwnProperty(key))
                            continue;
                        var open_1 = '';
                        if (_7_Chat.Chat.chat_open_subscriber === key) {
                            open_1 = ' show_subscriber';
                        }
                        if (!Contacts.data.hasOwnProperty(key)) {
                            var keyEscaped_1 = escapeHtml(key);
                            Contacts.data_get({ phone: key }, function (_a) {
                                var phone = _a.phone;
                                var contact = Contacts.data[phone];
                                if (!contact) {
                                    console.error('accurate_search|contact_data_get|нет контакта в реестре=', phone);
                                    return;
                                }
                                var transport = contact.transport, name = contact.name, name_custom = contact.name_custom, insta_login = contact.insta_login, telegram_login = contact.telegram_login;
                                var _b = _7_Chat.Chat.getContactPresentationData({
                                    phone: phone,
                                    transport: transport,
                                    name: name,
                                    name_custom: name_custom,
                                    insta_login: insta_login,
                                    telegram_login: telegram_login,
                                }), contactIcon = _b.contactIcon, contactName = _b.contactName, contactPhone = _b.contactPhone;
                                var phoneEscaped = escapeHtml(phone);
                                $(".contact_item_search[data-phone=\"".concat(phoneEscaped, "\"]")).html("<i class=\"".concat(contactIcon, "\"></i> <b>").concat(contactName, "</b> ").concat(contactPhone));
                            }, function (_a) {
                                var phone = _a.phone;
                                var phoneEscaped = escapeHtml(String(phone !== null && phone !== void 0 ? phone : ''));
                                $(".contact_item_search[data-phone=\"".concat(phoneEscaped, "\"]")).remove();
                            });
                            if (data.phones[key] === 'phone') {
                                search_content_phone_k++;
                                search_content_phone +=
                                    "<li data-phone=\"".concat(keyEscaped_1, "\" data-i18n-user-content class=\"contact_item_search ").concat(open_1, "\" onclick=\"_7_Chat.Chat.click_open_subscriber({phone:'").concat(keyEscaped_1, "',call_from:'Chat|search_handler|phone_spinner'})\">") +
                                        "<i class=\"fa fa-spinner fa-spin\"></i></li>";
                            }
                            else {
                                search_content_text_k++;
                                search_content_text +=
                                    "<li data-phone=\"".concat(keyEscaped_1, "\" data-i18n-user-content class=\"contact_item_search ").concat(open_1, "\" onclick=\"_7_Chat.Chat.click_open_subscriber({phone:'").concat(keyEscaped_1, "',call_from:'Chat|search_handler|text_spinner'})\">") +
                                        "<i class=\"fa fa-spinner fa-spin\"></i></li>";
                            }
                            continue;
                        }
                        var searchContact = Contacts.data[key];
                        if (!searchContact) {
                            console.error('search_handler|нет контакта в реестре=', key);
                            continue;
                        }
                        var transport = searchContact.transport, name_2 = searchContact.name, name_custom = searchContact.name_custom, insta_login = searchContact.insta_login, telegram_login = searchContact.telegram_login;
                        var _a = _7_Chat.Chat.getContactPresentationData({
                            phone: key,
                            transport: transport,
                            name: name_2,
                            name_custom: name_custom,
                            insta_login: insta_login,
                            telegram_login: telegram_login,
                        }), contactIcon = _a.contactIcon, contactName = _a.contactName, contactPhone = _a.contactPhone;
                        var keyEscaped = escapeHtml(key);
                        if (data.phones[key] === 'phone') {
                            search_content_phone_k++;
                            search_content_phone +=
                                "<li data-phone=\"".concat(keyEscaped, "\" data-i18n-user-content class=\"contact_item_search ").concat(open_1, "\" onclick=\"_7_Chat.Chat.click_open_subscriber({phone:'").concat(keyEscaped, "',call_from:'Chat|search_handler|phone'})\">") +
                                    "<i class=\"".concat(contactIcon, "\"></i> ") +
                                    "<b>".concat(contactName, "</b>") +
                                    " ".concat(contactPhone, " </li>");
                        }
                        else {
                            search_content_text_k++;
                            search_content_text +=
                                "<li data-phone=\"".concat(keyEscaped, "\" data-i18n-user-content class=\"contact_item_search ").concat(open_1, "\" onclick=\"_7_Chat.Chat.click_open_subscriber({phone:'").concat(keyEscaped, "',call_from:'Chat|search_handler|text'})\">") +
                                    "<i class=\"".concat(contactIcon, "\"></i> <b>").concat(contactName, "</b> ").concat(contactPhone, " </li>");
                        }
                    }
                    if (search_content_phone_k === 0 && search_content_text_k === 0)
                        $('#search_content').addClass('hidden');
                    else {
                        $('#search_result_kol').html(count_obj(data.phones).toString());
                        $('#search_content').removeClass('hidden');
                    }
                    $('#search_li').html(search_content_phone + '' + search_content_text);
                    $('#search-btn i').removeClass('fa-search fa-spin fa-spinner').addClass('fa-times');
                }
                else {
                    $('#search_result_kol').html('0');
                    $('#search_content').removeClass('hidden');
                    $('#search_li').html('<li class="text-center help-block"><small>По данному запросу номера<br> не найдены</small></li>');
                    $('#search-btn i').removeClass('fa-search fa-spin fa-spinner').addClass('fa-times');
                }
            }
            $('#search_phone_text').keyup($.debounce(1000, false, function () {
                search_handler($(this).val());
                return null;
            }));
            Chat_template.body.on('click', '.user_logout', function () {
                _7_Chat.Chat.logout();
            });
            Chat_template.body.on('click', '.open_img', function () {
                var modal_images = $('#modal_images');
                modal_images.removeClass('hidden');
                var img_url = $(this).data('img_url');
                if (typeof img_url === 'undefined')
                    img_url = $(this).attr('src');
                var modal_images_img = $('#modal_images_img img');
                modal_images_img.height('initial');
                modal_images_img.width('initial');
                modal_images_img.css('margin-top', '0');
                modal_images_img.css('display', 'none');
                if (img_url !== undefined && img_url !== null && typeof img_url !== 'object') {
                    modal_images_img.attr('src', String(img_url));
                }
            });
            Chat_template.body.on('click', '#modal_images, #modal_images_close', function () {
                $('#modal_images').addClass('hidden');
            });
            Chat_template.body.on('click', '#ai_no_process_icon', function () {
                toastr.info('ИИ-ассистент не обрабатывает этот диалог — сразу передаётся оператору');
            });
            Chat_template.body.on('click', '#button_edit_phone', function () {
                Button.preloader($('#button_edit_phone'));
                var viewPhone = _7_Chat.Chat.viewSubscriberPhone();
                if (viewPhone === null)
                    return;
                Contacts.data_get({ phone: viewPhone }, function (subscribers) {
                    Button.reset($('#button_edit_phone'));
                    var category = subscribers.category, phone = subscribers.phone, tel = subscribers.tel, name = subscribers.name, name_custom = subscribers.name_custom, transport = subscribers.transport, status = subscribers.status, notes = subscribers.notes, avatar = subscribers.avatar, avatar_full = subscribers.avatar_full;
                    $('#always_to_manager_row').toggleClass('hidden', _7_Chat.Chat.operator_data.check_chat_online !== 1);
                    $('#text_edit_always_to_manager').prop('checked', !!subscribers.always_to_manager);
                    var category_select = '';
                    for (var key in Contacts.category) {
                        if (key === '0' || !Contacts.category[key])
                            continue;
                        category_select += "<option value=\"".concat(key, "\">").concat(_1_Tasks.escapeHtml(Contacts.category[key].n), "</option>");
                    }
                    $('#text_edit_category').html(category_select).val(category);
                    $('#text_edit_phone').html(phone);
                    $('#text_edit_tel').val(tel);
                    $('#text_edit_name').val(name);
                    $('#text_edit_name_custom').val(name_custom === undefined || name_custom === '' ? name : name_custom);
                    var status_list = {
                        1: 'Подписан',
                        6: 'Заблокирован',
                    };
                    if (transport === 'whatsapp') {
                        status_list = {
                            1: 'Подписан',
                            2: 'Отписан от рассылки',
                            6: 'Заблокирован',
                        };
                    }
                    var status_select = '';
                    for (var key in status_list) {
                        status_select += "<option value=\"".concat(key, "\" ").concat(status === key ? 'selected' : '', ">").concat(status_list[key], "</option>");
                    }
                    $('#text_edit_status').html(status_select);
                    $('#modal_edit_phone_name').modal('show');
                    $('#text_edit_notes').val(notes);
                    $('#avatar_full').html(_7_Chat.Chat.avatar_full_html({ transport: transport, avatar: avatar, phone: phone, avatar_full: avatar_full }));
                    var $text_edit_phone_parent_x2 = $('#text_edit_phone').parent().parent();
                    if (transport === 'whatsapp_group') {
                        $text_edit_phone_parent_x2.hide();
                    }
                    else {
                        $text_edit_phone_parent_x2.show();
                    }
                    if (transport === 'whatsapp') {
                        Chat_WebSocket.ajax_nodejs({
                            data: { query: 'update_wp_profile_img', phone: _7_Chat.Chat.chat_view_subscriber },
                            before: function () { },
                            success: function (_data) { },
                            error: function (error) {
                                console.error('ajax_nodejs|update_wp_profile_img|error=', error);
                            },
                        });
                    }
                    if (transport === 'instagram') {
                        Chat_WebSocket.ajax_nodejs({
                            data: {
                                query: 'update_instagram',
                                phone: _7_Chat.Chat.chat_view_subscriber,
                            },
                            before: function () { },
                            success: function (_data) { },
                            error: function (error) {
                                console.error('ajax_nodejs|update_instagram|error=', error);
                            },
                        });
                    }
                }, function () {
                    Button.reset($('#button_edit_phone'));
                });
            });
            Chat_template.body.on('click', '#button_save_phone', function () {
                var status = $('#text_edit_status').val();
                if (status == 6) {
                    if (!confirm('Контакт будет скрыт из списка контактов. Вы не будете получать сообщения от этого контакта. Вы подтверждаете блокировку?'))
                        return;
                }
                Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'contact_data_edit',
                        phone: $('#text_edit_phone').html(),
                        name: $('#text_edit_name').val(),
                        name_custom: $('#text_edit_name_custom').val(),
                        tel: $('#text_edit_tel').val(),
                        category: $('#text_edit_category').val(),
                        notes: $('#text_edit_notes').val(),
                        status: status,
                        always_to_manager: $('#text_edit_always_to_manager').is(':checked'),
                    },
                    before: function () {
                        Button.preloader($('#button_save_phone'));
                    },
                    success: function (data) {
                        if (data.result === 0) {
                            var phone_1 = _7_Chat.Chat.viewSubscriberPhone();
                            if (phone_1 === null)
                                return;
                            $('#ai_no_process_icon').toggleClass('hidden', !$('#text_edit_always_to_manager').is(':checked'));
                            Contacts.data_get({ phone: phone_1 }, function (chat_subscribers_data) {
                                var _a;
                                $('#chat_subscrib_name').html(_7_Chat.Chat.getSubscriberNameHtml({
                                    phone: phone_1,
                                    transport: chat_subscribers_data['transport'],
                                    name: chat_subscribers_data['name'],
                                    name_custom: chat_subscribers_data['name_custom'],
                                    insta_login: chat_subscribers_data['insta_login'],
                                    telegram_login: chat_subscribers_data['telegram_login'],
                                }));
                                var categ_list = [];
                                if ((_a = chat_subscribers_data.category) === null || _a === void 0 ? void 0 : _a.length) {
                                    for (var key in chat_subscribers_data.category) {
                                        var categoryId = chat_subscribers_data.category[key];
                                        var category = categoryId !== undefined ? Contacts.category[categoryId] : undefined;
                                        if (chat_subscribers_data.category.hasOwnProperty(key) && category) {
                                            categ_list.push(category.n);
                                        }
                                    }
                                }
                                categ_list = categ_list.join(', ');
                                $('#chat_subscrib_group').text(categ_list).attr('title', categ_list);
                                Contacts.category_noread_load(function () {
                                    Tasks['sorter_load'] = true;
                                });
                            }, function (error) {
                                console.error('data_get|error=', error);
                            });
                            if (status == 6) {
                                Contacts.no_read_check(phone_1);
                                _7_Chat.Chat.show_page('chat_home');
                                delete Contacts.data[phone_1];
                                setTimeout(function () {
                                    Contacts.category_noread_load(function () {
                                        Tasks['sorter_load'] = true;
                                    });
                                }, 1000);
                            }
                            $('#modal_edit_phone_name').modal('hide');
                        }
                        else {
                            swal({
                                title: 'ОШИБКА!',
                                html: 'Не удалось сохранить изменения. Повторите действие.',
                                type: 'error',
                                cancelButtonText: 'Закрыть',
                            });
                        }
                        Button.reset($('#button_save_phone'));
                    },
                    error: function () {
                        Button.reset($('#button_save_phone'));
                    },
                });
            });
            Chat_template.body.on('click', '.mark_as_read', function () {
                _7_Chat.Chat.click_mark_as_read(undefined);
            });
            Chat_template.body.on('click', '.withdraw_chat_from_operator', function () {
                var phoneAttr = $(this).data('phone');
                var operatorName = $(this).data('operator-name') || _7_Chat.Chat.l('оператора');
                if (typeof phoneAttr !== 'string' && typeof phoneAttr !== 'number') {
                    console.error('withdraw_chat_from_operator|phone не строка и не число|=', phoneAttr);
                    return;
                }
                var phone = String(phoneAttr);
                if (!phone) {
                    console.error('withdraw_chat_from_operator|!phone');
                    return;
                }
                var toOperatorId = _7_Chat.Chat.operator_data.id;
                if (toOperatorId === undefined) {
                    console.error('withdraw_chat_from_operator|данные оператора ещё не загружены');
                    return;
                }
                var confirmMsg = _7_Chat.Chat.l('Изъять чат у') + ' ' + operatorName + ' ' + _7_Chat.Chat.l('и взять в работу?');
                if (!confirm(confirmMsg)) {
                    return;
                }
                Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'withdraw_chat_from_operator',
                        phone: phone,
                        to_operator_id: toOperatorId,
                    },
                    before: function () {
                        $('.withdraw_chat_from_operator').prop('disabled', true);
                    },
                    success: function (data) {
                        if (data.result === 0) {
                            Chat_WebSocket.send({
                                nodejs: 1,
                                command: 'alien_work',
                            });
                            Contacts.work_load(1, function () {
                                Tasks['sorter_load'] = true;
                                _7_Chat.Chat.click_open_subscriber({
                                    phone: phone,
                                    call_from: 'Chat|withdraw_chat_from_operator|refresh_opened',
                                });
                            });
                            toastr.success(_7_Chat.Chat.l('Чат успешно изъят у') + ' ' + operatorName);
                        }
                        else {
                            swal({
                                title: 'ОШИБКА!',
                                html: data.msg || 'Не удалось изъять чат. Повторите действие.',
                                type: 'error',
                                cancelButtonText: 'Закрыть',
                            });
                        }
                        $('.withdraw_chat_from_operator').prop('disabled', false);
                    },
                    error: function () {
                        swal({
                            title: 'ОШИБКА!',
                            html: 'Произошла ошибка при изъятии чата',
                            type: 'error',
                            cancelButtonText: 'Закрыть',
                        });
                        $('.withdraw_chat_from_operator').prop('disabled', false);
                    },
                });
            });
            Chat_template.body.on('show.bs.modal', '#my_work_to_operator', function () {
                _7_Chat.Chat.ai_transfer_status_query();
            });
            Chat_template.body.on('click', '#my_work_to_operator_button', function () {
                var operatop_to = $('#my_work_to_operator_operator_list').val();
                var comment = $('#my_work_to_operator_comment').val();
                if (empty(operatop_to) || empty(comment)) {
                    swal({
                        title: _7_Chat.Chat.l('ОШИБКА!'),
                        html: _7_Chat.Chat.l('Заполнены не все поля'),
                        type: 'error',
                        cancelButtonText: _7_Chat.Chat.l('Закрыть'),
                    });
                    return;
                }
                Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'my_work_to_operator',
                        phone: _7_Chat.Chat.chat_open_subscriber,
                        operatop_to: operatop_to,
                        comment: comment,
                    },
                    before: function () {
                        Button.preloader($('#my_work_to_operator_button'));
                    },
                    success: function (data) {
                        if (data.result === 0) {
                            Chat_WebSocket.send({
                                nodejs: 1,
                                command: 'alien_work',
                            });
                            Contacts.work_load(1, function () {
                                Tasks['sorter_load'] = true;
                                var openPhone = _7_Chat.Chat.openSubscriberPhone();
                                if (openPhone !== null) {
                                    _7_Chat.Chat.click_open_subscriber({
                                        phone: openPhone,
                                        call_from: 'Chat|my_work_to_operator|refresh_opened',
                                    });
                                }
                            });
                            $('#my_work_to_operator').modal('hide');
                            $('#my_work_to_operator_comment').val('');
                        }
                        else {
                            var refusal = _0_Constants.aiTransferRefusalOf(data['reason']);
                            if (refusal !== null)
                                Chat_template.display_ai_transfer_option(refusal);
                            swal({
                                title: _7_Chat.Chat.l('ОШИБКА!'),
                                html: _7_Chat.Chat.l(refusal === null
                                    ? 'Не удалось передать чат. Повторите действие.'
                                    : _0_Constants.AI_TRANSFER_REFUSAL_TEXT[refusal]),
                                type: 'error',
                                cancelButtonText: _7_Chat.Chat.l('Закрыть'),
                            });
                        }
                        Button.reset($('#my_work_to_operator_button'));
                    },
                    error: function () {
                        Button.reset($('#my_work_to_operator_button'));
                    },
                });
            });
            Chat_template.body.on('click', '.image_item_delete', function () {
                var file_url = $(this).data('file_url');
                if ($(this).data('type') === 'clear') {
                    $(this).parent().remove();
                }
                else {
                    if (typeof file_url === 'string') {
                        _7_Chat.Chat.click_img_delete2(file_url);
                    }
                }
                var callback = $(this).data('callback');
                if (callback && (typeof callback === 'string' || typeof callback === 'number')) {
                    var fileUploadCallback = void 0;
                    switch (String(callback)) {
                        case 'cb_quickMessages':
                            fileUploadCallback = FileUpload.cb_quickMessages;
                            break;
                        default:
                            fileUploadCallback = undefined;
                    }
                    if (typeof fileUploadCallback !== 'function') {
                        console.error('!FileUpload[callback]|callback=', callback);
                        return;
                    }
                    fileUploadCallback.call(FileUpload);
                }
            });
            Chat_template.body.on('click', '.quick_messages_item .message_text', function () {
                var key = $(this).data('id');
                if (typeof key !== 'number') {
                    console.warn('[TypeGuard] quick_messages_item: key имеет неверный тип', {
                        key: key,
                        type: typeof key,
                    });
                    return;
                }
                if (!_7_Chat.Chat.quick_messages_data)
                    return;
                var quick_messages = _7_Chat.Chat.quick_messages_data.quick_messages[key];
                if (!quick_messages)
                    return;
                if (!empty(quick_messages.message)) {
                    _7_Chat.Chat.obj.textarea_message_text2.html(_7_Chat.Chat.obj.textarea_message_text2.html() +
                        Chat_template.nl2br(_1_Tasks.escapeHtml(quick_messages.message)));
                    _7_Chat.Chat.obj.textarea_message_text.val(_7_Chat.Chat.obj.textarea_message_text.val() + quick_messages.message);
                }
                if (quick_messages.file_json) {
                    var file_json_2 = quick_messages.file_json;
                    if (Array.isArray(file_json_2)) {
                        file_json_2.forEach(function (file_item) {
                            FileUpload.fileNormalize({ url: file_item.fileUrl, ext: file_item.fileExt }, function (e) {
                                var fileUrlAttr = _1_Tasks.escapeHtml(file_item.fileUrl);
                                $('#list_images_body').prepend("<div class=\"p_load image_item\" data-file_url=\"".concat(fileUrlAttr, "\">\n") +
                                    " <button class=\"btn btn-default btn-xs pull-right image_item_delete\" data-file_url=\"".concat(fileUrlAttr, "\" data-type=\"clear\">") +
                                    '  <i class="fas fa-trash-alt"></i></button> ' +
                                    e.html +
                                    '</div>');
                            });
                        });
                    }
                    else {
                        if (file_json_2.fileUrl) {
                            FileUpload.fileNormalize({ url: file_json_2.fileUrl, ext: file_json_2.fileExt }, function (e) {
                                var fileUrlAttr = _1_Tasks.escapeHtml(file_json_2.fileUrl);
                                $('#list_images_body').prepend("<div class=\"p_load image_item\" data-file_url=\"".concat(fileUrlAttr, "\">\n") +
                                    " <button class=\"btn btn-default btn-xs pull-right image_item_delete\" data-file_url=\"".concat(fileUrlAttr, "\" data-type=\"clear\">") +
                                    '  <i class="fas fa-trash-alt"></i></button> ' +
                                    e.html +
                                    '</div>');
                            });
                        }
                    }
                    _7_Chat.Chat.list_images_show();
                }
                $('#quick_messages').modal('hide');
            });
            $('#quick_messages').on('hidden.bs.modal', function (_e) {
                $('#collapseQuickMessagesADD').removeClass('in');
            });
            Chat_template.body.on('click', '.quick_messages_delete', function () {
                if (!confirm('Удалить запись?'))
                    return;
                var quick_messages_id = $(this).data('quick_messages_id');
                if (typeof quick_messages_id !== 'number' || quick_messages_id <= 0) {
                    console.warn('[TypeGuard] quick_messages_delete: quick_messages_id имеет неверный тип или значение', { quick_messages_id: quick_messages_id, type: typeof quick_messages_id });
                    return;
                }
                Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'quick_messages_delete',
                        quick_messages_id: quick_messages_id,
                    },
                    before: function () { },
                    success: function (data) {
                        if (data.result === 0) {
                            _7_Chat.Chat.quick_messages_query();
                        }
                        else {
                            swal({
                                title: 'ОШИБКА!',
                                html: data.msg || 'Не удалось удалить запись. Повторите действие.',
                                type: 'error',
                                cancelButtonText: 'Закрыть',
                            });
                        }
                    },
                });
            });
            Chat_template.body.on('click', '#quick_messages_save', function () {
                var command = $('#template_command').val();
                var name = $('#template_name').val();
                var message = $('#template_message').val();
                if (command === '' || name === '' || message === '') {
                    swal({
                        title: 'ОШИБКА!',
                        html: 'Заполнены не все поля',
                        type: 'error',
                        cancelButtonText: 'Закрыть',
                    });
                    return;
                }
                Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'quick_messages_save',
                        command: command,
                        name: name,
                        message: message,
                    },
                    before: function () { },
                    success: function (data) {
                        if (data.result === 0) {
                            _7_Chat.Chat.quick_messages_query();
                            $('#template_command').val('');
                            $('#template_name').val('');
                            $('#template_message').val('');
                            $('#collapseQuickMessagesADD').removeClass('in');
                        }
                        else {
                            swal({
                                title: 'ОШИБКА!',
                                html: data.msg || 'Не удалось сохранить изменения. Повторите действие.',
                                type: 'error',
                                cancelButtonText: 'Закрыть',
                            });
                        }
                    },
                });
            });
            Chat_template.body.on('click', '.quick_messages_edit_show', function () {
                if ($(this).data('quick_messages_id') === '') {
                    $('#button_quick_messages_edit').data('quick_messages_id', '');
                    $('#template_command_edit').val('');
                    $('#template_name_edit').val('');
                    $('#template_message_edit').val('');
                    $('#quick_message_files').html('');
                    $('#modal_quick_messages_edit').modal('show');
                    return;
                }
                var quick_messages_id = Number($(this).data('quick_messages_id'));
                if (quick_messages_id > 0) {
                    var quick_messages_data = _7_Chat.Chat.quick_messages_get();
                    if (quick_messages_data === null)
                        return;
                    var quick_messages = quick_messages_data.quick_messages;
                    var _loop_4 = function (key) {
                        if (!quick_messages[key]) {
                            return "continue";
                        }
                        var _a = quick_messages[key], id = _a.id, command = _a.command, name_3 = _a.name, message = _a.message, file_json = _a.file_json;
                        if (id.toString() !== quick_messages_id.toString()) {
                            return "continue";
                        }
                        $('#button_quick_messages_edit').data('quick_messages_id', quick_messages_id);
                        $('#template_command_edit').val(command || '');
                        $('#template_name_edit').val(name_3);
                        $('#template_message_edit').val(message);
                        $('#quick_message_files').html('');
                        if (file_json) {
                            if (Array.isArray(file_json)) {
                                var _loop_5 = function (fileUrl, fileExt) {
                                    FileUpload.fileNormalize({ url: fileUrl, ext: fileExt }, function (e) {
                                        var fileUrlAttr = _1_Tasks.escapeHtml(fileUrl);
                                        $('#quick_message_files').append("<div class=\"p_load image_item\" data-file_url=\"".concat(fileUrlAttr, "\">") +
                                            "<button class=\"btn btn-default btn-xs pull-right image_item_delete\" data-file_url=\"".concat(fileUrlAttr, "\" data-type=\"clear\" data-callback=\"cb_quickMessages\">") +
                                            "<i class=\"fas fa-trash-alt\"></i></button>" +
                                            e.html +
                                            '</div>');
                                    });
                                };
                                for (var _i = 0, file_json_3 = file_json; _i < file_json_3.length; _i++) {
                                    var _b = file_json_3[_i], fileUrl = _b.fileUrl, fileExt = _b.fileExt;
                                    _loop_5(fileUrl, fileExt);
                                }
                            }
                            else {
                                if (file_json.fileUrl) {
                                    FileUpload.fileNormalize({ url: file_json.fileUrl, ext: file_json.fileExt }, function (e) {
                                        var fileUrlAttr = _1_Tasks.escapeHtml(file_json.fileUrl);
                                        $('#quick_message_files').append("<div class=\"p_load image_item\" data-file_url=\"".concat(fileUrlAttr, "\">") +
                                            "<button class=\"btn btn-default btn-xs pull-right image_item_delete\" data-file_url=\"".concat(fileUrlAttr, "\" data-type=\"clear\" data-callback=\"cb_quickMessages\">") +
                                            "<i class=\"fas fa-trash-alt\"></i></button>" +
                                            e.html +
                                            '</div>');
                                    });
                                }
                            }
                        }
                        $('#modal_quick_messages_edit').modal('show');
                        return "break";
                    };
                    for (var key in quick_messages) {
                        var state_1 = _loop_4(key);
                        if (state_1 === "break")
                            break;
                    }
                }
            });
            Chat_template.body
                .on('click', '#button_quick_messages_edit', function () {
                var command = $('#template_command_edit').val();
                var name = $('#template_name_edit').val();
                var message = $('#template_message_edit').val();
                var id = $(this).data('quick_messages_id');
                if (empty(command) || empty(name)) {
                    alert('Заполнены не все поля');
                    return;
                }
                var file_urls = [];
                $('#quick_message_files .image_item').each(function (_indx, element) {
                    var fileUrl = $(element).data('file_url');
                    if (typeof fileUrl === 'string') {
                        file_urls.push(fileUrl);
                    }
                });
                Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'quick_messages_edit',
                        command: command,
                        name: name,
                        message: message,
                        id: id !== undefined ? id : null,
                        file_urls: file_urls,
                    },
                    before: function () { },
                    success: function (data) {
                        if (data.result === 0) {
                            _7_Chat.Chat.quick_messages_query();
                            $('#modal_quick_messages_edit').modal('hide');
                        }
                        else {
                            swal({
                                title: 'ОШИБКА!',
                                html: data.msg || 'Не удалось сохранить изменения. Повторите действие.',
                                type: 'error',
                                cancelButtonText: 'Закрыть',
                            });
                        }
                    },
                });
            })
                .on('hidden.bs.modal', '#modal_quick_messages_edit', function (_e) {
                $('body').addClass('modal-open');
            });
            Chat_template.body.on('click', '.modal_add_subscribers_show', function () {
                $('#modal_add_subscribers').modal('show');
            });
            Chat_template.body.on('shown.bs.modal', '#modal_add_subscribers', function () {
                var _a, _b, _c, _d, _f;
                var text_add_channel = '<option value=""></option>';
                var whatsappChannels = (_a = _7_Chat.Chat.operator_data.channel) === null || _a === void 0 ? void 0 : _a.whatsapp;
                if (whatsappChannels) {
                    for (var i in whatsappChannels) {
                        var slotValue = whatsappChannels[i];
                        if (slotValue === undefined)
                            continue;
                        var phoneNumber = String(slotValue);
                        if (/^waba/.test(phoneNumber)) {
                            text_add_channel +=
                                "<option value=\"".concat(i, "\" data-transport=\"whatsapp\">").concat(phoneNumber.slice(4)) +
                                    " (WhatsApp Business)</option>";
                        }
                        else {
                            text_add_channel += "<option value=\"".concat(i, "\" data-transport=\"whatsapp\">").concat(phoneNumber, " (Whatsapp)</option>");
                        }
                    }
                }
                var tgChannels = (_b = _7_Chat.Chat.operator_data.channel) === null || _b === void 0 ? void 0 : _b.tg;
                if (tgChannels) {
                    for (var slotId in tgChannels) {
                        var slotValue = tgChannels[slotId];
                        if (slotValue === undefined)
                            continue;
                        var displayName = String(slotValue).replace(/^tg_/, '');
                        text_add_channel += "<option value=\"".concat(slotId, "\" data-transport=\"telegram\">").concat(displayName, " (Telegram)</option>");
                    }
                }
                var maxChannels = (_c = _7_Chat.Chat.operator_data.channel) === null || _c === void 0 ? void 0 : _c.max;
                if (maxChannels) {
                    for (var slotId in maxChannels) {
                        var slotValue = maxChannels[slotId];
                        if (slotValue === undefined)
                            continue;
                        var displayName = String(slotValue).replace(/^max_/, '');
                        text_add_channel += "<option value=\"".concat(slotId, "\" data-transport=\"max\">").concat(displayName, " (MAX)</option>");
                    }
                }
                $('#text_add_channel').html(text_add_channel);
                _7_Chat.Chat.initAddContactChannelSelect();
                var autoSelectValue = '';
                var autoSelectCount = 0;
                $('#text_add_channel option').each(function (_index, optionElement) {
                    var v = String($(optionElement).val() || '');
                    if (v !== '') {
                        autoSelectCount++;
                        autoSelectValue = v;
                    }
                });
                if (autoSelectCount === 1) {
                    _7_Chat.Chat.selectAddContactChannel(autoSelectValue);
                }
                $('#modal_add_subscribers .checkbox').addClass('hidden');
                $('#text_add_phone').val('');
                $('#text_add_name').val('');
                $('#text_add_tg_login').val('');
                $('#add_subscriber_phone_group').show();
                $('#add_subscriber_tg_login_group').hide();
                $('#add_subscriber_tg_status').hide();
                $('#add_subscriber_help_wa').show();
                $('#add_subscriber_help_tg').hide();
                $('#add_subscriber_help_max').hide();
                $('#contact_phone').html(String((_f = (_d = _7_Chat.Chat.operator_data.main_phone) === null || _d === void 0 ? void 0 : _d.phone) !== null && _f !== void 0 ? _f : ''));
                $('#modal_add_subscribers :input:not([data-dismiss])').prop('disabled', false);
                Inputmask({ alias: 'phone', placeholder: ' ' }).mask(document.querySelectorAll('#text_add_phone'));
            });
            Chat_template.body.on('shown.bs.modal', '#modal_add_subscribers', function () {
                var prefill = _7_Chat.Chat.add_subscriber_prefill;
                if (!prefill)
                    return;
                _7_Chat.Chat.add_subscriber_prefill = null;
                $('#text_add_phone').val(prefill.phone).trigger('input').trigger('change');
                if (prefill.name) {
                    $('#text_add_name').val(prefill.name).trigger('input').trigger('change');
                }
            });
            Chat_template.body.on('change', '#text_add_channel', function () {
                var _a, _b;
                var selectedOption = $(this).find(':selected');
                var transportRaw = selectedOption.data('transport');
                var transport = typeof transportRaw === 'string' ? transportRaw : undefined;
                _7_Chat.Chat.syncAddContactChannelSelect();
                if (transport === 'telegram') {
                    $('#add_subscriber_phone_group').hide();
                    $('#add_subscriber_tg_login_group').show();
                    $('#add_subscriber_help_wa').hide();
                    $('#add_subscriber_help_tg').show();
                    $('#add_subscriber_help_max').hide();
                    $('#modal_add_subscribers .checkbox').addClass('hidden');
                }
                else if (transport === 'max') {
                    $('#add_subscriber_phone_group').show();
                    $('#add_subscriber_tg_login_group').hide();
                    $('#add_subscriber_help_wa').hide();
                    $('#add_subscriber_help_tg').hide();
                    $('#add_subscriber_help_max').show();
                    $('#modal_add_subscribers .checkbox').addClass('hidden');
                }
                else {
                    $('#add_subscriber_phone_group').show();
                    $('#add_subscriber_tg_login_group').hide();
                    $('#add_subscriber_help_wa').show();
                    $('#add_subscriber_help_tg').hide();
                    $('#add_subscriber_help_max').hide();
                    if (!(this instanceof HTMLSelectElement)) {
                        console.error('text_add_channel|change|элемент не select');
                        return;
                    }
                    var i = this.value;
                    var re = new RegExp('^waba', 'g');
                    var slotValue = (_b = (_a = _7_Chat.Chat.operator_data.channel) === null || _a === void 0 ? void 0 : _a.whatsapp) === null || _b === void 0 ? void 0 : _b[i];
                    if (slotValue && re.test(String(slotValue))) {
                        $('#modal_add_subscribers .checkbox').addClass('hidden');
                    }
                    else {
                        $('#modal_add_subscribers .checkbox').removeClass('hidden');
                    }
                }
            });
            Chat_template.body.on('click', '#text_add_channel_menu .add-contact-channel-option', function (event) {
                event.preventDefault();
                var clickedElement = event.currentTarget;
                var channelValue = clickedElement instanceof Element ? String($(clickedElement).data('value') || '') : '';
                if (!channelValue) {
                    return;
                }
                _7_Chat.Chat.selectAddContactChannel(channelValue);
            });
            Chat_template.body.on('click', '#button_add_subscribers', function () {
                var selectedOption = $('#text_add_channel').find(':selected');
                var transportRaw = selectedOption.data('transport');
                var transport = typeof transportRaw === 'string' ? transportRaw : undefined;
                if (!transport) {
                    swal({
                        type: 'error',
                        title: 'Ошибка!',
                        html: 'Выберите канал.',
                    });
                    return;
                }
                if (transport === 'telegram') {
                    var tgLoginText = formFieldText('text_add_tg_login');
                    var spNumbText = formFieldText('text_add_channel');
                    var nameText = formFieldText('text_add_name');
                    if (tgLoginText === null || spNumbText === null || nameText === null)
                        return;
                    var tg_login = tgLoginText.trim();
                    var sp_numb_1 = spNumbText;
                    var name_4 = nameText.trim();
                    if (!tg_login || !/^@[a-zA-Z][a-zA-Z0-9_]{4,31}$/.test(tg_login)) {
                        swal({
                            type: 'error',
                            title: 'Ошибка!',
                            html: 'Введите корректный Telegram логин (например @username).',
                        });
                        return;
                    }
                    $('#modal_add_subscribers :input:not([data-dismiss])').prop('disabled', true);
                    $('#add_subscriber_tg_status_text').text('Проверяем контакт в Telegram...');
                    $('#add_subscriber_tg_status').show();
                    Chat_WebSocket.ajax_nodejs({
                        data: { query: 'tg_add_subscriber', tg_login: tg_login, sp_numb: sp_numb_1, name: name_4 },
                        before: function () { },
                        success: function (data) {
                            $('#add_subscriber_tg_status').hide();
                            $('#modal_add_subscribers :input:not([data-dismiss])').prop('disabled', false);
                            if (data.result === 0) {
                                $('#text_add_tg_login').val('');
                                $('#text_add_name').val('');
                                swal({
                                    type: 'success',
                                    html: data.result_description,
                                    cancelButtonText: 'Закрыть',
                                    showCancelButton: true,
                                    confirmButtonText: 'Открыть ' + data.phone,
                                }).then(function (result) {
                                    if (result.value && data.phone) {
                                        _7_Chat.Chat.click_open_subscriber({
                                            phone: data.phone,
                                            call_from: 'Chat|tg_add_subscriber|swal',
                                        });
                                        swal.closeModal();
                                        $('#modal_add_subscribers').modal('hide');
                                    }
                                });
                                $('#modal_add_subscribers').modal('hide');
                                _4_Sorter.Sorter.load();
                            }
                            else if (data.result === 2) {
                                swal({
                                    title: 'Контакт уже существует',
                                    html: data.result_description,
                                    type: 'info',
                                    cancelButtonText: 'Закрыть',
                                    showCancelButton: true,
                                    confirmButtonText: 'Открыть ' + data.phone,
                                }).then(function (result) {
                                    if (result.value && data.phone) {
                                        _7_Chat.Chat.click_open_subscriber({
                                            phone: data.phone,
                                            call_from: 'Chat|tg_add_subscriber|swal_confirm_open_exists',
                                        });
                                        swal.closeModal();
                                        $('#modal_add_subscribers').modal('hide');
                                    }
                                });
                            }
                            else {
                                swal({
                                    type: 'error',
                                    title: 'Ошибка!',
                                    html: data.result_description,
                                });
                            }
                        },
                        error: function () {
                            $('#add_subscriber_tg_status').hide();
                            Button.reset('#button_add_subscribers');
                            $('#modal_add_subscribers :input:not([data-dismiss])').prop('disabled', false);
                        },
                    });
                    return;
                }
                if (transport === 'max') {
                    var phoneText = formFieldText('text_add_phone');
                    var spNumbText = formFieldText('text_add_channel');
                    var nameText = formFieldText('text_add_name');
                    if (phoneText === null || spNumbText === null || nameText === null)
                        return;
                    var phoneRaw = phoneText.trim();
                    var sp_numb_2 = spNumbText;
                    var name_5 = nameText.trim();
                    var phoneDigits = phoneRaw.replace(/\D/g, '');
                    if (!phoneDigits || phoneDigits.length < 10) {
                        swal({
                            type: 'error',
                            title: 'Ошибка!',
                            html: 'Введите корректный телефон MAX.',
                        });
                        return;
                    }
                    $('#modal_add_subscribers :input:not([data-dismiss])').prop('disabled', true);
                    $('#add_subscriber_tg_status_text').text('Проверяем контакт в MAX...');
                    $('#add_subscriber_tg_status').show();
                    Chat_WebSocket.ajax_nodejs({
                        data: { query: 'max_add_subscriber', phone: phoneRaw, sp_numb: sp_numb_2, name: name_5 },
                        before: function () { },
                        success: function (data) {
                            $('#add_subscriber_tg_status').hide();
                            $('#modal_add_subscribers :input:not([data-dismiss])').prop('disabled', false);
                            if (data.result === 0) {
                                $('#text_add_phone').val('');
                                $('#text_add_name').val('');
                                swal({
                                    type: 'success',
                                    html: data.result_description,
                                    cancelButtonText: 'Закрыть',
                                    showCancelButton: true,
                                    confirmButtonText: 'Открыть ' + data.phone,
                                }).then(function (result) {
                                    if (result.value && data.phone) {
                                        _7_Chat.Chat.click_open_subscriber({
                                            phone: data.phone,
                                            call_from: 'Chat|max_add_subscriber|swal',
                                        });
                                        swal.closeModal();
                                        $('#modal_add_subscribers').modal('hide');
                                    }
                                });
                                $('#modal_add_subscribers').modal('hide');
                                _4_Sorter.Sorter.load();
                            }
                            else if (data.result === 2) {
                                swal({
                                    title: 'Контакт уже существует',
                                    html: data.result_description,
                                    type: 'info',
                                    cancelButtonText: 'Закрыть',
                                    showCancelButton: true,
                                    confirmButtonText: 'Открыть ' + data.phone,
                                }).then(function (result) {
                                    if (result.value && data.phone) {
                                        _7_Chat.Chat.click_open_subscriber({
                                            phone: data.phone,
                                            call_from: 'Chat|max_add_subscriber|swal_confirm_open_exists',
                                        });
                                        swal.closeModal();
                                        $('#modal_add_subscribers').modal('hide');
                                    }
                                });
                            }
                            else {
                                swal({
                                    type: 'error',
                                    title: 'Ошибка!',
                                    html: data.result_description,
                                });
                            }
                        },
                        error: function () {
                            $('#add_subscriber_tg_status').hide();
                            Button.reset('#button_add_subscribers');
                            $('#modal_add_subscribers :input:not([data-dismiss])').prop('disabled', false);
                        },
                    });
                    return;
                }
                var sp_numb = $('#text_add_channel').val();
                var phone = $('#text_add_phone').val();
                var name = $('#text_add_name').val();
                var contact_phone_check = 0;
                if ($('#contact_phone_check').prop('checked'))
                    contact_phone_check = 1;
                if (!phone) {
                    swal({
                        type: 'error',
                        title: 'Ошибка!',
                        html: 'Введите номер телефона.',
                    });
                    return;
                }
                Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'add_subscribers',
                        phone: phone,
                        name: name,
                        sp_numb: sp_numb,
                        contact_phone_check: contact_phone_check,
                        account_test: _7_Chat.Chat.operator_data.account_test || false,
                    },
                    before: function () {
                        Button.preloader('#button_add_subscribers');
                    },
                    success: function (data) {
                        if (data.result === 0) {
                            $('#text_add_phone').val('');
                            $('#text_add_name').val('');
                            swal({
                                type: 'success',
                                html: data.result_description,
                                cancelButtonText: 'Закрыть',
                                showCancelButton: true,
                                confirmButtonText: 'Открыть ' + data.phone,
                            }).then(function (result) {
                                if (result.value && data.phone) {
                                    _7_Chat.Chat.click_open_subscriber({
                                        phone: data.phone,
                                        call_from: 'Chat|add_subscribers|swal_confirm_open',
                                    });
                                    swal.closeModal();
                                    $('#modal_add_subscribers').modal('hide');
                                }
                            });
                            $('#modal_add_subscribers').modal('hide');
                            _4_Sorter.Sorter.load();
                        }
                        else if (data.result === 2) {
                            swal({
                                title: 'Ошибка!',
                                html: data.result_description,
                                type: 'error',
                                cancelButtonText: 'Закрыть',
                                showCancelButton: true,
                                confirmButtonText: 'Открыть ' + data.phone,
                            }).then(function (result) {
                                if (result.value && data.phone) {
                                    _7_Chat.Chat.click_open_subscriber({
                                        phone: data.phone,
                                        call_from: 'Chat|add_subscribers|swal_confirm_open_exists',
                                    });
                                    swal.closeModal();
                                    $('#modal_add_subscribers').modal('hide');
                                }
                            });
                        }
                        else {
                            swal({
                                type: 'error',
                                title: 'Ошибка!',
                                html: data.result_description,
                            });
                        }
                        Button.reset('#button_add_subscribers');
                    },
                    error: function () {
                        Button.reset('#button_add_subscribers');
                    },
                });
            });
            Chat_template.body.on('click', '.modal_group_send_show', function () {
                var _a;
                var cat_id = $(this).data('category_id');
                var category = Contacts.category;
                if (cat_id !== undefined &&
                    cat_id !== null &&
                    typeof cat_id !== 'boolean' &&
                    typeof cat_id !== 'object') {
                    $('#modal_group_send_id').val(cat_id);
                }
                if (typeof cat_id === 'string' || typeof cat_id === 'number') {
                    $('#modal_group_send_name').text(((_a = category[cat_id]) === null || _a === void 0 ? void 0 : _a.n) || '');
                }
                $('#modal_group_send_text').val('');
                $('#modal_group_send').modal('show');
            });
            $('#modal_group_send').on('shown.bs.modal', function () {
                $('#modal_group_send_text').focus();
            });
            Chat_template.body.on('click', '#group_send_button', function () {
                var cat_id = $('#modal_group_send_id').val();
                var groupSendText = formFieldText('modal_group_send_text');
                if (groupSendText === null)
                    return;
                var text = groupSendText.trim();
                if (cat_id === '') {
                    alert('ОШИБКА! Закройте модальное окно и повторить действие.');
                    return false;
                }
                if (text === '') {
                    alert('ОШИБКА! Заполнены не все обязательные поля');
                    return false;
                }
                if (text.length < 10) {
                    alert('ОШИБКА! Текст сообщения должен содержать более 10 символов');
                    return false;
                }
                Chat_WebSocket.ajax_nodejs({
                    data: { query: 'group_send', cat_id: cat_id, text: text },
                    before: function () {
                        Button.preloader($('#group_send_button'));
                    },
                    success: function (data) {
                        if (data.result === 0) {
                            if (_7_Chat.Chat.chat_open_subscriber) {
                                _7_Chat.Chat.messages_get({
                                    phone: _7_Chat.Chat.chat_open_subscriber,
                                    direction: 'DOWN',
                                    scroll: 'bottom',
                                });
                            }
                            swal({
                                type: 'success',
                                html: 'Рассылка успешно создана.',
                            });
                            $('#modal_group_send').modal('hide');
                        }
                        else {
                            swal({
                                type: 'error',
                                title: 'Ошибка!',
                                html: data.msg,
                            });
                        }
                        Button.reset($('#group_send_button'));
                    },
                    error: function () {
                        Button.reset($('#group_send_button'));
                    },
                });
                return undefined;
            });
            Chat_template.body.on('click', '.sendapi_deals_show', function () {
                if (!_7_Chat.Chat.chat_open_subscriber) {
                    swal({
                        type: 'error',
                        title: 'Ошибка!',
                        html: 'Чат взят в работу другим оператором',
                    });
                    return;
                }
                $('#sendapi_deals_amount').val('');
                $('#sendapi_deals_description').val('');
                Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'sendapi_deals_show',
                        phone: _7_Chat.Chat.chat_open_subscriber,
                    },
                    before: function () {
                        Button.preloader('.sendapi_deals_show');
                    },
                    success: function (data) {
                        Button.reset('.sendapi_deals_show');
                        if (data.result === 0) {
                            $('#modal_sendapi_deals').modal('show');
                        }
                        else {
                            swal({
                                type: 'error',
                                title: 'Ошибка!',
                                html: data.msg,
                            });
                        }
                    },
                    error: function () {
                        Button.reset('.sendapi_deals_show');
                    },
                });
            });
            Chat_template.body.on('click', '#button_sendapi_deals_create', function () {
                var amount = $('#sendapi_deals_amount').val();
                var description = $('#sendapi_deals_description').val();
                if (amount === '') {
                    swal({
                        type: 'error',
                        title: 'Ошибка!',
                        html: 'Заполните все поля',
                    });
                    return;
                }
                Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'sendapi_deals_create',
                        phone: _7_Chat.Chat.chat_open_subscriber,
                        amount: amount,
                        description: description,
                    },
                    before: function () {
                        Button.preloader('#button_sendapi_deals_create');
                    },
                    success: function (data) {
                        Button.reset('#button_sendapi_deals_create');
                        if (data.result === 0) {
                            $('#modal_sendapi_deals').modal('hide');
                            swal({
                                type: 'success',
                                html: 'Сделка создана',
                            });
                        }
                        else {
                            swal({
                                type: 'error',
                                title: 'Ошибка!',
                                html: data.msg,
                            });
                        }
                    },
                    error: function () {
                        Button.reset('#button_sendapi_deals_create');
                    },
                });
            });
            Chat_template.body.on('click', '.bitrix24_deals_show', function () {
                if (!_7_Chat.Chat.chat_open_subscriber) {
                    swal({
                        type: 'error',
                        title: 'Ошибка!',
                        html: 'Откройте чат с контактом',
                    });
                    return;
                }
                $('#bitrix24_deals_title').val('');
                $('#bitrix24_deals_amount').val('');
                $('#bitrix24_deals_description').val('');
                Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'bitrix24_deals_show',
                        phone: _7_Chat.Chat.chat_open_subscriber,
                    },
                    before: function () {
                        Button.preloader('.bitrix24_deals_show');
                    },
                    success: function (data) {
                        Button.reset('.bitrix24_deals_show');
                        if (data.result === 0) {
                            $('#modal_bitrix24_deals').modal('show');
                        }
                        else {
                            swal({
                                type: 'error',
                                title: 'Ошибка!',
                                html: data.msg || 'Bitrix24 интеграция недоступна',
                            });
                        }
                    },
                    error: function () {
                        Button.reset('.bitrix24_deals_show');
                    },
                });
            });
            Chat_template.body.on('click', '#button_bitrix24_deals_create', function () {
                var title = $('#bitrix24_deals_title').val();
                var amount = $('#bitrix24_deals_amount').val();
                var description = $('#bitrix24_deals_description').val();
                if (title === '' || amount === '') {
                    swal({
                        type: 'error',
                        title: 'Ошибка!',
                        html: 'Заполните все обязательные поля',
                    });
                    return;
                }
                Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'bitrix24_deals_create',
                        phone: _7_Chat.Chat.chat_open_subscriber,
                        title: title,
                        amount: amount,
                        description: description,
                    },
                    before: function () {
                        Button.preloader('#button_bitrix24_deals_create');
                    },
                    success: function (data) {
                        Button.reset('#button_bitrix24_deals_create');
                        if (data.result === 0) {
                            $('#modal_bitrix24_deals').modal('hide');
                            swal({
                                type: 'success',
                                html: 'Сделка создана в Bitrix24' + (data.deal_id ? " (ID: ".concat(data.deal_id, ")") : ''),
                            });
                        }
                        else {
                            swal({
                                type: 'error',
                                title: 'Ошибка!',
                                html: data.msg || 'Не удалось создать сделку',
                            });
                        }
                    },
                    error: function () {
                        Button.reset('#button_bitrix24_deals_create');
                    },
                });
            });
            Chat_template.body.on('click', '.glo_verify_identity_show', function () {
                $('#modal_glo_verify_identity_show').modal('show');
            });
            Chat_template.body.on('click', '#button_glo_verify_identity', function () {
                var glo_last_name = $('#glo_last_name');
                var glo_first_name = $('#glo_first_name');
                var glo_iin = $('#glo_iin');
                if (!_7_Chat.Chat.chat_view_subscriber) {
                    swal({
                        type: 'error',
                        title: 'Ошибка!',
                        html: 'Откройте чат с контактом',
                    });
                    return;
                }
                if (glo_last_name.val() === '' || glo_first_name.val() === '' || glo_iin.val() === '') {
                    swal({
                        type: 'error',
                        title: 'Ошибка!',
                        html: 'Заполните все поля',
                    });
                    return;
                }
                Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'glo_verify_identity',
                        phone: _7_Chat.Chat.chat_open_subscriber,
                        first_name: glo_first_name.val(),
                        last_name: glo_last_name.val(),
                        iin: glo_iin.val(),
                    },
                    before: function () {
                        Button.preloader($('#button_glo_verify_identity'));
                    },
                    success: function (data) {
                        Button.reset($('#button_glo_verify_identity'));
                        if (data.result === 0) {
                            $('#modal_glo_verify_identity_show').modal('hide');
                            swal({
                                type: 'success',
                                html: 'Данные отправлены',
                            });
                            var work = $('.my_work').data('work');
                            if (work === 'end_dialog') {
                                _7_Chat.Chat.click_my_work_step_2(work);
                            }
                            _7_Chat.Chat.click_mark_as_read(_7_Chat.Chat.chat_open_subscriber);
                            glo_last_name.val('');
                            glo_first_name.val('');
                            glo_iin.val('');
                        }
                        else {
                            swal({
                                type: 'error',
                                title: 'Ошибка!',
                                html: data.msg,
                            });
                        }
                    },
                    error: function () {
                        Button.reset($('#button_glo_verify_identity'));
                        swal({
                            type: 'error',
                            title: 'Ошибка!',
                            html: 'Не удалось отправить данные, попробуйте позже.',
                        });
                    },
                });
            });
            Chat_template.body.on('click', '.glo_add_user_show', function () {
                var _a;
                $('#glo_phone').html((_a = _7_Chat.Chat.viewSubscriberPhone()) !== null && _a !== void 0 ? _a : '');
                $('#modal_glo_add_user_show').modal('show');
            });
            Chat_template.body.on('click', '#button_glo_add_user', function () {
                if (!_7_Chat.Chat.chat_view_subscriber) {
                    swal({
                        type: 'error',
                        title: 'Ошибка!',
                        html: 'Откройте чат с контактом',
                    });
                    return;
                }
                Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'glo_add_user',
                        phone: _7_Chat.Chat.chat_open_subscriber,
                    },
                    before: function () {
                        Button.preloader($('#button_glo_add_user'));
                    },
                    success: function (data) {
                        Button.reset($('#button_glo_add_user'));
                        if (data.result === 0) {
                            $('#modal_glo_add_user_show').modal('hide');
                            swal({
                                type: 'success',
                                html: 'Данные отправлены',
                            });
                            var work = $('.my_work').data('work');
                            if (work === 'end_dialog') {
                                _7_Chat.Chat.click_my_work_step_2(work);
                            }
                            _7_Chat.Chat.click_mark_as_read(_7_Chat.Chat.chat_open_subscriber);
                        }
                        else {
                            swal({
                                type: 'error',
                                title: 'Ошибка!',
                                html: data.msg,
                            });
                        }
                    },
                    error: function () {
                        Button.reset($('#button_glo_add_user'));
                        swal({
                            type: 'error',
                            title: 'Ошибка!',
                            html: 'Не удалось отправить данные, попробуйте позже.',
                        });
                    },
                });
            });
            Chat_template.body.on('click', '.uon_show', function () {
                Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'uon_show',
                        phone: _7_Chat.Chat.chat_open_subscriber,
                    },
                    before: function () {
                        Button.preloader($('.uon_show'));
                    },
                    success: function (data) {
                        Button.reset($('.uon_show'));
                        if (data.result === 0) {
                            $('#uon_manager_id').val(data.uon_manager_id || '');
                            if (data.uon_user_phone !== null && data.uon_user_phone !== undefined) {
                                $('#uon_user_phone').val(data.uon_user_phone);
                            }
                            else {
                                $('#uon_user_phone').val('');
                            }
                            Inputmask({ mask: '+999999999999999', placeholder: '' }).mask(document.querySelectorAll('#uon_user_phone'));
                            $('#modal_uon').modal('show');
                        }
                        else {
                            swal({
                                type: 'error',
                                title: 'Ошибка!',
                                html: data.msg,
                            });
                        }
                    },
                    error: function () {
                        Button.reset($('.uon_show'));
                    },
                });
            });
            Chat_template.body.on('click', '#button_uon_lead_create', function () {
                var uon_user_phone = $('#uon_user_phone').val();
                var uon_manager_id = $('#uon_manager_id').val();
                if (empty(uon_user_phone) || empty(uon_manager_id)) {
                    swal({
                        type: 'error',
                        title: 'Ошибка!',
                        html: 'Заполните все поля',
                    });
                    return;
                }
                Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'uon_lead_create',
                        phone: _7_Chat.Chat.chat_open_subscriber,
                        uon_user_phone: uon_user_phone,
                        uon_manager_id: uon_manager_id,
                    },
                    before: function () {
                        Button.preloader($('#button_uon_lead_create'));
                    },
                    success: function (data) {
                        Button.reset($('#button_uon_lead_create'));
                        if (data.result === 0) {
                            $('#modal_uon').modal('hide');
                            swal({
                                type: 'success',
                                html: 'Обращение создано',
                            });
                        }
                        else {
                            swal({
                                type: 'error',
                                title: 'Ошибка!',
                                html: data.msg,
                            });
                        }
                    },
                    error: function () {
                        Button.reset($('#button_uon_lead_create'));
                    },
                });
            });
            Chat_template.body.on('click', '.amocrm_show', function () {
                Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'amocrm_show',
                        phone: _7_Chat.Chat.chat_open_subscriber,
                    },
                    before: function () {
                        Button.preloader($('.amocrm_show'));
                    },
                    success: function (data) {
                        var _a;
                        Button.reset($('.amocrm_show'));
                        if (data.result === 0) {
                            if (((_a = data.data) === null || _a === void 0 ? void 0 : _a.lead_id) &&
                                String(data.data.ph_numb) === String(_7_Chat.Chat.chat_open_subscriber)) {
                                $('#amocrm_lead_id').val(data.data.lead_id);
                                $('#amocrm_lead_snap').html(_7_Chat.Chat.l('Отвязать')).attr('data-mode', 'nosnap');
                            }
                            else {
                                $('#amocrm_lead_id').val('');
                                $('#amocrm_lead_snap').html(_7_Chat.Chat.l('Привязать')).attr('data-mode', 'snap');
                            }
                            $('#modal_amocrm2').modal('show');
                        }
                        else {
                        }
                    },
                    error: function () {
                        Button.reset($('.amocrm_show'));
                    },
                });
            });
            Chat_template.body.on('click', '#amocrm_lead_snap', function () {
                var lead_id = $('#amocrm_lead_id').val();
                if (empty(lead_id)) {
                    swal({
                        type: 'error',
                        title: 'Ошибка!',
                        html: 'Введите ID заявки',
                    });
                    return;
                }
                var mode = $(this).attr('data-mode');
                Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'amocrm_lead_snap',
                        phone: _7_Chat.Chat.chat_open_subscriber,
                        mode: mode !== undefined ? mode : null,
                        lead_id: lead_id,
                    },
                    before: function () {
                        Button.preloader($('#amocrm_lead_snap'));
                    },
                    success: function (data) {
                        Button.reset($('#amocrm_lead_snap'));
                        if (data.result === 0) {
                            if (data.data === 'snap') {
                                $('#amocrm_lead_id').val(data.lead_id || '');
                                $('#amocrm_lead_snap').html(_7_Chat.Chat.l('Отвязать')).attr('data-mode', 'nosnap');
                            }
                            else {
                                $('#amocrm_lead_id').val('');
                                $('#amocrm_lead_snap').html(_7_Chat.Chat.l('Привязать')).attr('data-mode', 'snap');
                            }
                        }
                        else {
                            swal({
                                type: 'error',
                                title: 'Ошибка!',
                                html: data.msg,
                            });
                        }
                    },
                    error: function () {
                        Button.reset($('#amocrm_lead_snap'));
                    },
                });
            });
            Chat_template.body.on('click', '.amocrm_open', function () {
                $('#modal_amocrm').modal('show');
                $('#modal_amocrm2').modal('hide');
            });
            Chat_template.body.on('change', '.amocrm_type_lead_select', function () {
                if ($(this).val() === 'support') {
                    $('.amocrm_type_lead_comment').removeClass('hidden');
                    return;
                }
                $('.amocrm_type_lead_comment').addClass('hidden');
            });
            Chat_template.body.on('click', '#amocrm_deal_add', function () {
                var lead_name = $('#lead_name').val();
                var lead_sale = $('#lead_sale').val();
                if (empty(lead_name) && _7_Chat.Chat.chat_open_subscriber) {
                    swal({
                        type: 'error',
                        title: 'Ошибка!',
                        html: 'Заполните обязательные поля',
                    });
                    return;
                }
                Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'amocrm_deal_add',
                        lead_name: lead_name,
                        lead_sale: lead_sale,
                        lead_type: $('#lead_type').val(),
                        lead_comment: $('#lead_comment').val(),
                        phone: _7_Chat.Chat.chat_open_subscriber,
                    },
                    before: function () {
                        Button.preloader($('#amocrm_deal_add'));
                    },
                    success: function (data) {
                        if (data.result === 0) {
                            $('#lead_name').val('');
                            $('#lead_sale').val('');
                            $('#lead_comment').val('');
                            $('#modal_amocrm').modal('hide');
                            swal({
                                type: 'success',
                                html: 'Сделка успешно создана.',
                            });
                        }
                        else {
                            swal({
                                type: 'error',
                                title: 'Ошибка!',
                                html: data.msg,
                            });
                        }
                        Button.reset($('#amocrm_deal_add'));
                    },
                    error: function () {
                        Button.reset($('#amocrm_deal_add'));
                    },
                });
            });
            Chat_template.body.on('shown.bs.modal', '#modal_amocrm', function () {
                $('#lead_name').val('');
                $('#lead_sale').val('');
            });
            Chat_template.body.on('click', '#accurate_search_chat_button', function () {
                var accurate_search_chat_text = $('#accurate_search_chat_text').val();
                if (empty(accurate_search_chat_text)) {
                    alert('Поле не заполнено');
                    return;
                }
                Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'accurate_search_chat_messages',
                        accurate_search_chat_text: accurate_search_chat_text,
                    },
                    before: function () {
                        Button.preloader($('#accurate_search_chat_button'));
                        $('#search_content').addClass('hidden');
                    },
                    success: function (data) {
                        if (data.result === 0) {
                            var escapeHtml = _1_Tasks.escapeHtml;
                            if (data.phones && count_obj(data.phones)) {
                                var search_content = '';
                                for (var phone in data.phones) {
                                    if (!data.phones.hasOwnProperty(phone))
                                        continue;
                                    if (!Contacts.data.hasOwnProperty(phone)) {
                                        Contacts.data_get({ phone: phone }, function () { }, function (error) {
                                            console.error(error);
                                        });
                                        console.log('не нашел в поиске = ' + phone);
                                        continue;
                                    }
                                    var title_name = '';
                                    var searchResultContact = Contacts.data[phone];
                                    if (!searchResultContact) {
                                        console.error('accurate_search|нет контакта в реестре=', phone);
                                        continue;
                                    }
                                    var transport = searchResultContact.transport, insta_login = searchResultContact.insta_login, id = searchResultContact.id;
                                    var name_6 = searchResultContact.name;
                                    if (!empty(name_6)) {
                                        name_6 = "<b>".concat(name_6, "</b> ");
                                        title_name = name_6;
                                    }
                                    var phoneEscaped = escapeHtml(phone);
                                    var contanct = '';
                                    if (transport !== 'whatsapp_group') {
                                        contanct = phoneEscaped;
                                    }
                                    if (transport === 'instagram' && typeof insta_login === 'string') {
                                        contanct = '@' + escapeHtml(insta_login);
                                    }
                                    search_content +=
                                        "<li class=\"subscriber_".concat(id, "\" onclick=\"_7_Chat.Chat.click_open_subscriber({phone:'").concat(phoneEscaped, "',call_from:'Chat|advanced_search_date|result_item'})\" title=\"").concat(title_name).concat(phoneEscaped, "\">") +
                                            "<i class=\"fa fa-phone\"></i> ".concat(name_6).concat(contanct, " <span class=\"no_read_message_kol badge bg-green pull-right\"></span></li>");
                                }
                                if (search_content === '')
                                    $('#search_content').addClass('hidden');
                                else {
                                    $('#search_result_kol').html(count_obj(data.phones).toString());
                                    $('#search_content').removeClass('hidden');
                                }
                                $('#search_li').html(search_content);
                                $('#search-btn i').removeClass('fa-search').addClass('fa-times');
                            }
                            else {
                                $('#search_content').addClass('hidden');
                                $('#search-btn i').addClass('fa-search').removeClass('fa-times');
                            }
                            $('#modal_advanced_search').modal('hide');
                        }
                        Button.reset($('#accurate_search_chat_button'));
                    },
                    error: function () {
                        Button.reset($('#accurate_search_chat_button'));
                    },
                });
            });
            Chat_template.body.on('click', '#advanced_search_button', function () {
                var date_from = $('#advanced_search_data_from').val();
                var date_to = $('#advanced_search_data_to').val();
                if (empty(date_from) || empty(date_to)) {
                    alert('Не все поля заполнены');
                    return;
                }
                Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'search_subscribers_advanced',
                        date_from: date_from,
                        date_to: date_to,
                    },
                    before: function () {
                        Button.preloader($('#advanced_search_button'));
                        $('#search_content').addClass('hidden');
                    },
                    success: function (data) {
                        if (data.result === 0) {
                            var escapeHtml = _1_Tasks.escapeHtml;
                            if (data.phones && count_obj(data.phones)) {
                                var search_content = '';
                                for (var key in data.phones) {
                                    var p = data.phones[key];
                                    if (p === undefined)
                                        continue;
                                    var pEscaped = escapeHtml(p);
                                    if (!Contacts.data.hasOwnProperty(p)) {
                                        Contacts.data_get({ phone: p }, function () { }, function (error) {
                                            console.error(error);
                                        });
                                        console.log('не нашел в поиске = ' + p);
                                        continue;
                                    }
                                    var title_name = '';
                                    var foundContact = Contacts.data[p];
                                    if (!foundContact) {
                                        console.error('search_chat_messages|нет контакта в реестре=', p);
                                        continue;
                                    }
                                    var transport = foundContact.transport, insta_login = foundContact.insta_login, id = foundContact.id;
                                    var name_7 = foundContact.name;
                                    if (name_7 !== '' && name_7 !== null) {
                                        name_7 = "<b>".concat(name_7, "</b> ");
                                        title_name = name_7;
                                    }
                                    var phone = _7_Chat.Chat.advancedSearchPhoneHtml({ phone: p, transport: transport, insta_login: insta_login });
                                    var titlePhone = _7_Chat.Chat.isWabaBsuidAddress(p) ? phone : pEscaped;
                                    search_content +=
                                        "<li class=\"subscriber_".concat(id, "\" onclick=\"_7_Chat.Chat.click_open_subscriber({phone:'").concat(pEscaped, "',call_from:'Chat|advanced_search_date|result_item_2'})\" title=\"").concat(title_name).concat(titlePhone, "\">") +
                                            "<i class=\"fa fa-phone\"></i> ".concat(name_7).concat(phone, " <span class=\"no_read_message_kol badge bg-green pull-right\"></span></li>");
                                }
                                if (search_content === '')
                                    $('#search_content').addClass('hidden');
                                else {
                                    $('#search_result_kol').html(count_obj(data.phones).toString());
                                    $('#search_content').removeClass('hidden');
                                }
                                $('#search_li').html(search_content);
                                $('#search-btn i').removeClass('fa-search').addClass('fa-times');
                            }
                            else {
                                $('#search_content').addClass('hidden');
                                $('#search-btn i').addClass('fa-search').removeClass('fa-times');
                            }
                            $('#modal_advanced_search').modal('hide');
                        }
                        Button.reset($('#advanced_search_button'));
                    },
                    error: function () {
                        Button.reset($('#advanced_search_button'));
                    },
                });
            });
            Chat_template.body.on('click', '#advanced_search_button_2', function () {
                var advancedSearchText = formFieldText('advanced_search_phone');
                if (advancedSearchText === null)
                    return;
                var advanced_search_phone = advancedSearchText;
                if (advanced_search_phone === '') {
                    alert('Не все поля заполнены');
                    return;
                }
                advanced_search_phone = advanced_search_phone.replace(/[^\d]/g, '');
                if (String(advanced_search_phone)[0] === '8') {
                    advanced_search_phone = String(advanced_search_phone).replace('8', '7');
                }
                Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'search_subscribers_advanced_2',
                        phone: advanced_search_phone,
                    },
                    before: function () {
                        Button.preloader($('#advanced_search_button_2'));
                        $('#search_content').addClass('hidden');
                    },
                    success: function (data) {
                        console.log(data);
                        if (data.result === 0) {
                            if (count_obj(data.phones)) {
                                search_handler_view(data);
                            }
                            else {
                                swal({
                                    type: 'info',
                                    html: 'По данному запросу номера не найдены',
                                });
                                $('#search_content').addClass('hidden');
                                $('#search-btn i').addClass('fa-search').removeClass('fa-times');
                            }
                            $('#modal_advanced_search').modal('hide');
                        }
                        Button.reset($('#advanced_search_button_2'));
                    },
                    error: function () {
                        Button.reset($('#advanced_search_button_2'));
                    },
                });
            });
            Chat_template.body.on('click', '.mark_as_read_operator_mess', function () {
                Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'check_message_read_operator_mess',
                        operator_id: _7_Chat.Chat.chat_open_operator,
                    },
                    before: function () { },
                    success: function (_data) {
                        _7_Chat.Chat.chat_noread_operator_messages_load();
                    },
                });
            });
            Chat_template.body.on('click', '.operator_chat_status_toggle', function (event) {
                event.preventDefault();
                event.stopPropagation();
                Chat_template.operator_chat_status_menu_open(this);
            });
            Chat_template.body.on('click', '.operator_chat_status_choice', function (event) {
                event.preventDefault();
                event.stopPropagation();
                _7_Chat.Chat.operator_chat_status_choose(this.getAttribute('data-status'));
            });
            document.addEventListener('mousedown', function (event) {
                var menu = document.getElementById('operator_chat_status_menu');
                if (!menu || !(event.target instanceof Node))
                    return;
                if (menu.contains(event.target))
                    return;
                if (event.target instanceof Element &&
                    event.target.closest('.operator_chat_status_toggle'))
                    return;
                Chat_template.operator_chat_status_menu_close();
            }, true);
            document.addEventListener('keydown', function (event) {
                if (event.key === 'Escape')
                    Chat_template.operator_chat_status_menu_close();
            });
            document.addEventListener('scroll', function () {
                Chat_template.operator_chat_status_menu_close();
            }, true);
            $('#operators_chat_status_all_online').on('click', function () {
                _7_Chat.Chat.operator_chat_status_set({ all: true }, 'online');
            });
            $('#operators_chat_status_all_pause').on('click', function () {
                _7_Chat.Chat.operator_chat_status_set({ all: true }, 'pause');
            });
            Chat_template.body.on('click', '.open_operator', function () {
                _7_Chat.Chat.click_open_operator($(this));
            });
            $('#chat_operator_send').on('click', _7_Chat.Chat.click_operator_send);
            $('#textarea_operator_text').keydown(function (e) {
                if (e.which === 13 && !e.ctrlKey && !e.shiftKey) {
                    e.preventDefault();
                    _7_Chat.Chat.click_operator_send();
                }
            });
            Chat_template.body.on('click', '.forward', function () {
                var id = $(this).data('id');
                if (id !== undefined && id !== null && typeof id !== 'boolean' && typeof id !== 'object') {
                    $('#search_mess_id').val(id);
                }
                $('#forward_phones, #forward_phones_pages, #forward_phones_select').html('');
                $('#modal_forward').modal('show');
            });
            Chat_template.body.on('click', '.message_error_icon', function () {
                var statusMsg = $(this).attr('data-status-msg') || '';
                if (!statusMsg)
                    return;
                swal({
                    type: 'error',
                    title: _7_Chat.Chat.l('Ошибка доставки'),
                    html: _7_Chat.Chat.l_composite(statusMsg),
                });
            });
            Chat_template.body.on('click', '.message_waba_restriction_icon', function () {
                swal({
                    type: 'info',
                    title: _7_Chat.Chat.l('Новое ограничение WhatsApp'),
                    html: _7_Chat.Chat.l('Это нововведение WhatsApp. Для аккаунтов, подключённых через связанные устройства') +
                        ' ' +
                        _7_Chat.Chat.l('(WhatsApp Business в режиме совместной работы, Coexistence), WhatsApp ввёл ограничение:') +
                        ' ' +
                        _7_Chat.Chat.l('сейчас нельзя') +
                        " <b>".concat(_7_Chat.Chat.l('первыми начинать новые диалоги'), "</b> ") +
                        _7_Chat.Chat.l('с клиентами.') +
                        '<br><br>' +
                        "<b>".concat(_7_Chat.Chat.l('Что это значит:'), "</b><br>") +
                        _7_Chat.Chat.l('• Вы не можете написать клиенту первым (инициировать новый чат).') +
                        '<br>' +
                        _7_Chat.Chat.l('• Ответы в') +
                        " <b>".concat(_7_Chat.Chat.l('уже открытые'), "</b> ") +
                        _7_Chat.Chat.l('диалоги работают как обычно.') +
                        '<br>' +
                        _7_Chat.Chat.l('• Если клиент пишет вам сам — вы можете спокойно ему отвечать.') +
                        '<br><br>' +
                        _7_Chat.Chat.l('Это изменение со стороны WhatsApp, а не ошибка вашего аккаунта или нашей системы.'),
                });
            });
            $('#modal_forward').on('shown.bs.modal', function () {
                $('#forward_phones, #forward_phones_pages, #forward_phones_select').html('');
                Contacts.forward_phones(1, '', function (_e) { });
            });
            Chat_template.body.on('click', '.forward_phone_item', function () {
                var k = $(this).data('k');
                var v = $(this).val();
                if (typeof k !== 'number') {
                    console.warn('[TypeGuard] forward_phone_item: k имеет неверный тип', {
                        k: k,
                        type: typeof k,
                    });
                    return;
                }
                var subscriber = _7_Chat.Chat.subscriber_full[k];
                if (subscriber && subscriber.phone === v) {
                    if ($(this).prop('checked')) {
                        subscriber.checked = 1;
                    }
                    else {
                        subscriber.checked = 0;
                    }
                }
                var kol = 0;
                for (var key in _7_Chat.Chat.subscriber_full) {
                    var sub = _7_Chat.Chat.subscriber_full[key];
                    if (sub && sub.checked === 1)
                        kol++;
                }
                $('#forward_count_select').html(kol.toString());
            });
            Chat_template.body.on('click', '#button_forward_send', function () {
                var id = $('#search_mess_id').val();
                var phone = [];
                for (var key in _7_Chat.Chat.subscriber_full) {
                    var sub = _7_Chat.Chat.subscriber_full[key];
                    if (sub && sub.checked === 1)
                        phone.push(sub.phone);
                }
                if (phone.length === 0) {
                    alert('Не выбраны контакты');
                    return;
                }
                Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'chat_forward_send',
                        phone: phone.join(),
                        mess_id: id,
                    },
                    before: function () {
                        Button.preloader($('#button_forward_send'));
                    },
                    success: function (jsondata) {
                        if (jsondata && Number(jsondata.result) === 0) {
                            swal({
                                type: 'success',
                                html: 'Сообщение отправлено',
                            });
                            $('#modal_forward').modal('hide');
                        }
                        else if (jsondata) {
                            toastr.error(jsondata.result_description || 'Неизвестная ошибка', 'ОШИБКА!');
                        }
                        else {
                            toastr.error('Попробуйте еще раз (2)', 'ОШИБКА!');
                        }
                        Button.reset($('#button_forward_send'));
                    },
                    error: function () {
                        Button.reset($('#button_forward_send'));
                    },
                });
            });
            Chat_template.body.on('click', '#forward_search_phone_chek', function () {
                var subscribers = _7_Chat.Chat.subscriber_full;
                var forward_phones = '';
                var btn = $(this);
                var check = btn.data('check');
                var kol = 0;
                $('#forward_search_phone').val('');
                if (check === '0') {
                    btn.data('check', '1');
                }
                else {
                    btn.data('check', '0');
                }
                for (var k in subscribers) {
                    var sub = subscribers[k];
                    if (!sub)
                        continue;
                    if (check === '0') {
                        if (sub.checked === 1) {
                            forward_phones +=
                                "<li><input type=\"checkbox\" ".concat(sub.checked === 1 ? 'checked' : '') +
                                    " class=\"forward_phone_item\" data-k=\"".concat(k, "\" value=\"").concat(sub.phone, "\"> ").concat(sub.phone, " ").concat(sub.name || '') +
                                    '</li>';
                        }
                    }
                    else {
                        kol++;
                        forward_phones +=
                            "<li><input type=\"checkbox\" ".concat(sub.checked === 1 ? 'checked' : '', " class=\"forward_phone_item\" data-k=\"").concat(k, "\" value=\"").concat(sub.phone, "\"> ") +
                                "".concat(sub.phone, " ").concat(sub.name || '') +
                                "</li>";
                        if (kol > 100)
                            break;
                    }
                }
                var forwardPhonesEl = document.getElementById('forward_phones');
                if (forwardPhonesEl) {
                    forwardPhonesEl.innerHTML = '<ul>' + forward_phones + '</ul>';
                }
            });
            Chat_template.body.on('click', '.modal_setting_show', function () {
                var list = '';
                if (count_obj(Contacts.category_sort)) {
                    Contacts.category_sort.forEach(function (categ_id) {
                        var _a, _b;
                        var hidden_chek = 'checked';
                        if (((_a = Contacts.category[categ_id]) === null || _a === void 0 ? void 0 : _a.h) === 0)
                            hidden_chek = '';
                        list +=
                            "<li class=\"list-group-item\" data-cat_id=\"".concat(categ_id, "\">") +
                                "<div class=\"input-group\">" +
                                "<input type=\"hidden\" class=\"setting_category_id\" value=\"".concat(categ_id, "\">") +
                                "<p class=\"form-control-static setting_category_name_".concat(categ_id, "\">") +
                                _1_Tasks.escapeHtml(String((_b = Contacts.category[categ_id]) === null || _b === void 0 ? void 0 : _b.n)) +
                                "</p>" +
                                (categ_id !== '0'
                                    ? "<span class=\"input-group-addon\"><input type=\"checkbox\" ".concat(hidden_chek, " class=\"setting_category_hidden_").concat(categ_id, "\"> ") +
                                        _7_Chat.Chat.l('Скрыть') +
                                        "</span>"
                                    : '') +
                                '<span class="input-group-btn">' +
                                '<button class="btn btn-default cat_sort_up" type="button"><i class="fa fa-chevron-up"></i></button>' +
                                '<button class="btn btn-default cat_sort_down" type="button"><i class="fa fa-chevron-down"></i></button>' +
                                '</span>' +
                                '</div>' +
                                '</li>';
                    });
                }
                $('#localOffsetInMinutes').text("\u0427\u0430\u0441\u043E\u0432\u043E\u0439 \u043F\u043E\u044F\u0441 \u0438\u0437 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439 \u0441\u0438\u0441\u0442\u0435\u043C\u044B: ".concat(Math.abs(Number(_7_Chat.Chat.localOffsetInMinutes)) / 60));
                if (_7_Chat.Chat.chatTimeUtc) {
                    var $chat_time_utc = $('#chat_time_utc');
                    $chat_time_utc.val(_7_Chat.Chat.chatTimeUtc);
                    $chat_time_utc.find('option').each(function () {
                        if ($(this).text() === String(_7_Chat.Chat.chatTimeUtc)) {
                            $(this).prop('selected', true);
                        }
                    });
                }
                $('#list_category_setting').html(list);
                $('#modal_setting').modal('show');
            });
            $('#modal_setting').on('show.bs.modal', function () {
                if (_7_Chat.Chat.isSettingsAdmin()) {
                    $('#settings_tab_admin_li').show();
                }
                else {
                    $('#settings_tab_admin_li').hide();
                }
                $('#modal_setting .nav-tabs a[href="#settings_tab_1"]').tab('show');
            });
            Chat_template.body.on('click', '.cat_sort_up', function () {
                var this_ = $(this).parent().parent().parent();
                if (this_.prev('.list-group-item').length > 0) {
                    this_.insertBefore(this_.prev('.list-group-item'));
                }
            });
            Chat_template.body.on('click', '.cat_sort_down', function () {
                var this_ = $(this).parent().parent().parent();
                if (this_.next('.list-group-item').length > 0) {
                    this_.insertAfter(this_.next('.list-group-item'));
                }
            });
            Chat_template.body.on('click', '#category_setting_button', function () {
                Contacts.category_sort = [];
                $('#list_category_setting .list-group-item').each(function (_indx, element) {
                    var cat_id = $(element).data('cat_id');
                    if (typeof cat_id !== 'string' && typeof cat_id !== 'number') {
                        console.warn('[TypeGuard] category_setting: cat_id имеет неверный тип', {
                            cat_id: cat_id,
                            type: typeof cat_id,
                        });
                        return;
                    }
                    var h = 0;
                    if ($('.setting_category_hidden_' + cat_id).prop('checked'))
                        h = 1;
                    if (Contacts.category[cat_id]) {
                        Contacts.category[cat_id]['h'] = h;
                    }
                    Contacts.category_sort.push(String(cat_id));
                });
                Contacts.category_save();
            });
            Chat_template.body.on('click', '#chat_time_utc_button', function () {
                var chatTimeUtcText = formFieldText('chat_time_utc');
                if (chatTimeUtcText === null)
                    return;
                var chat_time_utc = parseInt(chatTimeUtcText);
                if (isNaN(chat_time_utc)) {
                    localStorage.removeItem('chat_time_utc');
                    _7_Chat.Chat.chatTimeUtc = null;
                }
                else {
                    localStorage.setItem('chat_time_utc', chat_time_utc.toString());
                    _7_Chat.Chat.chatTimeUtc = chat_time_utc;
                }
                $('#modal_setting').modal('hide');
            });
            Chat_template.body.on('click', '#mark_all_as_read_button', function () {
                var $btn = $('#mark_all_as_read_button');
                var $icon = $('#mark_all_as_read_icon');
                var $spinner = $('#mark_all_as_read_spinner');
                $btn.prop('disabled', true);
                $icon.addClass('hidden');
                $spinner.removeClass('hidden');
                _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                    data: { query: 'mark_all_as_read' },
                    before: function () { },
                    success: function (data) {
                        $btn.prop('disabled', false);
                        $icon.removeClass('hidden');
                        $spinner.addClass('hidden');
                        if (data && data.result === 0) {
                            Contacts.no_read = {};
                            Contacts.category_noread = {};
                            $('.message_inbox').removeClass('no-read');
                            $('.mark_as_read').addClass('hidden');
                            Contacts.category_noread_load();
                            $('#modal_setting').modal('hide');
                        }
                    },
                    error: function () {
                        $btn.prop('disabled', false);
                        $icon.removeClass('hidden');
                        $spinner.addClass('hidden');
                    },
                });
            });
            Chat_template.body.on('click', '#reset_cache_button', function () {
                swal({
                    title: _7_Chat.Chat.l('Сбросить весь кеш?'),
                    html: _7_Chat.Chat.l('Локальный кэш чата (сохранённые сообщения, список контактов, очередь неотправленных) будет удалён, и чат перезагрузится с нуля. Данные на сервере не затрагиваются.'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: _7_Chat.Chat.l('Сбросить и перезагрузить'),
                    cancelButtonText: _7_Chat.Chat.l('Отмена'),
                }).then(function (result) {
                    if (!result || result.value !== true)
                        return;
                    $('#reset_cache_button').prop('disabled', true);
                    $('#reset_cache_icon').addClass('hidden');
                    $('#reset_cache_spinner').removeClass('hidden');
                    _7_Chat.Chat.resetAllCache();
                });
            });
            Chat_template.body.on('click', '.category_head', function () {
                var id = $(this).data('category_id');
                if (!isset(id))
                    return;
                var idString = typeof id === 'string' ? id : String(id);
                Contacts.category_save({
                    id: idString,
                    visible: $(this).next('ul').hasClass('menu-open'),
                });
            });
        },
        chat_subscribers_noread_up: function (_obj) {
            _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                data: { query: 'contact_no_read_up' },
                before: function () {
                    Button.preloader($('.noread_up'));
                },
                success: function (data) {
                    if (data.result === 0) {
                        try {
                            _4_Sorter.Sorter.load();
                        }
                        catch (e) {
                            console.error(e);
                        }
                        Button.reset($('.noread_up'));
                        return;
                    }
                    Button.reset($('.noread_up'));
                },
                error: function () {
                    Button.reset($('.noread_up'));
                },
            });
        },
        chat_subscribers_noread_up_state: function (state) {
            var button = $('.noread_up');
            if (!button.length)
                return;
            if (state === 'start') {
                Button.preloader(button);
                return;
            }
            Button.reset(button);
            try {
                _4_Sorter.Sorter.load();
            }
            catch (e) {
                console.error('chat_subscribers_noread_up_state|Sorter.load|error=', e);
            }
        },
        subscriber_chat_status: function (e) {
            var temp_class = $('#subscriber_chat_status');
            temp_class
                .removeClass('fa-circle text-green text-yellow')
                .addClass('fa-spinner fa-spin')
                .html('');
            _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                data: { query: 'subscriber_chat_status', status: e },
                before: function () { },
                success: function (data) {
                    if (data.result === 0) {
                        if (data.status === 'online') {
                            temp_class
                                .addClass('fa-circle text-green')
                                .removeClass('text-yellow fa-spinner fa-spin')
                                .html('<span class="hidden-xs"> ' + _7_Chat.Chat.l('Онлайн') + '</span>');
                        }
                        else {
                            temp_class
                                .addClass('fa-circle text-yellow')
                                .removeClass('text-green fa-spinner fa-spin')
                                .html('<span class="hidden-xs"> ' + _7_Chat.Chat.l('Перерыв') + '</span>');
                        }
                    }
                    else {
                        temp_class.attr('class', temp_class.attr('class') || '').html(temp_class.html());
                    }
                },
            });
        },
        automatic_message_distribution_apply: function (flag) {
            _7_Chat.Chat.operator_data.automatic_message_distribution = flag;
            $('#chat_status').toggleClass('hidden', flag !== 1);
            _8_Chat_template.Chat_template.display_operators();
            _8_Chat_template.Chat_template.display_noread_operator_messages();
        },
        is_cabinet_owner: function () {
            var _a = _7_Chat.Chat.operator_data, id = _a.id, central_user_id = _a.central_user_id;
            if (id === undefined || central_user_id === undefined)
                return false;
            return String(id) === String(central_user_id);
        },
        operators_chat_status_visible: function () {
            return _7_Chat.Chat.is_cabinet_owner() && _7_Chat.Chat.operator_data.automatic_message_distribution === 1;
        },
        operator_chat_status_set: function (target, status) {
            var data = 'all' in target
                ? { query: 'operator_chat_status_set', status: status, all: true }
                : { query: 'operator_chat_status_set', status: status, operator_ids: [target.operator_id] };
            _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                data: data,
                before: function () { },
                success: function (answer) {
                    if (answer.result !== 0) {
                        toastr.error(_7_Chat.Chat.l('Не удалось сменить статус оператора'));
                    }
                },
            });
        },
        operator_chat_status_choose: function (status) {
            var _a;
            var menu = document.getElementById('operator_chat_status_menu');
            var operatorId = Number(menu === null || menu === void 0 ? void 0 : menu.getAttribute('data-operator_id'));
            _8_Chat_template.Chat_template.operator_chat_status_menu_close();
            if (!Number.isInteger(operatorId) || (status !== 'online' && status !== 'pause')) {
                console.error('operator_chat_status_choose|меню не той формы', operatorId, status);
                return;
            }
            var current = (_a = _7_Chat.Chat.operators_get()[operatorId]) === null || _a === void 0 ? void 0 : _a.chat_status;
            if ((current === 'online' ? 'online' : 'pause') === status)
                return;
            _7_Chat.Chat.operator_chat_status_set({ operator_id: operatorId }, status);
        },
        operator_chat_status_update: function (operatorId, status) {
            var operator = _7_Chat.Chat.operators_get()[operatorId];
            if (!operator)
                return;
            operator.chat_status = status;
            _8_Chat_template.Chat_template.display_operator_chat_status(operatorId, status);
        },
        quick_messages_data: null,
        quick_messages_query: function () {
            _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                data: { query: 'quick_messages_query' },
                before: function () { },
                success: function (data) {
                    if (data.result === 0) {
                        _7_Chat.Chat.quick_messages_update(data, function () {
                            _8_Chat_template.Chat_template.display_quick_messages();
                        });
                    }
                },
            });
        },
        quick_messages_update: function (data, callback) {
            if (typeof callback !== 'function')
                callback = function () { };
            var func_callback = callback;
            _7_Chat.Chat.quick_messages_data = data;
            func_callback();
        },
        quick_messages_get: function () {
            if (_7_Chat.Chat.quick_messages_data !== null)
                return _7_Chat.Chat.quick_messages_data;
            return null;
        },
        ai_transfer_status_query: function () {
            var phone = _7_Chat.Chat.openSubscriberPhone();
            if (phone === null)
                return;
            _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                data: { query: 'ai_transfer_status', phone: phone },
                before: function () { },
                success: function (data) {
                    var _a;
                    if (data.result !== 0)
                        return;
                    var refusal = data['available'] === true
                        ? null
                        : ((_a = _0_Constants.aiTransferRefusalOf(data['reason'])) !== null && _a !== void 0 ? _a : 'ai_check_failed');
                    _8_Chat_template.Chat_template.display_ai_transfer_option(refusal);
                },
            });
        },
        operators_data: null,
        operators_query: function () {
            _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                data: { query: 'get_operators' },
                before: function () { },
                success: function (data) {
                    if (data.result === 0) {
                        _8_Chat_template.Chat_template.display_operator_list(data);
                        _7_Chat.Chat.operators_update(data, function () {
                            _8_Chat_template.Chat_template.display_operators();
                            setTimeout(function () {
                                _7_Chat.Chat.chat_noread_operator_messages_load();
                            }, 1000);
                        });
                    }
                },
            });
        },
        operators_update: function (data, callback) {
            if (typeof callback !== 'function')
                callback = function () { };
            var func_callback = callback;
            var mass = {};
            if (count_obj(data.operator_list)) {
                for (var key in data.operator_list) {
                    if (data.operator_list.hasOwnProperty(key)) {
                        var operator = data.operator_list[Number(key)];
                        if (operator && operator.id) {
                            mass[operator.id] = operator;
                        }
                    }
                }
            }
            _7_Chat.Chat.operators_data = mass;
            func_callback();
        },
        operators_get: function () {
            if (_7_Chat.Chat.operators_data !== null)
                return _7_Chat.Chat.operators_data;
            return {};
        },
        operator_messages_query: function (operator_id_to) {
            if (operator_id_to === undefined) {
                console.warn('[TypeGuard] operator_messages_query: operator_id_to is undefined');
                return;
            }
            _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                data: {
                    query: 'get_operator_messages',
                    operator_id_to: operator_id_to,
                },
                before: function () { },
                success: function (data) {
                    if (data.result === 0) {
                        _8_Chat_template.Chat_template.display_operator_messages(data);
                    }
                    else {
                        alert(data.result_description);
                    }
                },
            });
        },
        noread_operator_messages_update_beep: false,
        noread_operator_messages_update: function (data, callback) {
            var _a, _b, _c, _d, _f, _g;
            if (typeof callback !== 'function')
                callback = function () { };
            var func_callback = callback;
            if ($.isEmptyObject(data.messages)) {
                console.log('MessageBeep_off');
                if (typeof ipcRenderer === 'object' && ipcRenderer) {
                    ipcRenderer.send('asynchronous-message', { notyfi: 'MessageBeep_off' });
                }
            }
            if (Object.equal(data.messages, _7_Chat.Chat.chat_noread_operator_messages)) {
                return;
            }
            var n = 0;
            var open_operator = null;
            for (var key in data.messages) {
                if (!_7_Chat.Chat.chat_noread_operator_messages[key] ||
                    ((_c = (_b = (_a = _7_Chat.Chat.chat_noread_operator_messages[key]) === null || _a === void 0 ? void 0 : _a.message) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) <
                        ((_g = (_f = (_d = data.messages[key]) === null || _d === void 0 ? void 0 : _d.message) === null || _f === void 0 ? void 0 : _f.length) !== null && _g !== void 0 ? _g : 0)) {
                    n++;
                    open_operator = key;
                }
            }
            if (n > 0) {
                if (_7_Chat.Chat.win_programm_version()) {
                }
                else {
                    if (_7_Chat.Chat.noread_operator_messages_update_beep) {
                        if (_7_Chat.Chat.operator_data.chat_audio_notyfi_new_message_off !== 1) {
                            _7_Chat.Chat.audio_play();
                        }
                        toastr.options.onclick = function () {
                            _7_Chat.Chat.click_open_operator({
                                data: function (e) {
                                    if (e === 'operator_id')
                                        return open_operator;
                                    return undefined;
                                },
                            });
                        };
                        toastr.options.closeButton = true;
                        toastr.success('Новое входящее сообщение от оператора.');
                    }
                    _7_Chat.Chat.noread_operator_messages_update_beep = true;
                }
            }
            _7_Chat.Chat.chat_noread_operator_messages = data.messages;
            func_callback();
        },
        win_programm_version: function () {
            var win_programm_version = localStorage.getItem('win_programm_version');
            if (win_programm_version !== null && win_programm_version !== '')
                return win_programm_version;
            return false;
        },
        verification_chat_version: function (ver) {
            if (!isset(ver))
                return;
            _7_Chat.Chat.data.chat_version_new = ver;
            if (_7_Chat.Chat.data.chat_version !== ver) {
                if (!$('#message_update_chat').hasClass('alert'))
                    $('#block_notification').prepend("<div id=\"message_update_chat\" class=\"alert alert-info fade in\"><i class=\"fa fa-sync\"></i> " +
                        "<a href=\"".concat(_7_Chat.Chat.navbarPageId, "\">\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0447\u0430\u0442</a></div>"));
            }
            else {
                $('#message_update_chat').remove();
            }
        },
        is_chat_loader: function (s) {
            for (var key2 in s) {
                if (s.hasOwnProperty(key2) && s[key2] !== undefined) {
                    this.chat_loader[key2] = s[key2];
                }
            }
            var e = 0;
            for (var key in this.chat_loader) {
                if (this.chat_loader.hasOwnProperty(key)) {
                    if (!this.chat_loader[key])
                        e++;
                }
            }
            if (e === 0) {
                $('.wrapper').css('display', 'block');
                $('.loader_chat').remove();
                document.documentElement.classList.remove('chat-instant');
                $('#chat_sync_indicator').remove();
                _7_Chat.Chat.contactsSnapshotFlush();
            }
        },
        push_delete: function () {
            if (_7_Chat.Chat.oneSignalUserID !== false &&
                _7_Chat.Chat.oneSignalUserID !== undefined &&
                typeof _7_Chat.Chat.oneSignalUserID === 'string' &&
                _7_Chat.Chat.oneSignalUserID.length > 5) {
                jQuery.ajax({
                    type: 'POST',
                    url: '/ajax.php',
                    dataType: 'json',
                    data: {
                        action: 'push_delete',
                        oneSignalUserID: _7_Chat.Chat.oneSignalUserID,
                    },
                    success: function (_jsondata) { },
                    error: function (xhr) {
                        console.error(xhr);
                    },
                });
            }
        },
        start_once_check: false,
        start_once: function () {
            if (_7_Chat.Chat.start_once_check)
                return;
            _7_Chat.Chat.start_once_check = true;
            _5_Contacts.Contacts.init();
            _10_Chat_WebSocket.Chat_WebSocket.ajax_verifier();
            _7_Chat.Chat.quick_messages_query();
            _7_Chat.Chat.operators_query();
        },
        refresh_chat: function (url, refresh) {
            if (refresh === void 0) { refresh = false; }
            if (!refresh) {
                if (_7_Chat.Chat.composer_text() !== '')
                    return;
                _7_Chat.Chat.go_to_page(url);
                return;
            }
            _7_Chat.Chat.forced_reload_wait(url, _7_Chat.Chat.composer_text(), Date.now());
        },
        composer_text: function () {
            var plain = $('#textarea_message_text').val();
            var rich = $('.emoji-wysiwyg-editor').html();
            return (typeof plain === 'string' ? plain : '') + (typeof rich === 'string' ? rich : '');
        },
        forced_reload_idle_ms: 30000,
        forced_reload_wait: function (url, text, unchangedSince) {
            var current = _7_Chat.Chat.composer_text();
            if (current !== '') {
                var since_1 = current === text ? unchangedSince : Date.now();
                if (Date.now() - since_1 < _7_Chat.Chat.forced_reload_idle_ms) {
                    setTimeout(function () {
                        _7_Chat.Chat.forced_reload_wait(url, current, since_1);
                    }, 1000);
                    return;
                }
                _7_Chat.Chat.save_composer_draft();
            }
            if (_7_Chat.Chat.chat_open_subscriber) {
                localStorage.setItem('chat_update', String(_7_Chat.Chat.chat_open_subscriber));
            }
            _7_Chat.Chat.go_to_page(url);
        },
        save_composer_draft: function () {
            var phone = _7_Chat.Chat.viewSubscriberPhone();
            if (phone === null)
                return;
            var plain = $('#textarea_message_text').val();
            _2_Draft.Draft.put_t(phone, typeof plain === 'string' ? plain : '');
            var rich = $('.emoji-wysiwyg-editor').html();
            _2_Draft.Draft.put_d(phone, typeof rich === 'string' ? rich : '');
        },
        go_to_page: function (url) {
            location.href = url;
        },
        authorization_check: function () {
            jQuery.ajax({
                type: 'GET',
                url: _7_Chat.Chat.chatoperator,
                data: {
                    action: 'is_user_logged_in',
                    host: window.location.host,
                },
                dataType: 'json',
                success: function (data) {
                    var jsondata = _7_Chat.Chat.readAuthorizationCheck(data);
                    if (jsondata !== null && jsondata.res === 0) {
                        if (_7_Chat.Chat.operator_data.id !== jsondata.user.id) {
                            _7_Chat.Chat.refresh_chat(_7_Chat.Chat.navbarPageId, false);
                        }
                    }
                    else {
                        _7_Chat.Chat.refresh_chat(_7_Chat.Chat.navbarPageId, false);
                    }
                },
                error: function () { },
            });
        },
        saveOperatorSnapshot: function (data) {
            try {
                var id = Number(data === null || data === void 0 ? void 0 : data.id);
                var central = Number(data === null || data === void 0 ? void 0 : data.central_user_id);
                if (!Number.isFinite(id) || id <= 0 || !Number.isFinite(central) || central <= 0)
                    return;
                var dataExtra = data;
                var snapshot = {
                    id: id,
                    central_user_id: central,
                    user_name: typeof dataExtra.user_name === 'string' ? dataExtra.user_name : null,
                    user_email: typeof dataExtra.user_email === 'string' ? dataExtra.user_email : null,
                    roles: Array.isArray(data.roles) ? data.roles : null,
                    auto_read: typeof dataExtra.auto_read === 'number' ? dataExtra.auto_read : null,
                    contact_view: typeof dataExtra.contact_view === 'number' ? dataExtra.contact_view : null,
                    saved_at: Date.now(),
                };
                localStorage.setItem(OFFLINE_OPERATOR_SNAPSHOT_KEY, JSON.stringify(snapshot));
            }
            catch (error) {
                console.error('saveOperatorSnapshot|error=', error);
            }
        },
        clearOperatorSnapshot: function () {
            try {
                localStorage.removeItem(OFFLINE_OPERATOR_SNAPSHOT_KEY);
            }
            catch (error) {
                console.error('clearOperatorSnapshot|error=', error);
            }
        },
        isSettingsAdmin: function () {
            return (_7_Chat.Chat.operator_data.central_user_id === _7_Chat.Chat.operator_data.id ||
                (Array.isArray(_7_Chat.Chat.operator_data.roles) &&
                    (_7_Chat.Chat.operator_data.roles.includes('admin') ||
                        _7_Chat.Chat.operator_data.roles.includes('administrator') ||
                        _7_Chat.Chat.operator_data.roles.includes('admin_operator'))));
        },
        resetAllCache: function () {
            var cleanup = function () {
                return __awaiter(this, void 0, void 0, function () {
                    var chatStore, error_1, opId, keys, _i, keys_1, key, error_2, registrations, _a, registrations_1, registration, error_3;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                chatStore = _7_Chat.Chat.Chat_Store;
                                _7_Chat.Chat.Chat_Store = null;
                                if (!chatStore) return [3, 4];
                                _b.label = 1;
                            case 1:
                                _b.trys.push([1, 3, , 4]);
                                return [4, chatStore.deleteDatabasePr()];
                            case 2:
                                _b.sent();
                                return [3, 4];
                            case 3:
                                error_1 = _b.sent();
                                console.error('resetAllCache|deleteDatabasePr|error=', error_1);
                                return [3, 4];
                            case 4:
                                if (typeof indexedDB !== 'undefined') {
                                    opId = _7_Chat.Chat.operator_data ? _7_Chat.Chat.operator_data.id : undefined;
                                    if (opId !== undefined && opId !== null && String(opId) !== '') {
                                        try {
                                            indexedDB.deleteDatabase("ChatDB".concat(opId));
                                        }
                                        catch (error) {
                                            console.error('resetAllCache|deleteDatabase|error=', error);
                                        }
                                    }
                                }
                                _7_Chat.Chat.clearOperatorSnapshot();
                                _b.label = 5;
                            case 5:
                                _b.trys.push([5, 11, , 12]);
                                if (!(typeof caches !== 'undefined')) return [3, 10];
                                return [4, caches.keys()];
                            case 6:
                                keys = _b.sent();
                                _i = 0, keys_1 = keys;
                                _b.label = 7;
                            case 7:
                                if (!(_i < keys_1.length)) return [3, 10];
                                key = keys_1[_i];
                                if (!(key.indexOf('chat-shell-') === 0)) return [3, 9];
                                return [4, caches.delete(key)];
                            case 8:
                                _b.sent();
                                _b.label = 9;
                            case 9:
                                _i++;
                                return [3, 7];
                            case 10: return [3, 12];
                            case 11:
                                error_2 = _b.sent();
                                console.error('resetAllCache|caches|error=', error_2);
                                return [3, 12];
                            case 12:
                                _b.trys.push([12, 18, , 19]);
                                if (!(navigator.serviceWorker &&
                                    typeof navigator.serviceWorker.getRegistrations === 'function')) return [3, 17];
                                return [4, navigator.serviceWorker.getRegistrations()];
                            case 13:
                                registrations = _b.sent();
                                _a = 0, registrations_1 = registrations;
                                _b.label = 14;
                            case 14:
                                if (!(_a < registrations_1.length)) return [3, 17];
                                registration = registrations_1[_a];
                                if (!(registration.scope.indexOf('/chat') !== -1)) return [3, 16];
                                return [4, registration.unregister()];
                            case 15:
                                _b.sent();
                                _b.label = 16;
                            case 16:
                                _a++;
                                return [3, 14];
                            case 17: return [3, 19];
                            case 18:
                                error_3 = _b.sent();
                                console.error('resetAllCache|serviceWorker|error=', error_3);
                                return [3, 19];
                            case 19: return [2];
                        }
                    });
                });
            };
            var reload = function () {
                location.reload();
            };
            cleanup().then(reload, function (error) {
                console.error('resetAllCache|error=', error);
                reload();
            });
        },
        offlineCacheReady: function () {
            var chatStore = _7_Chat.Chat.Chat_Store;
            return !_7_Chat.Chat.chat_loader['websocket'] && !!chatStore && chatStore.isActive();
        },
        contactSnapshotPresentation: function (phone) {
            var contact = _5_Contacts.Contacts.data[phone];
            if (!contact)
                return null;
            var categoryRaw = contact.category;
            return {
                phone: phone,
                name: typeof contact.name === 'string' ? contact.name : '',
                name_custom: typeof contact.name_custom === 'string' ? contact.name_custom : null,
                transport: contact.transport,
                insta_login: typeof contact.insta_login === 'string' ? contact.insta_login : null,
                telegram_login: typeof contact.telegram_login === 'string' ? contact.telegram_login : null,
                sp_numb: typeof contact.sp_numb === 'number' ? contact.sp_numb : null,
                category: Array.isArray(categoryRaw) ? categoryRaw.map(String) : null,
            };
        },
        seedContactFromSnapshotRow: function (row) {
            var Contacts = _5_Contacts.Contacts;
            if (Contacts.data[row.phone])
                return;
            var contactData = {
                phone: row.phone,
                name: row.name,
                transport: row.transport,
                name_custom: row.name_custom,
                insta_login: row.insta_login === null ? undefined : row.insta_login,
                telegram_login: row.telegram_login,
                sp_numb: row.sp_numb === null ? undefined : row.sp_numb,
                category: row.category === null ? undefined : row.category,
            };
            Contacts.data[row.phone] = contactData;
        },
        contactsSnapshotSchedule: function (sorts, categ, start) {
            var chatStore = _7_Chat.Chat.Chat_Store;
            if (!chatStore || !chatStore.isActive())
                return;
            if (!_7_Chat.Chat.chat_loader['websocket'])
                return;
            _7_Chat.Chat.contacts_snapshot_last = { sorts: sorts, categ: categ, start: start };
            if (_7_Chat.Chat.contacts_snapshot_timeout !== null) {
                window.clearTimeout(_7_Chat.Chat.contacts_snapshot_timeout);
            }
            _7_Chat.Chat.contacts_snapshot_timeout = window.setTimeout(function () {
                _7_Chat.Chat.contacts_snapshot_timeout = null;
                _7_Chat.Chat.contactsSnapshotFlush();
            }, CONTACTS_SNAPSHOT_DEBOUNCE_MS);
            if (_7_Chat.Chat.contacts_snapshot_max_timeout === null) {
                _7_Chat.Chat.contacts_snapshot_max_timeout = window.setTimeout(function () {
                    _7_Chat.Chat.contacts_snapshot_max_timeout = null;
                    _7_Chat.Chat.contactsSnapshotFlush();
                }, CONTACTS_SNAPSHOT_MAX_WAIT_MS);
            }
        },
        contactsSnapshotFlush: function () {
            if (_7_Chat.Chat.contacts_snapshot_timeout !== null) {
                window.clearTimeout(_7_Chat.Chat.contacts_snapshot_timeout);
                _7_Chat.Chat.contacts_snapshot_timeout = null;
            }
            if (_7_Chat.Chat.contacts_snapshot_max_timeout !== null) {
                window.clearTimeout(_7_Chat.Chat.contacts_snapshot_max_timeout);
                _7_Chat.Chat.contacts_snapshot_max_timeout = null;
            }
            var chatStore = _7_Chat.Chat.Chat_Store;
            var pending = _7_Chat.Chat.contacts_snapshot_last;
            if (!chatStore || !chatStore.isActive() || !pending)
                return;
            var rows = [];
            var idx = 0;
            for (var key in pending.sorts) {
                var item = pending.sorts[key];
                if (!item || !item.phone)
                    continue;
                var position = pending.categ === '0' ? pending.start + idx : undefined;
                idx++;
                var presentation = _7_Chat.Chat.contactSnapshotPresentation(item.phone);
                rows.push(__assign({ phone: item.phone, ord: position, noread: typeof item.noread === 'number' ? item.noread : 0 }, (presentation !== null && presentation !== void 0 ? presentation : {})));
            }
            if (!rows.length)
                return;
            _7_Chat.Chat.contacts_snapshot_last = null;
            if (pending.categ === '0') {
                chatStore
                    .upsertContactsPr(rows, { ordRange: { start: pending.start, end: pending.start + idx } })
                    .catch(function (error) {
                    console.error('contactsSnapshotFlush|upsertContactsPr|error=', error);
                });
                return;
            }
            chatStore.upsertContactsPr(rows).catch(function (error) {
                console.error('contactsSnapshotFlush|upsertContactsPr|error=', error);
            });
        },
        contactUpsertFromData: function (phone) {
            var chatStore = _7_Chat.Chat.Chat_Store;
            if (!chatStore || !chatStore.isActive() || !phone)
                return;
            _7_Chat.Chat.contacts_data_upsert_pending[phone] = true;
            if (_7_Chat.Chat.contacts_data_upsert_timeout !== null)
                return;
            _7_Chat.Chat.contacts_data_upsert_timeout = window.setTimeout(function () {
                _7_Chat.Chat.contacts_data_upsert_timeout = null;
                var phones = Object.keys(_7_Chat.Chat.contacts_data_upsert_pending);
                _7_Chat.Chat.contacts_data_upsert_pending = {};
                var rows = [];
                for (var _i = 0, phones_1 = phones; _i < phones_1.length; _i++) {
                    var p = phones_1[_i];
                    var presentation = _7_Chat.Chat.contactSnapshotPresentation(p);
                    if (presentation)
                        rows.push(presentation);
                }
                if (!rows.length)
                    return;
                chatStore.upsertContactsPr(rows).catch(function (error) {
                    console.error('contactUpsertFromData|upsertContactsPr|error=', error);
                });
            }, 2000);
        },
        cacheBootTry: function () {
            if (_7_Chat.Chat.offline_boot_state !== 'idle')
                return;
            _7_Chat.Chat.offline_boot_state = 'started';
            try {
                if (typeof Chat_useDexie === 'undefined' || !Chat_useDexie)
                    return;
                if (typeof Dexie === 'undefined')
                    return;
                var raw = localStorage.getItem(OFFLINE_OPERATOR_SNAPSHOT_KEY);
                if (!raw)
                    return;
                var snapshotRaw = JSON.parse(raw);
                if (!isOfflineOperatorSnapshot(snapshotRaw)) {
                    console.warn('cacheBoot|снапшот оператора не той формы — кэш-бутстрап пропущен');
                    return;
                }
                var snapshot = snapshotRaw;
                if (snapshot.id <= 0)
                    return;
                console.log('cacheBoot|start|operator=', snapshot.id);
                if (!_7_Chat.Chat.chat_loader['get_operator']) {
                    var operatorData = {
                        id: snapshot.id,
                        central_user_id: snapshot.central_user_id,
                    };
                    if (snapshot.user_name !== null)
                        operatorData.user_name = snapshot.user_name;
                    if (snapshot.user_email !== null)
                        operatorData.user_email = snapshot.user_email;
                    if (snapshot.roles !== null)
                        operatorData.roles = snapshot.roles;
                    if (snapshot.auto_read !== null)
                        operatorData.auto_read = snapshot.auto_read;
                    if (snapshot.contact_view !== null)
                        operatorData.contact_view = snapshot.contact_view;
                    _7_Chat.Chat.operator_data = operatorData;
                }
                if (!_7_Chat.Chat.Chat_Store) {
                    _7_Chat.Chat.Chat_Store = new _6_1_Chat_Store.Chat_Store(snapshot.id);
                }
                var chatStore = _7_Chat.Chat.Chat_Store;
                if (!chatStore.isActive())
                    return;
                Promise.all([
                    chatStore.getCategoriesMetaPr(),
                    chatStore.getCategoryNoreadMetaPr(),
                    chatStore.getWorksMetaPr(),
                    chatStore.getContactsPagePr({ categ: '0', start: 0, limit: 1000000 }),
                ])
                    .then(function (_a) {
                    var _b;
                    var categoriesMeta = _a[0], noreadMeta = _a[1], worksMeta = _a[2], contactsPage = _a[3];
                    if (_7_Chat.Chat.start_once_check || _7_Chat.Chat.auth_invalid)
                        return;
                    if (!contactsPage.rows.length)
                        return;
                    var Contacts = _5_Contacts.Contacts;
                    var Sorter = _4_Sorter.Sorter;
                    for (var _i = 0, _c = contactsPage.rows; _i < _c.length; _i++) {
                        var row = _c[_i];
                        _7_Chat.Chat.seedContactFromSnapshotRow(row);
                    }
                    if (categoriesMeta) {
                        Contacts.category = categoriesMeta.list;
                        Contacts.category_sort = categoriesMeta.sort;
                        var firstCateg = Contacts.category_sort[0];
                        if (firstCateg && ((_b = Contacts.category[firstCateg]) === null || _b === void 0 ? void 0 : _b.h) === 0) {
                            Sorter.config.categ = firstCateg;
                        }
                        Contacts.category_render();
                    }
                    if (noreadMeta) {
                        Contacts.category_noread = noreadMeta.noread;
                    }
                    if (worksMeta) {
                        Contacts.work_my = worksMeta.work_my;
                        Contacts.work_alien = worksMeta.work_alien;
                        Contacts.work_ai = worksMeta.work_ai;
                        if (worksMeta.work_await !== undefined) {
                            Contacts.work_await = worksMeta.work_await;
                        }
                    }
                    _7_Chat.Chat.offline_boot_state = 'rendered';
                    $('.loader_chat').remove();
                    $('.wrapper').css('display', 'block');
                    _7_Chat.Chat.showSyncIndicator();
                    Contacts.category_open(Sorter.config.categ);
                    _3_SorterWork.SorterWork.load();
                    console.log('cacheBoot|rendered|contacts=', contactsPage.total);
                })
                    .catch(function (error) {
                    console.error('cacheBootTry|read|error=', error);
                });
            }
            catch (error) {
                console.error('cacheBootTry|error=', error);
            }
        },
        showSyncIndicator: function () {
            if ($('#chat_sync_indicator').length)
                return;
            $('#block_notification').prepend('<div id="chat_sync_indicator" class="alert alert-info fade in" style="margin-bottom:5px; padding:6px 10px;">' +
                '<i class="fa fa-spinner fa-spin"></i> ' +
                _7_Chat.Chat.l('Синхронизация...') +
                '</div>');
        },
        initLoaderWatchdog: function () {
            window.setTimeout(function () {
                if (_7_Chat.Chat.auth_invalid)
                    return;
                if (_7_Chat.Chat.chat_loader['contacts_init'])
                    return;
                console.error('initLoaderWatchdog|timeout=' +
                    INIT_LOADER_WATCHDOG_MS +
                    'ms — принудительно снимаем загрузочную индикацию');
                $('.wrapper').css('display', 'block');
                $('.loader_chat').remove();
                document.documentElement.classList.remove('chat-instant');
                $('#chat_sync_indicator').remove();
            }, INIT_LOADER_WATCHDOG_MS);
        },
        outboxApplySent: function (item, message_id) {
            var chatData = _7_Chat.Chat.chat_messages[item.phone];
            var bubble = chatData === null || chatData === void 0 ? void 0 : chatData.messages.find(function (msg) {
                return msg.message_id_tmp === item.message_id_tmp;
            });
            if (bubble) {
                bubble.id = message_id;
                if (chatData) {
                    var messages = chatData.messages;
                    for (var i = messages.length - 1; i >= 0; i--) {
                        var m = messages[i];
                        if (m && m !== bubble && m.id === message_id) {
                            messages.splice(i, 1);
                        }
                    }
                    _7_Chat.Chat.sortChatMessages(messages);
                }
            }
            else if (chatData) {
                _7_Chat.Chat.message_push({
                    phone: item.phone,
                    text: item.text,
                    fileUrl: null,
                    message_id: message_id,
                    message_id_tmp: item.message_id_tmp,
                });
            }
            var chatStore = _7_Chat.Chat.Chat_Store;
            if (chatStore && chatStore.isActive()) {
                var sentMessage = {
                    id: message_id,
                    ph_numb: item.phone,
                    message_id_tmp: item.message_id_tmp,
                    message_route: 'outbox',
                    message_type: 'message-chat',
                    message_text: item.text,
                    message_status: '0',
                    add_date: item.add_date,
                    user_id: Number(_7_Chat.Chat.operator_data.id),
                };
                chatStore.putSentMessagesPr(item.phone, [sentMessage]).catch(function (error) {
                    console.error('outboxApplySent|putSentMessagesPr|error=', error);
                });
            }
            if (String(_7_Chat.Chat.chat_view_subscriber) === String(item.phone)) {
                _8_Chat_template.Chat_template.display_messages2({
                    phone: item.phone,
                    scroll: 'bottom',
                    chat_open: null,
                    direction: 'DOWN',
                });
            }
        },
        outboxApplyFailed: function (item, description) {
            var chatData = _7_Chat.Chat.chat_messages[item.phone];
            var bubble = chatData === null || chatData === void 0 ? void 0 : chatData.messages.find(function (msg) {
                return msg.message_id_tmp === item.message_id_tmp;
            });
            if (bubble) {
                bubble.message_status = '4';
                bubble.message_status_msg = description;
            }
            toastr.error(description || 'Не удалось отправить отложенное сообщение');
            if (String(_7_Chat.Chat.chat_view_subscriber) === String(item.phone)) {
                _8_Chat_template.Chat_template.display_messages2({
                    phone: item.phone,
                    scroll: 'bottom',
                    chat_open: null,
                    direction: 'DOWN',
                });
            }
        },
        outboxFlush: function () {
            var chatStore = _7_Chat.Chat.Chat_Store;
            if (!chatStore || !chatStore.isActive())
                return;
            var now = Date.now();
            if (_7_Chat.Chat.outbox_flush_running !== 0 && now - _7_Chat.Chat.outbox_flush_running < 60000)
                return;
            var flushToken = now;
            _7_Chat.Chat.outbox_flush_running = flushToken;
            var releaseFlag = function () {
                if (_7_Chat.Chat.outbox_flush_running === flushToken)
                    _7_Chat.Chat.outbox_flush_running = 0;
            };
            chatStore
                .outboxAllPr()
                .then(function (items) {
                if (!items.length) {
                    releaseFlag();
                    return;
                }
                console.log('outboxFlush|start|items=', items.length);
                var queue = items.slice();
                var processNext = function () {
                    var item = queue.shift();
                    if (!item) {
                        releaseFlag();
                        return;
                    }
                    if (item.oid === undefined) {
                        processNext();
                        return;
                    }
                    if (!_7_Chat.Chat.chat_loader['websocket']) {
                        releaseFlag();
                        return;
                    }
                    var oid = item.oid;
                    chatStore
                        .outboxClaimPr(oid)
                        .then(function (claimed) {
                        if (!claimed) {
                            processNext();
                            return;
                        }
                        if (!_7_Chat.Chat.chat_loader['websocket']) {
                            chatStore.outboxReleasePr(oid).catch(function (error) {
                                console.error('outboxFlush|outboxReleasePr|error=', error);
                            });
                            releaseFlag();
                            return;
                        }
                        _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                            data: {
                                query: 'message_send',
                                phone: item.phone,
                                text: item.text,
                                file_url: [],
                                system_message: null,
                                answer_id: item.answer_id === undefined ? '' : item.answer_id,
                                message_id_tmp: item.message_id_tmp,
                            },
                            before: function () { },
                            success: function (jsondata) {
                                if (jsondata && Number(jsondata.result) === 0) {
                                    chatStore.outboxDeletePr(oid).catch(function (error) {
                                        console.error('outboxFlush|outboxDeletePr|error=', error);
                                    });
                                    _7_Chat.Chat.outboxApplySent(item, Number(jsondata.message_id));
                                }
                                else {
                                    chatStore.outboxDeletePr(oid).catch(function (error) {
                                        console.error('outboxFlush|outboxDeletePr|error=', error);
                                    });
                                    var description = jsondata && typeof jsondata.result_description === 'string'
                                        ? jsondata.result_description
                                        : '';
                                    _7_Chat.Chat.outboxApplyFailed(item, description);
                                }
                                processNext();
                            },
                            error: function (error) {
                                console.error('outboxFlush|message_send|error=', error);
                                releaseFlag();
                            },
                        });
                    })
                        .catch(function (error) {
                        console.error('outboxFlush|outboxClaimPr|error=', error);
                        releaseFlag();
                    });
                };
                processNext();
            })
                .catch(function (error) {
                console.error('outboxFlush|outboxAllPr|error=', error);
                releaseFlag();
            });
        },
        get_operator_data_chek: false,
        get_operator_data: function () {
            console.log('ww|get_operator_data');
            if (_7_Chat.Chat.get_operator_data_chek)
                return;
            _7_Chat.Chat.get_operator_data_chek = true;
            console.log('ww|get_operator_data=', _7_Chat.Chat.routePath + '/get_user');
            function get_query() {
                var result = {};
                var i = 0;
                var url = document.location.href;
                var qs = url.substring(url.indexOf('?') + 1).split('&');
                for (; i < qs.length; i++) {
                    var queryPart = qs[i];
                    if (queryPart === undefined)
                        continue;
                    var parts = queryPart.split('=');
                    if (parts.length >= 2 && parts[0] && parts[1]) {
                        result[parts[0]] = decodeURIComponent(parts[1]);
                    }
                }
                return result;
            }
            console.log('ww|get_operator_data|get_query=', get_query());
            jQuery.ajax({
                type: 'GET',
                url: _7_Chat.Chat.routePath + '/get_user',
                dataType: 'json',
                data: get_query(),
                success: function (data) {
                    var _a;
                    var jsondata = _7_Chat.Chat.readGetOperatorData(data);
                    _7_Chat.Chat.get_operator_data_chek = false;
                    if ((jsondata === null || jsondata === void 0 ? void 0 : jsondata.result) === 0 && jsondata.data) {
                        _7_Chat.Chat.auth_invalid = false;
                        var operatorData = jsondata.data;
                        _7_Chat.Chat.operator_data = operatorData;
                        var central_user_id = operatorData.central_user_id, id = operatorData.id, account_test = operatorData.account_test;
                        _2_Draft.Draft.clear();
                        _7_Chat.Chat.saveOperatorSnapshot(operatorData);
                        if (typeof Chat_useDexie !== 'undefined' && Chat_useDexie) {
                            _7_Chat.Chat.Chat_Store = new _6_1_Chat_Store.Chat_Store(id);
                        }
                        _6_FileUpload.FileUpload.quickMessagesInit();
                        if (central_user_id == 4373 || central_user_id == 4342 || central_user_id == 6222) {
                            if (central_user_id != id)
                                $('.contact_status_display').hide();
                        }
                        if (!!account_test) {
                            $('#demo_logo').html('<span style="background: #00a65a;border-radius: 4px;color: #ffffff;padding: 2px 6px;font-size: 10px;">demo</span>');
                            $('.no-demo-content').hide();
                            $('.demo-content').show();
                            $('#chat_home').css('padding', '0');
                            if (_7_Chat.Chat.isMobile.any()) {
                                $('.mobile_hidden').addClass('hidden');
                                $('.user-menu').html("<a href=\"https://sendapi.net/?page_id=22\" target=\"_blank\">".concat(_7_Chat.Chat.l('⚡️ПОДКЛЮЧИТЬ'), "</a>"));
                            }
                            else {
                                $('.user-menu').html("<a href=\"https://sendapi.net/?page_id=22\" target=\"_blank\">".concat(_7_Chat.Chat.l('⚡️ПОДКЛЮЧИТЬ КОМПАНИЮ'), "</a>"));
                            }
                        }
                        if (central_user_id == '10') {
                            $('.user-header').append("<a href=\"/chat\">".concat(_7_Chat.Chat.l('Новый чат'), "</a>"));
                        }
                        if (central_user_id == '10' ||
                            central_user_id == '1441' ||
                            central_user_id == '1519' ||
                            central_user_id == '2720' ||
                            central_user_id == '3908' ||
                            central_user_id == '5491' ||
                            central_user_id == '5492') {
                            $('.language_block').removeClass('hidden');
                        }
                        if (central_user_id == '168') {
                            $('.amocrm_type_lead_block').removeClass('hidden');
                        }
                        if (((_a = jsondata === null || jsondata === void 0 ? void 0 : jsondata.data) === null || _a === void 0 ? void 0 : _a.chat_status) === 'online') {
                            $('#subscriber_chat_status')
                                .addClass('text-green')
                                .removeClass('text-yellow fa-spinner fa-spin')
                                .html('<span class="hidden-xs"> ' + _7_Chat.Chat.l('Онлайн') + '</span>');
                        }
                        else {
                            $('#subscriber_chat_status')
                                .addClass('text-yellow')
                                .removeClass('text-green fa-spinner fa-spin')
                                .html('<span class="hidden-xs"> ' + _7_Chat.Chat.l('Перерыв') + '</span>');
                        }
                        _7_Chat.Chat.automatic_message_distribution_apply(jsondata.data.automatic_message_distribution === 1 ? 1 : 0);
                        _8_Chat_template.Chat_template.display_chat_user_name(jsondata.data.user_name || '', jsondata.data.user_email || '');
                        $('.avatar_img').html(jsondata.data.avatar || '');
                        _7_Chat.Chat.is_chat_loader({ get_operator: true });
                        if (jsondata.integration) {
                            _8_Chat_template.Chat_template.integration(jsondata.integration);
                        }
                        _10_Chat_WebSocket.Chat_WebSocket.connectV2();
                        _9_Chat_onesignal.Chat_onesignal.init(undefined);
                    }
                    else if ((jsondata === null || jsondata === void 0 ? void 0 : jsondata.result) === 'no_auth') {
                        _7_Chat.Chat.auth_invalid = true;
                        document.documentElement.classList.remove('chat-instant');
                        $('.wrapper').css('display', 'none');
                        $('#chat_sync_indicator').remove();
                        if (jsondata.auth_form && typeof jsondata.auth_form === 'string') {
                            _7_Chat.Chat.chat_auth(jsondata.auth_form);
                        }
                        _9_Chat_onesignal.Chat_onesignal.init(1);
                        _7_Chat.Chat.push_delete();
                    }
                    else {
                        _8_Chat_template.Chat_template.display_chat_user_name('', '');
                        _9_Chat_onesignal.Chat_onesignal.init(1);
                        _7_Chat.Chat.push_delete();
                    }
                    _7_Chat.Chat.initTags();
                    _7_Chat.Chat.initOutcomes();
                    _7_Chat.Chat.initLogs();
                },
                error: function () {
                    _7_Chat.Chat.get_operator_data_chek = false;
                    console.error('Ошибка загрузки данных оператора');
                    console.error('reload get_operator_data');
                    _7_Chat.Chat.cacheBootTry();
                    setTimeout(function () {
                        _7_Chat.Chat.get_operator_data();
                    }, 5000);
                },
            });
        },
        chat_auth: function (html) {
            var params = _7_Chat.Chat.url_params();
            if (html === 'redirect' && !isset(params['login'])) {
                document.location.href = _7_Chat.Chat.navbarPageId + (_7_Chat.Chat.isPageId ? '&' : '?') + 'login=1';
                return;
            }
            if (html !== 'redirect')
                _8_Chat_template.Chat_template.display_login_operator(html);
        },
        message_preloader: function (v, position) {
            if (position === void 0) { position = ''; }
            if (v === 'show') {
                var p = position || '';
                if (p === 'center') {
                    $('#message_height').html('');
                    $('#load_chat').removeClass('hidden').addClass('center');
                }
                else {
                    $('#load_chat').removeClass('hidden').removeClass('center');
                }
            }
            else if (v === 'hide') {
                $('#load_chat').addClass('hidden');
            }
        },
        updateChannelIndicator: function (_a) {
            var _b, _c, _d, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3;
            var sp_numb = _a.sp_numb, transport = _a.transport;
            var operatorData = _7_Chat.Chat.operator_data;
            var channel = ((_b = operatorData.channel) !== null && _b !== void 0 ? _b : {});
            var channelOff = ((_c = operatorData.channelOff) !== null && _c !== void 0 ? _c : {});
            var $chanell_block = $('#chanell_block');
            $chanell_block.html('');
            if (sp_numb === undefined || sp_numb === null || !transport) {
                return;
            }
            var id = String(sp_numb);
            var offBlock = "<span style=\"color: red;\">".concat(_7_Chat.Chat.l('(отключён)'), "</span>");
            var channelTitle = _7_Chat.Chat.l('Канал');
            var stripChannelPrefix = function (val) {
                return String(val).replace(/^(tg_|max_|waba)/, '');
            };
            var typeSuffix = '';
            var renderActive = function (value) {
                if (!value)
                    return false;
                $chanell_block.html("".concat(channelTitle, ": ").concat(stripChannelPrefix(value)).concat(typeSuffix, " | "));
                return true;
            };
            var renderInactive = function (value) {
                if (!value)
                    return false;
                $chanell_block.html("".concat(channelTitle, ": ").concat(stripChannelPrefix(value)).concat(typeSuffix, " ").concat(offBlock, " | "));
                return true;
            };
            if (transport === 'whatsapp' ||
                transport === 'whatsapp_group' ||
                transport === 'whatsapp_biz') {
                if (renderActive((_d = channel.whatsapp) === null || _d === void 0 ? void 0 : _d[id]))
                    return;
                renderInactive((_f = channelOff.whatsapp) === null || _f === void 0 ? void 0 : _f[id]);
                return;
            }
            if (transport === 'instagram' || transport === 'instagram_post') {
                if (renderActive((_g = channel.instagram) === null || _g === void 0 ? void 0 : _g[id]))
                    return;
                renderInactive((_h = channelOff.instagram) === null || _h === void 0 ? void 0 : _h[id]);
                return;
            }
            if (transport === 'telegram') {
                if (renderActive((_j = channel.telegram) === null || _j === void 0 ? void 0 : _j[id]))
                    return;
                renderInactive((_k = channelOff.telegram) === null || _k === void 0 ? void 0 : _k[id]);
                return;
            }
            if (transport === 'vk') {
                if (renderActive((_l = channel.vk) === null || _l === void 0 ? void 0 : _l[id]))
                    return;
                renderInactive((_m = channelOff.vk) === null || _m === void 0 ? void 0 : _m[id]);
                return;
            }
            if (transport === 'tg') {
                if (renderActive((_o = channel.tg) === null || _o === void 0 ? void 0 : _o[id]))
                    return;
                renderInactive((_p = channelOff.tg) === null || _p === void 0 ? void 0 : _p[id]);
                return;
            }
            if (transport === 'max' || transport === 'max_group' || transport === 'max_channel') {
                var activeValue = transport === 'max'
                    ? (_q = channel.max) === null || _q === void 0 ? void 0 : _q[id]
                    : transport === 'max_group'
                        ? ((_s = (_r = channel.max_group) === null || _r === void 0 ? void 0 : _r[id]) !== null && _s !== void 0 ? _s : (_t = channel.max) === null || _t === void 0 ? void 0 : _t[id])
                        : ((_v = (_u = channel.max_channel) === null || _u === void 0 ? void 0 : _u[id]) !== null && _v !== void 0 ? _v : (_w = channel.max) === null || _w === void 0 ? void 0 : _w[id]);
                var inactiveValue = transport === 'max'
                    ? (_x = channelOff.max) === null || _x === void 0 ? void 0 : _x[id]
                    : transport === 'max_group'
                        ? ((_z = (_y = channelOff.max_group) === null || _y === void 0 ? void 0 : _y[id]) !== null && _z !== void 0 ? _z : (_0 = channelOff.max) === null || _0 === void 0 ? void 0 : _0[id])
                        : ((_2 = (_1 = channelOff.max_channel) === null || _1 === void 0 ? void 0 : _1[id]) !== null && _2 !== void 0 ? _2 : (_3 = channelOff.max) === null || _3 === void 0 ? void 0 : _3[id]);
                if (renderActive(activeValue))
                    return;
                renderInactive(inactiveValue);
            }
        },
        messages_update: function (data, callback) {
            var _a, _b, _c;
            var _d;
            if (callback === void 0) { callback = function () { }; }
            var phone = data.phone, _f = data.messages, messages = _f === void 0 ? [] : _f, message_id_max = data.message_id_max, message_id_min = data.message_id_min, mongo_message_id_max = data.mongo_message_id_max, mongo_message_id_min = data.mongo_message_id_min, load_history_chek = data.load_history_chek;
            (_a = (_d = _7_Chat.Chat.chat_messages)[phone]) !== null && _a !== void 0 ? _a : (_d[phone] = {
                messages: [],
                message_id_max: null,
                message_id_min: null,
                mongo_message_id_max: null,
                mongo_message_id_min: null,
                load_history_chek: 0,
            });
            if (messages.length === 0) {
                callback();
                return;
            }
            var existingMessages = _7_Chat.Chat.chat_messages[phone].messages;
            messages.forEach(function (msg) {
                var _a;
                (_a = msg.id) !== null && _a !== void 0 ? _a : (msg.id = msg._id);
                var index = -1;
                if (msg.message_id_tmp !== undefined && msg.message_id_tmp !== null) {
                    index = existingMessages.findIndex(function (m) { return m.message_id_tmp === msg.message_id_tmp; });
                }
                if (index === -1) {
                    index = existingMessages.findIndex(function (m) { return m.id === msg.id; });
                }
                if (index !== -1) {
                    existingMessages[index] = msg;
                }
                else {
                    existingMessages.push(msg);
                }
            });
            _7_Chat.Chat.sortChatMessages(existingMessages);
            var chatData = _7_Chat.Chat.chat_messages[phone];
            chatData.message_id_max = Math.max(chatData.message_id_max || 0, Number(message_id_max) || 0);
            chatData.message_id_min = Math.min((_b = chatData.message_id_min) !== null && _b !== void 0 ? _b : Infinity, Number(message_id_min) || Infinity);
            chatData.mongo_message_id_max = Math.max(chatData.mongo_message_id_max || 0, Number(mongo_message_id_max) || 0);
            chatData.mongo_message_id_min = Math.min((_c = chatData.mongo_message_id_min) !== null && _c !== void 0 ? _c : Infinity, Number(mongo_message_id_min) || Infinity);
            chatData.load_history_chek = load_history_chek ? Number(load_history_chek) : 0;
            callback();
        },
        sortChatMessages: function (messages) {
            var sortId = function (msg) {
                return typeof msg.id === 'number' && msg.id > 0 ? msg.id : Number.MAX_SAFE_INTEGER;
            };
            messages.sort(function (a, b) {
                return sortId(a) - sortId(b);
            });
        },
        messages_get_in_load: false,
        messages_get: function (data) {
            var phone = data.phone;
            if (!_7_Chat.Chat.chat_messages_query[phone]) {
                _7_Chat.Chat.chat_messages_query[phone] = 0;
            }
            var now = Date.now();
            var throttleTime = 1000;
            var timeSinceLastCall = now - _7_Chat.Chat.chat_messages_query[phone];
            if (timeSinceLastCall < throttleTime) {
                if (_7_Chat.Chat.chat_messages_query_timeout[phone]) {
                    clearTimeout(_7_Chat.Chat.chat_messages_query_timeout[phone]);
                }
                var waitTime = throttleTime - timeSinceLastCall;
                console.log("messages_get|throttled|phone=".concat(phone, "|wait=").concat(waitTime, "ms|last=").concat(_7_Chat.Chat.chat_messages_query[phone]));
                _7_Chat.Chat.chat_messages_query_timeout[phone] = window.setTimeout(function () {
                    delete _7_Chat.Chat.chat_messages_query_timeout[phone];
                    _7_Chat.Chat.messages_get(data);
                }, waitTime);
                if (!_7_Chat.Chat.messages_get_in_load) {
                    _7_Chat.Chat.message_preloader('hide');
                }
                return;
            }
            if (_7_Chat.Chat.chat_messages_query_timeout[phone]) {
                clearTimeout(_7_Chat.Chat.chat_messages_query_timeout[phone]);
                delete _7_Chat.Chat.chat_messages_query_timeout[phone];
            }
            _7_Chat.Chat.chat_messages_query[phone] = now;
            var chatStore = _7_Chat.Chat.Chat_Store;
            if (chatStore && chatStore.isActive() && data.chat_open && !_7_Chat.Chat.chat_messages[phone]) {
                var hydrationSettled_1 = false;
                var hydrationGoServer_1 = function () {
                    if (hydrationSettled_1)
                        return;
                    hydrationSettled_1 = true;
                    _7_Chat.Chat.messages_get_request(data);
                };
                var hydrationTimer_1 = window.setTimeout(function () {
                    console.error('messages_get|hydratePr|timeout=' + HYDRATE_TIMEOUT_MS + 'ms|phone=' + phone);
                    hydrationGoServer_1();
                }, HYDRATE_TIMEOUT_MS);
                Promise.all([chatStore.hydratePr(phone), chatStore.outboxByPhonePr(phone)])
                    .then(function (_a) {
                    var hydration = _a[0], outboxItems = _a[1];
                    clearTimeout(hydrationTimer_1);
                    if (hydrationSettled_1)
                        return;
                    if (hydration && hydration.messages.length && !_7_Chat.Chat.chat_messages[phone]) {
                        var firstMessage = hydration.messages[0];
                        var messages = hydration.messages;
                        var _loop_6 = function (pendingItem) {
                            var alreadyShown = messages.some(function (msg) {
                                return msg.message_id_tmp === pendingItem.message_id_tmp;
                            });
                            if (alreadyShown)
                                return "continue";
                            var pendingMessage = {
                                id: null,
                                ph_numb: pendingItem.phone,
                                message_id_tmp: pendingItem.message_id_tmp,
                                message_route: 'outbox',
                                message_type: 'message-chat',
                                message_text: pendingItem.text,
                                message_status: '0',
                                add_date: pendingItem.add_date,
                                user_id: Number(_7_Chat.Chat.operator_data.id),
                            };
                            messages.push(pendingMessage);
                        };
                        for (var _i = 0, outboxItems_1 = outboxItems; _i < outboxItems_1.length; _i++) {
                            var pendingItem = outboxItems_1[_i];
                            _loop_6(pendingItem);
                        }
                        _7_Chat.Chat.chat_messages[phone] = {
                            messages: messages,
                            message_id_max: null,
                            message_id_min: typeof (firstMessage === null || firstMessage === void 0 ? void 0 : firstMessage.id) === 'number' ? firstMessage.id : null,
                            mongo_message_id_max: null,
                            mongo_message_id_min: null,
                            load_history_chek: hydration.hasMoreCached || !hydration.historyComplete ? 1 : 0,
                        };
                    }
                    hydrationSettled_1 = true;
                    _7_Chat.Chat.messages_get_request(data);
                })
                    .catch(function (error) {
                    clearTimeout(hydrationTimer_1);
                    console.error('messages_get|hydratePr|error=', error);
                    hydrationGoServer_1();
                });
                return;
            }
            _7_Chat.Chat.messages_get_request(data);
        },
        messages_get_request: function (data) {
            var phone = data.phone, _a = data.direction, direction = _a === void 0 ? 'DOWN' : _a;
            var chatData = _7_Chat.Chat.chat_messages[phone] || {};
            if (String(_7_Chat.Chat.chat_view_subscriber) === String(phone)) {
                if (data.chat_open) {
                    _7_Chat.Chat.messagesOpenLocal(phone);
                }
                else {
                    _8_Chat_template.Chat_template.display_messages2({
                        phone: phone,
                        scroll: null,
                        chat_open: null,
                        direction: direction,
                        disallow_hide_preloader: true,
                    });
                    _10_Chat_WebSocket.Chat_WebSocket.ensureAiStreamPreviewVisible(phone);
                    _10_Chat_WebSocket.Chat_WebSocket.applyPendingMessageStatuses(phone);
                }
            }
            var chatStore = _7_Chat.Chat.Chat_Store;
            var currentMinId = chatData.message_id_min;
            if (direction === 'UP' &&
                chatStore &&
                chatStore.isActive() &&
                typeof currentMinId === 'number' &&
                currentMinId > 0) {
                chatStore
                    .getOlderPagePr(phone, currentMinId)
                    .then(function (page) {
                    if (!_7_Chat.Chat.messagesUpAnchorValid(phone, currentMinId)) {
                        _7_Chat.Chat.message_preloader('hide');
                        return;
                    }
                    if (page && page.messages.length && _7_Chat.Chat.chat_messages[phone]) {
                        var pageMinId = null;
                        for (var _i = 0, _a = page.messages; _i < _a.length; _i++) {
                            var msg = _a[_i];
                            if (typeof msg.id === 'number' && (pageMinId === null || msg.id < pageMinId)) {
                                pageMinId = msg.id;
                            }
                        }
                        _7_Chat.Chat.messages_update({
                            phone: phone,
                            messages: page.messages,
                            message_id_min: pageMinId !== null && pageMinId !== void 0 ? pageMinId : undefined,
                            load_history_chek: page.hasMoreCached || !page.historyComplete,
                        }, function () {
                            if (_7_Chat.Chat.chat_view_subscriber === phone) {
                                _8_Chat_template.Chat_template.display_messages2({
                                    phone: phone,
                                    scroll: typeof data.scroll === 'string' ? data.scroll : null,
                                    chat_open: null,
                                    direction: 'UP',
                                });
                            }
                        });
                        return;
                    }
                    _7_Chat.Chat.messages_get_server(data);
                })
                    .catch(function (error) {
                    console.error('messages_get|getOlderPagePr|error=', error);
                    _7_Chat.Chat.messages_get_server(data);
                });
                return;
            }
            _7_Chat.Chat.messages_get_server(data);
        },
        messages_get_server: function (data) {
            var _a;
            var phone = data.phone, _b = data.direction, direction = _b === void 0 ? 'DOWN' : _b;
            var chatData = _7_Chat.Chat.chat_messages[phone] || {};
            var _c = chatData.message_id_min, message_id_min = _c === void 0 ? null : _c, _d = chatData.mongo_message_id_max, mongo_message_id_max = _d === void 0 ? null : _d, _f = chatData.mongo_message_id_min, mongo_message_id_min = _f === void 0 ? null : _f;
            var message_id_max = data.chat_open ? null : ((_a = chatData.message_id_max) !== null && _a !== void 0 ? _a : null);
            if (!_7_Chat.Chat.chat_loader['websocket']) {
                _7_Chat.Chat.message_preloader('hide');
            }
            _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                data: {
                    query: 'message_get_v2',
                    phone: phone,
                    direction: direction,
                    message_id_max: message_id_max,
                    message_id_min: message_id_min,
                    mongo_message_id_max: mongo_message_id_max,
                    mongo_message_id_min: mongo_message_id_min,
                    data_ajax: data,
                },
                before: function () {
                    _7_Chat.Chat.messages_get_in_load = true;
                },
                success: function (raw) {
                    var template = _8_Chat_template.Chat_template;
                    var response = template.parseMessagesGetV2(raw);
                    if (response === null || response.result === 1) {
                        if (response !== null) {
                            console.error('messages_get|сервер не отдал переписку|msg=', response.msg);
                        }
                        _7_Chat.Chat.messages_get_in_load = false;
                        _7_Chat.Chat.message_preloader('hide');
                        _7_Chat.Chat.messagesOpenShowLocal(phone);
                        return;
                    }
                    var messages = response.messages.map(function (data) {
                        return template.messageFromDataV2(data);
                    });
                    _10_Chat_WebSocket.Chat_WebSocket.applyPendingStatusesToBatch(response.phone, messages);
                    var noread = response.noread;
                    if (noread.phone !== undefined && noread.time !== undefined && noread.time !== null) {
                        _5_Contacts.Contacts.no_read[noread.phone] = __assign({ phone: noread.phone, time: noread.time }, (typeof noread.message_id === 'number' ? { message_id: noread.message_id } : {}));
                    }
                    var requestedMinId = typeof message_id_min === 'number' && message_id_min > 0 ? message_id_min : null;
                    var requestedMaxId = typeof message_id_max === 'number' && message_id_max > 0 ? message_id_max : null;
                    var pageFull = _7_Chat.Chat.messagesPageFull(response);
                    var chatStore = _7_Chat.Chat.Chat_Store;
                    if (chatStore && chatStore.isActive()) {
                        if (messages.length) {
                            chatStore
                                .putServerBatchPr(phone, messages, {
                                direction: direction === 'UP' ? 'UP' : 'DOWN',
                                requestedMinId: requestedMinId,
                                requestedMaxId: requestedMaxId,
                                pageFull: pageFull,
                            })
                                .catch(function (error) {
                                console.error('messages_get|putServerBatchPr|error=', error);
                            });
                        }
                        else if (direction === 'UP' && requestedMinId !== null && !pageFull) {
                            chatStore.markHistoryCompletePr(phone, requestedMinId).catch(function (error) {
                                console.error('messages_get|markHistoryCompletePr|error=', error);
                            });
                        }
                    }
                    if (direction === 'UP') {
                        if (!_7_Chat.Chat.messagesUpAnchorValid(response.phone, requestedMinId)) {
                            _7_Chat.Chat.messages_get_in_load = false;
                            _7_Chat.Chat.message_preloader('hide');
                            return;
                        }
                    }
                    else {
                        if (_7_Chat.Chat.messages_gap_fill[response.phone] === true) {
                            _7_Chat.Chat.messages_gap_fill_rerun[response.phone] = true;
                            _7_Chat.Chat.messages_get_in_load = false;
                            return;
                        }
                        if (!_7_Chat.Chat.messagesBatchContiguous(response.phone, messages, requestedMaxId, pageFull)) {
                            _7_Chat.Chat.messagesGapFill({ phone: response.phone, batch: messages, response: response, data: data });
                            return;
                        }
                    }
                    _7_Chat.Chat.messages_update({
                        phone: response.phone,
                        messages: messages,
                        message_id_max: response.message_id_max,
                        message_id_min: response.message_id_min,
                        mongo_message_id_max: response.mongo_message_id_max,
                        mongo_message_id_min: response.mongo_message_id_min,
                        load_history_chek: response.load_history_chek,
                    }, function () {
                        _7_Chat.Chat.messages_get_in_load = false;
                        if (_7_Chat.Chat.chat_view_subscriber === response.phone) {
                            _8_Chat_template.Chat_template.display_messages2({
                                phone: response.phone,
                                scroll: _7_Chat.Chat.messagesServerScroll(response.phone, data),
                                chat_open: data.chat_open || null,
                                direction: typeof data.direction === 'string' ? data.direction : '',
                            });
                            _7_Chat.Chat.messagesOpenMarkShown(response.phone);
                        }
                    });
                },
                error: function (error) {
                    console.error('messages_get|error=', error);
                    _7_Chat.Chat.messages_get_in_load = false;
                    _7_Chat.Chat.message_preloader('hide');
                    _7_Chat.Chat.messagesOpenShowLocal(phone);
                },
            });
        },
        messagesIdRange: function (messages) {
            var min = null;
            var max = null;
            for (var _i = 0, messages_1 = messages; _i < messages_1.length; _i++) {
                var msg = messages_1[_i];
                var id = msg.id;
                if (typeof id !== 'number' || !(id > 0))
                    continue;
                if (min === null || id < min)
                    min = id;
                if (max === null || id > max)
                    max = id;
            }
            return { min: min, max: max };
        },
        messagesBatchContiguous: function (phone, batch, requestedMaxId, pageFull) {
            var known = _7_Chat.Chat.chat_messages[phone];
            var knownMax = known ? _7_Chat.Chat.messagesIdRange(known.messages).max : null;
            if (knownMax === null)
                return true;
            var batchMin = _7_Chat.Chat.messagesIdRange(batch).min;
            if (batchMin === null)
                return true;
            if (batchMin <= knownMax)
                return true;
            return requestedMaxId !== null && requestedMaxId >= knownMax && !pageFull;
        },
        messagesPageFull: function (response) {
            return response.page_full !== false;
        },
        messagesUpAnchorValid: function (phone, anchorId) {
            var chatData = _7_Chat.Chat.chat_messages[phone];
            if (!chatData || anchorId === null)
                return true;
            var currentMin = chatData.message_id_min;
            return typeof currentMin !== 'number' || anchorId >= currentMin;
        },
        messagesServerScroll: function (phone, data) {
            var state = _7_Chat.Chat.messages_open_state;
            if (data.chat_open && state !== null && state.phone === phone && state.shown)
                return null;
            return typeof data.scroll === 'string' ? data.scroll : null;
        },
        messagesOpenBegin: function (phone) {
            var prev = _7_Chat.Chat.messages_open_state;
            if (prev !== null && prev.timer !== null)
                window.clearTimeout(prev.timer);
            _7_Chat.Chat.messages_open_state = { phone: phone, shown: false, timer: null };
        },
        messagesOpenLocal: function (phone) {
            var state = _7_Chat.Chat.messages_open_state;
            if (state === null || state.phone !== phone || state.shown || state.timer !== null)
                return;
            var noreadCount = _5_Contacts.Contacts.noread_by_phone[phone];
            var hasUnread = typeof noreadCount === 'number' && noreadCount > 0;
            var contact = _5_Contacts.Contacts.data[phone];
            var contactPending = contact === undefined || contact.avatar === undefined;
            if ((hasUnread || contactPending) && _7_Chat.Chat.chat_loader['websocket']) {
                state.timer = window.setTimeout(function () {
                    state.timer = null;
                    _7_Chat.Chat.messagesOpenShowLocal(phone);
                }, FRESH_WAIT_MS);
                return;
            }
            _7_Chat.Chat.messagesOpenShowLocal(phone);
        },
        messagesOpenShowLocal: function (phone) {
            var state = _7_Chat.Chat.messages_open_state;
            if (state === null || state.phone !== phone || state.shown)
                return;
            if (state.timer !== null) {
                window.clearTimeout(state.timer);
                state.timer = null;
            }
            if (String(_7_Chat.Chat.chat_view_subscriber) !== String(phone))
                return;
            var chatData = _7_Chat.Chat.chat_messages[phone];
            if (!chatData || !chatData.messages.length)
                return;
            state.shown = true;
            _8_Chat_template.Chat_template.display_messages2({
                phone: phone,
                scroll: null,
                chat_open: null,
                direction: 'DOWN',
            });
            _10_Chat_WebSocket.Chat_WebSocket.ensureAiStreamPreviewVisible(phone);
            _10_Chat_WebSocket.Chat_WebSocket.applyPendingMessageStatuses(phone);
        },
        messagesOpenMarkShown: function (phone) {
            var state = _7_Chat.Chat.messages_open_state;
            if (state === null || state.phone !== phone)
                return;
            if (state.timer !== null) {
                window.clearTimeout(state.timer);
                state.timer = null;
            }
            state.shown = true;
        },
        messagesPageUpPr: function (phone, beforeId) {
            return new Promise(function (resolve) {
                _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'message_get_v2',
                        phone: phone,
                        direction: 'UP',
                        message_id_max: null,
                        message_id_min: beforeId,
                        mongo_message_id_max: null,
                        mongo_message_id_min: null,
                        data_ajax: { phone: phone, direction: 'UP' },
                    },
                    before: function () { },
                    success: function (raw) {
                        var template = _8_Chat_template.Chat_template;
                        var response = template.parseMessagesGetV2(raw);
                        if (response === null || response.result === 1) {
                            if (response !== null) {
                                console.error('messagesPageUpPr|сервер не отдал страницу|msg=', response.msg);
                            }
                            resolve(null);
                            return;
                        }
                        var messages = response.messages.map(function (item) {
                            return template.messageFromDataV2(item);
                        });
                        _10_Chat_WebSocket.Chat_WebSocket.applyPendingStatusesToBatch(phone, messages);
                        var pageFull = _7_Chat.Chat.messagesPageFull(response);
                        var chatStore = _7_Chat.Chat.Chat_Store;
                        if (chatStore && chatStore.isActive()) {
                            if (messages.length) {
                                chatStore
                                    .putServerBatchPr(phone, messages, {
                                    direction: 'UP',
                                    requestedMinId: beforeId,
                                    requestedMaxId: null,
                                    pageFull: pageFull,
                                })
                                    .catch(function (error) {
                                    console.error('messagesPageUpPr|putServerBatchPr|error=', error);
                                });
                            }
                            else if (!pageFull) {
                                chatStore.markHistoryCompletePr(phone, beforeId).catch(function (error) {
                                    console.error('messagesPageUpPr|markHistoryCompletePr|error=', error);
                                });
                            }
                        }
                        resolve({ messages: messages, pageFull: pageFull });
                    },
                    error: function (error) {
                        console.error('messagesPageUpPr|error=', error);
                        resolve(null);
                    },
                });
            });
        },
        messagesGapFillPr: function (phone, batch, knownMax) {
            var collected = batch.slice();
            var step = function (anchor, pagesLeft) {
                if (pagesLeft <= 0)
                    return Promise.resolve({ connected: false, messages: collected });
                return _7_Chat.Chat.messagesPageUpPr(phone, anchor).then(function (page) {
                    if (page === null)
                        return { connected: false, messages: collected };
                    for (var _i = 0, _a = page.messages; _i < _a.length; _i++) {
                        var msg = _a[_i];
                        collected.push(msg);
                    }
                    var pageMin = _7_Chat.Chat.messagesIdRange(page.messages).min;
                    if (pageMin !== null && pageMin <= knownMax) {
                        return { connected: true, messages: collected };
                    }
                    if (!page.pageFull)
                        return { connected: false, messages: collected };
                    if (pageMin === null || pageMin >= anchor) {
                        return { connected: false, messages: collected };
                    }
                    return step(pageMin, pagesLeft - 1);
                });
            };
            var batchMin = _7_Chat.Chat.messagesIdRange(batch).min;
            if (batchMin === null)
                return Promise.resolve({ connected: true, messages: collected });
            return step(batchMin, GAP_FILL_MAX_PAGES);
        },
        messagesGapFill: function (params) {
            var phone = params.phone, batch = params.batch, response = params.response, data = params.data;
            var known = _7_Chat.Chat.chat_messages[phone];
            var knownMax = known ? _7_Chat.Chat.messagesIdRange(known.messages).max : null;
            if (knownMax === null) {
                console.error('messagesGapFill|нет известного хвоста|phone=', phone);
                return;
            }
            _7_Chat.Chat.messages_gap_fill[phone] = true;
            var finish = function () {
                delete _7_Chat.Chat.messages_gap_fill[phone];
                _7_Chat.Chat.messages_get_in_load = false;
                if (_7_Chat.Chat.messages_gap_fill_rerun[phone] === true) {
                    delete _7_Chat.Chat.messages_gap_fill_rerun[phone];
                    _7_Chat.Chat.messages_get({ phone: phone, direction: 'DOWN' });
                }
            };
            _7_Chat.Chat.messagesGapFillPr(phone, batch, knownMax)
                .then(function (fill) {
                var _a;
                var chatData = _7_Chat.Chat.chat_messages[phone];
                if (fill.connected && chatData) {
                    _7_Chat.Chat.messages_update({
                        phone: phone,
                        messages: fill.messages,
                        message_id_max: response.message_id_max,
                        message_id_min: response.message_id_min,
                        load_history_chek: (_a = chatData.load_history_chek) !== null && _a !== void 0 ? _a : 0,
                    }, function () { });
                }
                else {
                    _7_Chat.Chat.messagesReplace(phone, fill.messages, knownMax, response.message_id_max);
                }
                if (String(_7_Chat.Chat.chat_view_subscriber) === String(phone)) {
                    _8_Chat_template.Chat_template.display_messages2({
                        phone: phone,
                        scroll: fill.connected ? _7_Chat.Chat.messagesServerScroll(phone, data) : 'bottom',
                        chat_open: data.chat_open || null,
                        direction: 'DOWN',
                    });
                    _7_Chat.Chat.messagesOpenMarkShown(phone);
                }
                finish();
            })
                .catch(function (error) {
                console.error('messagesGapFill|error=', error);
                _7_Chat.Chat.message_preloader('hide');
                _7_Chat.Chat.messagesOpenShowLocal(phone);
                finish();
            });
        },
        messagesReplace: function (phone, fetched, knownMax, responseMaxId) {
            var _a;
            var chatData = _7_Chat.Chat.chat_messages[phone];
            var merged = (chatData ? chatData.messages : []).filter(function (msg) {
                return !(typeof msg.id === 'number' && msg.id > 0 && msg.id <= knownMax);
            });
            var _loop_7 = function (msg) {
                var index = merged.findIndex(function (item) {
                    return item.id === msg.id;
                });
                if (index === -1)
                    merged.push(msg);
                else
                    merged[index] = msg;
            };
            for (var _i = 0, fetched_1 = fetched; _i < fetched_1.length; _i++) {
                var msg = fetched_1[_i];
                _loop_7(msg);
            }
            _7_Chat.Chat.sortChatMessages(merged);
            var range = _7_Chat.Chat.messagesIdRange(merged);
            var maxId = Math.max(responseMaxId !== null && responseMaxId !== void 0 ? responseMaxId : 0, (_a = range.max) !== null && _a !== void 0 ? _a : 0);
            _7_Chat.Chat.chat_messages[phone] = {
                messages: merged,
                message_id_max: maxId > 0 ? maxId : null,
                message_id_min: range.min,
                mongo_message_id_max: null,
                mongo_message_id_min: null,
                load_history_chek: 1,
            };
        },
        click_img_delete2: function (file_url) {
            if (!file_url)
                return;
            $(".image_item[data-file_url=\"".concat(file_url, "\"]")).remove();
            var re = new RegExp('/quickMessages_', 'g');
            if (re.test(file_url))
                return;
            _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                data: {
                    query: 'img_delete',
                    file_url: file_url,
                    phone: _7_Chat.Chat.chat_view_subscriber,
                },
                before: function () { },
                success: function (data) {
                    if (data.result === 0) {
                        $(".image_item[data-file_url=\"".concat(file_url, "\"]")).remove();
                    }
                },
                error: function (error) {
                    console.error('click_img_delete2|error=', error);
                },
            });
        },
        initLogs: function () {
            if (_7_Chat.Chat.operator_data.enabled_logs !== 1) {
                return;
            }
            $('#chatLogs').removeClass('hidden');
        },
        initTags: function () {
            if (_7_Chat.Chat.operator_data.enabled_tags !== 1) {
                return;
            }
            $('#chatTags').removeClass('hidden');
            _7_Chat.Chat.getTags();
        },
        getTags: function () {
            $.ajax({
                url: '/service-stat/tags/chat/' + _7_Chat.Chat.operator_data.central_user_id,
                success: function (data) {
                    var tagsRaw = data;
                    if (typeof tagsRaw === 'object' &&
                        tagsRaw !== null &&
                        Reflect.get(tagsRaw, 'success') === false) {
                        return;
                    }
                    if (!isGetTagsResponse(tagsRaw)) {
                        console.error('getTags|ответ не той формы|data=', tagsRaw);
                        return;
                    }
                    var tags = tagsRaw;
                    if (tags.success) {
                        _7_Chat.Chat.tags = tags.data;
                        _7_Chat.Chat.fillTags();
                    }
                },
            });
        },
        fillTags: function () {
            var chatTags = $('#chatTags');
            _7_Chat.Chat.tags.forEach(function (el, index) {
                var input = $('<input class="tags" type="checkbox" name="end_dialog_tag">')
                    .attr('id', "tag".concat(index))
                    .val(el._id);
                var name = $('<span data-i18n-user-content></span>').text(el.tag_name);
                var label = $('<label class="control-label"></label>').attr('for', "tag".concat(index));
                label.append(input).append(' ').append(name);
                chatTags.append($('<div class="col-sm-4"></div>').append(label));
            });
        },
        initOutcomes: function () {
            if (_7_Chat.Chat.operator_data.enabled_outcome !== 1)
                return;
            $('#chatOutcome').removeClass('hidden');
            _7_Chat.Chat.getOutcomes();
        },
        getOutcomes: function () {
            $.ajax({
                url: '/service-stat/dialog-outcomes/chat/' + _7_Chat.Chat.operator_data.central_user_id,
                success: function (data) {
                    var reply = data;
                    if (!isGetOutcomesResponse(reply)) {
                        console.error('getOutcomes|ответ не той формы|data=', reply);
                        return;
                    }
                    if (!reply.success) {
                        console.error('getOutcomes|список вариантов не выдан|data=', reply);
                        return;
                    }
                    _7_Chat.Chat.outcomes = reply.data;
                    _7_Chat.Chat.fillOutcomes();
                },
                error: function () {
                    console.error('getOutcomes|варианты итога не загружены');
                },
            });
        },
        fillOutcomes: function () {
            var list = $('#chatOutcomeList');
            list.html('');
            var outcomes = _7_Chat.Chat.outcomes;
            if (outcomes === null)
                return;
            if (outcomes.length === 0) {
                var link = $('<a target="_blank"></a>')
                    .attr('href', cabinetPageUrl('/cabinet/dialog-outcomes'))
                    .text(_7_Chat.Chat.l('Добавить варианты итога'));
                list.append($('<p class="col-sm-12 help-block chat-outcome-empty"></p>')
                    .text(_7_Chat.Chat.l('Варианты итога не добавлены — диалог можно закончить без итога.') + ' ')
                    .append(link));
                return;
            }
            outcomes.forEach(function (el, index) {
                var input = $('<input class="outcome" type="radio" name="end_dialog_outcome">')
                    .attr('id', "outcome".concat(index))
                    .val(el._id);
                var name = $('<span data-i18n-user-content></span>').text(el.outcome_name);
                var label = $('<label class="control-label"></label>').attr('for', "outcome".concat(index));
                label.append(input).append(' ').append(name);
                list.append($('<div class="col-sm-6"></div>').append(label));
            });
        },
        end_dialog_save_data: function () {
            var logInput = $('#end_dialog_window_comment');
            Button.preloader('#end_dialog_window_button');
            var tagsEnabled = _7_Chat.Chat.operator_data.enabled_tags === 1;
            var logsEnabled = _7_Chat.Chat.operator_data.enabled_logs === 1;
            var outcomeEnabled = _7_Chat.Chat.operator_data.enabled_outcome === 1;
            var refuse = function (message) {
                alert(_7_Chat.Chat.l(message));
                Button.reset('#end_dialog_window_button');
                return false;
            };
            var outcomeId = '';
            if (outcomeEnabled) {
                if (_7_Chat.Chat.outcomes === null) {
                    return refuse('Не удалось загрузить варианты итога, диалог не завершён');
                }
                if (_7_Chat.Chat.outcomes.length > 0) {
                    var chosen = $('.outcome:checked').val();
                    if (typeof chosen !== 'string' || chosen === '')
                        return refuse('Выберите итог диалога');
                    outcomeId = chosen;
                }
            }
            var tags = [];
            if (tagsEnabled) {
                $('.tags:checked').each(function () {
                    tags.push($(this).val());
                });
                if (tags.length === 0)
                    return refuse('Отметьте теги!');
            }
            var logPhone = '';
            var logText = '';
            if (logsEnabled) {
                var phoneField = formFieldText('chat_message_phone');
                var logField = formFieldText('end_dialog_window_comment');
                if (phoneField === null || logField === null || phoneField === '') {
                    console.error('end_dialog_save_data|нет поля телефона или лога');
                    Button.reset('#end_dialog_window_button');
                    return false;
                }
                if (logField === '')
                    return refuse('Напишите лог!');
                if (_5_Contacts.Contacts.work_alien[phoneField]) {
                    return refuse('Диалог ведет другой оператор.');
                }
                var text_temp = logField;
                text_temp = text_temp.replace(/^(\s|\u00A0)+/g, '').replace(/\r?\n/g, '');
                logPhone = phoneField;
                logText = text_temp;
            }
            var closeDialog = function () {
                if (logsEnabled) {
                    _7_Chat.Chat.send_message_to_server({
                        phone: logPhone,
                        text: logText,
                        file_url: [],
                        system_message: 'log_message',
                    });
                    logInput.val('');
                }
                $('.tags:checked').prop('checked', false);
                $('.outcome:checked').prop('checked', false);
                _7_Chat.Chat.click_mark_as_read(undefined);
                setTimeout(function () {
                    _7_Chat.Chat.click_my_work_step_2('end_dialog');
                }, 100);
                Button.reset('#end_dialog_window_button');
                $('#end_dialog_window').modal('hide');
            };
            if (tags.length === 0 && outcomeId === '') {
                closeDialog();
                return undefined;
            }
            var data = {
                ph_numb: _7_Chat.Chat.chat_open_subscriber,
                sp_numb: 0,
                user_id: Number(_7_Chat.Chat.operator_data.central_user_id),
                tags: tags,
            };
            if (outcomeId !== '')
                data.outcome_id = outcomeId;
            var saveFailed = outcomeId !== ''
                ? 'Не удалось сохранить итог диалога, диалог не завершён'
                : 'Не удалось сохранить тег, диалог не завершён';
            $.ajax({
                type: 'POST',
                url: '/service-stat/subscriber-tags/',
                data: data,
                dataType: 'json',
                success: function (reply) {
                    if (typeof reply === 'object' &&
                        reply !== null &&
                        !Array.isArray(reply) &&
                        reply.status === 'ok') {
                        closeDialog();
                        return;
                    }
                    console.error('end_dialog_save_data|отметки не сохранены|reply=', reply);
                    refuse(saveFailed);
                },
                error: function () {
                    refuse(saveFailed);
                },
            });
            return undefined;
        },
        click_my_work: function (obj) {
            var work = obj && obj.data ? obj.data('work') : null;
            if (work !== null) {
                if (typeof work !== 'string') {
                    console.warn('[TypeGuard] click_my_work: work имеет неверный тип', {
                        work: work,
                        type: typeof work,
                    });
                    return;
                }
                if (work === 'take_to_work' ||
                    (_7_Chat.Chat.operator_data.enabled_tags !== 1 &&
                        _7_Chat.Chat.operator_data.enabled_logs !== 1 &&
                        _7_Chat.Chat.operator_data.enabled_outcome !== 1)) {
                    _7_Chat.Chat.click_my_work_step_2(work);
                    return;
                }
            }
            if (_7_Chat.Chat.operator_data.enabled_outcome === 1 &&
                (_7_Chat.Chat.outcomes === null || _7_Chat.Chat.outcomes.length === 0)) {
                _7_Chat.Chat.getOutcomes();
            }
            $('#end_dialog_window').modal('show');
        },
        click_my_work_step_2: function (work) {
            if (work == 'end_dialog') {
                _7_Chat.Chat.list_images_close();
            }
            _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                data: {
                    query: 'my_work',
                    work: work,
                    phone: _7_Chat.Chat.chat_open_subscriber,
                },
                before: function () {
                    Button.preloader('.my_work');
                },
                success: function (data) {
                    var _a;
                    Button.reset('.my_work');
                    if (data.result === 0) {
                        var my_work_operator = $('#my_work_operator'), my_work_to_operator_show = $('.my_work_to_operator_show'), mark_as_read = $('.mark_as_read');
                        var my_work_class = 'class="hidden-xs hidden-sm"';
                        if (_7_Chat.Chat.width < 768)
                            my_work_class = '';
                        var my_work_text = "<i class=\"fa fa-comment-dots\"></i> <span ".concat(my_work_class, ">") +
                            _7_Chat.Chat.l('Взять в работу') +
                            "</span>";
                        var my_work_type = 'take_to_work';
                        var my_work_title = _7_Chat.Chat.l('Взять в работу') + ' (Ctrl+G)';
                        my_work_operator.removeClass('hidden');
                        my_work_to_operator_show.addClass('hidden');
                        mark_as_read.addClass('hidden');
                        if (data.work === 'take_to_work') {
                            my_work_text =
                                "<i class=\"fa fa-comment\"></i> <span ".concat(my_work_class, ">") +
                                    _7_Chat.Chat.l('Закончить диалог') +
                                    "</span>";
                            my_work_type = 'end_dialog';
                            my_work_title = _7_Chat.Chat.l('Закончить диалог') + ' (Ctrl+G)';
                            my_work_operator.addClass('hidden');
                            my_work_to_operator_show.removeClass('hidden');
                            $('.textarea_message_text').focus();
                        }
                        $('.my_work')
                            .html(my_work_text)
                            .data('work', my_work_type)
                            .attr('title', my_work_title);
                    }
                    else if (data.result === 2) {
                        var phone = data.phone;
                        if (typeof phone === 'string' &&
                            _5_Contacts.Contacts.work_alien[phone] &&
                            _7_Chat.Chat.chat_open_subscriber == phone) {
                            _7_Chat.Chat.setChatOpenSubscriberFalse('click_my_work_step_2|result=2|work_alien');
                            $('#my_work_operator').addClass('hidden');
                            $('.work_button').css('display', 'none');
                            $('#blocker_operator').css('display', 'block');
                            $('#blocker_operator p').html(_7_Chat.Chat.l('Диалог ведет оператор:') +
                                ' <span>' +
                                ((_a = _5_Contacts.Contacts.work_alien[phone]) === null || _a === void 0 ? void 0 : _a.op_n) +
                                '</span>');
                            $('.my_work').addClass('hidden');
                        }
                    }
                    _5_Contacts.Contacts.work_load(1, function () {
                        _4_Sorter.Sorter.load();
                    });
                },
                error: function () {
                    Button.reset('.my_work');
                },
            });
        },
        add_subscriber_prefill: null,
        open_add_subscriber_prefilled: function (phone, name) {
            _7_Chat.Chat.add_subscriber_prefill = { phone: phone, name: name || '' };
            $('#modal_add_subscribers').modal('show');
        },
        click_open_subscriber_action: {},
        click_open_subscriber: function (params) {
            var _a, _b;
            if (typeof params === 'string') {
                params = { phone: params, call_from: 'legacy_inline_onclick' };
            }
            var phoneParam = params.phone;
            var kol_open = (_a = params.kol_open) !== null && _a !== void 0 ? _a : 0;
            var callFrom = (_b = params.call_from) !== null && _b !== void 0 ? _b : 'unknown';
            var Contacts = _5_Contacts.Contacts;
            var Draft = _2_Draft.Draft;
            var resolvedPhone = null;
            if (typeof phoneParam === 'number' || typeof phoneParam === 'string') {
                resolvedPhone = phoneParam;
            }
            else if (typeof phoneParam === 'object' &&
                phoneParam !== null &&
                'data' in phoneParam &&
                typeof phoneParam.data === 'function') {
                resolvedPhone = phoneParam.data('phone');
            }
            if (resolvedPhone === null || resolvedPhone === undefined || resolvedPhone === '') {
                console.error('click_open_subscriber|invalid_phone=', resolvedPhone, '|call_from=', callFrom, '|phoneParam=', phoneParam);
                return;
            }
            var phone = String(resolvedPhone);
            document.documentElement.classList.remove('chat-instant');
            if (!params.no_load_msg) {
                _7_Chat.Chat.setChatOpenSubscriberFalse("click_open_subscriber|init|from:".concat(callFrom));
                _7_Chat.Chat.message_preloader('show', 'center');
                $('#message_height').html('');
            }
            if (_7_Chat.Chat.click_open_subscriber_action[phone] !== true) {
                _7_Chat.Chat.click_open_subscriber_action[phone] = true;
                setTimeout(function (phone) {
                    delete _7_Chat.Chat.click_open_subscriber_action[phone];
                }, 500, phone);
            }
            else {
                return;
            }
            _7_Chat.Chat.list_images_close();
            $('#answer_id').val('');
            $('#answer_block').addClass('hidden').html('');
            if (typeof Android === 'object') {
                if (typeof Android.openSubscriber === 'function') {
                    Android.openSubscriber(phone);
                }
            }
            if (!Contacts.data[phone]) {
                Contacts.data_get({ phone: phone }, function () {
                    setTimeout(function (phone) {
                        kol_open++;
                        if (kol_open > 5)
                            return;
                        _7_Chat.Chat.click_open_subscriber({
                            phone: phone,
                            kol_open: kol_open,
                            call_from: 'Chat|click_open_subscriber|retry_after_contacts_data_get',
                        });
                    }, 1000, phone);
                }, function () {
                    if (typeof Bitrix24Handler !== 'undefined' && Bitrix24Handler.isCrmContext()) {
                        _7_Chat.Chat.open_add_subscriber_prefilled(phone, Bitrix24Handler.getContactName());
                        return;
                    }
                    toastr.error('Подписчик не найден', 'ОШИБКА');
                });
                return;
            }
            var openedContact = Contacts.data[phone];
            if (!openedContact) {
                console.error('click_open_subscriber|нет контакта в реестре=', phone);
                return;
            }
            var transport = openedContact.transport, name = openedContact.name, sp_numb = openedContact.sp_numb, category = openedContact.category, insta_login = openedContact.insta_login, name_custom = openedContact.name_custom, telegram_login = openedContact.telegram_login;
            _7_Chat.Chat.chat_message_send_button = false;
            _7_Chat.Chat.subscriber_last_activity[String(phone)] = Math.floor(Date.now() / 1000);
            $('#button_edit_phone').data('phone', phone);
            _7_Chat.Chat.chat_view_subscriber = phone;
            _6_FileUpload.FileUpload.chatInit();
            $('#ai_no_process_icon').addClass('hidden');
            Contacts.data_get({ phone: phone }, function (contactFlagsData) {
                if (String(_7_Chat.Chat.chat_view_subscriber) !== String(phone))
                    return;
                $('#ai_no_process_icon').toggleClass('hidden', !contactFlagsData.always_to_manager);
            });
            var renderWabaStatus = function () {
                Contacts.render_waba_status(phone);
            };
            if (transport === 'whatsapp_biz') {
                Contacts.data_get({ phone: phone, cache: false }, function () {
                    if (String(_7_Chat.Chat.chat_view_subscriber) !== String(phone))
                        return;
                    renderWabaStatus();
                }, function () {
                    renderWabaStatus();
                });
            }
            else {
                renderWabaStatus();
            }
            if (transport === 'whatsapp_biz')
                $('.li_waba_template').show();
            else
                $('.li_waba_template').hide();
            var b24_sync_contact_with_chat = _7_Chat.Chat.operator_data.b24_sync_contact_with_chat;
            if (b24_sync_contact_with_chat) {
                _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'system_notyfi_subscriber_open_v2',
                        phone: phone,
                        b24_sync_contact_with_chat: b24_sync_contact_with_chat,
                    },
                    before: function () { },
                    success: function (_data) { },
                    error: function () { },
                });
            }
            else {
                _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'system_notyfi_subscriber_open',
                        phone: phone,
                    },
                    before: function () { },
                    success: function (_data) { },
                    error: function () { },
                });
            }
            $('.show_operator').removeClass('show_operator');
            $('#search_li li').removeClass('show_subscriber');
            $('.menu_tabs a[href="#tab_subscribers"]').tab('show');
            _7_Chat.Chat.obj.textarea_message_text.val(Draft.get_t(phone));
            _7_Chat.Chat.obj.textarea_message_text2.html(Draft.get_d(phone));
            if (_7_Chat.Chat.obj.textarea_message_text.val() !== '' ||
                _7_Chat.Chat.obj.textarea_message_text2.html() !== '') {
                $('.message_send_button').removeClass('hidden');
                $('#audio_message_record').addClass('hidden');
            }
            else {
                if (!Contacts.instagram2_check(phone)) {
                    $('.message_send_button').addClass('hidden');
                    $('#audio_message_record').removeClass('hidden');
                }
                else {
                    $('.message_send_button').removeClass('hidden');
                    $('#audio_message_record').addClass('hidden');
                }
            }
            _7_Chat.Chat.chat_scroll_down = true;
            $('#chat_subscribers li').removeClass('show_subscriber');
            $('#chat_work li').removeClass('show_subscriber');
            $('.content').addClass('hidden');
            $('#chat_subscriber').removeClass('hidden');
            $('#chat_subscrib_name').html(_7_Chat.Chat.getSubscriberNameHtml({
                phone: phone,
                transport: transport,
                name: name,
                name_custom: name_custom,
                insta_login: insta_login,
                telegram_login: telegram_login,
            }));
            var chat_transport = 'fa fa-phone';
            if (transport != null) {
                chat_transport = _7_Chat.Chat.transportIcon(transport);
            }
            $('#chat_transport i').attr('class', '').addClass(chat_transport);
            var categList = [];
            if (category === null || category === void 0 ? void 0 : category.length) {
                for (var key in category) {
                    var categoryId = category[key];
                    var categoryRow = categoryId ? Contacts.category[categoryId] : undefined;
                    if (categoryRow) {
                        categList.push(categoryRow.n);
                    }
                }
            }
            var categ_list = categList.join(', ');
            $('#chat_subscrib_group').text(categ_list).attr('title', categ_list);
            _7_Chat.Chat.updateChannelIndicator({ sp_numb: sp_numb, transport: transport });
            if (!params.no_load_msg) {
                _7_Chat.Chat.messagesOpenBegin(phone);
                _7_Chat.Chat.messages_get({
                    phone: phone,
                    scroll: 'bottom',
                    chat_open: true,
                });
            }
            $('#chat_message_phone').val(phone);
            Contacts.work_alien_phone = null;
            if (transport === 'whatsapp_group') {
                _7_Chat.Chat.setChatOpenSubscriber(phone, 'click_open_subscriber|transport=whatsapp_group');
                _1_Tasks.findContactItemByPhone(phone).addClass('show_subscriber');
                $('#blocker_operator').css('display', 'none');
                $('.my_work, #my_work_operator').addClass('hidden');
            }
            else {
                var isAdmin = _7_Chat.Chat.operator_data.central_user_id === _7_Chat.Chat.operator_data.id ||
                    (_7_Chat.Chat.operator_data.roles &&
                        Array.isArray(_7_Chat.Chat.operator_data.roles) &&
                        (_7_Chat.Chat.operator_data.roles.includes('admin') ||
                            _7_Chat.Chat.operator_data.roles.includes('administrator') ||
                            _7_Chat.Chat.operator_data.roles.includes('admin_operator')));
                var alienWork = Contacts.work_alien[phone];
                var isAiWork = Boolean(Contacts.work_ai[phone]) || (alienWork === null || alienWork === void 0 ? void 0 : alienWork.op_n) === _0_Constants.AI_ASSISTANT_NAME;
                if (isAiWork) {
                    _7_Chat.Chat.setChatOpenSubscriberFalse('click_open_subscriber|work_ai_block');
                    if (!params.no_load_msg) {
                        Contacts.work_alien_phone = phone;
                    }
                    $('#my_work_operator').addClass('hidden');
                    $('.work_button').css('display', 'none');
                    $('#blocker_operator').css('display', 'block');
                    var aiBlockerHtml = _7_Chat.Chat.l('Диалог ведет ИИ-ассистент');
                    if (isAdmin) {
                        aiBlockerHtml += _10_Chat_WebSocket.buildWithdrawChatButtonHtml(phone, _7_Chat.Chat.l('ИИ-ассистента'));
                    }
                    $('#blocker_operator p').html(aiBlockerHtml);
                    $('.my_work').addClass('hidden');
                }
                else if (alienWork) {
                    _7_Chat.Chat.setChatOpenSubscriberFalse('click_open_subscriber|work_alien_block');
                    if (!params.no_load_msg) {
                        Contacts.work_alien_phone = phone;
                    }
                    $('#my_work_operator').addClass('hidden');
                    $('.work_button').css('display', 'none');
                    $('#blocker_operator').css('display', 'block');
                    var alienBlockerHtml = "".concat(_7_Chat.Chat.l('Диалог ведет оператор:'), " <span>").concat(alienWork.op_n, "</span>");
                    if (isAdmin) {
                        alienBlockerHtml += _10_Chat_WebSocket.buildWithdrawChatButtonHtml(phone, _7_Chat.Chat.l('оператора'));
                    }
                    $('#blocker_operator p').html(alienBlockerHtml);
                    $('.my_work').addClass('hidden');
                }
                else {
                    _7_Chat.Chat.setChatOpenSubscriber(phone, 'click_open_subscriber|opened');
                    $('.work_button').css('display', 'block');
                    $('#blocker_operator').css('display', 'none');
                    var my_work_class = 'class="hidden-xs hidden-sm"';
                    if (_7_Chat.Chat.width < 768)
                        my_work_class = '';
                    var my_work_text = "<i class=\"fa fa-comment-dots\"></i> <span ".concat(my_work_class, ">").concat(_7_Chat.Chat.l('Взять в работу'), "</span>");
                    var my_work_type = 'take_to_work';
                    var my_work_title = "".concat(_7_Chat.Chat.l('Взять в работу'), " (Ctrl+G)");
                    $('#my_work_operator').removeClass('hidden');
                    $('.my_work_to_operator_show').addClass('hidden');
                    if (Contacts.work_my[phone]) {
                        my_work_text =
                            "<i class=\"fa fa-comment\"></i>" +
                                "<span ".concat(my_work_class, ">").concat(_7_Chat.Chat.l('Закончить диалог'), "</span>");
                        my_work_type = 'end_dialog';
                        my_work_title = "".concat(_7_Chat.Chat.l('Закончить диалог'), " (Ctrl+G)");
                        $('#my_work_operator').addClass('hidden');
                        $('.my_work_to_operator_show').removeClass('hidden');
                    }
                    $('.my_work')
                        .removeClass('hidden')
                        .html(my_work_text)
                        .data('work', my_work_type)
                        .attr('title', my_work_title);
                    _1_Tasks.findContactItemByPhone(phone).addClass('show_subscriber');
                }
            }
            auto_read();
        },
        click_mark_as_read: function (phone) {
            if (!phone)
                phone = _7_Chat.Chat.chat_view_subscriber;
            if (!phone) {
                console.warn('click_mark_as_read|нет открытого чата');
                return;
            }
            _5_Contacts.Contacts.no_read_check(phone);
        },
        click_open_operator: function (obj) {
            var _a;
            _7_Chat.Chat.chat_view_subscriber = false;
            var operator_id_to = obj.data('operator_id');
            if (typeof operator_id_to !== 'string' && typeof operator_id_to !== 'number') {
                console.warn('[TypeGuard] click_open_operator: operator_id_to имеет неверный тип', {
                    operator_id_to: operator_id_to,
                    type: typeof operator_id_to,
                });
                return;
            }
            _7_Chat.Chat.chat_open_operator = operator_id_to;
            if (!isset(operator_id_to) || operator_id_to === '')
                return;
            var chat_operator_messages = $('#chat_operator_messages');
            chat_operator_messages.height(((_a = $(window).height()) !== null && _a !== void 0 ? _a : 0) - 184);
            var operator_data = _7_Chat.Chat.operators_get()[operator_id_to];
            if (operator_data === undefined || operator_data === null)
                return;
            _7_Chat.Chat.setChatOpenSubscriberFalse('click_open_operator|init');
            $('#chat_operator_send').data('operator_id_to', operator_id_to);
            $('.show_operator').removeClass('show_operator');
            $('.show_subscriber').removeClass('show_subscriber');
            if ('parent' in obj && obj.parent) {
                obj.parent().addClass('show_operator');
            }
            _7_Chat.Chat.show_page('chat_operator');
            $('#chat_operator_name').text(operator_data.name + ' [' + operator_data.roles + ']');
            _7_Chat.Chat.operator_messages_query(operator_id_to);
        },
        click_operator_send: function () {
            if (_7_Chat.Chat.chat_message_send_button)
                return;
            var Chat_WebSocket = _10_Chat_WebSocket.Chat_WebSocket;
            var $textarea_operator_text = $('#textarea_operator_text');
            var btn = $('#chat_operator_send');
            var operator_id_to = btn.data('operator_id_to');
            if (!$textarea_operator_text.length)
                return;
            var message = $textarea_operator_text.val();
            if (empty(message))
                return;
            if (Number(operator_id_to) > 0) {
                Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'operator_send',
                        operator_id_to: String(operator_id_to),
                        message: message,
                    },
                    before: function () {
                        _7_Chat.Chat.chat_message_send_button = true;
                    },
                    success: function (data) {
                        var _a;
                        if (data.result === 0) {
                            _7_Chat.Chat.operator_messages_query((_a = data.data_ajax) === null || _a === void 0 ? void 0 : _a.operator_id_to);
                            var $textarea_operator_text_1 = $('#textarea_operator_text');
                            $textarea_operator_text_1.val('');
                            autosize.update($textarea_operator_text_1);
                            chat_messages_scroll('bottom');
                        }
                        else {
                            alert(data.result_description);
                        }
                        _7_Chat.Chat.chat_message_send_button = false;
                    },
                    error: function () {
                        _7_Chat.Chat.chat_message_send_button = false;
                    },
                });
                Chat_WebSocket.ajax_nodejs({
                    data: {
                        query: 'check_message_read_operator_mess',
                        operator_id: _7_Chat.Chat.chat_open_operator,
                    },
                    before: function () { },
                    success: function (_data) {
                        _7_Chat.Chat.chat_noread_operator_messages_load();
                    },
                    error: function (error) {
                        console.error('click_operator_send|error=', error);
                    },
                });
            }
        },
        click_message_send: function () {
            if (_7_Chat.Chat.chat_message_send_button)
                return;
            _7_Chat.Chat.obj.textarea_message_text2.focus();
            var phone = formFieldText('chat_message_phone');
            if (!phone)
                return;
            if (_5_Contacts.Contacts.work_alien[phone]) {
                alert('Диалог ведет другой оператор.');
                return;
            }
            var file_url = [];
            $('#list_images_body .image_item').each(function (_indx, element) {
                var fileUrlData = $(element).data('file_url');
                if (typeof fileUrlData === 'string') {
                    file_url.push(fileUrlData);
                }
                else if (fileUrlData === undefined || fileUrlData === null) {
                    file_url.push(null);
                }
            });
            var text = formFieldText('textarea_message_text');
            if (text === null)
                return;
            var text_temp = text.replace(/^(\s|\u00A0)+/g, '').replace(/\r?\n/g, '');
            if (text_temp === '' && file_url.length === 0)
                return;
            _7_Chat.Chat.send_message_to_server({
                phone: String(phone),
                text: text,
                file_url: file_url,
            });
        },
        updateMessageId: function (_a) {
            var _b;
            var phone = _a.phone, message_id_tmp = _a.message_id_tmp, message_id = _a.message_id;
            if (!((_b = _7_Chat.Chat.chat_messages[phone]) === null || _b === void 0 ? void 0 : _b.messages)) {
                console.error('Сообщения для указанного телефона не найдены');
                return;
            }
            var message = _7_Chat.Chat.chat_messages[phone].messages.find(function (msg) { return msg.message_id_tmp === message_id_tmp; });
            if (!message) {
                console.error('Сообщение с указанным message_id_tmp не найдено');
                return;
            }
            message.message_id = String(message_id);
        },
        message_push: function (_a) {
            var _b;
            var phone = _a.phone, _c = _a.text, text = _c === void 0 ? '' : _c, _d = _a.fileUrl, fileUrl = _d === void 0 ? null : _d, message_id = _a.message_id, _f = _a.message_id_tmp, message_id_tmp = _f === void 0 ? null : _f, _g = _a.multipleAddRes, multipleAddRes = _g === void 0 ? null : _g;
            if (!(fileUrl === null || fileUrl === void 0 ? void 0 : fileUrl.length) && empty(text))
                return;
            if (!_7_Chat.Chat.chat_messages[phone])
                _7_Chat.Chat.chat_messages[phone] = { messages: [] };
            var newMsg = {
                add_date: moment().format('YYYY-MM-DD HH:mm:ss'),
                add_date_unix: null,
                file_url: null,
                file_url_quoted: null,
                from_user: null,
                id: null,
                insta_post_comment_id: null,
                message_id: null,
                message_quoted: null,
                message_route: 'outbox',
                message_status: 0,
                message_text: text,
                message_type: (fileUrl === null || fileUrl === void 0 ? void 0 : fileUrl.length) ? 'message-undefined' : 'message-chat',
                msg_quoted_ph_numb: null,
                ph_numb: String(phone),
                system_message: null,
                transport: (_b = _5_Contacts.Contacts.data[phone]) === null || _b === void 0 ? void 0 : _b.transport,
                user_id: Number(_7_Chat.Chat.operator_data.id),
                f: 1,
                message_id_tmp: message_id_tmp,
            };
            var messages = [];
            if (multipleAddRes === null || multipleAddRes === void 0 ? void 0 : multipleAddRes.length) {
                multipleAddRes.forEach(function (message_id, i) {
                    newMsg.file_url = (fileUrl === null || fileUrl === void 0 ? void 0 : fileUrl.length) ? fileUrl[i] || null : null;
                    newMsg.id = message_id;
                    newMsg.add_date_unix = Math.floor(Date.now() / 1000);
                    newMsg.message_type = 'message-undefined';
                    messages.push(__assign({}, newMsg));
                });
            }
            else {
                newMsg.file_url = (fileUrl === null || fileUrl === void 0 ? void 0 : fileUrl.length) ? fileUrl[0] : null;
                newMsg.id = message_id;
                newMsg.add_date_unix = Math.floor(Date.now() / 1000);
                newMsg.message_type = (fileUrl === null || fileUrl === void 0 ? void 0 : fileUrl.length) ? 'message-undefined' : 'message-chat';
                messages.push(__assign({}, newMsg));
            }
            for (var _i = 0, messages_2 = messages; _i < messages_2.length; _i++) {
                var message = messages_2[_i];
                var k = 0;
                for (var key2 in _7_Chat.Chat.chat_messages[phone].messages) {
                    var existing = _7_Chat.Chat.chat_messages[phone].messages[key2];
                    if (!existing)
                        continue;
                    if (!message.id && message._id) {
                        message.id = message._id;
                    }
                    if (!message.id && message_id_tmp) {
                        if (existing.message_id_tmp === message.message_id_tmp) {
                            _7_Chat.Chat.chat_messages[phone].messages[key2] = message;
                            k++;
                            break;
                        }
                    }
                    else {
                        if (existing.id === message.id) {
                            _7_Chat.Chat.chat_messages[phone].messages[key2] = message;
                            k++;
                            break;
                        }
                    }
                }
                if (k === 0) {
                    _7_Chat.Chat.chat_messages[phone].messages.push(message);
                }
            }
            var chatStore = _7_Chat.Chat.Chat_Store;
            if (chatStore && chatStore.isActive()) {
                chatStore
                    .putSentMessagesPr(String(phone), messages)
                    .catch(function (error) {
                    console.error('message_push|putSentMessagesPr|error=', error);
                });
            }
        },
        sendMsgFieldClear: function (phone) {
            _2_Draft.Draft.del(phone);
            _7_Chat.Chat.obj.textarea_message_text.val('');
            _7_Chat.Chat.obj.textarea_message_text2.html('');
        },
        sendMsgFieldUnblock: function () {
            Button.reset($('#chat_message_send'));
            _7_Chat.Chat.obj.textarea_message_text2.removeAttr('disabled').focus();
            _7_Chat.Chat.chat_message_send_button = false;
        },
        send_message_to_server: function (data) {
            var phone = data.phone, text = data.text, file_url = data.file_url, system_message = data.system_message;
            var message_id_tmp = Date.now().toString();
            if (!_7_Chat.Chat.chat_loader['websocket']) {
                var chatStore = _7_Chat.Chat.Chat_Store;
                if (chatStore && chatStore.isActive() && !system_message) {
                    if (file_url.length) {
                        toastr.error('Нет соединения — файлы нельзя отправить офлайн');
                        _7_Chat.Chat.sendMsgFieldUnblock();
                        return;
                    }
                    var answerId = (function (value) {
                        return Array.isArray(value) ? value.map(String) : String(value !== null && value !== void 0 ? value : '');
                    })($('#answer_id').val());
                    chatStore
                        .outboxAddPr({
                        phone: phone,
                        text: text,
                        answer_id: answerId,
                        message_id_tmp: message_id_tmp,
                        add_date: moment().format('YYYY-MM-DD HH:mm:ss'),
                        created_at: Date.now(),
                    })
                        .catch(function (error) {
                        console.error('send_message_to_server|outboxAddPr|error=', error);
                    });
                    _7_Chat.Chat.message_push({
                        phone: phone,
                        text: text,
                        fileUrl: null,
                        message_id: undefined,
                        message_id_tmp: message_id_tmp,
                    });
                    _8_Chat_template.Chat_template.display_messages2({
                        phone: phone,
                        scroll: 'bottom',
                        chat_open: null,
                        direction: 'DOWN',
                    });
                    _7_Chat.Chat.answer_panel_close();
                    _7_Chat.Chat.sendMsgFieldClear(phone);
                    _7_Chat.Chat.sendMsgFieldUnblock();
                    toastr.info('Нет соединения — сообщение будет отправлено при восстановлении связи');
                    return;
                }
                console.error('send_message_to_server|нет соединения и нет офлайн-очереди|phone=', phone);
                toastr.error('Нет соединения с сервером — сообщение не отправлено. Повторите позже.');
                _7_Chat.Chat.sendMsgFieldUnblock();
                return;
            }
            _10_Chat_WebSocket.Chat_WebSocket.ajax_nodejs({
                data: {
                    query: 'message_send',
                    phone: phone,
                    text: text,
                    file_url: file_url,
                    system_message: system_message || null,
                    answer_id: (function (value) { return (Array.isArray(value) ? value.map(String) : (value !== null && value !== void 0 ? value : '')); })($('#answer_id').val()),
                    message_id_tmp: message_id_tmp,
                },
                before: function () {
                    Button.preloader($('#chat_message_send'));
                    _7_Chat.Chat.chat_message_send_button = true;
                },
                success: function (jsondata) {
                    if (jsondata && Number(jsondata.result) === 0) {
                        _7_Chat.Chat.click_mark_as_read(data.phone);
                        _7_Chat.Chat.sendMsgFieldClear(data.phone);
                        autosize.update(_7_Chat.Chat.obj.textarea_message_text2);
                        var multipleAddRes = jsondata.multipleAddRes;
                        _7_Chat.Chat.message_push({
                            phone: phone,
                            text: text,
                            fileUrl: file_url,
                            message_id: jsondata.message_id,
                            multipleAddRes: Array.isArray(multipleAddRes) &&
                                multipleAddRes.every(function (item) { return typeof item === 'number'; })
                                ? multipleAddRes
                                : undefined,
                        });
                        _8_Chat_template.Chat_template.display_messages2({
                            phone: phone,
                            scroll: 'bottom',
                            chat_open: null,
                            direction: 'DOWN',
                        });
                        $('#block_preview').addClass('hidden');
                        $('#chat_file_id').val('');
                        $('#files').html('');
                        $('#answer_block').addClass('hidden').html('');
                        $('#answer_id').val('');
                        $('#list_images_body .image_item').each(function (_indx, element) {
                            $(element).remove();
                        });
                        _7_Chat.Chat.list_images_close();
                    }
                    else {
                        var result_description = '';
                        if (jsondata) {
                            if (empty(jsondata.result_description)) {
                                var msg = jsondata.msg;
                                result_description =
                                    msg !== undefined && msg !== null && typeof msg === 'string' ? msg : '';
                            }
                            else {
                                var desc = jsondata.result_description;
                                result_description =
                                    desc !== undefined && desc !== null && typeof desc === 'string' ? desc : '';
                            }
                        }
                        toastr.error(result_description, 'ОШИБКА!');
                    }
                    _7_Chat.Chat.sendMsgFieldUnblock();
                },
                error: function (error) {
                    console.error('send_message_to_server|error=', error);
                    _7_Chat.Chat.sendMsgFieldUnblock();
                },
            });
        },
        templatePlaceholderLabels: function (message) {
            var pattern = /\{\{([^{}]+)\}\}/g;
            var unique = [];
            var match = pattern.exec(message);
            while (match !== null) {
                var token = match[1];
                if (token !== undefined && /^[A-Za-z0-9_]+$/.test(token) && unique.indexOf(token) === -1) {
                    unique.push(token);
                }
                match = pattern.exec(message);
            }
            return unique.every(function (token) { return /^\d+$/.test(token); })
                ? unique.sort(function (left, right) { return Number(left) - Number(right); })
                : unique;
        },
        message_menu_answer: function (phone, message_id) {
            if (_7_Chat.Chat.chat_view_subscriber !== phone)
                return;
            _7_Chat.Chat.answer_panel_open(message_id);
        },
        quoted_message_open: function (phone, parent_id) {
            return __awaiter(this, void 0, void 0, function () {
                var maxPages, page, state, minId, exhausted;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (_7_Chat.Chat.chat_view_subscriber !== phone || _7_Chat.Chat.quoted_jump_in_progress[phone])
                                return [2];
                            _7_Chat.Chat.quoted_jump_in_progress[phone] = true;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 6, 7]);
                            maxPages = 20;
                            page = 0;
                            _a.label = 2;
                        case 2:
                            if (!(page <= maxPages)) return [3, 5];
                            if (_7_Chat.Chat.quoted_message_scroll(parent_id))
                                return [2];
                            state = _7_Chat.Chat.chat_messages[phone];
                            minId = state === undefined ? undefined : state.message_id_min;
                            exhausted = page === maxPages ||
                                state === undefined ||
                                state.load_history_chek !== 1 ||
                                typeof minId !== 'number';
                            if (exhausted || parent_id >= minId)
                                return [3, 5];
                            _7_Chat.Chat.messages_get({ phone: phone, direction: 'UP', message_id: minId });
                            return [4, _7_Chat.Chat.history_page_wait(phone, minId)];
                        case 3:
                            if (!(_a.sent()))
                                return [3, 5];
                            _a.label = 4;
                        case 4:
                            page += 1;
                            return [3, 2];
                        case 5:
                            toastr.warning(_7_Chat.Chat.l('Сообщение не найдено в загруженной истории переписки'));
                            return [3, 7];
                        case 6:
                            delete _7_Chat.Chat.quoted_jump_in_progress[phone];
                            return [7];
                        case 7: return [2];
                    }
                });
            });
        },
        quoted_message_scroll: function (message_id) {
            var $target = $('#mess_id_' + message_id);
            if (!$target.length)
                return false;
            $('#chat_subscribe_messages').nanoScroller({ scrollTo: $target });
            $target.css('background-color', 'rgba(255, 235, 59, 0.35)');
            setTimeout(function () { return $target.css('background-color', ''); }, 2000);
            return true;
        },
        history_page_wait: function (phone, minIdBefore) {
            return new Promise(function (resolve) {
                var attemptsLeft = 50;
                var check = function () {
                    var state = _7_Chat.Chat.chat_messages[phone];
                    if (state !== undefined && state.message_id_min !== minIdBefore) {
                        resolve(true);
                        return;
                    }
                    attemptsLeft -= 1;
                    if (attemptsLeft === 0) {
                        resolve(false);
                        return;
                    }
                    setTimeout(check, 100);
                };
                setTimeout(check, 100);
            });
        },
        logout: function () {
            _7_Chat.Chat.clearOperatorSnapshot();
            var chatStoreForLogout = _7_Chat.Chat.Chat_Store;
            if (chatStoreForLogout && chatStoreForLogout.isActive()) {
                _7_Chat.Chat.Chat_Store = null;
                chatStoreForLogout.deleteDatabasePr().catch(function (error) {
                    console.error('logout|deleteDatabasePr|error=', error);
                });
            }
            var push_data = {};
            if (typeof Android === 'object') {
                _7_Chat.Chat.oneSignalUserID = Android.getPushUserId();
                _7_Chat.Chat.oneSignalUserIDType = 'android';
                push_data = {
                    push_user_id: _7_Chat.Chat.oneSignalUserID,
                    push_token: Android.getPushToken(),
                    type_push: _7_Chat.Chat.oneSignalUserIDType,
                };
            }
            else if (typeof _7_Chat.Chat.oneSignalUserID === 'string' && _7_Chat.Chat.oneSignalUserID.length > 5) {
                push_data = {
                    push_user_id: _7_Chat.Chat.oneSignalUserID,
                    push_token: null,
                    type_push: _7_Chat.Chat.oneSignalUserIDType !== null && _7_Chat.Chat.oneSignalUserIDType !== undefined
                        ? _7_Chat.Chat.oneSignalUserIDType
                        : null,
                };
            }
            jQuery.ajax({
                type: 'GET',
                url: _7_Chat.Chat.chatoperator,
                data: {
                    action: 'logout',
                    push_data: push_data,
                },
                dataType: 'json',
                beforeSend: function (_xhr) { },
                success: function () {
                    document.location.href = _7_Chat.Chat.navbarPageId;
                },
                error: function (error) {
                    console.error(error);
                    document.location.href = _7_Chat.Chat.navbarPageId;
                },
            });
        },
    };
})(_7_Chat || (_7_Chat = {}));


"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
function messageDateArg(date) {
    if (date === null || date === undefined)
        return undefined;
    return date instanceof Date ? date.getTime() : date;
}
var _8_Chat_template;
(function (_8_Chat_template) {
    function isWireObject(value) {
        return typeof value === 'object' && value !== null && !Array.isArray(value);
    }
    function wireField(value, key) {
        return value[key];
    }
    function isIdOrNull(value) {
        return value === null || typeof value === 'string' || typeof value === 'number';
    }
    function isStringList(value) {
        if (!Array.isArray(value))
            return false;
        var items = value;
        return items.every(function (item) { return typeof item === 'string'; });
    }
    function isOptionalText(value) {
        return value === undefined || typeof value === 'string';
    }
    function isQuotedDataV2(value) {
        if (!isWireObject(value))
            return false;
        var messageId = wireField(value, 'message_id');
        return (typeof wireField(value, 'text') === 'string' &&
            typeof wireField(value, 'file_url') === 'string' &&
            typeof wireField(value, 'from_phone') === 'string' &&
            (messageId === undefined || (Number.isInteger(messageId) && Number(messageId) > 0)));
    }
    function isLocationDataV2(value) {
        if (!isWireObject(value) || typeof wireField(value, 'url') !== 'string')
            return false;
        var provider = wireField(value, 'provider');
        if (provider === 'google') {
            return (typeof wireField(value, 'lat') === 'string' &&
                typeof wireField(value, 'lng') === 'string' &&
                isOptionalText(wireField(value, 'name')) &&
                isOptionalText(wireField(value, 'address')));
        }
        if (provider === 'bing')
            return typeof wireField(value, 'query') === 'string';
        return false;
    }
    function isContactCardDataV2(value) {
        return (isWireObject(value) &&
            typeof wireField(value, 'name') === 'string' &&
            typeof wireField(value, 'business_name') === 'string' &&
            isStringList(wireField(value, 'phones')) &&
            typeof wireField(value, 'photo') === 'string' &&
            isStringList(wireField(value, 'extra')));
    }
    function isChatMessageDataV2(value) {
        if (!isWireObject(value))
            return false;
        var field = function (key) { return wireField(value, key); };
        var phNumb = field('ph_numb');
        var addDate = field('add_date');
        var addDateUnix = field('add_date_unix');
        var quoted = field('quoted');
        var location = field('location');
        var contact = field('contact');
        return (typeof field('id') === 'number' &&
            isIdOrNull(field('message_id')) &&
            isIdOrNull(field('user_id')) &&
            typeof field('transport') === 'string' &&
            typeof field('message_route') === 'string' &&
            typeof field('message_type') === 'string' &&
            typeof field('message_text') === 'string' &&
            typeof field('file_url') === 'string' &&
            typeof field('transcription_text') === 'string' &&
            isIdOrNull(field('message_status')) &&
            typeof field('system_message') === 'string' &&
            isIdOrNull(field('insta_post_comment_id')) &&
            isIdOrNull(field('sp_numb')) &&
            (typeof phNumb === 'string' || typeof phNumb === 'number') &&
            typeof field('is_edit') === 'number' &&
            typeof field('is_reaction') === 'number' &&
            typeof field('is_product') === 'number' &&
            typeof field('is_order') === 'number' &&
            (addDate === null || typeof addDate === 'string') &&
            (addDateUnix === null || typeof addDateUnix === 'number') &&
            typeof field('from_db_with_utc') === 'boolean' &&
            typeof field('from_user') === 'string' &&
            typeof field('from_user_name') === 'string' &&
            (quoted === null || isQuotedDataV2(quoted)) &&
            (location === null || isLocationDataV2(location)) &&
            (contact === null || isContactCardDataV2(contact)));
    }
    function isNoReadV2(value) {
        if (!isWireObject(value))
            return false;
        var categ = wireField(value, 'categ');
        var time = wireField(value, 'time');
        var messageId = wireField(value, 'message_id');
        return (isOptionalText(wireField(value, 'phone')) &&
            (categ === undefined || typeof categ === 'string' || typeof categ === 'number') &&
            (time === undefined ||
                time === null ||
                typeof time === 'string' ||
                typeof time === 'number') &&
            (messageId === undefined || messageId === null || typeof messageId === 'number'));
    }
    function isBoundaryOrNull(value) {
        return value === null || typeof value === 'number';
    }
    var Chat_templateCls = (function () {
        function Chat_templateCls() {
            var _this = this;
            this.body = $('body');
            this.chat_user_name = $('.chat_user_name');
            this.chat_user_email = $('.chat_user_email');
            this.loader_chat = $('.loader_chat');
            this.chat_auth = $('#chat_auth');
            this.chat_subscribers = $('#chat_subscribers');
            this.li_chat_subscribers = $('#chat_subscribers li');
            this.allowAnswerBtns = {};
            this.lastMessagesRender = null;
            this.isMessageNoRead = function (phone, messageId, addDate) {
                var noRead = _5_Contacts.Contacts.no_read[phone];
                if (!noRead)
                    return false;
                var borderId = Number(noRead.message_id);
                var currentId = Number(messageId);
                if (Number.isFinite(borderId) &&
                    borderId > 0 &&
                    Number.isFinite(currentId) &&
                    currentId > 0) {
                    return currentId >= borderId;
                }
                return Number(moment(messageDateArg(addDate)).format('x')) >= Number(noRead.time);
            };
            this.display_login_operator = function (data) {
                _this.loader_chat.css('display', 'none');
                _this.chat_auth.html(data).css('display', 'block');
            };
            this.integration = function (e) {
                var integration_block = $('.integration_block, .integration_block2');
                if (e.length === 0) {
                    integration_block.addClass('hidden');
                    return;
                }
                integration_block.removeClass('hidden');
                var Chat = _7_Chat.Chat;
                var li_link = '<li class="dropdown-header" style="color: #bbb;">' + Chat.l('Интеграции') + '</li>';
                var li_btn = '<li class="dropdown-header" style="color: #bbb;text-align: center;">' +
                    Chat.l('Интеграции') +
                    '</li>';
                for (var key in e) {
                    if (!e[key])
                        continue;
                    var entryName = _this.escapeHtml(String(e[key].name));
                    switch (e[key].provider) {
                        case 'amocrm':
                            li_link +=
                                "<li><a href=\"#\" class=\"".concat(e[key].provider, "_btn ") +
                                    (e[key].amocrm_mode == 1 ? 'amocrm_open' : 'amocrm_show') +
                                    "\">AmoCRM</a></li>";
                            li_btn +=
                                "<li><button type=\"button\" class=\"btn btn-default ".concat(e[key].provider, "_btn ") +
                                    (e[key].amocrm_mode === 1 ? 'amocrm_open' : 'amocrm_show') +
                                    "\">AmoCRM</button></li>";
                            break;
                        case 'uon':
                            li_link += "<li><a href=\"#\" class=\"".concat(e[key].provider, "_btn uon_show\">U-ON Travel</a></li>");
                            li_btn += "<li><button type=\"button\" class=\"btn btn-default ".concat(e[key].provider, "_btn uon_show\">U-ON Travel</button></li>");
                            break;
                        case 'sendapi_deals':
                            li_link +=
                                "<li><a href=\"#\" class=\"".concat(e[key].provider, "_btn sendapi_deals_show\">") +
                                    entryName +
                                    '</a></li>';
                            li_btn +=
                                "<li><button type=\"button\" class=\"btn btn-default ".concat(e[key].provider, "_btn sendapi_deals_show\">") +
                                    entryName +
                                    '</button></li>';
                            break;
                        case 'bitrix24_deals':
                            li_link +=
                                "<li><a href=\"#\" class=\"".concat(e[key].provider, "_btn bitrix24_deals_show\">") +
                                    entryName +
                                    '</a></li>';
                            li_btn +=
                                "<li><button type=\"button\" class=\"btn btn-default ".concat(e[key].provider, "_btn bitrix24_deals_show\">") +
                                    entryName +
                                    '</button></li>';
                            break;
                        case 'glo':
                            li_link +=
                                '<li role="separator" class="divider"></li><li class="dropdown-header" style="color: #bbb;">GLO</li>';
                            li_link +=
                                "<li><a href=\"#\" class=\"glo_verify_identity_show\">".concat(Chat.l('Подтвердить личность'), "</a></li>") +
                                    "<li><a href=\"#\" class=\"glo_add_user_show\">".concat(Chat.l('Добавить glo_user'), "</a></li>");
                            li_btn +=
                                '<li role="separator" class="divider"></li><li class="dropdown-header" style="color: #bbb;">GLO</li>';
                            li_btn +=
                                "<li><button type=\"button\" class=\"btn btn-default glo_verify_identity_show\">".concat(Chat.l('Подтвердить личность'), "</button></li>") +
                                    "<li><button type=\"button\" class=\"btn btn-default glo_add_user_show\">".concat(Chat.l('Добавить glo_user'), "</button></li>");
                            break;
                    }
                }
                if (Chat.operator_data.waba) {
                    li_link += "<li role=\"separator\" class=\"divider li_waba_template\"></li><li class=\"dropdown-header\" style=\"color: #bbb;\">".concat(Chat.l('Whatsapp бизнес'), "</li>");
                    li_link += "<li class=\"li_waba_template\"><a href=\"#\" class=\"waba_template_open\">".concat(Chat.l('Шаблоны'), "</a></li>");
                    li_btn += "<li role=\"separator\" class=\"divider li_waba_template\"></li><li class=\"dropdown-header\" style=\"color: #bbb;\">".concat(Chat.l('Whatsapp бизнес'), "</li>");
                    li_btn += "<li class=\"li_waba_template\"><button type=\"button\" class=\"btn btn-default waba_template_open\">".concat(Chat.l('Шаблоны'), "</button></li>");
                }
                $('.integration_block ul').html(li_link);
                $('.integration_block2').html(li_btn);
            };
            this.display_quick_messages = function () {
                var Chat = _7_Chat.Chat;
                var data = Chat.quick_messages_get();
                if (data === null || !data.quick_messages || data.quick_messages.length === 0) {
                    $('#table_quick_messages').html('<tr><td>' + Chat.l('Нет записей') + '</td></tr>');
                    return;
                }
                var quick_messages_tr = '';
                var _loop_1 = function (key) {
                    if (!data.quick_messages[key])
                        return "continue";
                    var _a = data.quick_messages[key], operator_id = _a.operator_id, id = _a.id, file_json = _a.file_json;
                    var command = _this.escapeHtml(String(data.quick_messages[key].command));
                    var name_1 = _this.escapeHtml(data.quick_messages[key].name);
                    var message = _this.nl2br(_this.escapeHtml(data.quick_messages[key].message));
                    var quick_messages_bt = '';
                    if (String(operator_id) === String(Chat.operator_data.id)) {
                        quick_messages_bt =
                            "<button type=\"button\" class=\"btn btn-default btn-xs quick_messages_edit_show\" data-quick_messages_id=\"".concat(id, "\"><i class=\"fas fa-edit\"></i></button> ") +
                                "<button type=\"button\" class=\"btn btn-default btn-xs quick_messages_delete\" data-quick_messages_id=\"".concat(id, "\"><i class=\"fas fa-times\"></i></button>");
                    }
                    if (file_json) {
                        var files_1 = '';
                        if (Array.isArray(file_json)) {
                            file_json.forEach(function (file_item) {
                                _6_FileUpload.FileUpload.fileNormalize({ url: file_item.fileUrl, ext: file_item.fileExt }, function (e) {
                                    files_1 += "<div class=\"p_load image_item\" data-file_url=\"".concat(_1_Tasks.escapeHtml(file_item.fileUrl), "\">").concat(e.html, "</div>");
                                });
                            });
                        }
                        else {
                            if (file_json.fileUrl) {
                                _6_FileUpload.FileUpload.fileNormalize({ url: file_json.fileUrl, ext: file_json.fileExt }, function (e) {
                                    files_1 += "<div class=\"p_load image_item\" data-file_url=\"".concat(_1_Tasks.escapeHtml(file_json.fileUrl), "\">").concat(e.html, "</div>");
                                });
                            }
                        }
                        quick_messages_tr +=
                            '<tr><td>' +
                                '<div class="quick_messages_item row">' +
                                "<div class=\"col-sm-12\">".concat(Chat.l('Команда'), ": ").concat(command, " | ").concat(Chat.l('Название шаблона'), ": ").concat(name_1) +
                                '</div>' +
                                "<div class=\"col-sm-12 message\"><div class=\"message_text\" data-id=\"".concat(key, "\">") +
                                message +
                                "<div class=\"quick_message_files\">".concat(files_1, "</div>") +
                                '</div></div>' +
                                "<div class=\"col-sm-12\">".concat(quick_messages_bt, "</div>") +
                                '</div></td></tr>';
                        return "continue";
                    }
                    quick_messages_tr +=
                        '<tr><td>' +
                            '<div class="quick_messages_item row">' +
                            "<div class=\"col-sm-12\">".concat(Chat.l('Команда'), ": ").concat(command, " | ").concat(Chat.l('Название шаблона'), ": ").concat(name_1) +
                            '</div>' +
                            "<div class=\"col-sm-12 message\"><div class=\"message_text\" data-id=\"".concat(key, "\">") +
                            message +
                            '</div></div>' +
                            "<div class=\"col-sm-12\">".concat(quick_messages_bt, "</div>") +
                            '</div></td></tr>';
                };
                for (var key in data.quick_messages) {
                    _loop_1(key);
                }
                $('#table_quick_messages').html(quick_messages_tr);
            };
            this.display_operators = function () {
                var _a;
                var Chat = _7_Chat.Chat;
                var escapeHtml = _1_Tasks.escapeHtml;
                var operators = Chat.operators_get();
                var showChatStatus = Chat.operators_chat_status_visible();
                $('#operators_chat_status_bulk').toggleClass('hidden', !showChatStatus);
                if (count_obj(operators)) {
                    var li = '';
                    for (var key in operators) {
                        var operator = operators[key];
                        if (!operator || typeof operator !== 'object')
                            continue;
                        var operatorObj = operator;
                        if (!operatorObj.id || String(operatorObj.id) === String(Chat.operator_data.id))
                            continue;
                        if (operatorObj.h === 1)
                            continue;
                        li +=
                            "<li class=\"operator_".concat(operatorObj.id, "\">") +
                                "<a href=\"javascript:;\" class=\"open_operator\" data-operator_id=\"".concat(operatorObj.id, "\">") +
                                "<i class=\"fa fa-user\"></i> " +
                                (showChatStatus
                                    ? _this.operator_chat_status_html(operatorObj.id, operatorObj.chat_status)
                                    : '') +
                                "<span data-i18n-user-content>".concat(escapeHtml((_a = operatorObj.name) !== null && _a !== void 0 ? _a : ''), "</span>") +
                                " <span class=\"no_read_message_kol badge bg-green pull-right\"></span>" +
                                "</a></li>";
                    }
                    $('#chat_operators').html(li);
                }
                else {
                    $('#chat_operators').html('');
                }
            };
            this.operator_chat_status_html = function (operatorId, status) {
                var Chat = _7_Chat.Chat;
                var escapeHtml = _1_Tasks.escapeHtml;
                if (status === undefined)
                    return '<span class="operator_chat_status"></span>';
                var online = status === 'online';
                var hint = "".concat(Chat.l(online ? 'Онлайн' : 'Перерыв'), ". ").concat(Chat.l('Сменить статус оператора'));
                return ("<span class=\"operator_chat_status operator_chat_status_toggle\" role=\"button\"" +
                    " aria-haspopup=\"menu\" aria-expanded=\"false\"" +
                    " data-operator_id=\"".concat(escapeHtml(String(operatorId)), "\" data-status=\"").concat(online ? 'online' : 'pause', "\"") +
                    " title=\"".concat(escapeHtml(hint), "\" aria-label=\"").concat(escapeHtml(hint), "\"") +
                    " style=\"cursor: pointer; margin-right: 4px; white-space: nowrap;\">" +
                    "<i class=\"fas fa-circle ".concat(online ? 'text-green' : 'text-yellow', "\"></i>") +
                    "<span class=\"caret\" style=\"margin-left: 2px;\"></span></span>");
            };
            this.display_operator_chat_status = function (operatorId, status) {
                if (!_7_Chat.Chat.operators_chat_status_visible())
                    return;
                $("#chat_operators .operator_".concat(operatorId, " .operator_chat_status")).replaceWith(_this.operator_chat_status_html(operatorId, status));
            };
            this.operator_chat_status_menu_open = function (toggle) {
                var Chat = _7_Chat.Chat;
                var escapeHtml = _1_Tasks.escapeHtml;
                var operatorId = Number(toggle.getAttribute('data-operator_id'));
                var current = toggle.getAttribute('data-status');
                var open = document.getElementById('operator_chat_status_menu');
                var sameOperator = open !== null && open.getAttribute('data-operator_id') === String(operatorId);
                _this.operator_chat_status_menu_close();
                if (sameOperator || !Number.isInteger(operatorId))
                    return;
                var item = function (status, color, label) {
                    return "<li class=\"".concat(current === status ? 'active' : '', "\" role=\"none\">") +
                        "<a href=\"#\" class=\"operator_chat_status_choice\" role=\"menuitem\" data-status=\"".concat(status, "\">") +
                        "<i class=\"fas fa-circle ".concat(color, "\"></i> ").concat(escapeHtml(Chat.l(label)), "</a></li>");
                };
                var rect = toggle.getBoundingClientRect();
                $('body').append("<ul id=\"operator_chat_status_menu\" class=\"dropdown-menu\" role=\"menu\"" +
                    " data-operator_id=\"".concat(operatorId, "\"") +
                    " style=\"display: block; position: fixed; left: ".concat(Math.round(rect.left), "px;") +
                    " top: ".concat(Math.round(rect.bottom + 2), "px; min-width: 0; z-index: 2000;\">") +
                    item('online', 'text-green', 'Онлайн') +
                    item('pause', 'text-yellow', 'Перерыв') +
                    "</ul>");
                toggle.setAttribute('aria-expanded', 'true');
            };
            this.operator_chat_status_menu_close = function () {
                $('#operator_chat_status_menu').remove();
                document
                    .querySelectorAll('.operator_chat_status_toggle[aria-expanded="true"]')
                    .forEach(function (el) { return el.setAttribute('aria-expanded', 'false'); });
            };
            this.display_operator_messages = function (data) {
                var _a;
                var chat_operator_messages = $('#chat_operator_messages');
                chat_operator_messages.html('');
                if (!data.messages.length) {
                    return;
                }
                var Chat = _7_Chat.Chat;
                var $mark_as_read_operator_mess = $('.mark_as_read_operator_mess');
                $mark_as_read_operator_mess.addClass('hidden');
                if (Chat.chat_open_operator) {
                    var operatorKey = String(Chat.chat_open_operator);
                    if (Chat.chat_noread_operator_messages[operatorKey]) {
                        $mark_as_read_operator_mess.removeClass('hidden');
                    }
                }
                var message = '';
                for (var key in data.messages) {
                    if (!data.messages[key])
                        continue;
                    var _b = data.messages[key], operator_id_from = _b.operator_id_from, message_text = _b.message_text, add_date = _b.add_date, from_db_with_utc = _b.from_db_with_utc, id = _b.id;
                    if (String(operator_id_from) === String(Chat.operator_data.id)) {
                        message +=
                            "<div class=\"direct-chat-msg right\" id=\"".concat(key, "\">") +
                                "<div class=\"direct-chat-avatar\" title=\"".concat(Chat.l('Оператор'), "\"><i class=\"fa fa-phone-volume\"></i></div>") +
                                '<div class="direct-chat-text pull-right">' +
                                replaceCarret({ message_text: message_text }) +
                                '<small class="direct-chat-timestamp message_time">' +
                                Chat.time_zone(add_date, from_db_with_utc !== null && from_db_with_utc !== void 0 ? from_db_with_utc : false) +
                                '</small></div></div>';
                    }
                    else {
                        var no_red = '';
                        if (Chat.chat_open_operator) {
                            var operatorKey = String(Chat.chat_open_operator);
                            var messages = (_a = Chat.chat_noread_operator_messages[operatorKey]) === null || _a === void 0 ? void 0 : _a.message;
                            if (messages && Array.isArray(messages)) {
                                for (var _i = 0, messages_1 = messages; _i < messages_1.length; _i++) {
                                    var msg = messages_1[_i];
                                    if (String(msg.message_id) === String(id)) {
                                        no_red = 'no-read';
                                    }
                                }
                            }
                        }
                        message +=
                            "<div class=\"direct-chat-msg ".concat(no_red, "\" id=\"").concat(key, "\">") +
                                "<div class=\"direct-chat-avatar\" title=\"".concat(Chat.l('Оператор'), "\"><i class=\"fa fa-phone-volume\"></i></div>") +
                                '<div class="direct-chat-text">' +
                                replaceCarret({ message_text: message_text }) +
                                '<small class="direct-chat-timestamp message_time">' +
                                Chat.time_zone(add_date, from_db_with_utc !== null && from_db_with_utc !== void 0 ? from_db_with_utc : false) +
                                '</small></div></div>';
                    }
                }
                chat_operator_messages.html(message);
                if ($('div.direct-chat-msg').hasClass('no-read')) {
                    $mark_as_read_operator_mess.removeClass('hidden');
                }
                else {
                    $mark_as_read_operator_mess.addClass('hidden');
                }
                setTimeout(function () {
                    chat_messages_scroll('bottom');
                }, 200);
            };
            this.message_reaction = function (reaction) {
                if (!reaction || reaction === '')
                    return '';
                return '<div class="reaction">' + reaction + '</div>';
            };
            this.message_old_edit = function (_a) {
                var is_edit = _a.is_edit;
                if (!is_edit)
                    return '';
                return ("<div class=\"message_old_edit\">" +
                    "<div class=\"message_old_title\">".concat(_7_Chat.Chat.l('✎ Отредактировано'), "</div>") +
                    "</div>");
            };
            this.message_is_product = function (_a) {
                var is_product = _a.is_product;
                if (!is_product)
                    return '';
                return ("<div class=\"message_old_edit\">" +
                    "<div class=\"message_old_title\">".concat(_7_Chat.Chat.l('🛒 Товар'), "</div>") +
                    "</div>");
            };
            this.message_is_order = function (_a) {
                var is_order = _a.is_order, file_url = _a.file_url;
                if (!is_order)
                    return '';
                var orderImg = '';
                if (file_url) {
                    orderImg =
                        "<div class=\"message_image\"><div class=\"p_load\">" +
                            "<img src=\"".concat(file_url, "\" class=\"imgload\" onload=\"_7_Chat.Chat.imgload(this)\" data-img_url=\"").concat(file_url, "\" alt=\"\"></div>");
                }
                return ("<div class=\"message_old_edit\">" +
                    "<div class=\"message_old_title\">".concat(_7_Chat.Chat.l('🛒 Заказ'), "</div>") +
                    orderImg +
                    "</div>");
            };
            this.message_type_badge = function (_a) {
                var message_type = _a.message_type;
                if (!message_type)
                    return '';
                var badges = {
                    'message-live-location': { icon: '📍', label: _7_Chat.Chat.l('Live-геопозиция') },
                    'message-list': { icon: '📋', label: _7_Chat.Chat.l('Список') },
                    'message-list-response': { icon: '✅', label: _7_Chat.Chat.l('Ответ на список') },
                    'message-buttons': { icon: '🔘', label: _7_Chat.Chat.l('Кнопки') },
                    'message-buttons-response': { icon: '✅', label: _7_Chat.Chat.l('Ответ на кнопки') },
                    'message-interactive': { icon: '👆', label: _7_Chat.Chat.l('Интерактив') },
                    'message-interactive-response': {
                        icon: '✅',
                        label: _7_Chat.Chat.l('Ответ на интерактив'),
                    },
                    'message-poll': { icon: '📊', label: _7_Chat.Chat.l('Опрос') },
                    'message-contact': { icon: '👤', label: _7_Chat.Chat.l('Контакт') },
                    'message-vcard': { icon: '👤', label: _7_Chat.Chat.l('Контакт') },
                    'message-album': { icon: '🖼️', label: _7_Chat.Chat.l('Альбом') },
                    'message-template': { icon: '📝', label: _7_Chat.Chat.l('Шаблон') },
                };
                var badge = badges[message_type];
                if (!badge)
                    return '';
                return ("<div class=\"message_type_badge\">" +
                    "<span class=\"badge_icon\">".concat(badge.icon, "</span> ") +
                    "<span class=\"badge_label\">".concat(badge.label, "</span>") +
                    "</div>");
            };
            this.wabaRestrictionInfoIcon = function (message_text) {
                if (!message_text)
                    return '';
                var isRestriction = /не можете начинать новые чаты/i.test(message_text) ||
                    /на связанных устройствах установлены ограничения/i.test(message_text);
                if (!isRestriction)
                    return '';
                return ("<span class=\"message_waba_restriction_icon\" " +
                    "style=\"color:#3c8dbc;cursor:pointer;margin-left:6px;font-size:14px;\" " +
                    "title=\"".concat(_7_Chat.Chat.l('Подробнее об ограничении WhatsApp'), "\"><i class=\"fa fa-question-circle\"></i></span>"));
            };
            this.message_outbox = function (_a) {
                var message_text = _a.message_text, transcription_text = _a.transcription_text, add_date = _a.add_date, from_db_with_utc = _a.from_db_with_utc, message_id = _a.message_id, ph_numb = _a.ph_numb, file_url = _a.file_url, avatar = _a.avatar, forward_hidden = _a.forward_hidden, isLogMessage = _a.isLogMessage, title = _a.title, message_status = _a.message_status, message_status_msg = _a.message_status_msg, operator_send = _a.operator_send, status_h = _a.status_h;
                var Chat = _7_Chat.Chat;
                var logCls = isLogMessage ? "log" : '';
                var messageStatus = isLogMessage
                    ? ""
                    : "<span class=\"message_status ".concat(status_h !== null && status_h !== void 0 ? status_h : '', " status_").concat(message_status !== null && message_status !== void 0 ? message_status : '', "\"></span>");
                var escapedStatusMsg = message_status_msg
                    ? message_status_msg
                        .replace(/&/g, '&amp;')
                        .replace(/"/g, '&quot;')
                        .replace(/'/g, '&#39;')
                        .replace(/</g, '&lt;')
                        .replace(/>/g, '&gt;')
                    : '';
                var errorIcon = escapedStatusMsg
                    ? "<span class=\"message_error_icon\" data-status-msg=\"".concat(escapedStatusMsg, "\" style=\"color:#d9534f;cursor:pointer;margin-left:4px;font-size:14px;\" title=\"").concat(Chat.l('Ошибка доставки'), "\"><i class=\"fa fa-question-circle\"></i></span>")
                    : '';
                var msg = '';
                msg += "<div class=\"direct-chat-msg message_outbox right ".concat(logCls, "\" id=\"mess_id_").concat(message_id !== null && message_id !== void 0 ? message_id : '', "\">");
                msg += "<div class=\"direct-chat-avatar\" title=\"".concat(title !== null && title !== void 0 ? title : '', "\"><i class=\"fa ").concat(avatar !== null && avatar !== void 0 ? avatar : '', "\"></i></div>");
                msg +=
                    "<div class=\"direct-chat-text\">" +
                        _this.message_menu(ph_numb || '', message_id !== null && message_id !== void 0 ? message_id : '', file_url) +
                        replaceCarret({ message_text: message_text !== null && message_text !== void 0 ? message_text : '' });
                if (isLogMessage) {
                    msg += _this.wabaRestrictionInfoIcon(message_text !== null && message_text !== void 0 ? message_text : '');
                }
                if (file_url && !_this.hasRenderedFile(message_text !== null && message_text !== void 0 ? message_text : '')) {
                    try {
                        var html = _this.messageFile({ file_url: file_url }).html;
                        msg += html;
                    }
                    catch (e) {
                        console.error('message_outbox|e=', e);
                    }
                }
                if (transcription_text) {
                    msg +=
                        "<div class=\"message_transcription\" style=\"margin-top:6px; padding-top:6px; border-top:1px dashed rgba(0,0,0,0.12);\">" +
                            "<div class=\"message_transcription_title\" style=\"font-size:12px; opacity:0.7;\">".concat(Chat.l('Транскрипция:'), "</div>") +
                            "<div class=\"message_transcription_text\" style=\"font-size:13px;\">".concat(replaceCarret({
                                message_text: transcription_text,
                            }), "</div>") +
                            "</div>";
                }
                msg +=
                    "<small class=\"direct-chat-timestamp message_time\">".concat(Chat.time_zone(messageDateArg(add_date), from_db_with_utc !== null && from_db_with_utc !== void 0 ? from_db_with_utc : 0)) +
                        (operator_send !== null && operator_send !== void 0 ? operator_send : '') +
                        "</small>";
                msg +=
                    messageStatus +
                        errorIcon +
                        "<button class=\"btn forward ".concat(forward_hidden !== null && forward_hidden !== void 0 ? forward_hidden : '', "\" data-id=\"").concat(message_id !== null && message_id !== void 0 ? message_id : '', "\"><i class=\"fa fa-share\" aria-hidden=\"true\"></i></button>");
                msg += '</div>';
                msg += '</div>';
                return msg;
            };
            this.message_inbox = function (_a) {
                var message_text = _a.message_text, transcription_text = _a.transcription_text, add_date = _a.add_date, from_db_with_utc = _a.from_db_with_utc, message_id = _a.message_id, ph_numb = _a.ph_numb, no_red = _a.no_red, avatar = _a.avatar, forward_hidden = _a.forward_hidden, insta_post_answer_btn = _a.insta_post_answer_btn, inbox_id = _a.inbox_id, isLogMessage = _a.isLogMessage, is_edit = _a.is_edit, is_product = _a.is_product, is_order = _a.is_order, file_url = _a.file_url, message_type = _a.message_type;
                var Chat = _7_Chat.Chat;
                var inboxIdTag = inbox_id ? "inbox_id = \"".concat(inbox_id, "\"") : '';
                var logCls = isLogMessage ? "log" : '';
                var msg = '';
                msg += "<div class=\"direct-chat-msg message_inbox ".concat(no_red !== null && no_red !== void 0 ? no_red : '', " ").concat(logCls, "\" id=\"mess_id_").concat(message_id !== null && message_id !== void 0 ? message_id : '', "\" chat_message_id=\"").concat(message_id !== null && message_id !== void 0 ? message_id : '', "\" ").concat(inboxIdTag, ">");
                if (!isLogMessage) {
                    msg += "<div class=\"direct-chat-avatar\" title=\"".concat(Chat.l('Подписчик'), "\">").concat(avatar !== null && avatar !== void 0 ? avatar : '', "</div>");
                }
                msg += "<div class=\"direct-chat-text\">";
                msg += _this.message_menu(ph_numb !== null && ph_numb !== void 0 ? ph_numb : '', message_id !== null && message_id !== void 0 ? message_id : '', file_url);
                msg += _this.message_old_edit({ is_edit: is_edit });
                msg += _this.message_is_product({ is_product: is_product });
                msg += _this.message_is_order({ is_order: is_order, file_url: file_url });
                msg += _this.message_type_badge({ message_type: message_type });
                if (file_url && !_this.hasRenderedFile(message_text !== null && message_text !== void 0 ? message_text : '')) {
                    try {
                        var html = _this.messageFile({ file_url: file_url }).html;
                        msg += html;
                    }
                    catch (e) {
                        console.error('message_inbox|messageFile|e=', e);
                    }
                }
                msg += replaceCarret({ message_text: message_text !== null && message_text !== void 0 ? message_text : '' });
                if (isLogMessage) {
                    msg += _this.wabaRestrictionInfoIcon(message_text !== null && message_text !== void 0 ? message_text : '');
                }
                if (transcription_text) {
                    msg +=
                        "<div class=\"message_transcription\" style=\"margin-top:6px; padding-top:6px; border-top:1px dashed rgba(0,0,0,0.12);\">" +
                            "<div class=\"message_transcription_title\" style=\"font-size:12px; opacity:0.7;\">".concat(Chat.l('Транскрипция:'), "</div>") +
                            "<div class=\"message_transcription_text\" style=\"font-size:13px;\">".concat(replaceCarret({
                                message_text: transcription_text,
                            }), "</div>") +
                            "</div>";
                }
                msg +=
                    "<small class=\"direct-chat-timestamp message_time\">".concat(Chat.time_zone(messageDateArg(add_date), from_db_with_utc !== null && from_db_with_utc !== void 0 ? from_db_with_utc : 0), "</small>") +
                        (insta_post_answer_btn !== null && insta_post_answer_btn !== void 0 ? insta_post_answer_btn : '') +
                        "<button class=\"btn forward ".concat(forward_hidden !== null && forward_hidden !== void 0 ? forward_hidden : '', "\" data-id=\"").concat(message_id !== null && message_id !== void 0 ? message_id : '', "\"><i class=\"fa fa-share\" aria-hidden=\"true\"></i></button>");
                msg += '</div></div>';
                return msg;
            };
            this.hasRenderedFile = function (message_text) {
                return (/class="sa-audio"/.test(message_text) ||
                    /<video[\s>]/i.test(message_text) ||
                    /class="message_image"/.test(message_text) ||
                    /<i class="fa fa-download"/.test(message_text) ||
                    /<i class="fa fa-file[-"]/.test(message_text));
            };
            this.allowAnswerBtn = function (_central_user_id) {
                return true;
            };
            this.message_menu = function (phone, message_id, file_url) {
                var _a;
                var Chat = _7_Chat.Chat;
                var items = [];
                if (_this.allowAnswerBtn(Number(Chat.operator_data.central_user_id))) {
                    var messages = (_a = Chat.chat_messages[phone]) === null || _a === void 0 ? void 0 : _a.messages;
                    var message = null;
                    if (messages) {
                        for (var _i = 0, messages_2 = messages; _i < messages_2.length; _i++) {
                            var m = messages_2[_i];
                            if (m.id !== null && m.id !== undefined && String(m.id) === String(message_id)) {
                                message = m;
                                break;
                            }
                        }
                    }
                    if (message !== null &&
                        message.system_message !== 'log_message' &&
                        !_0_Constants.isRevokeNotice(message.system_message) &&
                        !_0_Constants.isOwnerRevokeNotice(message.system_message)) {
                        items.push("<li><a href=\"#\" onclick=\"_7_Chat.Chat.message_menu_answer('".concat(_1_Tasks.escapeHtml(String(phone)), "','").concat(message_id, "')\">").concat(Chat.l('Ответить'), "</a></li>"));
                    }
                }
                if (file_url) {
                    items.push("<li><a href=\"".concat(_this.escapeHtml(file_url), "\" download=\"\" target=\"_blank\">").concat(Chat.l('Скачать файл'), "</a></li>"));
                }
                if (!items.length)
                    return '';
                var menuId = "message_menu_".concat(_this.escapeHtml(String(message_id)));
                return ("<div class=\"dropdown message_menu\">" +
                    "<button class=\"btn btn-default dropdown-toggle\" type=\"button\" id=\"".concat(menuId, "\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" aria-label=\"").concat(Chat.l('Меню сообщения'), "\">") +
                    "<i class=\"fa fa-bars\"></i>" +
                    "</button>" +
                    "<ul class=\"dropdown-menu dropdown-menu-right\" aria-labelledby=\"".concat(menuId, "\">") +
                    items.join('') +
                    "</ul>" +
                    "</div>");
            };
            this.display_messages = function (data) {
                var _a, _b, _c;
                console.log('display_messages|');
                var phone = data.phone, scroll = data.scroll, chat_open = data.chat_open, direction = data.direction;
                var messages = data.messages;
                var Chat = _7_Chat.Chat;
                var Contacts = _5_Contacts.Contacts;
                var $chat_subscribe_messages = $('#chat_subscribe_messages');
                if (!Chat.chat_view_subscriber) {
                    Chat.message_preloader('hide');
                    return;
                }
                var subscriberKey = String(Chat.chat_view_subscriber);
                if (!Contacts.data[subscriberKey]) {
                    Chat.message_preloader('hide');
                    return;
                }
                if (count_obj(messages) === 0 && chat_open === null) {
                    Chat.message_preloader('hide');
                    return;
                }
                subscriberKey = String(Chat.chat_view_subscriber);
                var subscribers = Contacts.data[subscriberKey];
                var msg = '', status_h = '', ava = '', title = '', operator_send = '', no_red = '', avatar = '';
                if (chat_open === null &&
                    messages &&
                    (Array.isArray(messages) ? messages.length : count_obj(messages))) {
                    if (!Array.isArray(messages)) {
                        var messages_temp = [];
                        for (var key in messages) {
                            if (!messages[key])
                                continue;
                            messages_temp.push(messages[key]);
                        }
                        messages = messages_temp;
                    }
                    messages.sort(function (a, b) {
                        var _a, _b, _c, _d;
                        if (((_a = a.id) !== null && _a !== void 0 ? _a : 0) < ((_b = b.id) !== null && _b !== void 0 ? _b : 0))
                            return -1;
                        if (((_c = a.id) !== null && _c !== void 0 ? _c : 0) > ((_d = b.id) !== null && _d !== void 0 ? _d : 0))
                            return 1;
                        return 0;
                    });
                    for (var key2 in messages) {
                        if (!messages[key2])
                            continue;
                        var _d = messages[key2], message_route = _d.message_route, message_type = _d.message_type, system_message = _d.system_message, message_text = _d.message_text, transcription_text = _d.transcription_text, add_date = _d.add_date, from_db_with_utc = _d.from_db_with_utc, id = _d.id, ph_numb = _d.ph_numb, is_edit = _d.is_edit, is_reaction = _d.is_reaction, is_product = _d.is_product, is_order = _d.is_order, user_id = _d.user_id, message_status = _d.message_status, message_status_msg = _d.message_status_msg, transport = _d.transport, message_id = _d.message_id, insta_post_comment_id = _d.insta_post_comment_id, file_url = _d.file_url;
                        if (message_route === 'outbox') {
                            var isAi = system_message === 'ai_assistant' || user_id === -1;
                            var ownerRevokeNotice = _0_Constants.isOwnerRevokeNotice(system_message);
                            ava = isAi ? 'fa-robot' : 'fa-phone-volume';
                            title = isAi ? Chat.l('ИИ-ассистент') : Chat.l('Оператор');
                            status_h = '';
                            if (message_type === 'message-mailing') {
                                ava = 'fa-envelope';
                                title = Chat.l('Рассылка');
                            }
                            if (system_message === 'bot') {
                                ava = 'fa-user-secret';
                                title = 'Bot';
                            }
                            operator_send = '';
                            if (isAi) {
                                operator_send = " (\uD83E\uDD16 ".concat(_0_Constants.AI_ASSISTANT_NAME, ")");
                            }
                            if (user_id && !isAi && !ownerRevokeNotice) {
                                var operatorData = Chat.operators_get()[user_id];
                                if (operatorData && typeof operatorData === 'object' && 'name' in operatorData) {
                                    var operatorObj = operatorData;
                                    operator_send = " (".concat(_this.escapeHtml(String(operatorObj.name)), ")");
                                }
                                else if (operatorData) {
                                    console.warn('8_Chat_template.ts: operatorData не содержит поле name:', operatorData);
                                }
                            }
                            var forward_hidden = '';
                            forward_hidden = 'hidden';
                            msg += _this.message_outbox({
                                message_text: message_text,
                                transcription_text: transcription_text,
                                add_date: add_date,
                                from_db_with_utc: from_db_with_utc,
                                message_id: id,
                                ph_numb: ph_numb,
                                file_url: file_url,
                                isLogMessage: system_message === 'log_message' || ownerRevokeNotice,
                                avatar: ava,
                                title: title,
                                forward_hidden: forward_hidden,
                                message_status: message_status,
                                message_status_msg: message_status_msg,
                                operator_send: operator_send,
                                status_h: status_h,
                            });
                        }
                        else {
                            no_red = _this.isMessageNoRead(phone, id, add_date) ? ' no-read' : '';
                            avatar = '<i class="fa fa-user"></i>';
                            if (subscribers && subscribers.avatar === 1) {
                                avatar = "<img src=\"/wp-content/uploads/2010/10/".concat(Chat.chat_view_subscriber, ".jpg?").concat(subscribers.ava_t, "\">");
                            }
                            var inbox_id = message_id;
                            if ((subscribers === null || subscribers === void 0 ? void 0 : subscribers.transport) !== 'whatsapp') {
                                inbox_id = id;
                            }
                            var insta_post_answer_btn = '';
                            if (transport === 'instagram_post' && Number(insta_post_comment_id) > 0) {
                                insta_post_answer_btn = " <button type=\"button\" class=\"answer_btn\" style=\"font-size: 10px\" onclick=\"_7_Chat.Chat.answer_btn(this)\" data-chat_message_id=\"".concat(id, "\">").concat(Chat.l('Ответить'), "</button>");
                            }
                            var forward_hidden = '';
                            forward_hidden = 'hidden';
                            msg += _this.message_inbox({
                                message_text: message_text,
                                transcription_text: transcription_text,
                                add_date: add_date,
                                from_db_with_utc: from_db_with_utc,
                                message_id: id,
                                ph_numb: ph_numb,
                                is_edit: is_edit,
                                is_reaction: is_reaction,
                                is_product: is_product,
                                is_order: is_order,
                                file_url: file_url,
                                message_type: message_type,
                                isLogMessage: system_message === 'log_message',
                                no_red: no_red,
                                avatar: avatar,
                                forward_hidden: forward_hidden,
                                insta_post_answer_btn: insta_post_answer_btn,
                                inbox_id: inbox_id,
                            });
                        }
                    }
                    $chat_subscribe_messages.nanoScroller();
                    if (direction === 'DOWN') {
                        $('#message_height').append(msg);
                        if (Chat.chat_scroll_down) {
                            setTimeout(function () {
                                $chat_subscribe_messages.nanoScroller({ scroll: 'bottom' });
                            }, 200);
                        }
                    }
                    else if (direction === 'UP') {
                        $('#message_height').prepend(msg);
                        setTimeout(function () {
                            try {
                                if (typeof scroll === 'number') {
                                    $chat_subscribe_messages.nanoScroller({ scrollTo: $("#mess_id_".concat(scroll)) });
                                }
                                else {
                                    $chat_subscribe_messages.nanoScroller();
                                }
                            }
                            catch (error) {
                                console.log('nanoScroller|1|error=', error);
                            }
                        }, 200);
                    }
                    if (Chat.chat_open_subscriber) {
                        var subscriberKey_1 = String(Chat.chat_open_subscriber);
                        if (Contacts.no_read[subscriberKey_1] &&
                            (Contacts.work_my[subscriberKey_1] || (subscribers === null || subscribers === void 0 ? void 0 : subscribers.transport) === 'whatsapp_group')) {
                            $('.mark_as_read').removeClass('hidden');
                        }
                        else {
                            $('.mark_as_read').addClass('hidden');
                        }
                    }
                    $('.emoji, .large-emoji').removeAttr('src');
                    Chat.message_preloader('hide');
                    return;
                }
                if ((_b = (_a = Chat.chat_messages[phone]) === null || _a === void 0 ? void 0 : _a.messages) === null || _b === void 0 ? void 0 : _b.length) {
                    var messages_3 = (_c = Chat.chat_messages[phone]) === null || _c === void 0 ? void 0 : _c.messages;
                    for (var key in messages_3) {
                        if (!messages_3[key])
                            continue;
                        var _e = messages_3[key], message_text = _e.message_text, transcription_text = _e.transcription_text, add_date = _e.add_date, from_db_with_utc = _e.from_db_with_utc, id = _e.id, ph_numb = _e.ph_numb, file_url = _e.file_url, is_edit = _e.is_edit, is_reaction = _e.is_reaction, is_product = _e.is_product, is_order = _e.is_order, system_message = _e.system_message, transport = _e.transport, message_route = _e.message_route, message_type = _e.message_type, user_id = _e.user_id, message_status = _e.message_status, message_status_msg = _e.message_status_msg, insta_post_comment_id = _e.insta_post_comment_id;
                        if (message_route === 'outbox') {
                            var isAi = system_message === 'ai_assistant' ||
                                user_id === _0_Constants.AI_ASSISTANT_OPERATOR_ID;
                            var ownerRevokeNotice = _0_Constants.isOwnerRevokeNotice(system_message);
                            ava = isAi ? 'fa-robot' : 'fa-phone-volume';
                            title = isAi ? Chat.l('ИИ-ассистент') : Chat.l('Оператор');
                            status_h = '';
                            if (message_type === 'message-mailing') {
                                ava = 'fa-envelope';
                                title = Chat.l('Рассылка');
                            }
                            if (system_message === 'bot') {
                                ava = 'fa-user-secret';
                                title = 'Bot';
                            }
                            operator_send = '';
                            if (isAi) {
                                operator_send = " (\uD83E\uDD16 ".concat(_0_Constants.AI_ASSISTANT_NAME, ")");
                            }
                            var _operator = void 0;
                            if (user_id && !isAi && !ownerRevokeNotice) {
                                var operatorData = Chat.operators_get()[user_id];
                                if (operatorData && typeof operatorData === 'object' && 'name' in operatorData) {
                                    _operator = operatorData;
                                    operator_send = " (".concat(_this.escapeHtml(_operator.name), ")");
                                }
                                else if (operatorData) {
                                    console.warn('8_Chat_template.ts: operatorData не содержит поле name:', operatorData);
                                }
                            }
                            var forward_hidden = '';
                            forward_hidden = 'hidden';
                            msg += _this.message_outbox({
                                message_text: message_text,
                                transcription_text: transcription_text,
                                add_date: add_date,
                                from_db_with_utc: from_db_with_utc,
                                message_id: id,
                                ph_numb: ph_numb,
                                file_url: file_url,
                                isLogMessage: system_message === 'log_message' || ownerRevokeNotice,
                                avatar: ava,
                                title: title,
                                forward_hidden: forward_hidden,
                                message_status: message_status,
                                message_status_msg: message_status_msg,
                                operator_send: operator_send,
                                status_h: status_h,
                            });
                        }
                        else {
                            no_red = _this.isMessageNoRead(phone, id, add_date) ? ' no-read' : '';
                            avatar = '<i class="fa fa-user"></i>';
                            if (subscribers && subscribers.avatar === 1) {
                                avatar = "<img src=\"/wp-content/uploads/2010/10/".concat(Chat.chat_view_subscriber, ".jpg?").concat(subscribers.ava_t, "\">");
                            }
                            var insta_post_answer_btn = '';
                            if (transport === 'instagram_post' && Number(insta_post_comment_id) > 0) {
                                insta_post_answer_btn = " <button type=\"button\" class=\"answer_btn\" style=\"font-size: 10px\" onclick=\"_7_Chat.Chat.answer_btn(this)\" data-chat_message_id=\"".concat(id, "\">").concat(Chat.l('Ответить'), "</button>");
                            }
                            var forward_hidden = '';
                            forward_hidden = 'hidden';
                            msg += _this.message_inbox({
                                message_text: message_text,
                                transcription_text: transcription_text,
                                add_date: add_date,
                                from_db_with_utc: from_db_with_utc,
                                message_id: id,
                                ph_numb: ph_numb,
                                is_edit: is_edit,
                                is_reaction: is_reaction,
                                is_product: is_product,
                                is_order: is_order,
                                file_url: file_url,
                                message_type: message_type,
                                isLogMessage: system_message === 'log_message',
                                no_red: no_red,
                                avatar: avatar,
                                forward_hidden: forward_hidden,
                                insta_post_answer_btn: insta_post_answer_btn,
                            });
                        }
                    }
                }
                $chat_subscribe_messages.children('#message_height').html(msg);
                Chat.message_preloader('hide');
                var openPhoneForMark = Chat.openSubscriberPhone();
                if (openPhoneForMark !== null &&
                    Contacts.no_read[openPhoneForMark] &&
                    (Contacts.work_my[openPhoneForMark] || (subscribers === null || subscribers === void 0 ? void 0 : subscribers.transport) === 'whatsapp_group')) {
                    $('.mark_as_read').removeClass('hidden');
                }
                else {
                    $('.mark_as_read').addClass('hidden');
                }
                $('.emoji, .large-emoji').removeAttr('src');
                $chat_subscribe_messages.nanoScroller();
                if (isset(scroll) && scroll === 'bottom') {
                    setTimeout(function () {
                        $chat_subscribe_messages.nanoScroller({ scroll: 'bottom' });
                    }, 200);
                }
                else {
                    if (Chat.chat_scroll_down) {
                        setTimeout(function () {
                            $chat_subscribe_messages.nanoScroller({ scroll: 'bottom' });
                        }, 200);
                    }
                }
            };
            this.display_messages2 = function (data) {
                var Chat = _7_Chat.Chat;
                var Contacts = _5_Contacts.Contacts;
                var phone = data.phone, scroll = data.scroll, chat_open = data.chat_open, direction = data.direction;
                var msg = '', status_h = '', ava = '', title = '', operator_send = '', no_red = '', avatar = '';
                var $chat_subscribe_messages = $('#chat_subscribe_messages');
                var messages = !Chat.chat_messages[phone] || !Chat.chat_messages[phone].messages
                    ? []
                    : Chat.chat_messages[phone].messages;
                if (!Chat.chat_view_subscriber || !Contacts.data[Chat.chat_view_subscriber]) {
                    if (!data.disallow_hide_preloader)
                        Chat.message_preloader('hide');
                    return;
                }
                if (count_obj(messages) === 0 && chat_open === null) {
                    if (!data.disallow_hide_preloader)
                        Chat.message_preloader('hide');
                    return;
                }
                var subscribers = Contacts.data[Chat.chat_view_subscriber];
                for (var key in messages) {
                    if (!messages[key])
                        continue;
                    var _a = messages[key], message_route = _a.message_route, message_type = _a.message_type, system_message = _a.system_message, user_id = _a.user_id, message_text = _a.message_text, transcription_text = _a.transcription_text, add_date = _a.add_date, from_db_with_utc = _a.from_db_with_utc, id = _a.id, ph_numb = _a.ph_numb, transport = _a.transport, insta_post_comment_id = _a.insta_post_comment_id, message_status = _a.message_status, message_status_msg = _a.message_status_msg, file_url = _a.file_url, is_edit = _a.is_edit, is_reaction = _a.is_reaction, is_product = _a.is_product, is_order = _a.is_order;
                    if (message_route === 'outbox') {
                        var isAi = system_message === 'ai_assistant' ||
                            Number(user_id) === _0_Constants.AI_ASSISTANT_OPERATOR_ID;
                        var ownerRevokeNotice = _0_Constants.isOwnerRevokeNotice(system_message);
                        ava = isAi ? 'fa-robot' : 'fa-phone-volume';
                        title = isAi ? Chat.l('ИИ-ассистент') : Chat.l('Оператор');
                        status_h = '';
                        if (message_type === 'message-mailing') {
                            ava = 'fa-envelope';
                            title = Chat.l('Рассылка');
                        }
                        if (system_message === 'bot') {
                            ava = 'fa-user-secret';
                            title = 'Bot';
                        }
                        operator_send = '';
                        if (isAi) {
                            operator_send = " (\uD83E\uDD16 ".concat(_0_Constants.AI_ASSISTANT_NAME, ")");
                        }
                        if (user_id !== null && user_id !== undefined && !isAi && !ownerRevokeNotice) {
                            var operatorData = Chat.operators_get()[user_id];
                            if (operatorData && typeof operatorData === 'object' && 'name' in operatorData) {
                                var operatorObj = operatorData;
                                operator_send = " (".concat(_this.escapeHtml(String(operatorObj.name)), ")");
                            }
                        }
                        var forward_hidden = '';
                        forward_hidden = 'hidden';
                        msg += _this.message_outbox({
                            message_text: message_text,
                            transcription_text: transcription_text,
                            add_date: add_date,
                            from_db_with_utc: from_db_with_utc,
                            message_id: id,
                            ph_numb: ph_numb,
                            file_url: file_url,
                            isLogMessage: system_message === 'log_message' || ownerRevokeNotice,
                            avatar: ava,
                            title: title,
                            forward_hidden: forward_hidden,
                            message_status: message_status,
                            message_status_msg: message_status_msg,
                            operator_send: operator_send,
                            status_h: status_h,
                        });
                    }
                    else {
                        no_red = _this.isMessageNoRead(phone, id, add_date) ? ' no-read' : '';
                        avatar = '<i class="fa fa-user"></i>';
                        if (subscribers && subscribers.avatar === 1) {
                            avatar = "<img src=\"/wp-content/uploads/2010/10/".concat(Chat.chat_view_subscriber, ".jpg?").concat(subscribers.ava_t, "\" alt=\"\" loading=\"lazy\"/>");
                        }
                        var insta_post_answer_btn = '';
                        if (transport === 'instagram_post' && Number(insta_post_comment_id) > 0) {
                            insta_post_answer_btn = " <button type=\"button\" class=\"answer_btn\" style=\"font-size: 10px\" onclick=\"_7_Chat.Chat.answer_btn(this)\" data-chat_message_id=\"".concat(id, "\">").concat(Chat.l('Ответить'), "</button>");
                        }
                        var forward_hidden = '';
                        forward_hidden = 'hidden';
                        msg += _this.message_inbox({
                            message_text: message_text,
                            transcription_text: transcription_text,
                            add_date: add_date,
                            from_db_with_utc: from_db_with_utc,
                            message_id: id,
                            ph_numb: ph_numb || '',
                            file_url: file_url,
                            is_edit: is_edit,
                            is_reaction: is_reaction,
                            is_product: is_product,
                            is_order: is_order,
                            message_type: message_type,
                            isLogMessage: system_message === 'log_message',
                            no_red: no_red,
                            avatar: avatar,
                            forward_hidden: forward_hidden,
                            insta_post_answer_btn: insta_post_answer_btn,
                        });
                    }
                }
                var $messageHeight = $chat_subscribe_messages.children('#message_height');
                var messageHeightEl = $messageHeight[0];
                var lastRender = _this.lastMessagesRender;
                var alreadyShown = messageHeightEl !== undefined &&
                    lastRender !== null &&
                    lastRender.phone === phone &&
                    lastRender.html === msg &&
                    lastRender.first === messageHeightEl.firstChild;
                if (!alreadyShown) {
                    $messageHeight.html(msg);
                    _this.lastMessagesRender = {
                        phone: phone,
                        html: msg,
                        first: messageHeightEl !== undefined ? messageHeightEl.firstChild : null,
                    };
                }
                if (!data.disallow_hide_preloader) {
                    Chat.message_preloader('hide');
                }
                var openPhoneForMark = Chat.openSubscriberPhone();
                if (openPhoneForMark !== null &&
                    Contacts.no_read[openPhoneForMark] &&
                    (Contacts.work_my[openPhoneForMark] || (subscribers === null || subscribers === void 0 ? void 0 : subscribers.transport) === 'whatsapp_group')) {
                    $('.mark_as_read').removeClass('hidden');
                }
                else {
                    $('.mark_as_read').addClass('hidden');
                }
                $('.emoji, .large-emoji').removeAttr('src');
                $chat_subscribe_messages.nanoScroller();
                if (direction === 'UP') {
                    setTimeout(function () {
                        try {
                            if (typeof scroll === 'number') {
                                $chat_subscribe_messages.nanoScroller({ scrollTo: $("#mess_id_".concat(scroll)) });
                            }
                            else {
                                $chat_subscribe_messages.nanoScroller();
                            }
                        }
                        catch (error) {
                            console.log('nanoScroller|2|error=', error);
                        }
                    }, 200);
                    return;
                }
                if (scroll === 'bottom' || Chat.chat_scroll_down) {
                    $chat_subscribe_messages.nanoScroller({ scroll: 'bottom' });
                    setTimeout(function () {
                        $chat_subscribe_messages.nanoScroller({ scroll: 'bottom' });
                    }, 200);
                }
            };
            this.display_chat_user_name = function (data, email) {
                _this.chat_user_name.text(data);
                _this.chat_user_email.text(email);
            };
            this.display_operator_list = function (data) {
                var _a;
                if ((_a = data.operator_list) === null || _a === void 0 ? void 0 : _a.length) {
                    var option = '';
                    var AI_ASSISTANT_OPERATOR_ID = _0_Constants.AI_ASSISTANT_OPERATOR_ID;
                    option += "<option value=\"".concat(AI_ASSISTANT_OPERATOR_ID, "\">\uD83E\uDD16 ").concat(_7_Chat.Chat.l('ИИ-ассистент'), "</option>");
                    for (var key in data.operator_list) {
                        if (!data.operator_list[key] || data.operator_list[key].h === 1)
                            continue;
                        if (_7_Chat.Chat.operator_data.id === data.operator_list[key].id)
                            continue;
                        var roles = _7_Chat.Chat.l('оператор');
                        if (data.operator_list[key].roles === 'admin')
                            roles = _7_Chat.Chat.l('администратор');
                        option += "<option value=\"".concat(data.operator_list[key].id, "\">").concat(_this.escapeHtml(data.operator_list[key].name), " [").concat(roles, "]</option>");
                    }
                    $('#my_work_to_operator_operator_list').html(option);
                }
                else {
                    var AI_ASSISTANT_OPERATOR_ID = _0_Constants.AI_ASSISTANT_OPERATOR_ID;
                    $('#my_work_to_operator_operator_list').html("<option value=\"".concat(AI_ASSISTANT_OPERATOR_ID, "\">\uD83E\uDD16 ").concat(_7_Chat.Chat.l('ИИ-ассистент'), "</option>"));
                }
            };
            this.display_ai_transfer_option = function (refusal) {
                var $select = $('#my_work_to_operator_operator_list');
                var aiValue = String(_0_Constants.AI_ASSISTANT_OPERATOR_ID);
                var $option = $select.find("option[value=\"".concat(aiValue, "\"]"));
                if (!$option.length)
                    return;
                var aiWasSelected = $select.val() === aiValue;
                var label = refusal === null ? 'ИИ-ассистент' : _0_Constants.AI_TRANSFER_OPTION_LABEL[refusal];
                $option.text("\uD83E\uDD16 ".concat(_7_Chat.Chat.l(label))).prop('disabled', refusal !== null);
                if (refusal !== null && aiWasSelected) {
                    var $available = $select.find('option:not(:disabled)');
                    var firstValue = $available.length ? $available.val() : null;
                    $select.val(typeof firstValue === 'string' ? firstValue : null);
                }
            };
            this.display_noread_operator_messages = function () {
                var data = _7_Chat.Chat.chat_noread_operator_messages;
                $('#chat_operators .no_read_message_kol, .tab_operators_no_read').html('');
                var msgsCnt = count_obj(data);
                if (msgsCnt) {
                    $('.tab_operators_no_read').html(msgsCnt.toString());
                    for (var key in data) {
                        var operatorMsgs = data[key];
                        if (!operatorMsgs)
                            continue;
                        if (operatorMsgs && typeof operatorMsgs === 'object' && 'message' in operatorMsgs) {
                            var msgsObj = operatorMsgs;
                            if (msgsObj.message) {
                                $(".operator_".concat(key, " .no_read_message_kol")).html(String(msgsObj.message.length));
                            }
                        }
                    }
                }
            };
            this.display_message_no_connect = function (data) {
                if (data) {
                    $('#chat_sync_indicator').remove();
                    if (!$('#message_no_connect').hasClass('alert'))
                        $('#block_notification').prepend("<div id=\"message_no_connect\" class=\"alert alert-danger fade in\"><i class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\"></i> ".concat(_7_Chat.Chat.l('Нет соединения с сервером'), "</div>"));
                }
                else {
                    $('#message_no_connect').remove();
                }
            };
            this.audioPlayer = function (file_url) {
                return ("<div class=\"sa-audio\" data-sa-audio=\"1\">" +
                    "<audio class=\"sa-audio__el\" preload=\"metadata\" src=\"".concat(file_url, "\"></audio>") +
                    _this.mediaControlsHtml() +
                    "</div>");
            };
            this.mediaControlsHtml = function () {
                return ("<button type=\"button\" class=\"sa-media__btn\" aria-label=\"".concat(_7_Chat.Chat.l('Воспроизвести'), "\"><i class=\"fa fa-play\"></i></button>") +
                    "<input type=\"range\" class=\"sa-media__seek\" min=\"0\" max=\"0\" step=\"0.1\" value=\"0\" aria-label=\"".concat(_7_Chat.Chat.l('Перемотка'), "\" disabled>") +
                    "<span class=\"sa-media__time\">--:--</span>" +
                    _this.mediaRateButton());
            };
            this.escapeHtml = function (text) {
                return String(text)
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/"/g, '&quot;')
                    .replace(/'/g, '&#039;');
            };
            this.nl2br = function (text) {
                return text.replace(/\r\n|\n|\r/g, '<br>');
            };
            this.fileDownloadLink = function (file_url, iconClass) {
                return ("<a href=\"".concat(file_url, "\" download target=\"_blank\">") +
                    "<i class=\"fa ".concat(iconClass, "\" style=\"font-size: 24px;\"></i> ").concat(_7_Chat.Chat.l('Скачать файл'), "</a><br>"));
            };
            this.pdfOpenLink = function (file_url) {
                var safeUrl = _this.escapeHtml(file_url);
                return ("<a href=\"".concat(safeUrl, "\" class=\"open_pdf\" data-pdf_url=\"").concat(safeUrl, "\" target=\"_blank\">") +
                    "<i class=\"fa fa-file-pdf\" style=\"font-size: 24px;\"></i> ".concat(_7_Chat.Chat.l('Открыть PDF'), "</a><br>"));
            };
            this.fileByExtHtml = function (file_url, tailText) {
                var _a, _b, _c;
                var path = (_a = file_url.split('?')[0]) !== null && _a !== void 0 ? _a : file_url;
                var parts = path.split('.');
                var ext = (_c = (_b = (parts.length > 1 ? parts[parts.length - 1] : '')) === null || _b === void 0 ? void 0 : _b.toLowerCase()) !== null && _c !== void 0 ? _c : '';
                var tail = _this.escapeHtml(tailText);
                switch (ext) {
                    case 'jpeg':
                    case 'jpg':
                    case 'png':
                    case 'gif':
                        return _this.imageHtml(file_url) + tail;
                    case 'asf':
                    case 'avi':
                    case 'm1v':
                    case 'mp2':
                    case 'mp4':
                    case 'mp2v':
                    case 'mpe':
                    case 'mpeg':
                    case 'mpg':
                    case 'mpv2':
                    case 'wmv':
                        return _this.videoHtml(file_url) + tail;
                    case 'mp3':
                    case 'wav':
                    case 'opus':
                    case 'ogg':
                    case 'oga':
                    case 'flac':
                    case 'amr':
                    case 'aac':
                        return _this.audioPlayer(file_url) + tail;
                    case 'ppt':
                    case 'pptx':
                        return _this.fileDownloadLink(file_url, 'fa-file-powerpoint') + tail;
                    case 'xls':
                    case 'xlsx':
                        return _this.fileDownloadLink(file_url, 'fa-file-excel') + tail;
                    case 'doc':
                    case 'docx':
                        return _this.fileDownloadLink(file_url, 'fa-file-word') + tail;
                    case 'pdf':
                    case 'pdfx':
                        return _this.pdfOpenLink(file_url) + tail;
                    case 'zip':
                        return _this.fileDownloadLink(file_url, 'fa-file-archive') + tail;
                    case 'txt':
                        return _this.fileDownloadLink(file_url, 'fa-file-alt') + tail;
                    default:
                        return _this.fileDownloadLink(file_url, 'fa-file') + tail;
                }
            };
            this.imageHtml = function (file_url) {
                return ("<div class=\"message_image\"><div class=\"p_load\">" +
                    "<img src=\"".concat(file_url, "\" class=\"open_img imgload\" onload=\"_7_Chat.Chat.imgload(this)\" ") +
                    "data-img_url=\"".concat(file_url, "\" alt=\"\"></div>") +
                    "<a href=\"".concat(file_url, "\" class=\"downloadFile\" download target=\"_blank\" title=\"").concat(_7_Chat.Chat.l('Скачать картинку'), "\">") +
                    "<i class=\"fa fa-download\" aria-hidden=\"true\"></i></a></div>");
            };
            this.videoHtml = function (file_url) {
                return ("<div class=\"sa-video\">" +
                    "<video class=\"sa-video__el\" playsinline webkit-playsinline preload=\"metadata\">" +
                    "<source src=\"".concat(file_url, "\" /></video>") +
                    "<div class=\"sa-video__bar\">" +
                    _this.mediaControlsHtml() +
                    "<button type=\"button\" class=\"sa-video__pip\" aria-label=\"".concat(_7_Chat.Chat.l('Картинка в картинке'), "\" ") +
                    "title=\"".concat(_7_Chat.Chat.l('Картинка в картинке'), "\" hidden><i class=\"fa fa-clone\"></i></button>") +
                    "<button type=\"button\" class=\"sa-video__full\" aria-label=\"".concat(_7_Chat.Chat.l('Во весь экран'), "\" ") +
                    "title=\"".concat(_7_Chat.Chat.l('Во весь экран'), "\"><i class=\"fa fa-expand\"></i></button>") +
                    "</div>" +
                    "</div>");
            };
            this.mediaRateButton = function () {
                return ("<button type=\"button\" class=\"sa-media__rate\" aria-label=\"".concat(_7_Chat.Chat.l('Скорость воспроизведения 1×'), "\" ") +
                    "title=\"".concat(_7_Chat.Chat.l('Скорость воспроизведения'), "\">1\u00D7</button>"));
            };
            this.messageFromUserHtml = function (message) {
                if (!message.from_user)
                    return '';
                var phone = _this.escapeHtml(message.from_user);
                if (!message.from_user_name) {
                    return "<div class=\"group_from_user\">".concat(phone, "</div>");
                }
                return ("<div class=\"group_from_user\" onclick=\"_7_Chat.Chat.click_open_subscriber('".concat(phone, "');\">") +
                    "".concat(phone, " (").concat(_this.escapeHtml(message.from_user_name), ")</div>"));
            };
            this.messageQuotedHtml = function (message) {
                var quoted = message.quoted;
                if (!quoted)
                    return '';
                var fileHtml = quoted.file_url ? _this.fileByExtHtml(quoted.file_url, '') : '';
                var text = quoted.text ? _this.nl2br(_this.escapeHtml(quoted.text)) : '';
                if (text && quoted.from_phone && message.transport === 'instagram_post') {
                    text = "<div class=\"group_from_user\">".concat(_this.escapeHtml(quoted.from_phone), "</div>").concat(text);
                }
                var title = _this.escapeHtml(_7_Chat.Chat.l('Перейти к сообщению'));
                if (!fileHtml && !text) {
                    var deletionNotice = _0_Constants.isRevokeNotice(message.system_message) ||
                        _0_Constants.isOwnerRevokeNotice(message.system_message);
                    if (!deletionNotice || quoted.message_id === undefined)
                        return '';
                    text = title;
                }
                if (quoted.message_id === undefined)
                    return "<div class=\"message_quoted\">".concat(fileHtml).concat(text, "</div>");
                var phone = _this.escapeHtml(String(message.ph_numb));
                return ("<div class=\"message_quoted message_quoted_jump\" data-parent-id=\"".concat(quoted.message_id, "\" role=\"button\"") +
                    " tabindex=\"0\" title=\"".concat(title, "\" aria-label=\"").concat(title, "\" style=\"cursor: pointer\"") +
                    " onclick=\"_7_Chat.Chat.quoted_message_open('".concat(phone, "', ").concat(quoted.message_id, ")\">").concat(fileHtml).concat(text, "</div>"));
            };
            this.messageDataBodyHtml = function (message) {
                if (_0_Constants.isRevokeNotice(message.system_message))
                    return _this.revokeNoticeHtml();
                if (_0_Constants.isOwnerRevokeNotice(message.system_message))
                    return _this.ownerRevokeNoticeHtml();
                var message_type = message.message_type, file_url = message.file_url, location = message.location;
                var text = _this.escapeHtml(message.message_text);
                var textBr = _this.nl2br(text);
                var badge = function (cls, icon) {
                    return "<div class=\"".concat(cls, "\"><i class=\"fa ").concat(icon, "\"></i> ").concat(textBr, "</div>");
                };
                switch (message_type) {
                    case 'message-mailing':
                        if (!file_url)
                            return textBr;
                        return _this.fileByExtHtml(file_url, message.message_text);
                    case 'message-chat':
                        return textBr;
                    case 'message-location':
                        if (!location || location.provider !== 'google')
                            return textBr;
                        return ("<div class=\"message_location modal_maps_open\" id=\"message_location_".concat(message.id, "\" ") +
                            "data-maps_1=\"".concat(_this.escapeHtml(location.lat), "\" data-maps_2=\"").concat(_this.escapeHtml(location.lng), "\" ") +
                            "data-maps_url=\"".concat(_this.escapeHtml(location.url), "\"></div>"));
                    case 'message-location-bing':
                        if (!location || location.provider !== 'bing')
                            return textBr;
                        return ("<div class=\"message_location modal_maps_open_bing\" id=\"message_location_".concat(message.id, "\" ") +
                            "data-maps_1=\"".concat(_this.escapeHtml(location.query), "\" ") +
                            "data-maps_url=\"".concat(encodeURIComponent(location.url), "\"></div>"));
                    case 'message-image':
                        return _this.imageHtml(file_url) + text;
                    case 'message-ppt':
                    case 'message-audio':
                        return _this.audioPlayer(file_url);
                    case 'file-video':
                        return _this.videoHtml(file_url) + text;
                    case 'file-ppt':
                    case 'file-pptx':
                        return _this.fileDownloadLink(file_url, 'fa-file-powerpoint') + text;
                    case 'file-xls':
                    case 'file-xlsx':
                        return _this.fileDownloadLink(file_url, 'fa-file-excel') + text;
                    case 'file-doc':
                    case 'file-docx':
                        return _this.fileDownloadLink(file_url, 'fa-file-word') + text;
                    case 'file-pdf':
                        return _this.pdfOpenLink(file_url) + text;
                    case 'file-zip':
                        return _this.fileDownloadLink(file_url, 'fa-file-archive') + text;
                    case 'file-xml':
                        return _this.fileDownloadLink(file_url, 'fa-file') + text;
                    case 'file-text':
                        return _this.fileDownloadLink(file_url, 'fa-file-alt') + text;
                    case 'message-undefined':
                        return file_url ? _this.fileByExtHtml(file_url, message.message_text) : textBr;
                    case 'message-live-location':
                        return "<div class=\"message_live_location\"><i class=\"fa fa-map-marker\"></i> <span class=\"live-badge\">LIVE</span> ".concat(textBr, "</div>");
                    case 'message-product':
                        return badge('message_product', 'fa-shopping-cart');
                    case 'message-order':
                        return badge('message_order', 'fa-file-alt');
                    case 'message-list':
                    case 'message-list-response':
                        return badge('message_list', 'fa-list');
                    case 'message-buttons':
                    case 'message-buttons-response':
                        return badge('message_buttons', 'fa-th-large');
                    case 'message-interactive':
                    case 'message-interactive-response':
                        return badge('message_interactive', 'fa-hand-pointer');
                    case 'message-poll':
                        return badge('message_poll', 'fa-chart-bar');
                    case 'message-contact':
                    case 'message-vcard':
                        if (!message.contact)
                            return badge('message_contact', 'fa-address-card');
                        return _this.contactCardHtml(message.contact);
                    case 'message-album':
                        return badge('message_album', 'fa-images');
                    default:
                        return text;
                }
            };
            this.revokeNoticeHtml = function () {
                return "<div class=\"message_revoke_notice\" style=\"font-style: italic; opacity: 0.8;\">" +
                    "<i class=\"fas fa-trash-alt\"></i> ".concat(_this.escapeHtml(_7_Chat.Chat.l('Пользователь удалил это сообщение')), "</div>");
            };
            this.ownerRevokeNoticeHtml = function () {
                return "<div class=\"message_owner_revoke_notice\" style=\"font-style: italic; opacity: 0.8;\">" +
                    "<i class=\"fas fa-trash-alt\"></i> ".concat(_this.escapeHtml(_7_Chat.Chat.l('Сообщение удалено с телефона')), "</div>");
            };
            this.contactCardHtml = function (contact) {
                var avatar = contact.photo
                    ? "<img class=\"message_contact_photo\" src=\"".concat(_this.escapeHtml(contact.photo), "\" alt=\"\" ") +
                        "style=\"width:44px;height:44px;border-radius:50%;object-fit:cover;display:block;\">"
                    : "<i class=\"fa fa-address-card\" style=\"font-size:36px;width:44px;text-align:center;opacity:0.55;\"></i>";
                var rows = [];
                if (contact.name) {
                    rows.push("<div class=\"message_contact_name\" style=\"font-weight:600;\">".concat(_this.escapeHtml(contact.name), "</div>"));
                }
                if (contact.business_name) {
                    rows.push("<div class=\"message_contact_business\">".concat(_this.escapeHtml(contact.business_name), "</div>"));
                }
                for (var _i = 0, _a = contact.phones; _i < _a.length; _i++) {
                    var phone = _a[_i];
                    rows.push("<div class=\"message_contact_phone\">".concat(_this.escapeHtml(phone), "</div>"));
                }
                for (var _b = 0, _c = contact.extra; _b < _c.length; _b++) {
                    var row = _c[_b];
                    rows.push("<div class=\"message_contact_extra\" style=\"opacity:0.7;\">".concat(_this.escapeHtml(row), "</div>"));
                }
                return ("<div class=\"message_contact\" style=\"display:flex;align-items:center;gap:10px;\">" +
                    "<div class=\"message_contact_avatar\" style=\"flex:0 0 auto;\">".concat(avatar, "</div>") +
                    "<div class=\"message_contact_body\" style=\"min-width:0;word-break:break-word;\">" +
                    "".concat(rows.join(''), "</div>") +
                    "</div>");
            };
            this.messageDataToHtml = function (message) {
                return (_this.messageFromUserHtml(message) +
                    _this.messageQuotedHtml(message) +
                    _this.messageDataBodyHtml(message));
            };
            this.parseMessagesGetV2 = function (raw) {
                if (!isWireObject(raw)) {
                    console.error('parseMessagesGetV2|ответ не объект|raw=', raw);
                    return null;
                }
                var resultRaw = wireField(raw, 'result');
                var result = typeof resultRaw === 'number' || typeof resultRaw === 'string' ? Number(resultRaw) : NaN;
                if (result === 1) {
                    var msg = wireField(raw, 'msg');
                    if (typeof msg !== 'string') {
                        console.error('parseMessagesGetV2|отказ без msg|raw=', raw);
                        return null;
                    }
                    return { result: 1, msg: msg };
                }
                if (result !== 0) {
                    console.error('parseMessagesGetV2|неизвестный result|raw=', raw);
                    return null;
                }
                var phone = wireField(raw, 'phone');
                var messageIdMax = wireField(raw, 'message_id_max');
                var messageIdMin = wireField(raw, 'message_id_min');
                var loadHistoryChek = wireField(raw, 'load_history_chek');
                var noread = wireField(raw, 'noread');
                var messagesRaw = wireField(raw, 'messages');
                var pageFull = wireField(raw, 'page_full');
                if (typeof phone !== 'string' ||
                    !isBoundaryOrNull(messageIdMax) ||
                    !isBoundaryOrNull(messageIdMin) ||
                    wireField(raw, 'mongo_message_id_max') !== null ||
                    wireField(raw, 'mongo_message_id_min') !== null ||
                    (loadHistoryChek !== 1 && loadHistoryChek !== null) ||
                    !isNoReadV2(noread) ||
                    !Array.isArray(messagesRaw) ||
                    (pageFull !== undefined && typeof pageFull !== 'boolean')) {
                    console.error('parseMessagesGetV2|конверт не той формы|raw=', raw);
                    return null;
                }
                var items = messagesRaw;
                var messages = [];
                for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
                    var item = items_1[_i];
                    if (!isChatMessageDataV2(item)) {
                        console.error('parseMessagesGetV2|сообщение не той формы|phone=', phone, '|item=', item);
                        continue;
                    }
                    messages.push(item);
                }
                return __assign({ result: 0, phone: phone, messages: messages, message_id_max: messageIdMax, message_id_min: messageIdMin, mongo_message_id_max: null, mongo_message_id_min: null, load_history_chek: loadHistoryChek, noread: noread }, (typeof pageFull === 'boolean' ? { page_full: pageFull } : {}));
            };
            this.messageFromDataV2 = function (data) {
                var addDate = data.add_date, rest = __rest(data, ["add_date"]);
                return __assign(__assign(__assign({}, rest), (addDate === null ? {} : { add_date: addDate })), { message_text: _this.messageDataToHtml(data) });
            };
            this.messageFile = function (_a) {
                var _b, _c;
                var file_url = _a.file_url, _d = _a.addHref, addHref = _d === void 0 ? true : _d;
                var path = (_b = file_url.split('?')[0]) !== null && _b !== void 0 ? _b : file_url;
                var parts = path.split('/');
                var filename = (_c = parts[parts.length - 1]) !== null && _c !== void 0 ? _c : '';
                var extensionMatch = filename.match(/\.([a-zA-Z0-9]+)$/);
                var ext = extensionMatch ? extensionMatch[1] : null;
                console.log('messageFile|', { path: path, parts: parts, filename: filename, ext: ext });
                var html = '';
                var url = null;
                switch (ext || 'none') {
                    case 'jpeg':
                    case 'jpg':
                    case 'png':
                    case 'gif':
                    case 'webp':
                        html =
                            "<div class=\"message_image\"><div class=\"p_load\">" +
                                "<img src=\"".concat(file_url, "\" class=\"imgload\" onload=\"_7_Chat.Chat.imgload(this)\" data-img_url=\"").concat(file_url, "\" alt=\"\"></div></div>");
                        addHref = false;
                        break;
                    case 'mp3':
                    case 'wav':
                    case 'opus':
                    case 'ogg':
                    case 'flac':
                    case 'amr':
                    case 'aac':
                    case 'oga':
                    case 'm4a':
                        html = _this.audioPlayer(file_url);
                        addHref = false;
                        break;
                    case 'mp4':
                    case 'avi':
                    case 'mpeg':
                    case 'mpg':
                    case 'wmv':
                    case '3gpp':
                        html = _this.videoHtml(file_url);
                        addHref = false;
                        break;
                }
                if (addHref) {
                    html +=
                        "<a href=\"".concat(url || file_url, "\" download=\"\" target=\"_blank\">") +
                            "<i class=\"fa fa-file\" style=\"font-size:18px;\"></i> ".concat(_7_Chat.Chat.l('Скачать файл'), "</a><br>");
                }
                return { html: html, url: url };
            };
        }
        return Chat_templateCls;
    }());
    _8_Chat_template.Chat_template = new Chat_templateCls();
})(_8_Chat_template || (_8_Chat_template = {}));


"use strict";
var _9_Chat_onesignal;
(function (_9_Chat_onesignal) {
    function isOneSignalLoaded(api) {
        return typeof Reflect.get(api, 'getUserId') === 'function';
    }
    _9_Chat_onesignal.Chat_onesignal = {
        oneSignalUserID: false,
        oneSignalUserIDType: null,
        is_send: false,
        timer: null,
        del_push: null,
        init: function (del_push) {
            if (del_push !== undefined)
                this.del_push = Boolean(del_push);
            if (typeof Android === 'object' && this.del_push !== null) {
                setTimeout(function () {
                    _7_Chat.Chat.oneSignalUserID = Android.getPushUserId();
                    _7_Chat.Chat.oneSignalUserIDType = 'android';
                    _9_Chat_onesignal.Chat_onesignal.oneSignalUserID = Android.getPushUserId();
                    _9_Chat_onesignal.Chat_onesignal.oneSignalUserIDType = 'android';
                    jQuery.ajax({
                        type: 'POST',
                        url: '/ajax.php',
                        dataType: 'json',
                        data: {
                            action: 'push_delete',
                            oneSignalUserID: _9_Chat_onesignal.Chat_onesignal.oneSignalUserID,
                        },
                        success: function (_data) {
                        },
                        error: function (xhr) {
                            console.error(xhr);
                        },
                    });
                }, 1000);
            }
            _9_Chat_onesignal.Chat_onesignal.timer = setInterval(function () {
                _9_Chat_onesignal.Chat_onesignal.send();
            }, 1000);
            $(document).ready(function () {
                var oneSignalQueue = [];
                var windowWithOneSignal = window;
                windowWithOneSignal.oneSignal = window.OneSignal || oneSignalQueue;
                var oneSignal = windowWithOneSignal.oneSignal;
                if (typeof oneSignal !== 'undefined' && localStorage.getItem('oneSignal_off') === null) {
                    oneSignal.push([
                        'addListenerForNotificationOpened',
                        function (data) {
                            _7_Chat.Chat.refresh_chat(_7_Chat.Chat.navbarPageId + '#phone=' + data.data.ph_numb_from);
                            location.reload();
                        },
                    ]);
                    windowWithOneSignal.checkIsSetUserId_load = false;
                    var check_counter_1 = 0;
                    var checkIsSetUserId_1 = function () {
                        oneSignal.push([
                            'getNotificationPermission',
                            function (permission) {
                                console.log(permission);
                                windowWithOneSignal.checkIsSetUserId_load = true;
                                if (permission === 'denied' || permission === 'default') {
                                    return;
                                }
                                if (!isOneSignalLoaded(oneSignal)) {
                                    console.error('oneSignal|getUserId|SDK ещё не загружен');
                                    return;
                                }
                                oneSignal.getUserId(function (userId) {
                                    if (userId === null) {
                                        check_counter_1++;
                                    }
                                    if (check_counter_1 > 4) {
                                        localStorage.setItem('oneSignal_off', '1');
                                        return;
                                    }
                                    console.log('oneSignal User ID:');
                                    console.log(userId);
                                    if (typeof userId !== 'string') {
                                        setTimeout(function () {
                                            checkIsSetUserId_1();
                                        }, 1000);
                                        return;
                                    }
                                    _7_Chat.Chat.oneSignalUserID = userId;
                                    _7_Chat.Chat.oneSignalUserIDType = 'browser';
                                    _9_Chat_onesignal.Chat_onesignal.oneSignalUserID = userId;
                                    _9_Chat_onesignal.Chat_onesignal.oneSignalUserIDType = 'browser';
                                    _9_Chat_onesignal.Chat_onesignal.is_send = true;
                                    if (_9_Chat_onesignal.Chat_onesignal.del_push !== null) {
                                        jQuery.ajax({
                                            type: 'POST',
                                            url: '/ajax.php',
                                            dataType: 'json',
                                            data: {
                                                action: 'push_delete',
                                                oneSignalUserID: _9_Chat_onesignal.Chat_onesignal.oneSignalUserID,
                                            },
                                            success: function (_data) {
                                            },
                                            error: function (xhr) {
                                                console.error(xhr);
                                            },
                                        });
                                    }
                                });
                            },
                        ]);
                    };
                    checkIsSetUserId_1();
                }
            });
        },
        send: function () {
            if (_9_Chat_onesignal.Chat_onesignal.is_send) {
                if (this.del_push !== null) {
                    jQuery.ajax({
                        type: 'POST',
                        url: '/ajax.php',
                        dataType: 'json',
                        data: {
                            action: 'push_delete',
                            oneSignalUserID: _9_Chat_onesignal.Chat_onesignal.oneSignalUserID,
                        },
                        success: function (_data) {
                        },
                        error: function (xhr) {
                            console.error(xhr);
                        },
                    });
                    _9_Chat_onesignal.Chat_onesignal.is_send = false;
                    return;
                }
                if (!_7_Chat.Chat.operator_data.hasOwnProperty('id'))
                    return;
                if (!_7_Chat.Chat.operator_data.hasOwnProperty('central_user_id'))
                    return;
                _10_Chat_WebSocket.Chat_WebSocket.send({
                    nodejs: 1,
                    command: 'set_app_push_data',
                    push_user_id: this.oneSignalUserID,
                    type_push: this.oneSignalUserIDType,
                    push_token: null,
                    operator_id: _7_Chat.Chat.operator_data.id,
                    central_user_id: _7_Chat.Chat.operator_data.central_user_id,
                });
                _9_Chat_onesignal.Chat_onesignal.is_send = false;
            }
        },
    };
})(_9_Chat_onesignal || (_9_Chat_onesignal = {}));


"use strict";
var _10_Chat_WebSocket;
(function (_10_Chat_WebSocket) {
    function isWireRecord(value) {
        return typeof value === 'object' && value !== null && !Array.isArray(value);
    }
    var PLANNED_RECONNECT_RECHECK_MS = 1000;
    var PLANNED_RECONNECT_MAX_WAIT_MS = 5 * 60 * 1000;
    var OPENED_ELSEWHERE_REASON = 'opened_elsewhere';
    function isConnectPush(value) {
        if (!isWireRecord(value))
            return false;
        return (typeof value['epoch'] === 'string' &&
            typeof value['seq'] === 'number' &&
            typeof value['connection_id'] === 'string' &&
            typeof value['resync'] === 'boolean');
    }
    function isWireId(value) {
        return typeof value === 'string' || typeof value === 'number';
    }
    function isOptionalWireText(value) {
        return value === undefined || typeof value === 'string';
    }
    function isUpdateMessageEventData(value) {
        var messageData = value['message_data'];
        if (!isWireRecord(messageData))
            return false;
        return (isWireId(messageData['phone']) &&
            isWireId(messageData['message_id']) &&
            isOptionalWireText(messageData['message_text']) &&
            isOptionalWireText(messageData['transcription_text']));
    }
    function isUpdateMessageStatusData(value) {
        var messageData = value['message_data'];
        if (!isWireRecord(messageData))
            return false;
        return (isWireId(messageData['ph_numb']) &&
            isWireId(messageData['status']) &&
            isOptionalWireText(messageData['message_status_msg']));
    }
    function isUpdateStatusMessageIdData(value) {
        var messageData = value['message_data'];
        if (!isWireRecord(messageData))
            return false;
        return (isWireId(messageData['phone']) &&
            isWireId(messageData['message_id']) &&
            isWireId(messageData['status']) &&
            isOptionalWireText(messageData['message_status_msg']));
    }
    function isServerResponse(value) {
        return (isWireRecord(value) &&
            typeof value['result'] === 'number' &&
            isOptionalWireText(value['result_description']) &&
            isOptionalWireText(value['msg']));
    }
    function isNoReadOperatorMessagesMap(value) {
        if (typeof value !== 'object' || value === null || Array.isArray(value))
            return false;
        for (var _i = 0, _a = Object.keys(value); _i < _a.length; _i++) {
            var key = _a[_i];
            var bucket = Reflect.get(value, key);
            if (typeof bucket !== 'object' || bucket === null)
                return false;
            var list = Reflect.get(bucket, 'message');
            if (!Array.isArray(list))
                return false;
            for (var index = 0; index < list.length; index++) {
                var notice = list[index];
                if (typeof notice !== 'object' || notice === null)
                    return false;
                var messageId = Reflect.get(notice, 'message_id');
                if (messageId !== undefined && messageId !== null && !isWireId(messageId))
                    return false;
            }
        }
        return true;
    }
    function isCategoryNoreadMap(value) {
        if (typeof value !== 'object' || value === null)
            return false;
        for (var _i = 0, _a = Object.keys(value); _i < _a.length; _i++) {
            var key = _a[_i];
            var item = Reflect.get(value, key);
            if (typeof item !== 'object' || item === null)
                return false;
            var id = Reflect.get(item, 'id');
            var name_1 = Reflect.get(item, 'name');
            var noreadCount = Reflect.get(item, 'noread_count');
            var userCountMs = Reflect.get(item, 'user_count_ms');
            if (typeof id !== 'number' && typeof id !== 'string')
                return false;
            if (name_1 !== undefined && typeof name_1 !== 'string')
                return false;
            if (noreadCount !== undefined && typeof noreadCount !== 'number')
                return false;
            if (userCountMs !== undefined && typeof userCountMs !== 'number')
                return false;
        }
        return true;
    }
    var CHANNEL_SLOT_KEY_SET = new Set([
        'whatsapp',
        'whatsapp_group',
        'whatsapp_biz',
        'instagram',
        'instagram_post',
        'telegram',
        'vk',
        'tg',
        'max',
        'max_group',
        'max_channel',
    ]);
    var isChannelSlotKey = function (value) {
        if (typeof value !== 'string')
            return false;
        var found = false;
        CHANNEL_SLOT_KEY_SET.forEach(function (key) {
            if (key === value)
                found = true;
        });
        return found;
    };
    _10_Chat_WebSocket.buildWithdrawChatButtonHtml = function (phone, operatorName) {
        return (' <button type="button" class="btn btn-warning btn-xs withdraw_chat_from_operator" ' +
            'data-phone="' +
            phone +
            '" ' +
            'data-operator-name="' +
            operatorName +
            '" ' +
            'style="margin-left: 10px;">' +
            '<i class="fa fa-hand-paper"></i> ' +
            _7_Chat.Chat.l('Изъять чат') +
            '</button>');
    };
    var Chat_WebSocketCls = (function () {
        function Chat_WebSocketCls() {
            var _this = this;
            this._aiStreamBuffers = {};
            this._aiStreamState = {};
            this._aiStreamWaitEndsAt = {};
            this._aiStreamWaitIntervals = {};
            this._pendingStatusByMessageId = {};
            this._pendingStatusTimers = {};
            this.timer_close = null;
            this.push_epoch = null;
            this.push_conn = null;
            this.push_seq_last = 0;
            this.socket = null;
            this.hostname = null;
            this.ping_time = null;
            this.ping_sent_time = null;
            this.connect_timer = null;
            this.connect_verifier_time = null;
            this.auth_verification_error = false;
            this.reconnect_init = false;
            this.connect_verifier_check = false;
            this.no_increment = false;
            this.incrementTasksAjax = {};
            this.socketHosts = [];
            this.socketHostCnt = 0;
            this._incrementTasksAjaxCnt = 0;
            this._connectTimeout = null;
            this.addIncrementTasksAjax = function (data) {
                ++_10_Chat_WebSocket.Chat_WebSocket._incrementTasksAjaxCnt;
                _10_Chat_WebSocket.Chat_WebSocket.incrementTasksAjax[_10_Chat_WebSocket.Chat_WebSocket._incrementTasksAjaxCnt] = data;
            };
            this.incrementTasksAjaxNode = {};
            this._incrementTasksAjaxNodeCnt = 0;
            this.addIncrementTasksAjaxNode = function (data) {
                ++_10_Chat_WebSocket.Chat_WebSocket._incrementTasksAjaxNodeCnt;
                _10_Chat_WebSocket.Chat_WebSocket.incrementTasksAjaxNode[_10_Chat_WebSocket.Chat_WebSocket._incrementTasksAjaxNodeCnt] = data;
            };
            this._getSocketHost = function () {
                if (_10_Chat_WebSocket.Chat_WebSocket.hostname === 'sendapi.net') {
                    _this.socketHosts = ['app.sendapi.net', 'sendapi.net'];
                }
                return _this.socketHosts[_this.socketHostCnt] || _10_Chat_WebSocket.Chat_WebSocket.hostname;
            };
            this.ajaxError = function (data) {
                var res;
                try {
                    if (typeof data.result === 'string') {
                        var parsed = JSON.parse(data.result);
                        var description = isWireRecord(parsed) ? parsed['result_description'] : undefined;
                        res = {
                            result_description: typeof description === 'string' ? description : 'Invalid result type',
                        };
                    }
                    else {
                        res = { result_description: 'Invalid result type' };
                    }
                }
                catch (error) {
                    console.error('ajaxError|JSON|parse|error=', error);
                    console.error('ajaxError|JSON|parse|data.result=', data.result);
                    console.error('ajaxError|-----');
                    res = {
                        result_description: 'Undefined error',
                    };
                }
                swal({
                    type: 'error',
                    title: 'Ошибка!',
                    html: res.result_description,
                });
            };
            this.connect_verifier = function () {
                var Chat = _7_Chat.Chat;
                var Chat_template = _8_Chat_template.Chat_template;
                setInterval(function () {
                    if (_10_Chat_WebSocket.Chat_WebSocket.connect_verifier_check)
                        return;
                    _10_Chat_WebSocket.Chat_WebSocket.connect_verifier_check = true;
                    if (Chat.auth_invalid) {
                        _10_Chat_WebSocket.Chat_WebSocket.connect_verifier_time = null;
                        Chat_template.display_message_no_connect(false);
                    }
                    else if (Chat.chat_loader['websocket']) {
                        _10_Chat_WebSocket.Chat_WebSocket.connect_verifier_time = null;
                        Chat_template.display_message_no_connect(false);
                    }
                    else {
                        if (_10_Chat_WebSocket.Chat_WebSocket.connect_verifier_time === null) {
                            _10_Chat_WebSocket.Chat_WebSocket.connect_verifier_time = Math.floor(Date.now() / 1000);
                        }
                        else {
                            var time_new = Math.floor(Date.now() / 1000);
                            if (time_new - _10_Chat_WebSocket.Chat_WebSocket.connect_verifier_time > 10)
                                Chat_template.display_message_no_connect(true);
                        }
                    }
                    _10_Chat_WebSocket.Chat_WebSocket.connect_verifier_check = false;
                }, 1000);
            };
            this.send = function (obj) {
                if (_7_Chat.Chat.chat_loader['websocket'] !== true) {
                    return;
                }
                if (!_10_Chat_WebSocket.Chat_WebSocket.socket) {
                    console.error('send|!Chat_WebSocket.socket');
                    return;
                }
                if (_10_Chat_WebSocket.Chat_WebSocket.socket.emit) {
                    _10_Chat_WebSocket.Chat_WebSocket.socket.emit('message', obj);
                    return;
                }
                if (!_10_Chat_WebSocket.Chat_WebSocket.socket.readyState) {
                    setTimeout(function () {
                        _10_Chat_WebSocket.Chat_WebSocket.send(obj);
                    }, 1000);
                }
                else if (_10_Chat_WebSocket.Chat_WebSocket.socket.send) {
                    _10_Chat_WebSocket.Chat_WebSocket.socket.send(JSON.stringify(obj));
                }
            };
            this.ensureAiStreamPreviewVisible = function (phone) {
                var _a;
                var Chat = _7_Chat.Chat;
                var currentPhone = typeof Chat.chat_view_subscriber === 'string' ||
                    typeof Chat.chat_view_subscriber === 'number'
                    ? String(Chat.chat_view_subscriber)
                    : '';
                var phoneKey = String(phone);
                if (!currentPhone || currentPhone !== phoneKey) {
                    return;
                }
                var previewId = "ai_stream_preview_".concat(phoneKey);
                var $wrap = $('#chat_subscribe_messages');
                if (!$wrap.length)
                    return;
                var updateNanoScroller = function () {
                    var nativeScrollBottom = function () {
                        var $scrollEl = (function () {
                            var $messageHeight = $wrap.find('#message_height');
                            if ($messageHeight.length)
                                return $messageHeight;
                            var $nanoContent = $wrap.find('.nano-content');
                            if ($nanoContent.length)
                                return $nanoContent;
                            return $wrap;
                        })();
                        var el = $scrollEl[0];
                        if (!el)
                            return;
                        $scrollEl.scrollTop(el.scrollHeight);
                    };
                    try {
                        $wrap.nanoScroller();
                        $wrap.nanoScroller({ scroll: 'bottom' });
                    }
                    catch (error) {
                        console.error('ensureAiStreamPreviewVisible|nanoScroller|error', error);
                    }
                    finally {
                        nativeScrollBottom();
                    }
                };
                var $wrapContent = $wrap.find('.nano-content');
                var $messageHeight = $wrap.find('#message_height');
                var $target = $messageHeight.length
                    ? $messageHeight
                    : $wrapContent.length
                        ? $wrapContent
                        : $wrap;
                var normalizeText = function (text) {
                    return String(text)
                        .replace(/<br\s*\/?\s*>/gi, '\n')
                        .replace(/<[^>]+>/g, '')
                        .replace(/\s+/g, ' ')
                        .trim();
                };
                var ensurePreview = function () {
                    var $preview = $('#' + previewId);
                    if ($preview.length) {
                        if ($target.length && !$preview.parent().is($target)) {
                            $target.append($preview);
                        }
                        return $preview;
                    }
                    var html = "<div class=\"direct-chat-msg message_outbox right ai_stream_preview\" id=\"".concat(previewId, "\">") +
                        "<div class=\"direct-chat-avatar\" title=\"".concat(Chat.l('ИИ'), "\"><i class=\"fa fa-user-secret\"></i></div>") +
                        "<div class=\"direct-chat-text\">" +
                        "<span class=\"ai_stream_loader\"><i class=\"fa fa-spinner fa-spin\"></i></span>" +
                        "<span class=\"ai_stream_text\"></span>" +
                        "<small class=\"direct-chat-timestamp message_time\">".concat(Chat.l('ИИ печатает…'), "</small>") +
                        "</div>" +
                        "</div>";
                    $target.append(html);
                    $preview = $('#' + previewId);
                    return $preview;
                };
                var removePreview = function () {
                    $('#' + previewId).remove();
                };
                var setPreviewLoading = function (isLoading) {
                    var $preview = ensurePreview();
                    if (isLoading) {
                        $preview.find('.ai_stream_loader').removeClass('hidden');
                    }
                    else {
                        $preview.find('.ai_stream_loader').addClass('hidden');
                    }
                };
                var setPreviewText = function (text) {
                    var $preview = ensurePreview();
                    var safe = $('<div>').text(text).html().replace(/\n/g, '<br>');
                    $preview.find('.ai_stream_text').html(safe);
                    setPreviewLoading((text || '').trim().length === 0);
                };
                var setPreviewStatus = function (statusText) {
                    var $preview = ensurePreview();
                    $preview.find('.direct-chat-timestamp.message_time').text(statusText);
                };
                var bufferText = _this._aiStreamBuffers[phoneKey];
                var doneState = _this._aiStreamState[phoneKey];
                if (doneState && doneState.lastText) {
                    var messages = (_a = _7_Chat.Chat.chat_messages[phoneKey]) === null || _a === void 0 ? void 0 : _a.messages;
                    var needle = normalizeText(doneState.lastText);
                    if (needle && messages && Array.isArray(messages) && messages.length) {
                        var AI_ASSISTANT_OPERATOR_ID = _0_Constants.AI_ASSISTANT_OPERATOR_ID;
                        for (var i = messages.length - 1, seen = 0; i >= 0 && seen < 10; --i, ++seen) {
                            var m = messages[i];
                            if (!m)
                                continue;
                            if (m.message_route !== 'outbox')
                                continue;
                            var isAi = m.system_message === 'ai_assistant' || m.user_id === AI_ASSISTANT_OPERATOR_ID;
                            if (!isAi)
                                continue;
                            var candidate = normalizeText(m.message_text || '');
                            if (candidate && (candidate === needle || candidate.includes(needle))) {
                                removePreview();
                                delete _this._aiStreamState[phoneKey];
                                return;
                            }
                        }
                    }
                }
                if (typeof bufferText === 'string') {
                    ensurePreview();
                    setPreviewText(bufferText);
                    setPreviewStatus(Chat.l('ИИ печатает…'));
                    setTimeout(updateNanoScroller, 0);
                    return;
                }
                if (doneState) {
                    ensurePreview();
                    setPreviewLoading(false);
                    setPreviewText(doneState.lastText || '');
                    setPreviewStatus(Chat.l('Отправка…'));
                    setTimeout(updateNanoScroller, 0);
                    return;
                }
                removePreview();
            };
            this._clearPendingMessageStatusTimer = function (messageId) {
                var timer = _this._pendingStatusTimers[messageId];
                if (!timer) {
                    return;
                }
                clearTimeout(timer);
                delete _this._pendingStatusTimers[messageId];
            };
            this._escapeStatusMessage = function (message) {
                return message
                    .replace(/&/g, '&amp;')
                    .replace(/"/g, '&quot;')
                    .replace(/'/g, '&#39;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;');
            };
            this._applyMessageStatusToDom = function (_a) {
                var messageId = _a.messageId, status = _a.status, messageStatusMsg = _a.messageStatusMsg;
                var $statusEl = $("div#mess_id_".concat(messageId, " .message_status"));
                if (!$statusEl.length) {
                    return false;
                }
                $statusEl.each(function (_index, element) {
                    for (var _i = 0, _a = Array.from(element.classList); _i < _a.length; _i++) {
                        var name_2 = _a[_i];
                        if (name_2.startsWith('status_'))
                            element.classList.remove(name_2);
                    }
                });
                $statusEl.addClass("status_".concat(status));
                if (!messageStatusMsg) {
                    return true;
                }
                var escapedMsg = _this._escapeStatusMessage(messageStatusMsg);
                var $msg = $("div#mess_id_".concat(messageId));
                if (!$msg.find('.message_error_icon').length) {
                    var errorHtml = "<span class=\"message_error_icon\" data-status-msg=\"".concat(escapedMsg, "\" style=\"color:#d9534f;cursor:pointer;margin-left:4px;font-size:14px;\" title=\"").concat(_7_Chat.Chat.l('Ошибка доставки'), "\"><i class=\"fa fa-question-circle\"></i></span>");
                    $(errorHtml).insertAfter($statusEl);
                }
                else {
                    $msg.find('.message_error_icon').attr('data-status-msg', escapedMsg);
                }
                return true;
            };
            this._schedulePendingMessageStatusApply = function (messageId) {
                if (_this._pendingStatusTimers[messageId]) {
                    return;
                }
                var attempt = 0;
                var tryApply = function () {
                    var pending = _this._pendingStatusByMessageId[messageId];
                    if (!pending) {
                        _this._clearPendingMessageStatusTimer(messageId);
                        return;
                    }
                    var currentPhone = typeof _7_Chat.Chat.chat_view_subscriber === 'string' ||
                        typeof _7_Chat.Chat.chat_view_subscriber === 'number'
                        ? String(_7_Chat.Chat.chat_view_subscriber)
                        : '';
                    if (pending.phone && currentPhone !== String(pending.phone)) {
                        _this._clearPendingMessageStatusTimer(messageId);
                        return;
                    }
                    if (_this._applyMessageStatusToDom({
                        messageId: messageId,
                        status: pending.status,
                        messageStatusMsg: pending.message_status_msg,
                    })) {
                        delete _this._pendingStatusByMessageId[messageId];
                        _this._clearPendingMessageStatusTimer(messageId);
                        return;
                    }
                    attempt += 1;
                    if (attempt >= 20) {
                        _this._clearPendingMessageStatusTimer(messageId);
                        return;
                    }
                    _this._pendingStatusTimers[messageId] = setTimeout(tryApply, 100);
                };
                _this._pendingStatusTimers[messageId] = setTimeout(tryApply, 100);
            };
            this._setPendingMessageStatus = function (_a) {
                var messageId = _a.messageId, status = _a.status, phone = _a.phone, messageStatusMsg = _a.messageStatusMsg;
                var key = String(messageId);
                _this._pendingStatusByMessageId[key] = {
                    status: status,
                    phone: phone,
                    message_status_msg: messageStatusMsg,
                };
                _this._schedulePendingMessageStatusApply(key);
            };
            this.applyPendingMessageStatuses = function (phone) {
                var _a;
                var Chat = _7_Chat.Chat;
                var phoneKey = String(phone);
                if (String(Chat.chat_view_subscriber) !== phoneKey) {
                    return;
                }
                var messages = (_a = Chat.chat_messages[phoneKey]) === null || _a === void 0 ? void 0 : _a.messages;
                if (!messages || !Array.isArray(messages)) {
                    return;
                }
                var toRemove = [];
                var _loop_1 = function (messageId) {
                    var pending = _this._pendingStatusByMessageId[messageId];
                    if (!pending) {
                        return "continue";
                    }
                    var idx = messages.findIndex(function (m) { return m && String(m.id) === String(messageId); });
                    if (idx < 0)
                        return "continue";
                    var pendingMessage = messages[idx];
                    if (!pendingMessage)
                        return "continue";
                    pendingMessage.message_status = _6_1_Chat_Store.toMessageStatus(pending.status);
                    if (pending.message_status_msg) {
                        pendingMessage.message_status_msg = pending.message_status_msg;
                    }
                    if (_this._applyMessageStatusToDom({
                        messageId: messageId,
                        status: pending.status,
                        messageStatusMsg: pending.message_status_msg,
                    })) {
                        toRemove.push(messageId);
                        _this._clearPendingMessageStatusTimer(messageId);
                    }
                    else {
                        _this._schedulePendingMessageStatusApply(messageId);
                    }
                };
                for (var messageId in _this._pendingStatusByMessageId) {
                    _loop_1(messageId);
                }
                toRemove.forEach(function (id) {
                    delete _this._pendingStatusByMessageId[id];
                });
            };
            this.applyPendingStatusesToBatch = function (phone, messages) {
                for (var _i = 0, messages_1 = messages; _i < messages_1.length; _i++) {
                    var message = messages_1[_i];
                    var key = String(message.id);
                    var pending = _this._pendingStatusByMessageId[key];
                    if (!pending)
                        continue;
                    if (pending.phone !== undefined && String(pending.phone) !== String(phone))
                        continue;
                    message.message_status = _6_1_Chat_Store.toMessageStatus(pending.status);
                    if (pending.message_status_msg) {
                        message.message_status_msg = pending.message_status_msg;
                    }
                    delete _this._pendingStatusByMessageId[key];
                    _this._clearPendingMessageStatusTimer(key);
                }
            };
            this.rejectOffline = function (error) {
                if (!error)
                    return;
                error({
                    result: 1,
                    msg: 'offline',
                    result_description: 'Нет соединения с сервером',
                });
            };
            this.failPendingAjax = function (reason) {
                var _a;
                var Chat = _7_Chat.Chat;
                var failed = 0;
                for (var key in Chat.chat_memory.ajax) {
                    if (!Object.prototype.hasOwnProperty.call(Chat.chat_memory.ajax, key))
                        continue;
                    var errorFunc = (_a = Chat.chat_memory.ajax[key]) === null || _a === void 0 ? void 0 : _a.error;
                    if (errorFunc === null || errorFunc === void 0 ? void 0 : errorFunc.func) {
                        try {
                            errorFunc.func(reason);
                        }
                        catch (e) {
                            console.error('failPendingAjax|error.func|error=', e);
                        }
                    }
                    delete Chat.chat_memory.ajax[key];
                    failed += 1;
                }
                return failed;
            };
            this.ajax_verifier = function () {
                var Chat = _7_Chat.Chat;
                setInterval(function () {
                    var _a, _b;
                    if (count_obj(Chat.chat_memory.ajax)) {
                        for (var key in Chat.chat_memory.ajax) {
                            if ((_a = Chat.chat_memory.ajax[key]) === null || _a === void 0 ? void 0 : _a.add_date) {
                                var timeout = Math.floor(Date.now() / 1000) - Chat.chat_memory.ajax[key].add_date;
                                if (timeout > 60) {
                                    if ((_b = Chat.chat_memory.ajax[key].error) === null || _b === void 0 ? void 0 : _b.func) {
                                        Chat.chat_memory.ajax[key].error.func('timeout');
                                    }
                                    delete Chat.chat_memory.ajax[key];
                                }
                            }
                        }
                    }
                }, 1000);
            };
            this.ajax = function (obj) {
                var Chat = _7_Chat.Chat;
                if (!Chat.chat_loader['websocket']) {
                    _10_Chat_WebSocket.Chat_WebSocket.rejectOffline(obj.error);
                    return;
                }
                obj.before();
                var success = {};
                if (obj.success) {
                    success = {
                        func: obj.success,
                    };
                }
                var error = {};
                if (obj.error) {
                    error = {
                        func: obj.error,
                    };
                }
                var increment = null;
                if (_10_Chat_WebSocket.Chat_WebSocket.no_increment) {
                    _10_Chat_WebSocket.Chat_WebSocket.addIncrementTasksAjax({
                        success: success,
                        error: error,
                        add_date: Math.floor(Date.now() / 1000),
                    });
                }
                else {
                    increment = Chat.chat_increment_get();
                    Chat.chat_memory.ajax[increment] = {
                        success: success,
                        error: error,
                        add_date: Math.floor(Date.now() / 1000),
                    };
                }
                obj.operator_data = Chat.operator_data;
                _10_Chat_WebSocket.Chat_WebSocket.send({
                    command: 'ajax',
                    data: obj.data,
                    increment: increment,
                });
            };
            this.ajax_nodejs = function (obj) {
                var Chat = _7_Chat.Chat;
                if (!Chat.chat_loader['websocket']) {
                    _10_Chat_WebSocket.Chat_WebSocket.rejectOffline(obj.error);
                    return;
                }
                obj.before();
                var success = {};
                if (obj.success) {
                    success = {
                        func: obj.success,
                    };
                }
                var error = {};
                if (obj.error) {
                    error = {
                        func: obj.error,
                    };
                }
                var increment = null;
                if (_10_Chat_WebSocket.Chat_WebSocket.no_increment) {
                    _10_Chat_WebSocket.Chat_WebSocket.addIncrementTasksAjaxNode({
                        success: success,
                        error: error,
                        add_date: Math.floor(Date.now() / 1000),
                    });
                }
                else {
                    increment = Chat.chat_increment_get();
                    Chat.chat_memory.ajax[increment] = {
                        success: success,
                        error: error,
                        add_date: Math.floor(Date.now() / 1000),
                    };
                }
                obj.operator_data = Chat.operator_data;
                _10_Chat_WebSocket.Chat_WebSocket.send({
                    command: 'ajax_nodejs',
                    data: obj.data,
                    increment: increment,
                });
            };
            this.connect = function () {
                if (_this._connectTimeout) {
                    clearTimeout(_this._connectTimeout);
                }
                try {
                    _this.connectHandle();
                }
                catch (error) {
                    console.error('connect|connectHandle|error=', error);
                    _this._connectTimeout = setTimeout(function () {
                        _this.connect();
                    }, 1000);
                }
            };
            this.connectHandle = function () {
                var push_check = false;
                if ('Notification' in window) {
                    if (Notification.permission === 'granted') {
                        push_check = true;
                    }
                }
                var Chat = _7_Chat.Chat;
                var operatorData = Chat.operator_data;
                if (!_0_Constants.isLoadedOperatorData(operatorData)) {
                    console.error('connectHandle|данные оператора ещё не загружены — подключение отложено');
                    return;
                }
                var app_id = operatorData.app_id, id = operatorData.id, user_name = operatorData.user_name, central_user_id = operatorData.central_user_id, hesh = operatorData.hesh, chat_user_phone = operatorData.chat_user_phone;
                var params = {
                    app_id: app_id !== undefined ? app_id : null,
                    operator_id: id,
                    operator_name: user_name,
                    central_user_id: central_user_id,
                    hesh: hesh,
                    chat_user_phone: chat_user_phone,
                    chat_version: Chat.data.chat_version,
                    push_user_id: Chat.oneSignalUserID,
                    type_push: Chat.oneSignalUserIDType,
                    push_check: push_check,
                    lang: $.cookie('lang') || 'russian',
                    win_programm_version: Chat.win_programm_version(),
                };
                _10_Chat_WebSocket.Chat_WebSocket.hostname = window.location.hostname;
                if (_10_Chat_WebSocket.Chat_WebSocket.hostname !== 'sendapi.net' &&
                    _10_Chat_WebSocket.Chat_WebSocket.hostname !== 'app.sendapi.net' &&
                    _10_Chat_WebSocket.Chat_WebSocket.hostname !== 'app.botcorp.io' &&
                    _10_Chat_WebSocket.Chat_WebSocket.hostname !== 'sendapi.kz' &&
                    _10_Chat_WebSocket.Chat_WebSocket.hostname !== 'sendapi.ru') {
                    _10_Chat_WebSocket.Chat_WebSocket.hostname = 'sendapi.net';
                }
                var connect_path_sio = operatorData.connect_path_sio || Chat.chatoperator;
                if (Chat.upgrade_connect_path_sio) {
                    connect_path_sio = Chat.upgrade_connect_path_sio;
                }
                if (_10_Chat_WebSocket.Chat_WebSocket.socket) {
                    _10_Chat_WebSocket.Chat_WebSocket.socket.connect();
                }
                else {
                    _10_Chat_WebSocket.Chat_WebSocket.socket = _10_Chat_WebSocket.Chat_WebSocket.ioSock({
                        connect_path_sio: connect_path_sio,
                        params: params,
                    });
                }
            };
            this.connectV2 = function () {
                if (_this._connectTimeout) {
                    clearTimeout(_this._connectTimeout);
                }
                try {
                    _this.connectHandleV2();
                }
                catch (error) {
                    console.error('connectV2|connectHandle|error=', error);
                    _this._connectTimeout = setTimeout(function () {
                        _this.connectV2();
                    }, 1000);
                }
            };
            this.connectHandleV2 = function () {
                var push_check = false;
                if ('Notification' in window) {
                    if (Notification.permission === 'granted') {
                        push_check = true;
                    }
                }
                var Chat = _7_Chat.Chat;
                var operatorData = Chat.operator_data;
                if (!_0_Constants.isLoadedOperatorData(operatorData)) {
                    console.error('connectHandleV2|данные оператора ещё не загружены — подключение отложено');
                    return;
                }
                var app_id = operatorData.app_id, id = operatorData.id, user_name = operatorData.user_name, central_user_id = operatorData.central_user_id, hesh = operatorData.hesh, chat_user_phone = operatorData.chat_user_phone;
                var params = {
                    app_id: app_id !== undefined ? app_id : null,
                    operator_id: id,
                    operator_name: user_name,
                    central_user_id: central_user_id,
                    hesh: hesh,
                    chat_user_phone: chat_user_phone,
                    chat_version: Chat.data.chat_version,
                    push_user_id: Chat.oneSignalUserID,
                    type_push: Chat.oneSignalUserIDType,
                    push_check: push_check,
                    lang: $.cookie('lang') || 'russian',
                    win_programm_version: Chat.win_programm_version(),
                };
                var resume = _10_Chat_WebSocket.Chat_WebSocket.pushResumeParams();
                if (resume)
                    Object.assign(params, resume);
                _10_Chat_WebSocket.Chat_WebSocket.hostname = window.location.hostname;
                if (_10_Chat_WebSocket.Chat_WebSocket.hostname !== 'sendapi.net' &&
                    _10_Chat_WebSocket.Chat_WebSocket.hostname !== 'app.sendapi.net' &&
                    _10_Chat_WebSocket.Chat_WebSocket.hostname !== 'app.botcorp.io' &&
                    _10_Chat_WebSocket.Chat_WebSocket.hostname !== 'sendapi.kz' &&
                    _10_Chat_WebSocket.Chat_WebSocket.hostname !== 'sendapi.ru') {
                    _10_Chat_WebSocket.Chat_WebSocket.hostname = 'sendapi.net';
                }
                var connect_path_sio = Chat.operator_data.connect_path_sio || Chat.chatoperator;
                if (Chat.upgrade_connect_path_sio) {
                    connect_path_sio = Chat.upgrade_connect_path_sio;
                }
                _10_Chat_WebSocket.Chat_WebSocket.socket = _10_Chat_WebSocket.Chat_WebSocket.ioSockV2({
                    connect_path_sio: connect_path_sio,
                    params: params,
                });
            };
            this.closeSocket = function () {
                if (!_10_Chat_WebSocket.Chat_WebSocket.socket) {
                    console.error('closeSocket|!Chat_WebSocket.socket');
                    return;
                }
                if (_10_Chat_WebSocket.Chat_WebSocket.socket.disconnect) {
                    _10_Chat_WebSocket.Chat_WebSocket.socket.disconnect();
                }
                else if (_10_Chat_WebSocket.Chat_WebSocket.socket.close) {
                    _10_Chat_WebSocket.Chat_WebSocket.socket.close();
                }
            };
            this.heartbeatTick = function (now) {
                var Chat = _7_Chat.Chat;
                try {
                    var sentAt = _10_Chat_WebSocket.Chat_WebSocket.ping_sent_time;
                    var unanswered = sentAt !== null &&
                        (_10_Chat_WebSocket.Chat_WebSocket.ping_time === null || _10_Chat_WebSocket.Chat_WebSocket.ping_time < sentAt);
                    if (unanswered && now - sentAt > 35000) {
                        if (_10_Chat_WebSocket.Chat_WebSocket.connect_timer === null) {
                            if (!_10_Chat_WebSocket.Chat_WebSocket.auth_verification_error && !_10_Chat_WebSocket.Chat_WebSocket.reconnect_init) {
                                Chat.is_chat_loader({ websocket: false });
                                _10_Chat_WebSocket.Chat_WebSocket.connect_timer = setTimeout(function () {
                                    var _a;
                                    _10_Chat_WebSocket.Chat_WebSocket.reconnect_init = true;
                                    _10_Chat_WebSocket.Chat_WebSocket.ping_sent_time = null;
                                    if ((_a = _10_Chat_WebSocket.Chat_WebSocket.socket) === null || _a === void 0 ? void 0 : _a.emit) {
                                        _10_Chat_WebSocket.Chat_WebSocket.reconnectSocket();
                                        _10_Chat_WebSocket.Chat_WebSocket.connect_timer = null;
                                        _10_Chat_WebSocket.Chat_WebSocket.reconnect_init = false;
                                    }
                                    else {
                                        _10_Chat_WebSocket.Chat_WebSocket.closeSocket();
                                        setTimeout(function () {
                                            _10_Chat_WebSocket.Chat_WebSocket.connect();
                                            _10_Chat_WebSocket.Chat_WebSocket.connect_timer = null;
                                            _10_Chat_WebSocket.Chat_WebSocket.reconnect_init = false;
                                        }, 800);
                                    }
                                }, 200);
                            }
                        }
                    }
                    if (Chat.chat_loader['websocket'] === true) {
                        _10_Chat_WebSocket.Chat_WebSocket.send('ping');
                        if (!unanswered)
                            _10_Chat_WebSocket.Chat_WebSocket.ping_sent_time = now;
                    }
                }
                catch (e) {
                    console.error(e);
                }
            };
            this.pushResumeParams = function () {
                if (_10_Chat_WebSocket.Chat_WebSocket.push_epoch === null || _10_Chat_WebSocket.Chat_WebSocket.push_conn === null)
                    return null;
                return {
                    push_epoch: _10_Chat_WebSocket.Chat_WebSocket.push_epoch,
                    push_seq: String(_10_Chat_WebSocket.Chat_WebSocket.push_seq_last),
                    push_conn: _10_Chat_WebSocket.Chat_WebSocket.push_conn,
                };
            };
            this._trackPushSeq = function (data) {
                var seq = data['push_seq'];
                if (typeof seq === 'number' && seq > _10_Chat_WebSocket.Chat_WebSocket.push_seq_last) {
                    _10_Chat_WebSocket.Chat_WebSocket.push_seq_last = seq;
                }
            };
            this._applyConnectPush = function (data) {
                var push = data['push'];
                if (!isConnectPush(push)) {
                    console.error('_onConnect|в ответе connect нет push или он не той формы|push=', push);
                    return true;
                }
                if (push.epoch !== _10_Chat_WebSocket.Chat_WebSocket.push_epoch || push.seq > _10_Chat_WebSocket.Chat_WebSocket.push_seq_last) {
                    _10_Chat_WebSocket.Chat_WebSocket.push_seq_last = push.seq;
                }
                _10_Chat_WebSocket.Chat_WebSocket.push_epoch = push.epoch;
                _10_Chat_WebSocket.Chat_WebSocket.push_conn = push.connection_id;
                return push.resync;
            };
            this._refreshAfterConnect = function (resync) {
                var Chat = _7_Chat.Chat;
                var Contacts = _5_Contacts.Contacts;
                var phone = Chat.chat_view_subscriber;
                if (phone && (typeof phone === 'string' || typeof phone === 'number')) {
                    var phoneStr = String(phone);
                    var viewedChat = Chat.chat_messages[phoneStr];
                    var viewUnconfirmed = viewedChat === undefined || viewedChat.message_id_max === null;
                    if (resync || viewUnconfirmed) {
                        console.log('connect|messages_get|phone=', phoneStr, '|resync=', resync);
                        Chat.messages_get({
                            phone: phoneStr,
                            scroll: 'bottom',
                            chat_open: true,
                        });
                    }
                }
                if (resync && Chat.start_once_check) {
                    Contacts.category_noread_load(function () {
                        Contacts.work_load(1, function () {
                            _4_Sorter.Sorter.load();
                            _10_Chat_WebSocket.Chat_WebSocket._applyWorkStateToOpenChat();
                        });
                    });
                }
            };
            this.reconnectSocket = function () {
                if (!_10_Chat_WebSocket.Chat_WebSocket.socket) {
                    console.error('reconnectSocket|!Chat_WebSocket.socket');
                    return;
                }
                if (_10_Chat_WebSocket.Chat_WebSocket.socket.disconnect && _10_Chat_WebSocket.Chat_WebSocket.socket.connect) {
                    _10_Chat_WebSocket.Chat_WebSocket.socket.disconnect();
                    _10_Chat_WebSocket.Chat_WebSocket.socket.connect();
                }
                else if (_10_Chat_WebSocket.Chat_WebSocket.socket.close) {
                    _10_Chat_WebSocket.Chat_WebSocket.socket.close();
                }
            };
            this.onmessage = function (_a) {
                var _b;
                var data = _a.data;
                if (typeof data === 'string') {
                    if (data === 'pong') {
                        _10_Chat_WebSocket.Chat_WebSocket.ping_time = Date.now();
                        return;
                    }
                    try {
                        var parsed = JSON.parse(data);
                        if (!isWireRecord(parsed)) {
                            console.error('onmessage|payload не словарь|parsed=', parsed);
                            return;
                        }
                        data = parsed;
                    }
                    catch (error) {
                        console.error('onmessage|JSON|parse|error=', error);
                        return;
                    }
                }
                if (typeof data === 'object' && data !== null) {
                    var Chat_1 = _7_Chat.Chat;
                    var Contacts_1 = _5_Contacts.Contacts;
                    var Tasks_1 = _1_Tasks.Tasks;
                    _10_Chat_WebSocket.Chat_WebSocket._trackPushSeq(data);
                    switch (data.command) {
                        case 'upgrade_connect_path':
                            console.log('upgrade_connect_path|data=', data);
                            if (typeof data.connect_path_sio === 'string') {
                                Chat_1.upgrade_connect_path_sio = data.connect_path_sio;
                            }
                            _10_Chat_WebSocket.Chat_WebSocket.reconnectSocket();
                            return;
                        case 'upgrade_connect_path_sio':
                            console.log('upgrade_connect_path_sio|data=', data);
                            if (typeof data.connect_path_sio === 'string') {
                                Chat_1.upgrade_connect_path_sio = data.connect_path_sio;
                            }
                            _10_Chat_WebSocket.Chat_WebSocket.reconnectSocket();
                            return;
                        case 'connect':
                            _10_Chat_WebSocket.Chat_WebSocket._onConnect({ data: data });
                            return;
                        case 'ping':
                            _10_Chat_WebSocket.Chat_WebSocket.send({ command: 'pong' });
                            return;
                        case 'pong':
                            _10_Chat_WebSocket.Chat_WebSocket.ping_time = Date.now();
                            return;
                        case 'inbox_file':
                            if (Chat_1.chat_view_subscriber === data.ph_numb &&
                                (typeof data.ph_numb === 'string' || typeof data.ph_numb === 'number')) {
                                Chat_1.messages_get({
                                    phone: data.ph_numb,
                                    scroll: 'bottom',
                                    direction: 'DOWN',
                                });
                            }
                            return;
                        case 'update_message':
                            if (isUpdateMessageEventData(data)) {
                                _10_Chat_WebSocket.Chat_WebSocket._onUpdateMessage({ data: data });
                            }
                            else {
                                console.error('update_message|конверт не той формы|data=', data);
                            }
                            return;
                        case 'update_all_messages_if_chat_is_open':
                            if (Chat_1.chat_view_subscriber === data.phone &&
                                (typeof data.phone === 'string' || typeof data.phone === 'number')) {
                                var phone = data.phone;
                                var indexId = (_b = Chat_1.chat_messages[phone]) === null || _b === void 0 ? void 0 : _b.messages.findIndex(function (msg) {
                                    return ((data.message_id_tmp && msg.message_id_tmp == data.message_id_tmp) ||
                                        (data.message_id && msg.id == data.message_id));
                                });
                                if (indexId !== undefined && indexId > -1) {
                                    return;
                                }
                                Chat_1.messages_get({
                                    phone: phone,
                                    scroll: 'bottom',
                                    direction: 'DOWN',
                                });
                            }
                            return;
                        case 'ai_stream_open_chat_check': {
                            var payload = data;
                            var phone = payload.phone;
                            var checkId = payload.check_id;
                            if (!(typeof phone === 'string' || typeof phone === 'number'))
                                return;
                            if (typeof checkId !== 'string' || !checkId)
                                return;
                            if (String(Chat_1.chat_view_subscriber) !== String(phone))
                                return;
                            _10_Chat_WebSocket.Chat_WebSocket.send({
                                nodejs: 1,
                                command: 'ai_stream_open_chat_confirm',
                                phone: phone,
                                check_id: checkId,
                            });
                            return;
                        }
                        case 'ai_stream': {
                            var payload = data;
                            var phone_1 = payload.phone;
                            var action = payload.action;
                            var chunk = payload.chunk;
                            var waitMs = payload.wait_ms;
                            if (!(typeof phone_1 === 'string' || typeof phone_1 === 'number'))
                                return;
                            if (typeof action !== 'string')
                                return;
                            if (String(Chat_1.chat_view_subscriber) !== String(phone_1))
                                return;
                            var phoneKey_1 = String(phone_1);
                            var previewId_1 = "ai_stream_preview_".concat(phoneKey_1);
                            var $wrap_1 = $('#chat_subscribe_messages');
                            if (!$wrap_1.length)
                                return;
                            var updateNanoScroller_1 = function (scrollToBottom) {
                                var nativeScrollBottom = function () {
                                    var $scrollEl = (function () {
                                        var $messageHeight = $wrap_1.find('#message_height');
                                        if ($messageHeight.length)
                                            return $messageHeight;
                                        var $nanoContent = $wrap_1.find('.nano-content');
                                        if ($nanoContent.length)
                                            return $nanoContent;
                                        return $wrap_1;
                                    })();
                                    var el = $scrollEl[0];
                                    if (!el)
                                        return;
                                    $scrollEl.scrollTop(el.scrollHeight);
                                };
                                try {
                                    $wrap_1.nanoScroller();
                                }
                                catch (error) {
                                    console.error('ai_stream|nanoScroller|update|error', error);
                                }
                                if (!scrollToBottom)
                                    return;
                                try {
                                    $wrap_1.nanoScroller({ scroll: 'bottom' });
                                }
                                catch (error) {
                                    console.error('ai_stream|nanoScroller|scrollBottom|error', error);
                                }
                                finally {
                                    nativeScrollBottom();
                                }
                            };
                            var $wrapContent = $wrap_1.find('.nano-content');
                            var $messageHeight = $wrap_1.find('#message_height');
                            var $target_1 = $messageHeight.length
                                ? $messageHeight
                                : $wrapContent.length
                                    ? $wrapContent
                                    : $wrap_1;
                            var buffers = _this._aiStreamBuffers;
                            var streamState_1 = _this._aiStreamState;
                            var waitEndsAt_1 = _this._aiStreamWaitEndsAt;
                            var waitIntervals_1 = _this._aiStreamWaitIntervals;
                            var clearWait_1 = function () {
                                if (waitIntervals_1[phoneKey_1] !== undefined) {
                                    clearInterval(waitIntervals_1[phoneKey_1]);
                                    delete waitIntervals_1[phoneKey_1];
                                }
                                if (waitEndsAt_1[phoneKey_1] !== undefined) {
                                    delete waitEndsAt_1[phoneKey_1];
                                }
                            };
                            var ensurePreview_1 = function () {
                                var $preview = $('#' + previewId_1);
                                if ($preview.length) {
                                    if ($target_1.length && !$preview.parent().is($target_1)) {
                                        $target_1.append($preview);
                                    }
                                    return $preview;
                                }
                                var html = "<div class=\"direct-chat-msg message_outbox right\" id=\"".concat(previewId_1, "\">") +
                                    "<div class=\"direct-chat-avatar\" title=\"".concat(Chat_1.l('ИИ'), "\"><i class=\"fa fa-user-secret\"></i></div>") +
                                    "<div class=\"direct-chat-text\">" +
                                    "<span class=\"ai_stream_loader\"><i class=\"fa fa-spinner fa-spin\"></i></span>" +
                                    "<span class=\"ai_stream_text\"></span>" +
                                    "<small class=\"direct-chat-timestamp message_time\">".concat(Chat_1.l('ИИ печатает…'), "</small>") +
                                    "</div>" +
                                    "</div>";
                                $target_1.append(html);
                                $preview = $('#' + previewId_1);
                                return $preview;
                            };
                            var setPreviewLoading_1 = function (isLoading) {
                                var $preview = ensurePreview_1();
                                if (isLoading) {
                                    $preview.find('.ai_stream_loader').removeClass('hidden');
                                }
                                else {
                                    $preview.find('.ai_stream_loader').addClass('hidden');
                                }
                            };
                            var setPreviewText_1 = function (text) {
                                var $preview = ensurePreview_1();
                                var safe = $('<div>').text(text).html().replace(/\n/g, '<br>');
                                $preview.find('.ai_stream_text').html(safe);
                                setPreviewLoading_1((text || '').trim().length === 0);
                            };
                            var setPreviewStatus_1 = function (statusText) {
                                var $preview = ensurePreview_1();
                                $preview.find('.direct-chat-timestamp.message_time').text(statusText);
                            };
                            var updateWaitUi_1 = function () {
                                var endAt = waitEndsAt_1[phoneKey_1];
                                if (!endAt)
                                    return;
                                var remainMs = Math.max(0, endAt - Date.now());
                                var remainSec = Math.max(1, Math.ceil(remainMs / 1000));
                                setPreviewLoading_1(true);
                                setPreviewText_1("".concat(Chat_1.l('Ожидаем паузу'), " ").concat(remainSec, " ").concat(Chat_1.l('сек'), "\u2026"));
                                setPreviewStatus_1("".concat(Chat_1.l('Пауза перед ответом:'), " ").concat(remainSec, " ").concat(Chat_1.l('сек')));
                            };
                            if (action === 'wait') {
                                clearWait_1();
                                var ms = typeof waitMs === 'number' && waitMs > 0 ? waitMs : 1000;
                                waitEndsAt_1[phoneKey_1] = Date.now() + ms;
                                $('#' + previewId_1).remove();
                                ensurePreview_1();
                                updateWaitUi_1();
                                waitIntervals_1[phoneKey_1] = window.setInterval(function () {
                                    if (String(Chat_1.chat_view_subscriber) !== String(phone_1)) {
                                        return;
                                    }
                                    var endAt = waitEndsAt_1[phoneKey_1];
                                    if (!endAt) {
                                        clearWait_1();
                                        return;
                                    }
                                    if (Date.now() >= endAt) {
                                        clearWait_1();
                                        setPreviewLoading_1(true);
                                        setPreviewText_1('');
                                        setPreviewStatus_1(Chat_1.l('ИИ готовится…'));
                                        return;
                                    }
                                    updateWaitUi_1();
                                }, 1000);
                                try {
                                    setTimeout(function () {
                                        updateNanoScroller_1(true);
                                    }, 0);
                                }
                                catch (error) {
                                    console.error('ai_stream|wait|nanoScroller|error', error);
                                }
                                return;
                            }
                            if (action === 'start') {
                                clearWait_1();
                                buffers[phoneKey_1] = '';
                                delete streamState_1[phoneKey_1];
                                $('#' + previewId_1).remove();
                                ensurePreview_1();
                                setPreviewLoading_1(true);
                                setPreviewText_1('');
                                setPreviewStatus_1(Chat_1.l('ИИ печатает…'));
                                try {
                                    setTimeout(function () {
                                        updateNanoScroller_1(true);
                                    }, 0);
                                }
                                catch (error) {
                                    console.error('ai_stream|start|nanoScroller|error', error);
                                }
                                return;
                            }
                            if (action === 'chunk') {
                                clearWait_1();
                                if (typeof chunk === 'string') {
                                    buffers[phoneKey_1] = (buffers[phoneKey_1] || '') + chunk;
                                }
                                setPreviewText_1(buffers[phoneKey_1] || '');
                                setPreviewStatus_1(Chat_1.l('ИИ печатает…'));
                                try {
                                    setTimeout(function () {
                                        updateNanoScroller_1(true);
                                    }, 0);
                                }
                                catch (error) {
                                    console.error('ai_stream|chunk|nanoScroller|error', error);
                                }
                                return;
                            }
                            if (action === 'done') {
                                clearWait_1();
                                var lastText = buffers[phoneKey_1] || '';
                                delete buffers[phoneKey_1];
                                var doneAt_1 = Date.now();
                                streamState_1[phoneKey_1] = { doneAt: doneAt_1, lastText: lastText };
                                setPreviewLoading_1(false);
                                setPreviewStatus_1(Chat_1.l('Отправка…'));
                                setTimeout(function () {
                                    var state = streamState_1[phoneKey_1];
                                    if (!state || state.doneAt !== doneAt_1)
                                        return;
                                    $('#' + previewId_1).remove();
                                    delete streamState_1[phoneKey_1];
                                }, 15000);
                                return;
                            }
                            return;
                        }
                        case 'update_message_status':
                            if (isUpdateMessageStatusData(data)) {
                                _10_Chat_WebSocket.Chat_WebSocket._onUpdateMessageStatus({ data: data });
                            }
                            else {
                                console.error('update_message_status|конверт не той формы|data=', data);
                            }
                            return;
                        case 'update_status_message_id':
                            if (isUpdateStatusMessageIdData(data)) {
                                _10_Chat_WebSocket.Chat_WebSocket._onUpdateStatusMessageId({ data: data });
                            }
                            else {
                                console.error('update_status_message_id|конверт не той формы|data=', data);
                            }
                            return;
                        case 'subscriber_chat_status':
                            if (data.status === 'online') {
                                $('#subscriber_chat_status')
                                    .addClass('text-green')
                                    .removeClass('text-yellow fa-spinner fa-spin')
                                    .html("<span class=\"hidden-xs\"> ".concat(Chat_1.l('Онлайн'), "</span>"));
                            }
                            else {
                                $('#subscriber_chat_status')
                                    .addClass('text-yellow')
                                    .removeClass('text-green fa-spinner fa-spin')
                                    .html("<span class=\"hidden-xs\"> ".concat(Chat_1.l('Перерыв'), "</span>"));
                            }
                            return;
                        case 'automatic_message_distribution_update': {
                            var flag = data.automatic_message_distribution;
                            if (flag !== 0 && flag !== 1) {
                                console.error('automatic_message_distribution_update|флаг не той формы|data=', data);
                                return;
                            }
                            Chat_1.automatic_message_distribution_apply(flag);
                            return;
                        }
                        case 'operator_chat_status': {
                            var operatorId = data.operator_id;
                            var status_1 = data.status;
                            if (typeof operatorId !== 'number' ||
                                (typeof status_1 !== 'string' && typeof status_1 !== 'number')) {
                                console.error('operator_chat_status|кадр не той формы|data=', data);
                                return;
                            }
                            Chat_1.operator_chat_status_update(operatorId, String(status_1));
                            return;
                        }
                        case 'set_full_profile_img':
                            if (typeof data.data === 'object' && data.data !== null) {
                                var dataObj = data.data;
                                var phone = 'phone' in dataObj ? dataObj.phone : undefined;
                                var file_url = 'file_url' in dataObj ? dataObj.file_url : undefined;
                                if (String(Chat_1.chat_view_subscriber) === String(phone)) {
                                    var avatar_full = $('#avatar_full');
                                    if (!file_url || typeof file_url !== 'string') {
                                        avatar_full.html("<div style=\"padding: 40px;color: #a2a2a2;border: 1px solid #ddd;\">".concat(Chat_1.l('Нет фото'), "</div>"));
                                        return;
                                    }
                                    avatar_full.html("<img width=\"100%\" src=\"".concat(file_url, "?").concat(Math.floor(Date.now() / 1000), "\">"));
                                }
                            }
                            break;
                        case 'authorization_check':
                            Chat_1.authorization_check();
                            return;
                        case 'phone_up':
                            Tasks_1['sorter_load'] = true;
                            return;
                        case 'update_avatar':
                            if (typeof data.phone === 'string' || typeof data.phone === 'number') {
                                Contacts_1.data_get({ phone: String(data.phone) }, function () { }, function (error) { return console.error('update_avatar|data_get|error=', error); });
                            }
                            return;
                        case 'alien_work':
                            Contacts_1.work_load(1, function () {
                                Tasks_1['sorter_load'] = true;
                            });
                            return;
                        case 'sync_complete':
                            Contacts_1.category_noread_load(function () {
                                Contacts_1.work_load(1, function () {
                                    Tasks_1['sorter_load'] = true;
                                });
                            });
                            return;
                        case 'update_quick_messages':
                            Chat_1.quick_messages_query();
                            return;
                        case 'my_work_to_operator':
                            toastr.options.onclick = function () {
                                var phoneValue = typeof data.phone === 'string' || typeof data.phone === 'number'
                                    ? data.phone
                                    : undefined;
                                if (phoneValue !== undefined) {
                                    Chat_1.click_open_subscriber({
                                        phone: phoneValue,
                                        kol_open: 0,
                                        call_from: 'Chat_WebSocket|toastr_my_work_to_operator',
                                    });
                                }
                            };
                            toastr.options.closeButton = true;
                            toastr.success(Chat_1.l('К вам перемещен чат.'));
                            return;
                        case 'update_chat_version':
                            console.log('update_chat_version');
                            if (data.chat_version && Chat_1.data.chat_version !== data.chat_version) {
                                if (Chat_1.chat_open_subscriber) {
                                    localStorage.setItem('chat_update', String(Chat_1.chat_open_subscriber));
                                }
                                Chat_1.refresh_chat(Chat_1.navbarPageId, true);
                            }
                            return;
                        case 'set_chat_version':
                            if (data.chat_ver_new !== undefined &&
                                data.chat_ver_new !== null &&
                                (typeof data.chat_ver_new === 'string' || typeof data.chat_ver_new === 'number')) {
                                Chat_1.verification_chat_version(data.chat_ver_new);
                            }
                            return;
                        case 'no_read_del':
                            if (typeof data.phone === 'string') {
                                Contacts_1.no_read_del(data.phone);
                            }
                            return;
                        case 'no_read_set':
                            if (typeof data.ph_numb === 'string' &&
                                typeof data.category === 'object' &&
                                data.category !== null) {
                                if (!isCategoryNoreadMap(data.category)) {
                                    console.error('contact_no_read_set|category не словарь категорий|=', data.category);
                                    return;
                                }
                                Contacts_1.no_read_set({
                                    ph_numb: data.ph_numb,
                                    category: data.category,
                                    k: typeof data.k === 'number' ? data.k : undefined,
                                });
                            }
                            return;
                        case 'noread_update':
                            Tasks_1['sorter_load'] = true;
                            return;
                        case 'noread_up_state':
                            if (typeof data.state === 'string') {
                                Chat_1.chat_subscribers_noread_up_state(data.state);
                            }
                            return;
                        case 'check_message_read':
                            var checkMessageReadId = data.check_message_read_id;
                            if (typeof checkMessageReadId === 'object' && checkMessageReadId !== null) {
                                for (var key in checkMessageReadId) {
                                    $(".message_inbox[inbox_id=\"".concat(key, "\"]")).removeClass('no-read');
                                }
                            }
                            if (!Chat_1.chat_view_subscriber) {
                                console.error('check_message_read|!Chat.chat_view_subscriber');
                                return;
                            }
                            var chatViewSubscriberStr = typeof Chat_1.chat_view_subscriber === 'string' ||
                                typeof Chat_1.chat_view_subscriber === 'number'
                                ? String(Chat_1.chat_view_subscriber)
                                : '';
                            var subscribers = chatViewSubscriberStr
                                ? Contacts_1.data[chatViewSubscriberStr]
                                : undefined;
                            var chatMyWorkRaw = Reflect.get(Chat_1, 'chat_my_work');
                            var chatMyWorkHit = chatViewSubscriberStr && typeof chatMyWorkRaw === 'object' && chatMyWorkRaw !== null
                                ? Reflect.get(chatMyWorkRaw, chatViewSubscriberStr)
                                : undefined;
                            if ($('div.direct-chat-msg').hasClass('no-read') &&
                                (chatMyWorkHit || (subscribers === null || subscribers === void 0 ? void 0 : subscribers.transport) === 'whatsapp_group')) {
                                $('.mark_as_read').removeClass('hidden');
                            }
                            else {
                                $('.mark_as_read').addClass('hidden');
                            }
                            Tasks_1['sorter_load'] = true;
                            return;
                        case 'check_message_read2':
                            if (Chat_1.chat_view_subscriber === data.phone ||
                                String($('#chat_subscrib_name b').html()) === String(data.phone)) {
                                $('.message_inbox').removeClass('no-read');
                                $('.mark_as_read').addClass('hidden');
                            }
                            Tasks_1['sorter_load'] = true;
                            return;
                        case 'check_noread_operator_messages':
                            Chat_1.chat_noread_operator_messages_load();
                            return;
                        case 'noread_operator_messages':
                            if (typeof data.messages === 'object' && data.messages !== null) {
                                var noreadMessages = data.messages;
                                if (!isNoReadOperatorMessagesMap(noreadMessages)) {
                                    console.error('noread_operator_messages|форма messages не совпала|messages=', noreadMessages);
                                    return;
                                }
                                Chat_1.noread_operator_messages_update({ messages: noreadMessages }, function () {
                                    _8_Chat_template.Chat_template.display_noread_operator_messages();
                                    if (Chat_1.chat_open_operator &&
                                        (typeof Chat_1.chat_open_operator === 'string' ||
                                            typeof Chat_1.chat_open_operator === 'number')) {
                                        Chat_1.operator_messages_query(Chat_1.chat_open_operator);
                                    }
                                });
                            }
                            return;
                        case 'waba_message_insert':
                            if (data.ph_numb &&
                                (typeof data.ph_numb === 'string' || typeof data.ph_numb === 'number')) {
                                var phNumb = String(data.ph_numb);
                                var wabaContact = Contacts_1.data[phNumb];
                                if (wabaContact !== undefined) {
                                    if (typeof data.inbox_time === 'number') {
                                        wabaContact.inbox_time = data.inbox_time;
                                    }
                                    if (String(Chat_1.chat_view_subscriber) === phNumb) {
                                        Contacts_1.render_waba_status(phNumb);
                                    }
                                }
                            }
                            return;
                        case 'update_subscribers':
                            _10_Chat_WebSocket.Chat_WebSocket._onUpdateSubscribers({ data: data });
                            return;
                        case 'channel_status_update':
                            _10_Chat_WebSocket.Chat_WebSocket._onChannelStatusUpdate({ data: data });
                            return;
                        case 'update_category':
                            console.log('update_category');
                            Contacts_1.category_load(function () {
                                Tasks_1['sorter_load'] = true;
                            });
                            return;
                        case 'waba_template_update':
                            if ($('#modal_waba_template_show').hasClass('in')) {
                                Chat_1.waba_template_load({ keepChannel: true });
                            }
                            return;
                        case 'get_my_work':
                            _10_Chat_WebSocket.Chat_WebSocket._onGetMyWork();
                            return;
                        case 'chat_ver_new':
                            if (data.chat_ver_new !== undefined &&
                                data.chat_ver_new !== null &&
                                (typeof data.chat_ver_new === 'string' || typeof data.chat_ver_new === 'number')) {
                                Chat_1.verification_chat_version(data.chat_ver_new);
                            }
                            return;
                        case 'ajax':
                            _10_Chat_WebSocket.Chat_WebSocket._onAjax({ data: data });
                            return;
                        case 'ajax_nodejs':
                            _10_Chat_WebSocket.Chat_WebSocket._onAjaxNodejs({ data: data });
                            return;
                        default:
                            console.error('onmessage|default|data=', data);
                    }
                }
            };
            this.onclose = function () {
                if (_10_Chat_WebSocket.Chat_WebSocket.reconnect_init) {
                    return;
                }
                _10_Chat_WebSocket.Chat_WebSocket.reconnect_init = true;
                console.log('socket.onclose');
                _7_Chat.Chat.is_chat_loader({ websocket: false });
                var failed = _10_Chat_WebSocket.Chat_WebSocket.failPendingAjax('disconnection');
                if (failed) {
                    console.log('socket.onclose|прервано запросов=', failed);
                }
                if (!_10_Chat_WebSocket.Chat_WebSocket.auth_verification_error) {
                    setTimeout(function () {
                        _10_Chat_WebSocket.Chat_WebSocket.connect();
                        _10_Chat_WebSocket.Chat_WebSocket.reconnect_init = false;
                    }, 500);
                    return;
                }
                _10_Chat_WebSocket.Chat_WebSocket.reconnect_init = false;
            };
            this.ioSock = function (_a) {
                var path = _a.connect_path_sio, query = _a.params;
                console.log('ioSock|init');
                var socket = io("wss://".concat(_10_Chat_WebSocket.Chat_WebSocket.hostname), {
                    path: path,
                    query: query,
                    reconnection: false,
                    autoConnect: false,
                });
                socket.on('connect', function () {
                    console.log('Connected');
                });
                socket.on('message', function (message) {
                    var data;
                    try {
                        if (typeof message === 'string') {
                            var parsed = JSON.parse(message);
                            if (parsed === 'pong') {
                                _10_Chat_WebSocket.Chat_WebSocket.onmessage({ data: 'pong' });
                                return;
                            }
                            if (!isWireRecord(parsed)) {
                                console.error('onmessage|payload не словарь|parsed=', parsed);
                                return;
                            }
                            data = parsed;
                        }
                        else {
                            console.error('onmessage|invalid message type=', typeof message);
                            return;
                        }
                    }
                    catch (error) {
                        console.error('onmessage|error=', JSON.stringify(error));
                        console.error('onmessage|message=', message);
                        return;
                    }
                    _10_Chat_WebSocket.Chat_WebSocket.onmessage({ data: data });
                });
                socket.on('disconnect', function () {
                    console.log('ioSock|Disconnected');
                    _10_Chat_WebSocket.Chat_WebSocket.onclose();
                });
                socket.on('connect_error', function (error) {
                    console.error('ioSock|connect_error|error=', JSON.stringify(error));
                    _10_Chat_WebSocket.Chat_WebSocket.onclose();
                });
                socket.connect();
                return socket;
            };
            this.ioSockV2 = function (_a) {
                var path = _a.connect_path_sio, query = _a.params;
                console.log('ioSockV2|init');
                var host = _this._getSocketHost();
                var opts = {
                    reconnectionDelayMax: 10000,
                    reconnection: true,
                    autoConnect: true,
                    path: path,
                    query: query,
                    withCredentials: true,
                };
                var socket = io("wss://".concat(host), opts);
                socket.on('connect', function () {
                    console.log('Connected');
                });
                socket.on('message', function (message) {
                    var data;
                    try {
                        if (typeof message === 'string') {
                            var parsed = JSON.parse(message);
                            if (parsed === 'pong') {
                                _10_Chat_WebSocket.Chat_WebSocket.onmessage({ data: 'pong' });
                                return;
                            }
                            if (!isWireRecord(parsed)) {
                                console.error('onmessage|payload не словарь|parsed=', parsed);
                                return;
                            }
                            data = parsed;
                        }
                        else {
                            console.error('onmessage|invalid message type=', typeof message);
                            return;
                        }
                    }
                    catch (error) {
                        console.error('onmessage|error=', JSON.stringify(error));
                        console.error('onmessage|message=', message);
                        return;
                    }
                    _10_Chat_WebSocket.Chat_WebSocket.onmessage({ data: data });
                });
                socket.on('disconnect', function () {
                    console.error('ioSockV2|Disconnected');
                    _7_Chat.Chat.is_chat_loader({ websocket: false });
                    var resume = _10_Chat_WebSocket.Chat_WebSocket.pushResumeParams();
                    if (resume)
                        Object.assign(query, resume);
                });
                socket.on('connect_error', function (error) {
                    var _a;
                    console.error('ioSockV2|connect_error|error=', error === null || error === void 0 ? void 0 : error.toString());
                    _7_Chat.Chat.is_chat_loader({ websocket: false });
                    if (socket.active) {
                        _this._getHost();
                        return;
                    }
                    if ((_a = error === null || error === void 0 ? void 0 : error.toString()) === null || _a === void 0 ? void 0 : _a.includes('io_middleware')) {
                        var errorMessage = typeof error === 'object' &&
                            error !== null &&
                            'message' in error &&
                            typeof error.message === 'string'
                            ? error.message
                            : '';
                        if (errorMessage && _this._errorMessageHandler({ message: errorMessage })) {
                            return;
                        }
                        _this._getHost();
                        socket.connect();
                        return;
                    }
                    console.log('ioSockV2|connect_error|Reconnecting in 15 seconds...');
                    _this._getHost();
                    _this._scheduleManualReconnect();
                });
                socket.connect();
                return socket;
            };
            this._manualReconnectTimer = null;
            this._scheduleManualReconnect = function () {
                if (_this._manualReconnectTimer !== null)
                    return;
                _this._manualReconnectTimer = setTimeout(function () {
                    var _a;
                    _this._manualReconnectTimer = null;
                    if ((_a = _10_Chat_WebSocket.Chat_WebSocket.socket) === null || _a === void 0 ? void 0 : _a.connected)
                        return;
                    _10_Chat_WebSocket.Chat_WebSocket.reconnectSocket();
                }, 15000);
            };
            this._getHost = function () {
                var _a;
                ++_this.socketHostCnt;
                if (_this.socketHostCnt >= _this.socketHosts.length) {
                    _this.socketHostCnt = 0;
                }
                var host = _this._getSocketHost();
                if ((_a = _10_Chat_WebSocket.Chat_WebSocket.socket) === null || _a === void 0 ? void 0 : _a.io) {
                    _10_Chat_WebSocket.Chat_WebSocket.socket.io.uri = "wss://".concat(host);
                }
                return host;
            };
            this._errorMessageHandler = function (_a) {
                var message = _a.message;
                var data;
                try {
                    if (typeof message === 'string') {
                        data = JSON.parse(message);
                    }
                    else {
                        return false;
                    }
                }
                catch (error) {
                    console.error('ioSockV2|_errorMessageHandler|error=', error);
                    console.error('ioSockV2|_errorMessageHandler|error|message=', message);
                    return;
                }
                var status = typeof data === 'object' && data !== null ? Reflect.get(data, 'status') : undefined;
                if (status === 'unauthorized') {
                    _10_Chat_WebSocket.Chat_WebSocket.auth_verification_error = true;
                    _10_Chat_WebSocket.Chat_WebSocket.closeSocket();
                    var reason = typeof data === 'object' && data !== null ? Reflect.get(data, 'reason') : undefined;
                    if (reason === 'blocked_operator') {
                        swal({
                            type: 'error',
                            title: _7_Chat.Chat.l('Ошибка!'),
                            html: _7_Chat.Chat.l('Превышено количество разрешенных одновременных подключений для текущего пользователя'),
                            showCancelButton: false,
                            confirmButtonColor: '#DD6B55',
                            confirmButtonText: 'OK',
                        });
                        return true;
                    }
                    swal({
                        type: 'error',
                        title: _7_Chat.Chat.l('Ошибка!'),
                        html: _7_Chat.Chat.l('Авторизационные данные не прошли проверку подлинности. Переавторизуйтесь.'),
                        showCancelButton: false,
                        confirmButtonColor: '#DD6B55',
                        confirmButtonText: _7_Chat.Chat.l('Выход'),
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                    }).then(function (result) {
                        if (!result || result.value !== true)
                            return;
                        _7_Chat.Chat.logout();
                    });
                    return true;
                }
            };
            this._onUpdateStatusMessageId = function (_a) {
                var _b;
                var data = _a.data;
                var Chat = _7_Chat.Chat;
                var _c = data.message_data, phone = _c.phone, message_id = _c.message_id, status = _c.status, message_status_msg = _c.message_status_msg;
                var messages = (_b = Chat.chat_messages[phone]) === null || _b === void 0 ? void 0 : _b.messages;
                var updatedInMemory = false;
                if (messages) {
                    for (var key4 in messages) {
                        var message = messages[key4];
                        if (message) {
                            if (String(message.id) === String(message_id)) {
                                message.message_status = status;
                                if (message_status_msg) {
                                    message.message_status_msg = message_status_msg;
                                }
                                updatedInMemory = true;
                            }
                        }
                    }
                }
                var chatStore = Chat.Chat_Store;
                var numericMessageId = Number(message_id);
                if (updatedInMemory && numericMessageId > 0 && chatStore && chatStore.isActive()) {
                    chatStore
                        .updateStatusesPr(String(phone), [numericMessageId], Number(status), message_status_msg)
                        .catch(function (error) {
                        console.error('_onUpdateStatusMessageId|updateStatusesPr|error=', error);
                    });
                }
                if (String(Chat.chat_view_subscriber) !== String(phone)) {
                    return;
                }
                if (!_this._applyMessageStatusToDom({
                    messageId: message_id,
                    status: status,
                    messageStatusMsg: message_status_msg,
                })) {
                    _this._setPendingMessageStatus({
                        messageId: message_id,
                        status: status,
                        phone: phone,
                        messageStatusMsg: message_status_msg,
                    });
                }
            };
            this._onUpdateMessageStatus = function (_a) {
                var data = _a.data;
                var Chat = _7_Chat.Chat;
                var _b = data.message_data, ph_numb = _b.ph_numb, status = _b.status, message_status_msg = _b.message_status_msg;
                if (!Chat.chat_messages[ph_numb]) {
                    return;
                }
                var updatedIds = [];
                var messages = Chat.chat_messages[ph_numb].messages;
                for (var key in messages) {
                    if (!messages[key]) {
                        continue;
                    }
                    var _c = messages[key], message_route = _c.message_route, id = _c.id;
                    if (message_route !== 'outbox') {
                        continue;
                    }
                    var message_status = Number(messages[key].message_status);
                    if (message_status === 4) {
                        continue;
                    }
                    var _status = +status;
                    var isErrorStatus = _status === 4 || _status < 0;
                    if (isErrorStatus ? message_status > 0 : message_status >= _status) {
                        continue;
                    }
                    var outboxMessage = messages[key];
                    if (!outboxMessage) {
                        continue;
                    }
                    outboxMessage.message_status = _status;
                    if (message_status_msg) {
                        outboxMessage.message_status_msg = message_status_msg;
                    }
                    if (typeof id === 'number' && id > 0) {
                        updatedIds.push(id);
                    }
                    if (String(Chat.chat_view_subscriber) !== String(ph_numb)) {
                        continue;
                    }
                    if (!_this._applyMessageStatusToDom({
                        messageId: id,
                        status: _status,
                        messageStatusMsg: message_status_msg,
                    })) {
                        _this._setPendingMessageStatus({
                            messageId: id,
                            status: _status,
                            phone: ph_numb,
                            messageStatusMsg: message_status_msg,
                        });
                        continue;
                    }
                }
                var chatStore = Chat.Chat_Store;
                if (updatedIds.length && chatStore && chatStore.isActive()) {
                    chatStore
                        .updateStatusesPr(String(ph_numb), updatedIds, +status, message_status_msg)
                        .catch(function (error) {
                        console.error('_onUpdateMessageStatus|updateStatusesPr|error=', error);
                    });
                }
            };
            this._onConnect = function (_a) {
                var data = _a.data;
                var resultValue = typeof data.result === 'number' ? data.result : -1;
                if (resultValue !== 0) {
                    console.error('connect|data=', data);
                    return;
                }
                var Chat = _7_Chat.Chat;
                var _b = Chat.operator_data, id = _b.id, central_user_id = _b.central_user_id;
                var no_increment = typeof data.no_increment === 'boolean' ? data.no_increment : false;
                var verification = typeof data.verification === 'number' ? data.verification : 0;
                if (no_increment) {
                    console.log('no_increment = true');
                    _10_Chat_WebSocket.Chat_WebSocket.no_increment = true;
                }
                if (verification === 6) {
                    _10_Chat_WebSocket.Chat_WebSocket.reconnectSocket();
                    return;
                }
                if (verification === 5) {
                    _10_Chat_WebSocket.Chat_WebSocket.auth_verification_error = true;
                    _10_Chat_WebSocket.Chat_WebSocket.closeSocket();
                    if (data.reason === OPENED_ELSEWHERE_REASON) {
                        _10_Chat_WebSocket.Chat_WebSocket._showOpenedElsewhere();
                        return;
                    }
                    swal({
                        type: 'error',
                        title: Chat.l('Ошибка!'),
                        html: Chat.l('Превышено количество разрешенных одновременных подключений для текущего пользователя'),
                        showCancelButton: false,
                        confirmButtonColor: '#DD6B55',
                        confirmButtonText: 'OK',
                        closeOnConfirm: false,
                    }, function () {
                        location.reload();
                    });
                    return;
                }
                if (verification === 4) {
                    _10_Chat_WebSocket.Chat_WebSocket.auth_verification_error = true;
                    _10_Chat_WebSocket.Chat_WebSocket.closeSocket();
                    swal({
                        type: 'error',
                        title: _7_Chat.Chat.l('Ошибка!'),
                        html: Chat.l('Ошибка при инициализации загрузки чата. Обновите чат, чтобы попробовать еще раз'),
                    });
                    return;
                }
                if (verification === 1) {
                    _10_Chat_WebSocket.Chat_WebSocket.auth_verification_error = true;
                    _10_Chat_WebSocket.Chat_WebSocket.closeSocket();
                    swal({
                        type: 'error',
                        title: Chat.l('Ошибка!'),
                        html: Chat.l('Авторизационные данные не прошли проверку подлинности. Переавторизуйтесь.'),
                        showCancelButton: false,
                        confirmButtonColor: '#DD6B55',
                        confirmButtonText: Chat.l('Выход'),
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                    }).then(function (result) {
                        if (!result || result.value !== true)
                            return;
                        Chat.logout();
                    });
                    return;
                }
                if (verification === 2) {
                    _10_Chat_WebSocket.Chat_WebSocket.auth_verification_error = true;
                    _10_Chat_WebSocket.Chat_WebSocket.closeSocket();
                    Chat.is_chat_loader({ websocket: false });
                    swal({
                        type: 'error',
                        title: Chat.l('Ошибка!'),
                        html: Chat.l('2 К вашему аккаунту не подключен номер (отправитель). Обратитесь к администратору системы или авторизуйтесь под другой учетной записью.') + '<a href="tel:77776528920">+7 (777) 652-89-20</a>',
                    });
                }
                if (verification === 3) {
                    _10_Chat_WebSocket.Chat_WebSocket.auth_verification_error = true;
                    _10_Chat_WebSocket.Chat_WebSocket.closeSocket();
                    swal({
                        type: 'error',
                        title: Chat.l('Внимание!'),
                        html: Chat.l('Вы не оплатили счет, Ваш аккаунт заблокирован. Свяжитесь с техподдержкой:') +
                            ' <br>' +
                            '<a href="tel:77776528920">+7 (777) 652-89-20</a>',
                    });
                    return;
                }
                if (verification !== 0) {
                    _10_Chat_WebSocket.Chat_WebSocket.auth_verification_error = true;
                    _10_Chat_WebSocket.Chat_WebSocket.closeSocket();
                    swal({
                        type: 'error',
                        title: Chat.l('Ошибка!'),
                        html: Chat.l('Неизвестная ошибка. Обратитесь в службу технической поддержки') +
                            '<a href="tel:77776528920">+7 (777) 652-89-20</a>',
                    });
                    return;
                }
                Chat.is_chat_loader({ websocket: true });
                _10_Chat_WebSocket.Chat_WebSocket.ping_sent_time = null;
                Chat.outboxFlush();
                _10_Chat_WebSocket.Chat_WebSocket._refreshAfterConnect(_10_Chat_WebSocket.Chat_WebSocket._applyConnectPush(data));
                if (typeof Android === 'object') {
                    Chat.oneSignalUserID = Android.getPushUserId();
                    Chat.oneSignalUserIDType = 'android';
                    _10_Chat_WebSocket.Chat_WebSocket.send({
                        nodejs: 1,
                        command: 'set_app_push_data',
                        push_user_id: Chat.oneSignalUserID,
                        push_token: Android.getPushToken(),
                        type_push: Chat.oneSignalUserIDType,
                        operator_id: id,
                        central_user_id: central_user_id,
                    });
                }
                else if (window.ReactNativeWebView && (Chat.data.ios_app || Chat.data.android_app)) {
                    try {
                        window.ReactNativeWebView.postMessage(JSON.stringify({
                            mode: 'getPushToken',
                        }));
                    }
                    catch (error) {
                        console.error('postMessage 1|error=', error);
                    }
                }
                else if (typeof Chat.oneSignalUserID === 'string' && Chat.oneSignalUserID.length > 5) {
                    _10_Chat_WebSocket.Chat_WebSocket.send({
                        nodejs: 1,
                        command: 'set_app_push_data',
                        push_user_id: Chat.oneSignalUserID,
                        type_push: Chat.oneSignalUserIDType,
                        push_token: null,
                        operator_id: id,
                        central_user_id: central_user_id,
                    });
                }
                if (!Chat.operator_data.connect_path_sio) {
                    Chat.authorization_check();
                }
                setTimeout(function () {
                    Chat.start_once();
                }, 20);
                if (_10_Chat_WebSocket.Chat_WebSocket.timer_close !== null) {
                    clearTimeout(_10_Chat_WebSocket.Chat_WebSocket.timer_close);
                    _10_Chat_WebSocket.Chat_WebSocket.timer_close = null;
                }
                _10_Chat_WebSocket.Chat_WebSocket.timer_close = setTimeout(function () {
                    _10_Chat_WebSocket.Chat_WebSocket.timer_close = null;
                    _10_Chat_WebSocket.Chat_WebSocket._plannedReconnect(Date.now() + PLANNED_RECONNECT_MAX_WAIT_MS);
                }, 500000);
            };
            this._showOpenedElsewhere = function () {
                var Chat = _7_Chat.Chat;
                Chat.is_chat_loader({ websocket: false });
                swal({
                    type: 'warning',
                    title: Chat.l('Чат открыт в другом браузере'),
                    html: Chat.l('Чат открыт в другом браузере или вкладке. Нажмите «Открыть здесь», чтобы продолжить работу в этом окне.'),
                    showCancelButton: false,
                    confirmButtonText: Chat.l('Открыть здесь'),
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                }).then(function (result) {
                    if (!result || result.value !== true)
                        return;
                    location.reload();
                });
            };
            this._hasOperationInFlight = function () {
                var Chat = _7_Chat.Chat;
                return count_obj(Chat.chat_memory.ajax) > 0 || Chat.chat_message_send_button;
            };
            this._plannedReconnect = function (deadline) {
                if (_10_Chat_WebSocket.Chat_WebSocket.auth_verification_error)
                    return;
                if (_10_Chat_WebSocket.Chat_WebSocket._hasOperationInFlight() && Date.now() < deadline) {
                    _10_Chat_WebSocket.Chat_WebSocket.timer_close = setTimeout(function () {
                        _10_Chat_WebSocket.Chat_WebSocket.timer_close = null;
                        _10_Chat_WebSocket.Chat_WebSocket._plannedReconnect(deadline);
                    }, PLANNED_RECONNECT_RECHECK_MS);
                    return;
                }
                _7_Chat.Chat.is_chat_loader({ websocket: false });
                _10_Chat_WebSocket.Chat_WebSocket.failPendingAjax('disconnection');
                _10_Chat_WebSocket.Chat_WebSocket.reconnectSocket();
            };
            this._onGetMyWork = function () {
                var Tasks = _1_Tasks.Tasks;
                _5_Contacts.Contacts.work_load(1, function () {
                    Tasks['sorter_load'] = true;
                    _10_Chat_WebSocket.Chat_WebSocket._applyWorkStateToOpenChat();
                });
            };
            this._applyWorkStateToOpenChat = function () {
                var Chat = _7_Chat.Chat;
                var Contacts = _5_Contacts.Contacts;
                if (!Chat.chat_open_subscriber) {
                    console.log('_onGetMyWork|1');
                    if (Contacts.work_alien_phone) {
                        var phone = Contacts.work_alien_phone;
                        Contacts.work_alien_phone = null;
                        Chat.click_open_subscriber({
                            phone: phone,
                            no_load_msg: true,
                            call_from: 'Chat_WebSocket|onGetMyWork|open_work_alien_phone',
                        });
                    }
                    return;
                }
                if (typeof Chat.chat_open_subscriber !== 'string' &&
                    typeof Chat.chat_open_subscriber !== 'number') {
                    console.error('_onGetMyWork|chat_open_subscriber!==string!==number', Chat.chat_open_subscriber);
                    return;
                }
                var chat_open_subscriber = String(Chat.chat_open_subscriber);
                if (!Contacts.data[chat_open_subscriber]) {
                    console.log('_onGetMyWork|2|Contacts.data=', Contacts.data);
                    console.log('_onGetMyWork|2|chat_open_subscriber=', chat_open_subscriber);
                    return;
                }
                var subscribers = Contacts.data[chat_open_subscriber];
                if (subscribers.transport === 'whatsapp_group') {
                    $('#blocker_operator').css('display', 'none');
                    $('.my_work, #my_work_operator').addClass('hidden');
                }
                else {
                    var my_work_class = 'class="hidden-xs hidden-sm"';
                    if (Chat.width < 768)
                        my_work_class = '';
                    var my_work_text = "<i class=\"fa fa-comment-dots\"></i> <span ".concat(my_work_class, ">") +
                        Chat.l('Взять в работу') +
                        '</span>';
                    var my_work_type = 'take_to_work';
                    var my_work_title = Chat.l('Взять в работу') + ' (Ctrl+G)';
                    var $my_work_operator = $('#my_work_operator');
                    var $my_work_to_operator_show = $('.my_work_to_operator_show');
                    $my_work_operator.removeClass('hidden');
                    $my_work_to_operator_show.addClass('hidden');
                    if (Contacts.work_my[chat_open_subscriber]) {
                        my_work_text =
                            "<i class=\"fa fa-comment\"></i> <span ".concat(my_work_class, ">") +
                                Chat.l('Закончить диалог') +
                                '</span>';
                        my_work_type = 'end_dialog';
                        my_work_title = Chat.l('Закончить диалог') + ' (Ctrl+G)';
                        $my_work_operator.addClass('hidden');
                        $my_work_to_operator_show.removeClass('hidden');
                    }
                    $('.my_work').html(my_work_text).data('work', my_work_type).attr('title', my_work_title);
                }
                if ($('div.direct-chat-msg').hasClass('no-read') &&
                    (Contacts.work_my[chat_open_subscriber] || subscribers.transport === 'whatsapp_group')) {
                    $('.mark_as_read').removeClass('hidden');
                }
                else {
                    $('.mark_as_read').addClass('hidden');
                }
                console.log('Chat.operator_data=', Chat.operator_data.roles);
                var isAdmin = Chat.operator_data.central_user_id === Chat.operator_data.id ||
                    (Chat.operator_data.roles &&
                        Array.isArray(Chat.operator_data.roles) &&
                        (Chat.operator_data.roles.includes('admin') ||
                            Chat.operator_data.roles.includes('administrator') ||
                            Chat.operator_data.roles.includes('admin_operator')));
                console.log('Chat.operator_data|isAdmin=', isAdmin);
                var alienWork = Contacts.work_alien[chat_open_subscriber];
                var isAiWork = Boolean(Contacts.work_ai[chat_open_subscriber]) ||
                    (alienWork === null || alienWork === void 0 ? void 0 : alienWork.op_n) === _0_Constants.AI_ASSISTANT_NAME;
                if (isAiWork) {
                    $('#my_work_operator').addClass('hidden');
                    $('.work_button').css('display', 'none');
                    $('#blocker_operator').css('display', 'block');
                    var aiBlockerHtml = Chat.l('Диалог ведет ИИ-ассистент');
                    if (isAdmin) {
                        aiBlockerHtml += _10_Chat_WebSocket.buildWithdrawChatButtonHtml(chat_open_subscriber, Chat.l('ИИ-ассистента'));
                    }
                    $('#blocker_operator p').html(aiBlockerHtml);
                }
                else if (alienWork) {
                    $('#my_work_operator').addClass('hidden');
                    $('.work_button').css('display', 'none');
                    $('#blocker_operator').css('display', 'block');
                    var alienBlockerHtml = Chat.l('Диалог ведет оператор:') + ' <span>' + alienWork.op_n + '</span>';
                    if (isAdmin) {
                        alienBlockerHtml += _10_Chat_WebSocket.buildWithdrawChatButtonHtml(chat_open_subscriber, Chat.l('оператора'));
                    }
                    $('#blocker_operator p').html(alienBlockerHtml);
                }
                else {
                    $('.work_button').css('display', 'block');
                    $('#blocker_operator').css('display', 'none');
                }
            };
            this._onAjaxNodejs = function (_a) {
                var _b, _c;
                var data = _a.data;
                var Chat = _7_Chat.Chat;
                if (_10_Chat_WebSocket.Chat_WebSocket.no_increment) {
                    _this._onAjaxNodejsToIncrement({ data: data });
                    return;
                }
                if (!data.increment) {
                    console.error('ajax_nodejs|!data.increment|data=', data);
                    return;
                }
                if (Chat.chat_memory['ajax'][data.increment]) {
                    _10_Chat_WebSocket.Chat_WebSocket.send({
                        nodejs: 1,
                        command: 'delete_increment',
                        increment: data.increment,
                    });
                }
                if (data.error !== undefined && +data.error === 1) {
                    swal({
                        type: 'error',
                        title: Chat.l('Ошибка!'),
                        html: (_b = data.result) === null || _b === void 0 ? void 0 : _b.result_description,
                    });
                    delete Chat.chat_memory['ajax'][data.increment];
                    return;
                }
                var ajaxEntry = Chat.chat_memory['ajax'][data.increment];
                if (ajaxEntry) {
                    var successFunc = (_c = ajaxEntry.success) === null || _c === void 0 ? void 0 : _c.func;
                    if (successFunc &&
                        data.result &&
                        typeof data.result === 'object' &&
                        'result' in data.result) {
                        try {
                            successFunc(data.result);
                        }
                        catch (error) {
                            console.error('ajax_nodejs|successFunc|error=', error);
                            swal({
                                type: 'error',
                                title: Chat.l('Ошибка!'),
                                html: Chat.l('Произошла ошибка при обработке данных от сервера. Попробуйте еще раз.'),
                            });
                        }
                    }
                    delete Chat.chat_memory['ajax'][data.increment];
                }
            };
            this._onAjaxNodejsToIncrement = function (_a) {
                var _b, _c, _d;
                var data = _a.data;
                if (data.error !== undefined && +data.error === 1) {
                    swal({
                        type: 'error',
                        title: _7_Chat.Chat.l('Ошибка!'),
                        html: (_b = data.result) === null || _b === void 0 ? void 0 : _b.result_description,
                    });
                    return;
                }
                for (var key in _10_Chat_WebSocket.Chat_WebSocket.incrementTasksAjaxNode) {
                    var success = (_c = _10_Chat_WebSocket.Chat_WebSocket.incrementTasksAjaxNode[key]) === null || _c === void 0 ? void 0 : _c.success;
                    if (!success) {
                        delete _10_Chat_WebSocket.Chat_WebSocket.incrementTasksAjaxNode[key];
                        continue;
                    }
                    try {
                        if (data.result && typeof data.result === 'object' && data.result !== null) {
                            var response = data.result;
                            if (isServerResponse(response)) {
                                (_d = success.func) === null || _d === void 0 ? void 0 : _d.call(success, response);
                            }
                            else {
                                console.error('ajax_nodejs|2|ответ не той формы|data.result=', response);
                            }
                        }
                    }
                    catch (error) {
                        console.error('ajax_nodejs|2|func|error=', error);
                        console.error('ajax_nodejs|2|func|data.result=', data.result);
                    }
                    delete _10_Chat_WebSocket.Chat_WebSocket.incrementTasksAjaxNode[key];
                    return;
                }
                console.log('ajax_nodejs|2|post for|data.result=', data.result);
            };
            this._onAjaxToIncrement = function (_a) {
                var _b, _c;
                var data = _a.data;
                if (data.error !== undefined && +data.error === 1) {
                    _10_Chat_WebSocket.Chat_WebSocket.ajaxError(data);
                    return;
                }
                for (var key in _10_Chat_WebSocket.Chat_WebSocket.incrementTasksAjax) {
                    var success = (_b = _10_Chat_WebSocket.Chat_WebSocket.incrementTasksAjax[key]) === null || _b === void 0 ? void 0 : _b.success;
                    if (!success) {
                        delete _10_Chat_WebSocket.Chat_WebSocket.incrementTasksAjax[key];
                        continue;
                    }
                    try {
                        if (data.result && typeof data.result === 'string') {
                            var parsed = JSON.parse(data.result);
                            if (isServerResponse(parsed)) {
                                (_c = success.func) === null || _c === void 0 ? void 0 : _c.call(success, parsed);
                            }
                            else {
                                console.error('ajax|ответ не той формы|parsed=', parsed);
                            }
                        }
                    }
                    catch (error) {
                        console.error('ajax|JSON|parse|error=', error);
                        console.error('ajax|JSON|parse|data.result=', data.result);
                        console.error('ajax|-----------');
                    }
                    delete _10_Chat_WebSocket.Chat_WebSocket.incrementTasksAjax[key];
                    return;
                }
                console.log('ajax|post for|data.result=', data.result);
            };
            this._onAjax = function (_a) {
                var _b;
                var data = _a.data;
                var Chat = _7_Chat.Chat;
                if (_10_Chat_WebSocket.Chat_WebSocket.no_increment) {
                    _this._onAjaxToIncrement({ data: data });
                    return;
                }
                if (!data.increment) {
                    console.error('ajax|!data.increment|data=', data);
                    return;
                }
                if (Chat.chat_memory['ajax'][data.increment]) {
                    _10_Chat_WebSocket.Chat_WebSocket.send({
                        command: 'delete_increment',
                        increment: data.increment,
                    });
                }
                if (data.error !== undefined && +data.error === 1) {
                    _10_Chat_WebSocket.Chat_WebSocket.ajaxError(data);
                    delete Chat.chat_memory['ajax'][data.increment];
                    return;
                }
                var ajaxEntry2 = Chat.chat_memory['ajax'][data.increment];
                if (ajaxEntry2) {
                    var successFunc = (_b = ajaxEntry2.success) === null || _b === void 0 ? void 0 : _b.func;
                    if (successFunc) {
                        try {
                            if (data.result && typeof data.result === 'string') {
                                var parsed = JSON.parse(data.result);
                                if (isServerResponse(parsed)) {
                                    successFunc(parsed);
                                }
                                else {
                                    console.error('ajax|2|ответ не той формы|parsed=', parsed);
                                }
                            }
                        }
                        catch (error) {
                            console.error('ajax|2|JSON|parse|error=', error);
                            console.error('ajax|2|JSON|parse|data.result=', data.result);
                        }
                    }
                    delete Chat.chat_memory['ajax'][data.increment];
                }
            };
            this._onUpdateSubscribers = function (_a) {
                var data = _a.data;
                var Chat = _7_Chat.Chat;
                var Contacts = _5_Contacts.Contacts;
                var Tasks = _1_Tasks.Tasks;
                if (!data.ph_numb) {
                    Tasks['sorter_load'] = true;
                    return;
                }
                Contacts.data_get({ phone: String(data.ph_numb) }, function (chat_subscribers_data) {
                    if (String(Chat.chat_view_subscriber) !== String(data.ph_numb)) {
                        Tasks['sorter_load'] = true;
                        return;
                    }
                    $('#chat_subscrib_name').html(Chat.getSubscriberNameHtml({
                        phone: String(Chat.chat_view_subscriber),
                        transport: chat_subscribers_data['transport'],
                        name: chat_subscribers_data['name'],
                        name_custom: chat_subscribers_data['name_custom'],
                        insta_login: chat_subscribers_data['insta_login'],
                        telegram_login: chat_subscribers_data['telegram_login'],
                    }));
                    var categ_list = [];
                    if (chat_subscribers_data.category && chat_subscribers_data.category.length > 0) {
                        for (var key in chat_subscribers_data.category) {
                            var categoryId = chat_subscribers_data.category[key];
                            var category = categoryId ? Contacts.category[categoryId] : undefined;
                            if (category) {
                                categ_list.push(category.n);
                            }
                        }
                    }
                    categ_list = categ_list.join(', ');
                    $('#chat_subscrib_group').text(categ_list).attr('title', categ_list);
                    Tasks['sorter_load'] = true;
                }, function (error) {
                    console.error('update_subscribers|error=', error);
                });
            };
            this._onChannelStatusUpdate = function (_a) {
                var _b, _c, _d, _e;
                var _f, _g;
                var data = _a.data;
                var Chat = _7_Chat.Chat;
                var Contacts = _5_Contacts.Contacts;
                var channelType = typeof data.channelType === 'string' ? data.channelType : '';
                var phoneId = typeof data.phoneId === 'string' || typeof data.phoneId === 'number'
                    ? String(data.phoneId)
                    : '';
                if (!channelType || !phoneId) {
                    return;
                }
                if (!isChannelSlotKey(channelType)) {
                    console.warn('channel_status_update|unsupported channelType', channelType);
                    return;
                }
                Chat.operator_data = Chat.operator_data || {};
                (_b = (_f = Chat.operator_data).channel) !== null && _b !== void 0 ? _b : (_f.channel = {});
                (_c = (_g = Chat.operator_data).channelOff) !== null && _c !== void 0 ? _c : (_g.channelOff = {});
                var channel = Chat.operator_data.channel;
                var channelOff = Chat.operator_data.channelOff;
                (_d = channel[channelType]) !== null && _d !== void 0 ? _d : (channel[channelType] = {});
                (_e = channelOff[channelType]) !== null && _e !== void 0 ? _e : (channelOff[channelType] = {});
                var activeMap = channel[channelType];
                var inactiveMap = channelOff[channelType];
                var phoneNumber = typeof data.phoneNumber === 'string' || typeof data.phoneNumber === 'number'
                    ? String(data.phoneNumber)
                    : activeMap[phoneId] || inactiveMap[phoneId] || '';
                var isActive = data.activeStatus === 'on';
                if (isActive) {
                    activeMap[phoneId] = phoneNumber;
                    delete inactiveMap[phoneId];
                }
                else {
                    inactiveMap[phoneId] = phoneNumber;
                    delete activeMap[phoneId];
                }
                var currentPhone = typeof Chat.chat_view_subscriber === 'string' ||
                    typeof Chat.chat_view_subscriber === 'number'
                    ? String(Chat.chat_view_subscriber)
                    : '';
                if (!currentPhone) {
                    return;
                }
                var contact = Contacts.data[currentPhone];
                if ((contact === null || contact === void 0 ? void 0 : contact.sp_numb) && String(contact.sp_numb) === phoneId) {
                    Chat.updateChannelIndicator({
                        sp_numb: contact.sp_numb,
                        transport: contact.transport,
                    });
                }
            };
            this._onUpdateMessage = function (_a) {
                var data = _a.data;
                var Chat = _7_Chat.Chat;
                var _b = data.message_data, phone = _b.phone, message_id = _b.message_id, message_text = _b.message_text, transcription_text = _b.transcription_text;
                var chatStore = Chat.Chat_Store;
                if (chatStore && chatStore.isActive()) {
                    var cacheFields = {};
                    if (typeof message_text === 'string')
                        cacheFields.message_text = message_text;
                    if (typeof transcription_text === 'string') {
                        cacheFields.transcription_text = transcription_text;
                    }
                    if (Object.keys(cacheFields).length) {
                        chatStore
                            .updateMessageFieldsPr(String(phone), Number(message_id), cacheFields)
                            .catch(function (error) {
                            console.error('_onUpdateMessage|updateMessageFieldsPr|error=', error);
                        });
                    }
                }
                if (!Chat.chat_messages[phone]) {
                    return;
                }
                var messages = Chat.chat_messages[phone].messages;
                for (var key2 in messages) {
                    var updatedMessage = messages[key2];
                    if (!updatedMessage)
                        continue;
                    if (String(updatedMessage.id) === String(message_id)) {
                        if (typeof message_text === 'string') {
                            updatedMessage.message_text = message_text;
                        }
                        if (typeof transcription_text === 'string') {
                            updatedMessage.transcription_text = transcription_text;
                        }
                        if (String(Chat.chat_view_subscriber) === String(phone)) {
                            if (typeof message_text === 'string') {
                                $("div[chat_message_id=\"".concat(message_id, "\"] .direct-chat-text")).html(message_text);
                            }
                            if (typeof transcription_text === 'string') {
                                var $directText = $("div[chat_message_id=\"".concat(message_id, "\"] .direct-chat-text"));
                                if ($directText.length) {
                                    var $t = $directText.find('.message_transcription_text');
                                    var transcriptionHtml = replaceCarret({
                                        message_text: transcription_text,
                                    });
                                    if ($t.length) {
                                        $t.html(transcriptionHtml);
                                    }
                                    else {
                                        var blockHtml = "<div class=\"message_transcription\" style=\"margin-top:6px; padding-top:6px; border-top:1px dashed rgba(0,0,0,0.12);\">" +
                                            "<div class=\"message_transcription_title\" style=\"font-size:12px; opacity:0.7;\">".concat(Chat.l('Транскрипция:'), "</div>") +
                                            "<div class=\"message_transcription_text\" style=\"font-size:13px;\">".concat(transcriptionHtml, "</div>") +
                                            "</div>";
                                        var $ts = $directText.find('small.direct-chat-timestamp');
                                        if ($ts.length) {
                                            $(blockHtml).insertBefore($ts);
                                        }
                                        else {
                                            $directText.html(String($directText.html()) + blockHtml);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            };
        }
        return Chat_WebSocketCls;
    }());
    _10_Chat_WebSocket.Chat_WebSocket = new Chat_WebSocketCls();
})(_10_Chat_WebSocket || (_10_Chat_WebSocket = {}));


"use strict";
_10_Chat_WebSocket.Chat_WebSocket.connect_verifier();
var auto_read_action = {};
function auto_read() {
    var Chat = _7_Chat.Chat;
    if (Chat.chat_open_subscriber && Chat.operator_data.auto_read === 1 && Chat.is_focus) {
        var subscriberKey_1 = String(Chat.chat_open_subscriber);
        if (auto_read_action[subscriberKey_1] !== true) {
            auto_read_action[subscriberKey_1] = true;
            setTimeout(function () {
                Chat.click_mark_as_read(Chat.chat_open_subscriber);
                delete auto_read_action[subscriberKey_1];
            }, 2000);
        }
    }
}
Object.equal = function (firstObj, secondObject) {
    if ($.isEmptyObject(firstObj) && $.isEmptyObject(secondObject))
        return true;
    if ($.isEmptyObject(firstObj) || $.isEmptyObject(secondObject))
        return false;
    var keysFirstObj = Object.keys(firstObj);
    var keysSecondObject = Object.keys(secondObject);
    if (keysFirstObj.length !== keysSecondObject.length) {
        return false;
    }
    return !keysFirstObj.filter(function (key) {
        var val1 = firstObj[key];
        var val2 = secondObject[key];
        if (typeof val1 === 'object' && val1 !== null) {
            return !Object.equal(jsonRecordOf(val1), jsonRecordOf(val2));
        }
        else {
            return val1 !== val2;
        }
    }).length;
};
function jsonRecordOf(value) {
    var record = {};
    if (Array.isArray(value)) {
        for (var index = 0; index < value.length; index++) {
            var item = value[index];
            if (item !== undefined)
                record[String(index)] = item;
        }
        return record;
    }
    if (typeof value === 'string') {
        for (var index = 0; index < value.length; index++) {
            record[String(index)] = value.charAt(index);
        }
        return record;
    }
    if (typeof value === 'object' && value !== null)
        return value;
    return record;
}
function isset(str) {
    return typeof str !== 'undefined';
}
function empty(str) {
    if (str === undefined)
        return true;
    if (str === null)
        return true;
    return str === '';
}
function isJson(item) {
    var itemStr = typeof item !== 'string' ? JSON.stringify(item) : item;
    var parsed;
    try {
        parsed = JSON.parse(itemStr);
    }
    catch (e) {
        return false;
    }
    return typeof parsed === 'object' && parsed !== null;
}
function count_obj(obj) {
    if (!obj) {
        console.warn('count_obj: получен null или undefined объект');
        return 0;
    }
    try {
        if (Array.isArray(obj)) {
            return obj.length;
        }
        return Object.keys(obj).length;
    }
    catch (error) {
        console.error('count_obj|error=', error);
        console.error('count_obj|obj=', obj);
        return 0;
    }
}
function passed_time(t) {
    var time = Math.floor(Date.now() / 1000) - t;
    if (time < 60) {
        return {
            time: Math.ceil(time),
            time_type: 'sec',
            time_desc: Math.ceil(time) + ' сек.',
        };
    }
    else if (time < 3600) {
        return {
            time: Math.ceil(time / 60),
            time_type: 'min',
            time_desc: Math.ceil(time / 60) + ' мин.',
        };
    }
    else if (time < 86400) {
        return {
            time: Math.ceil(time / (60 * 60)),
            time_type: 'hour',
            time_desc: Math.ceil(time / (60 * 60)) + ' час.',
        };
    }
    else {
        return {
            time: Math.ceil(time / (60 * 60 * 24)),
            time_type: 'day',
            time_desc: Math.ceil(time / (60 * 60 * 24)) + ' дн.',
        };
    }
}
function replaceAll(search, replace, subject) {
    if (empty(subject))
        return subject;
    try {
        return subject.split(search).join(replace);
    }
    catch (error) {
        console.error('replaceAll|error=', error);
        return subject;
    }
}
function replaceCarret(_a) {
    var message_text = _a.message_text;
    var options = {
        target: '_blank',
        rel: 'noopener',
    };
    try {
        message_text = linkifyHtml(message_text, options);
    }
    catch (error) {
        console.error('linkify|error=', error);
    }
    return replaceAll('\n', '<br>', message_text);
}
var Button = {
    preloader: function (obj) {
        if (_7_Chat.Chat.chat_loader['websocket'] === false)
            return;
        var buttons = typeof obj === 'string' ? $(obj) : obj;
        buttons.each(function (_index, element) {
            var button = $(element);
            if (button.data('html') !== undefined) {
                button.attr('disabled', 'disabled');
                return;
            }
            var width = element.getClientRects().length > 0 ? button.width() : undefined;
            button.data('html', button.html());
            button.html('<i class="fa fa-spinner  fa-spin"></i>');
            if (width !== undefined && width > 0)
                button.width(width);
            button.attr('disabled', 'disabled');
        });
    },
    reset: function (obj) {
        var buttons = typeof obj === 'string' ? $(obj) : obj;
        buttons.each(function (_index, element) {
            var button = $(element);
            var html = button.data('html');
            if (typeof html === 'string') {
                button.html(html);
                button.width('');
                button.removeAttr('disabled');
                button.removeData('html');
            }
        });
    },
};
function chat_messages_scroll(position) {
    var chat_subscribe_messages = $('#chat_subscribe_messages');
    var messages_height = $('#message_height').height();
    var chat_operator_messages = $('#chat_operator_messages');
    switch (position) {
        case 'bottom':
            if (messages_height) {
                chat_subscribe_messages.scrollTop(messages_height);
            }
            chat_operator_messages.scrollTop(99999999999);
            break;
        case 'top':
            chat_subscribe_messages.scrollTop(0);
            break;
        default:
            break;
    }
}
function notifyMe(phone) {
    var Chat = _7_Chat.Chat;
    if (Chat.win_programm_version() || Chat.isMobile.any() || Chat.is_focus)
        return;
    if (!('Notification' in window)) {
        return;
    }
    if (Notification.permission === 'granted') {
        var notification_1 = new Notification('Чат', {
            tag: 'notification',
            body: 'Новое входящее сообщение',
            icon: '/img/sendapi_logo_notify_50.png',
        });
        notification_1.onclick = function () {
            window.focus();
            Chat.click_open_subscriber({ phone: phone });
            setTimeout(notification_1.close.bind(notification_1), 500);
        };
    }
    else if (Notification.permission !== 'denied') {
        Notification.requestPermission(function (permission) {
            if (permission === 'granted') {
                var notification_2 = new Notification('Чат', {
                    tag: 'notification',
                    body: 'Новое входящее сообщение',
                    icon: '/img/sendapi_logo_notify_50.png',
                });
                notification_2.onclick = function () {
                    window.focus();
                    Chat.click_open_subscriber({ phone: phone });
                    setTimeout(notification_2.close.bind(notification_2), 500);
                };
            }
        });
    }
}
function initMapGoogle_bing() {
    var Chat = _7_Chat.Chat;
    Chat.map_google = 1;
    var mapElement = document.getElementById('maps_bing');
    if (!mapElement)
        return;
    var map = new google.maps.Map(mapElement, {
        zoom: 14,
    });
    var geocoder = new google.maps.Geocoder();
    var marker = new google.maps.Marker({
        visible: false,
        map: map,
    });
    geocoder.geocode({ address: String(Chat.maps_k1) }, function (results, status) {
        if (status === google.maps.GeocoderStatus.OK && results[0]) {
            map.setCenter(results[0].geometry.location);
            marker.setOptions({
                visible: true,
                title: String(Chat.maps_k1),
                position: results[0].geometry.location,
            });
            map.setZoom(17);
        }
    });
}
function initMapGoogle() {
    var Chat = _7_Chat.Chat;
    var uluru = [Chat.maps_k1, Chat.maps_k2];
    var myMap = new ymaps.Map('maps_google', {
        center: uluru,
        zoom: 14,
    }), myPlacemark = new ymaps.Placemark(myMap.getCenter());
    myMap.geoObjects.add(myPlacemark);
}
FileReaderJS.setupClipboard(document.body, {
    on: {
        loadend: function (e) {
            b64toBlob(e.target.result, function (blob) {
                if (!blob)
                    return;
                var $fileupload3 = $('#fileupload3');
                if ($fileupload3.data('blueimp-fileupload')) {
                    $fileupload3.fileupload('add', { files: blob });
                    _7_Chat.Chat.list_images_show();
                }
                else {
                    console.error('File upload plugin is not initialized.');
                    toastr.error('Не удалось добавить файл. Попробуйте еще раз');
                }
            }, function () { });
        },
        error: function () { },
    },
});
function b64toBlob(b64, onsuccess, onerror) {
    var img = new Image();
    img.onerror = onerror;
    img.onload = function onload() {
        var canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext('2d');
        if (!ctx)
            return;
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        canvas.toBlob(onsuccess);
    };
    img.src = b64;
}
window.onkeydown = function (event) {
    var Chat = _7_Chat.Chat;
    if (event.ctrlKey && event.keyCode === 81) {
        event.preventDefault();
        if (Chat.chat_open_subscriber) {
            Chat.click_mark_as_read(Chat.chat_open_subscriber);
        }
    }
    else if (event.ctrlKey && event.keyCode === 71) {
        event.preventDefault();
        if (Chat.chat_open_subscriber) {
            Chat.click_my_work($('.my_work'));
        }
    }
    else if (event.ctrlKey && event.keyCode === 89) {
        event.preventDefault();
        if (Chat.chat_open_subscriber) {
            $('#my_work_to_operator').modal('show');
        }
    }
};
window.onbeforeunload = function (evt) {
    if (_7_Chat.Chat.deferred_messages.length > 0) {
        var message = 'Есть сообщения ожидающие отправки. Вы потеряете их, если покинете страницу.';
        var unloadEvent = evt === undefined ? window.event : evt;
        if (unloadEvent instanceof BeforeUnloadEvent) {
            unloadEvent.returnValue = message;
        }
        return message;
    }
    return undefined;
};
window.addEventListener('message', _7_Chat.Chat.onPostMessage);
document.addEventListener('message', _7_Chat.Chat.onPostMessage);
window.addEventListener('load', function () {
    var touchsurface = document.getElementById('chat_subscribe_messages'), threshold = 100, allowedTime = 500;
    var startX, startY, dist, elapsedTime, startTime;
    function handleswipe(isrightswipe) {
        $('#chat_subscribe_messages').nanoScroller();
        if (isrightswipe)
            $('body').addClass('sidebar-open');
        else {
            $('body').removeClass('sidebar-open');
        }
    }
    if (touchsurface) {
        touchsurface.addEventListener('touchstart', function (e) {
            var touchobj = e.changedTouches[0];
            if (!touchobj)
                return;
            dist = 0;
            startX = touchobj.pageX;
            startY = touchobj.pageY;
            startTime = Date.now();
        }, false);
        touchsurface.addEventListener('touchmove', function (_e) {
        }, false);
        touchsurface.addEventListener('touchend', function (e) {
            var touchobj = e.changedTouches[0];
            if (!touchobj || startX === undefined || startTime === undefined || startY === undefined)
                return;
            dist = touchobj.pageX - startX;
            elapsedTime = Date.now() - startTime;
            var swiperightBol = elapsedTime <= allowedTime &&
                dist >= threshold &&
                Math.abs(touchobj.pageY - startY) <= 500;
            handleswipe(swiperightBol);
        }, false);
    }
}, false);
setInterval(function () {
    var Chat = _7_Chat.Chat;
    if (Chat.data.chat_version_new === '')
        return;
    if (Chat.data.chat_version_new !== Chat.data.chat_version) {
        if (Chat.composer_text() !== '')
            return;
        if (Chat.chat_open_subscriber) {
            var subscriberKey = String(Chat.chat_open_subscriber);
            if (typeof subscriberKey === 'string') {
                localStorage.setItem('chat_update', subscriberKey);
            }
            else {
                console.error('chat.ts: Chat.chat_open_subscriber не является строкой:', Chat.chat_open_subscriber);
            }
        }
        Chat.refresh_chat(Chat.navbarPageId);
    }
}, 60000);

// ── classic-футер (сгенерирован _bundler/create_chat_v3_esm.js) ──
// Явный возврат объявлений в глобальный скоуп: IIFE-обёртка прячет их,
// а inline-скрипты twig-лоадеров обращаются к ним как к глобалам.
var __chatGlobalScope =
  typeof globalThis !== 'undefined'
    ? globalThis
    : typeof window !== 'undefined'
      ? window
      : self;
__chatGlobalScope._0_Constants = _0_Constants;
__chatGlobalScope._1_Tasks = _1_Tasks;
__chatGlobalScope._2_Draft = _2_Draft;
__chatGlobalScope._3_SorterWork = _3_SorterWork;
__chatGlobalScope._4_Sorter = _4_Sorter;
__chatGlobalScope._5_Contacts = _5_Contacts;
__chatGlobalScope._6_FileUpload = _6_FileUpload;
__chatGlobalScope._6_1_Chat_Store = _6_1_Chat_Store;
__chatGlobalScope._7_Chat = _7_Chat;
__chatGlobalScope._8_Chat_template = _8_Chat_template;
__chatGlobalScope._9_Chat_onesignal = _9_Chat_onesignal;
__chatGlobalScope._10_Chat_WebSocket = _10_Chat_WebSocket;
__chatGlobalScope.auto_read = auto_read;
__chatGlobalScope.empty = empty;
__chatGlobalScope.count_obj = count_obj;
__chatGlobalScope.replaceAll = replaceAll;
__chatGlobalScope.Button = Button;
__chatGlobalScope.initMapGoogle_bing = initMapGoogle_bing;
__chatGlobalScope.initMapGoogle = initMapGoogle;
